<template>
    <div>
        <!-- Nav Bar main -->
        <nav-bar-main></nav-bar-main>

        <nav-bar-dispositivi v-if="plantDetails != null"></nav-bar-dispositivi>

        <!-- Modal for add a lamp or multiple lamps to a monitoring zone -->
        <AddToMonitoringZone :lamp="lampToAdd" v-model="modalAddToZone" :alerts="alerts" @hide="resetAddToZone"/> 
        <multiple-add-to-monitoring-zone :lamps="lampsToAdd" v-model="modalMultipleAddToZone" :alerts="alerts" @hide="resetMultipleAddToZone" @updated-zone="azzeraSelezione"/>

        <!-- Modal for remove central unit -->
        <remove-central-unit :cu="cuToRemove" v-model="modalRemoveCuVisible" @hide="resetRemoveCuModal" />

        <!-- Modal for reset central unit -->
        <reset-central-unit :cu="cuToReset" v-model="modalResetCuVisible" />

        <!-- Modal for send gateway command -->
        <gateway-command :cu="gatewayToCommand" v-model="modalGatewayCommandVisible" />

        <!-- Modal for send gateway command -->
        <!-- <gateway-lamps-insert :cu="gatewayInsert" :lamps="lampsInZone" v-model="modalGatewayLampsInsertVisible" /> -->
        <GatewayLampsInsert 
            :cu="gatewayInsert" 
            :zones="zonesInPlant" 
            v-model="modalGatewayLampsInsertVisible" 
            @data-ready="handleDataFromGateway"
            @searching-finished="searchingBleLamps = false" />

        <!-- Modal for watching the searching lamps by a gateway -->
        <GatewayLampsSearch 
            :cu="currentGateway" 
            :dataPolling="dataFromPolling" 
            v-model="modalGatewayLampsSearchVisible"
            :searchingOn="searchingBleLamps" />

        <!-- Modal for view groups on a central unit -->
        <groups-central-unit :cu="cuGroups" v-model="modalGroupsCuVisible" @hide="resetGroupsCuModal" />

        <!-- Modal for advanced on a central unit -->
        <advanced-central-unit :cu="cuAdvanced" :sendAction="sendFmCommand" v-model="modalAdvancedCuVisible"
            @hide="resetAdvancedCuModal" />

        <!-- Modal for Inputs/Relay on a central unit -->
        <inputs-central-unit :cu="cuInputs" :sendAction="sendCommand" v-model="modalInputsCuVisible"
            @hide="resetInputsCuModal" />

        <!-- Modal for central details -->
        <CentralDetails 
            v-model="modalCentDetailShow" 
            :editingCent="editingCent" 
            :currentCent="currentCent" 
            :updateFinito="!updatingName"
            @hide="hideCentDetails" 
            @updating="(name) => { updatingName = true; nomeCent= name; }"
            @editing="(val) => editingCent = val" />

        <!-- Modal for lamp details     [ @updating="(name) => { updatingName = true; nomeLamp = name; }"
            @editing="(val) => editingLamp = val" :updateFinito="!updatingName" :editingLamp="editingLamp" ]      
            Non ho previsto un side-effect su this.$store.state.plantUnits, conviene che sia la shadow ad aggiornare -->
        <LampDetails 
            v-model="modalLampDetailShow"            
            :currentCent="currentCent"
            :currentLamp="currentLamp" 
            :scanning="scanning"           
            :sendAction="sendDescLampSicuroCommand"
            @hide="hideLampDetails"
            @nameUpdated="(name) => { currentLamp.desc = name; }"
        />

        <!-- Modal for lamp configuration -->
        <LampConfig 
            v-model="modalLampConfigShow"
            :currentCent="currentCent"
            :currentLamp="currentLamp"
            :sendAction="sendConfigLampSicuroCommand"
            @hide="hideLampConfig" />

        <!-- Modal for line configuration -->
        <LineConfig 
            v-model="modalLineConfigShow"
            :currentCent="currentCent"
            :currentLine="currentLine"
            :sendAction="sendConfigLineSicuroCommand"
            @hide="hideLineConfig" />

        <!-- Modal for Line details -->
        <LineDetails 
            v-model="modalLineDetailShow"
            :currentCent="currentCent"
            :currentLine="currentLine" 
            :sendAction="sendDescLineSicuroCommand"/>

        <!-- Modal for Ak details -->
        <AkDetails 
            v-model="modalAkDetailShow"
            :currentAk="currentAk"  />

        <!-- Modal for Charger details -->
        <ChargerDetails 
            v-model="modalChargerDetailShow"
            :currentCharger="currentCharger" />

        <!-- Modal for groups on a Sicuro central unit  :currentCent="currentCent" -->
        <GroupsSicuroCentralUnit 
            v-model="modalGroupsSicuroCuVisible"
            :cuId="cuSicuroId"
            :cuType="cuSicuroType"
            :sendAction="sendConfigGruppiSicuroCommand" 
            :cmdResult="cmdResult" />

        <div v-if="plantDetails != null" class="animated fadeIn container-fluid" style="padding-bottom: 15px">
            <show-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="mediumAndAbove">
                <div>
                    <!--     dei comandi visibile solo se admin o installatore o collaboratore -->
                    <b-row v-if="this.ruoloUtente(this.$store.getters.userId) == 'installer' || this.ruoloUtente(this.$store.getters.userId) == 'collab' || this.$store.state.user.usertype == 'admin'" class="fixed-top navbar-command ">
                        <b-col lg="12" md="12">

                            <!-- <div v-if="error != null">
                                <div v-if="error.tipo != null">
                                    <b-alert show variant="danger" dismissible>
                                        {{ $t(error.tipo, {cuid: error.par}) }}
                                    </b-alert>
                                </div> -->
                                <!-- mantengo per compatibilità con l'esistente -->
                                <!-- <div v-else class="alert alert-danger alert-dismissible" role="alert">
                                    {{ $t(error) }}
                                </div>
                            </div> -->
                            <ErrorBanner />

                            <!-- banner per basic plant -->
                            <!-- <b-alert v-if="plantDetails != null && this.$store.getters.isCentralized && plantDetails.plant_type == 'basic'" show
                                variant="warning" style="display:inline-block;width:100%;padding:0.25rem;">
                                <banner-pro />
                            </b-alert> -->

                            <!-- banner per pro expired -->
                            <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning"
                                style="display:inline-block;width:100%;padding:0.25rem;">
                                <banner-pro-expired />
                            </b-alert>

                            <!-- alert per feedback dei comandi -->
                            <b-row class="alert-feeback-command">
                                <b-col lg="12" md="12">
                                    <b-alert v-for="(alert, indexA) in alerts" :show="alert.timeLeft"
                                        v-bind:key="indexA" :variant="alert.state" dismissible fade
                                        @dismissed="alert.timeLeft = 0" @dismiss-count-down="alert.countDownChanged">
                                        <div>
                                            <i v-if="alert.state == 'danger'"
                                                class="fa fa-1x fa-exclamation-circle mr-2"></i>
                                            <i v-if="alert.state == 'success'"
                                                class="fa fa-1x fa-check-circle mr-2"></i>
                                            <div class="pb-3" style="display:inline; font-size:13px; height:15px;">
                                                {{ alert.msg }}</div>
                                        </div>
                                    </b-alert>
                                </b-col>
                            </b-row>

                            <!--- Loader per il caricamento pagina o invio dei comandi -->
                            <Loader />

                            <!-- barra dei comandi -->
                            <b-row v-if="plantDetails != null && this.$store.getters.isCentralized" class="pull-left mb-3 ml-4"
                                style="width: 100%">
                                <add-central-unit> </add-central-unit>

                                <b-dropdown id="generic_command" text="Comandi" class="typo-label mr-1 ml-1 mt-3">
                                    <template slot="button-content">
                                        <i class="fa fa-paper-plane"></i>
                                        <span class="ml-2 mr-2 typo-label">{{ $t("command_button.command") }}</span>
                                    </template>
                                    <b-dropdown-item :disabled="!emergencySelection || (sicuroSelection && !sicuroCentSelection)"
                                        @click="sendGenericCommand('test_funzionale')">
                                        {{ $t('command.test_funzionale') }}</b-dropdown-item>
                                    <b-dropdown-item :disabled="!emergencySelection || (sicuroSelection && !sicuroCentSelection)"
                                        @click="sendGenericCommand('test_autonomia')">
                                        {{ $t('command.test_autonomia') }}</b-dropdown-item>
                                    <b-dropdown-item :disabled="!emergencySelection || (sicuroSelection && !sicuroCentSelection)"
                                        @click="sendGenericCommand('stop_test')">
                                        {{ $t('command.stop_test') }}</b-dropdown-item>
                                    <b-dropdown-item :disabled="(!emergencySelection || sicuroSelection)"
                                        @click="sendGenericCommand('rest_mode')">
                                        {{ $t('command.rest_mode') }}</b-dropdown-item>
                                    <b-dropdown-item :disabled="((!emergencySelection && !lightingSelection) || sicuroSelection)"
                                        @click="sendGenericCommand('refresh')">
                                        {{ $t('command.refresh') }}</b-dropdown-item>
                                    <b-dropdown-item :disabled="((!emergencySelection && !lightingSelection) || sicuroSelection)"
                                        @click="sendGenericCommand('stop_blink')">
                                        {{ $t('command.stop_blink') }}</b-dropdown-item>
                                    <b-dropdown-item :disabled="((!emergencySelection && !lightingSelection) || sicuroSelection)"
                                        @click="$bvModal.show('modal-descrittivo')">
                                        {{ $t('command.set_description') }}</b-dropdown-item>
                                </b-dropdown>
                                <parametri-impianto v-if="(emergencySelection && !sicuroSelection)" :sendAction="sendGenericCommandMulti"
                                    :lamp="lampadeSel" :cu="centraliSel" :group="gruppoSel" :alerts="alerts"
                                    :configView="configViewParam()" class="pull-right"></parametri-impianto>
                                <pianifica-test v-if="((emergencySelection && !sicuroSelection) || sicuroCentSelection)" :sendAction="sendPianificaTest"
                                    :cu="centraliSel" :alerts="alerts"
                                    :timezoneLocation="this.$store.state.timezoneLocation"></pianifica-test>
                                <parametri-uvoxy v-if="(emergencySelection && !sicuroSelection)" :sendAction="sendGenericCommandMulti"
                                    :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts"
                                    class="pull-right"></parametri-uvoxy>
                                
                                 <!-- Aggiungi a zona di monitoraggio -->    
                                <b-button v-if="(!sicuroSelection && lightingSelection) && righeSel.length > 0" class="typo-butt-command mr-1 ml-1 mt-3 but-oval-long" @click="showMultipleAddToMonitoringZone(righeSel)">
                                    <span style="font-size: 12x;"><i class="fa fa-chart-pie mr-1" style="font-size:18px; color:#0090cd;"></i>{{$t("add_to_monitoring_zone.button_add_to_zone")}}</span>
                                </b-button>   
 
                                <!-- <dimming-dialog v-if="lightingSelection" :sendAction="sendGenericCommandMulti" :lamp="lampadeSel" :cu="centraliSel" :group="gruppoSel" :alerts="alerts"> </dimming-dialog> 
                                <create-scene-dialog v-if="lightingSelection"></create-scene-dialog> -->

                                <div id="navbar-search">

                                     <!-- Barra dei filtri -->   
                                    <div id="navbar-filter" v-if="!advancedFilters">
                                        <b-input-group :prepend="$t('filter.title') + ' :'">
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterSelected(this.errorFilters)"
                                                    @click="errorFilter()" :content="$t('filter.error')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-exclamation-circle"></i></b-button>
                                            </b-input-group-append> 
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterSelectedOrphan(this.orphanFilters)"
                                                    @click="orphanFilter()" :content="$t('filter.orphan')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <b-iconstack font-scale="1.5">
                                                        <b-icon stacked icon="wifi" v-bind:class="OrphanSelected(this.orphanFilters)"></b-icon>
                                                        <b-icon stacked icon="slash" v-bind:class="OrphanSelected(this.orphanFilters)"></b-icon>      
                                                    </b-iconstack>    
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterSelectedEmergencyOn(this.emergencyFilters)"
                                                    @click="emergencyOnFilter()" :content="$t('filter.emergency')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <b-iconstack font-scale="1.5">
                                                        <b-icon stacked icon="plug" scale="1" v-bind:class="EmergencyOnSelected(this.emergencyFilters)"></b-icon>
                                                        <b-icon stacked icon="lightning-fill"  scale="0.5" style="color: white;"></b-icon> 
                                                        <b-icon stacked icon="circle"  scale="1" v-bind:class="EmergencyOnSelected(this.emergencyFilters)"></b-icon>    
                                                     </b-iconstack>   
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterSelected(this.advancedFilters)"
                                                    @click="showFilters()" :content="$t('filter.advanced')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-filter"></i></b-button>
                                            </b-input-group-append>
                                            <b-form-input type="text" :placeholder="$t('search')"
                                                v-model="filters.search" class="ml-2" :content="$t('filter.search')"
                                                v-tippy="{ placement: 'top', arrow: true }"></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="primary" @click="filtra()"><i
                                                        class="fa fa-search"></i></b-button>
                                            </b-input-group-append>
                                        </b-input-group>

                                        <!-- Barra dei filtri errori specifici -->   
                                         <b-input-group v-if="!advancedFilters && this.errorFilters==true" class="mb-5">
                                            <b-input-group-append style="margin-left:90px;">
                                                <b-button v-bind:class="FilterComErrorSelected(this.errorComFilters)"
                                                    @click="errorComFilter()" :content="$t('filter.error_com')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-exclamation-circle"></i>
                                                </b-button>
                                            </b-input-group-append> 
                                            <b-input-group-append>
                                                <b-button  v-bind:class="FilterBatteryErrorSelected(this.errorBatteryFilters)"
                                                    @click="errorBatteryFilter()" :content="$t('filter.error_battery')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-battery-full ml-1"></i>
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterHardwareErrorSelected(this.errorHardwareFilters)"
                                                    @click="errorHardwareFilter()" :content="$t('filter.error_hardware')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-microchip ml-2"></i>
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterLedErrorSelected(this.errorLedFilters)"
                                                    @click="errorLedFilter()" :content="$t('filter.error_led')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-lightbulb ml-2"></i>
                                                </b-button>
                                            </b-input-group-append>
                                            <b-input-group-append>
                                                <b-button v-bind:class="FilterOtherErrorSelected(this.errorOtherFilters)"
                                                    @click="errorOtherFilter()" :content="$t('filter.error_other')"
                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                    <i class="fa fa-exclamation ml-1 mr-1"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>


                                    </div>
                                </div>
                            </b-row>
                            <b-row v-else class="pull-left ml-4" style="width: 100%">
                                <AddZone :tableBtData="tableBtData"></AddZone>
                            </b-row>
                        </b-col>
                    </b-row>
                    
                </div>
            </show-at>


            <show-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="large">
                <div>
                    <b-nav class="mobile-sub-nav fixed-top scrollable">
                        <!--<b-button size="sm" v-b-toggle.commands-collapse>+</b-button>-->
                        <!--<b-nav-text style="padding-left:16px"> {{$t("navbar_dispositivi.button_centrali")}}</b-nav-text>-->
                        <!--<b-dropdown id="dd-centrali-menu" right no-caret >
                            <template v-slot:button-content>
                            <i class="fa fa-bars fa-lg"></i>
                            </template>
                            <b-dropdown-item class="active">Tutti i dispositivi</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantgeneral/'+ this.$store.state.currentPlant.id}" >{{$t("navbar.settings_generali")}}</b-dropdown-item>
                            <b-dropdown-item :to="{path: '/plantusers/'+ this.$store.state.currentPlant.id}">{{$t("navbar.settings_utenti")}}</b-dropdown-item>
                        </b-dropdown>-->
                        <div>
                            <!-- <b-link href="#" active>Tutti i dispositivi</b-link> 
                            <b-link href="#">Emergenza</b-link>
                            <b-link href="#">Illuminazione</b-link>
                            <b-link href="#">Sensori</b-link>
                            <b-link href="#">Raggruppamenti</b-link> -->
                        </div>
                    </b-nav>
                </div>
            </show-at>

            <!-- <show-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="small">
                <loader />
            </show-at> -->
            <!------------------------------------------->
            <!-- TABELLA DISPOSITIVI BLUETOOTH DESKTOP -->
            <!------------------------------------------->

            <b-row v-if="plantDetails != null && ((this.$store.getters.isBluetooth && !this.$store.getters.isCentralized && deviceTypeFilter() == null) || deviceTypeFilter()=='zoneBluetooth')"
                id="table-device" class="pt-5">
                <b-col cols="12" class="mainDataCol">
                    <hide-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="small">
            <!---- TABLE ZONE BLUETOOTH -->
                        <b-check-group id="righeSel" v-model="righeSel" >
                            <v-client-table v-if="tableBtData.length >= 0" :columns="ble_zone_columns" :data="tableBtData"
                                :options="optionsBle" :theme="theme" id="dataTable2" ref="tableBle"
                                class="table-dispo borderless text-primary styled mb-5">
                                <tr slot="beforeLimit">
                                    <b-button class="noborder-button download float-right"
                                        @click="createPDF_ImpiantoBle()">
                                        <i class="fas fa fa-1x fa-download mr-3"></i>
                                        <span v-if="lampadeSel.length == 0 && centraliSel.length == 0">
                                            {{ this.$t('report_pdf.download_all_pdf') }}</span>
                                        <span v-if="centraliSel.length > 0 || lampadeSel.length > 0">
                                            {{ this.$t('report_pdf.download_selected_pdf') }}</span>
                                    </b-button>
                                </tr>
                                <!-- bluetooth icon -->
                                <div slot="image" slot-scope="props">
                                    <i class="fa fa-bluetooth-b fa-2x" style="color:#0090CD;
                                        border: solid 2px;
                                        border-radius: 40%;
                                        padding: 10px;" />
                                </div>

                                <!-- zone description with editing mode -->
                                <div slot="desc" slot-scope="props">
                                    <span v-if="!editingZone"><strong>{{ props.row.zoneName }}</strong></span>
                                    <span v-if="!editingZone"><b-button @click="editNomeZone(props.row)"><i
                                                class="fa fa-edit"></i></b-button></span>
                                    <span v-if="editingZone && props.row == currentZone">
                                        <div role="group">
                                            <b-form-input type="text" v-model="nomeZone" :maxlength="maxchar"></b-form-input>
                                            <b-form-text v-html="zoneNameInfo"></b-form-text>
                                        </div>
                                    </span>
                                    <span v-if="editingZone && props.row == currentZone">
                                        <b-button v-if="!updatingName" @click="saveNomeZone"><i
                                                class="fa fa-check"></i></b-button>
                                        <b-button v-if="!updatingName" @click="abortNomeZone"><i
                                                class="fa fa-close"></i></b-button>
                                        <span v-if="updatingName"><i class="fa fa-spinner fa-spin"></i></span>
                                    </span>
                                </div>

                                <!-- zone number -->
                                <div slot="num" slot-scope="props">
                                    <div class="justify-content-center">
                                        <div class="justify-content-center">{{ $t("bluetooth.zone_number") }}</div>
                                        <div v-if="props.row.zoneNumber" class="justify-content-center">
                                            <strong>{{ props.row.zoneNumber }}</strong>
                                        </div>
                                        <div v-else class="justify-content-center"> - </div>
                                    </div>
                                </div>

                                <!-- gateway in zone -->
                                <div v-if="props.row.gatewayId && props.row.gatewayId!=null && props.row.gatewayId!='null'" slot="gateway" slot-scope="props">
                                    <b-row>
                                        <b-col>
                                            <div style="text-align:right;">
                                                <img :src="pathDeviceImages + 'gateway_basic.png'" style="height:30px; width:auto;" />
                                            </div>
                                        </b-col>
                                        <b-col>
                                            <div style="text-align:left;">
                                                BLEGATEWAY
                                            </div>
                                            <div style="text-align:left;" v-if="props.row.gatewayId">
                                                Serial Id: <strong>{{ props.row.gatewayId }}</strong>
                                            </div>  
                                        </b-col>
                                    </b-row>  
                                </div>

                                <!-- lamps in zone -->
                                <div slot="lamps" slot-scope="props">
                                    <div v-if="props.row.bleLamps.length >= 0" class="justify-content-center">
                                        <strong>{{ props.row.bleLamps.length }}</strong>
                                    </div>
                                    <div v-if="props.row.bleLamps.length > 0 && zoneTypeBleLamp(props.row)[0] == 0"
                                        class="justify-content-center">{{ $t("bluetooth.devices_lighting") }}</div>
                                    <div v-if="props.row.bleLamps.length > 0 && zoneTypeBleLamp(props.row)[1] == 0"
                                        class="justify-content-center">{{ $t("bluetooth.devices_emergency") }}</div>
                                    <div v-if="props.row.bleLamps.length > 0 && zoneTypeBleLamp(props.row)[0] != 0 && zoneTypeBleLamp(props.row)[1] != 0"
                                        class="justify-content-center">{{ $t("bluetooth.devices_mixed") }}</div>
                                    <div v-if="props.row.bleLamps.length == 0"  class="justify-content-center">{{ $t("bluetooth.devices") }}</div>
                                </div>

                                <!-- potenza-->
                                <div v-if="props.row.gatewayId && props.row.gatewayId!=null && props.row.gatewayId!='null'" slot="potenza" slot-scope="props">
                                    <div class="d-flex justify-content-center">
                                        {{ $t("details_lamp.lamp_actual_power") }}
                                    </div>
                                    <strong>
                                        {{ calcolaLampsPower(props.row.bleLamps) }}
                                    </strong>
                                </div>
                                <!-- energia consumata-->
                                <div v-if="props.row.gatewayId && props.row.gatewayId!=null && props.row.gatewayId!='null'" slot="energia" slot-scope="props">
                                    <div class="d-flex justify-content-center">
                                        {{ $t("details_lamp.lamp_energy") }}
                                    </div>
                                    <strong>
                                        {{ calcolaLampsEnergy(props.row.bleLamps) }}
                                    </strong>
                                </div>
                                <!-- ore di funzionamento-->
                                <div v-if="props.row.gatewayId && props.row.gatewayId!=null && props.row.gatewayId!='null'" slot="ore" slot-scope="props">
                                    <div class="d-flex justify-content-center">
                                        {{ $t("details_lamp.lamp_timeon") }}
                                    </div>
                                    <strong>
                                        {{ calcolaLampsTimeOn(props.row.bleLamps) }}
                                    </strong>
                                </div>                                
                                <!-- status -->
                                <div slot="stato" slot-scope="props">
                                    <!-- Bottone con icona cestino -->
                                    <button v-if="props.row.bleLamps.length == 0" style="background: transparent; border: none; cursor: pointer;"
                                        @click="deleteBleZone(props.row.plantId, props.row.zoneId, plantDetails.plantname)" :aria-label="$t('bluetooth.delete_empty_zone')">
                                        <i class="fas fa-trash-alt" style="font-size: 20px; color: grey" :aria-hidden="true"></i>
                                    </button>

                                    <div v-else>
                                        <div v-if="zoneErrorBleLamp(props.row) == 0">
                                            <i class="fa fa-2x fa-check check-ok"></i>
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-2x fa-exclamation-circle check-err"></i>
                                        </div>
                                    </div>
                                </div>


                                <div slot="child_row" slot-scope="props">

                                    <table class="table table-child" id="dataTableChild">
                                        <tbody>

                                            <!-- lampade bluetooth  -->
                                            <tr v-for="(bleLamp, lampindex) in props.row.bleLamps" v-bind:key="bleLamp.id"
                                                class="tr_child">

                                                <td>
                                                    <div style="display:inline-block; width: 21px"></div>
                                                </td>

                                                <td tabindex="0" style="width:80px; max-width: 80px; min-width:80px">
                                                </td>
                                                
                                                <td class="imgColumnClass">
                                                    <img v-if="bleLamp.lamp.product_image != null && bleLamp.lamp.product_image != ''"
                                                        :src="pathDeviceImages + bleLamp.lamp.product_image"
                                                        style="height:60px; width:auto;" />
                                                    <div v-else class="ml-1">
                                                        <img :src="'/img/emergency.jpg'" style="height:auto; width:80px;" />
                                                    </div>
                                                </td>

                                                <td class="descColumnClass">
                                                    <b-row class="child-table"><strong><span>{{ bleLamp.lamp.desc}}</span></strong></b-row>

                                                    <b-row class="child-table">
                                                        <strong class="float-left"><span style="font-size:smaller;"
                                                                class="pr-1">[{{lampindex + 1 }}]</span>ID:<span>{{ bleLamp.id }}</span>
                                                        </strong>
                                                    </b-row>

                                                    <b-row class="child-table">

                                                        <span>
                                                            Cod. {{ bleLamp.lamp.order_code }}
                                                        </span>

                                                        <img v-if="bleLamp.lamp.lamp_type == 'SA'" src="/img/SA.png"
                                                            class="icon-lamp-type" />
                                                        <img v-if="bleLamp.lamp.lamp_type == 'SE'" src="/img/SE.png"
                                                            class="icon-lamp-type" />

                                                    </b-row>
                                                    <b-row class="child-table" v-if="bleLamp.lamp.product_desc">
                                                        <span>{{ bleLamp.lamp.product_desc }}</span>
                                                    </b-row>
                                                    <b-row class="child-table" v-if="bleLamp.lamp.mac_address && bleLamp.lamp.mac_address.split(':').length==6">
                                                        <span class="typo-littleblack pt-1">MAC ADDRESS: {{ bleLamp.lamp.mac_address }}</span>
                                                    </b-row>

                                                    <!-- settings sdb -->    
                                                    <b-row class="child-table pt-1">
                                                        <span v-if="bleLamp.lamp.hasOwnProperty('lightSensor')">
                                                            <img  v-if="bleLamp.lamp.lightSensorPresence && bleLamp.lamp.lightSensorPresence==true && bleLamp.lamp.lightSensor.autodimmerEnabled==false" src="img/fotosensor_disable.png" style="height:15px;" />
                                                            <img  v-if="bleLamp.lamp.lightSensorPresence && bleLamp.lamp.lightSensorPresence==true && bleLamp.lamp.lightSensor.autodimmerEnabled==true" src="img/fotosensor.png" style="height:15px;" />
                                                            <span v-if="bleLamp.lamp.lightSensorPresence && bleLamp.lamp.lightSensorPresence==true && bleLamp.lamp.lightSensor.autodimmerEnabled==true && bleLamp.lamp.lightSensor.isMaster==true" style="color:#03b0f0; font-weight:400; font-size:13px;">M</span>      
                                                        </span>
                                                        <img  v-if="bleLamp.lamp.inputStatus && bleLamp.lamp.inputStatus==1" src="img/pushbutton.png" style="height:15px;" class="pl-2" /> 
                                                        <img  v-if="bleLamp.lamp.inputStatus && bleLamp.lamp.inputStatus==2" src="img/person.png" style="height:15px;" class="pl-2" /> 
                                                        <img  v-if="bleLamp.lamp.radioModulePresence && bleLamp.lamp.radioModulePresence==true" src="img/radioFM.png" style="height:15px;" class="pl-2" />    
                                                        <span v-if="bleLamp.lamp.group" class="typo-littleblue pl-2">GROUP: {{ bleLamp.lamp.group }}</span>                                                 
                                                    </b-row>

                                                    <b-row class="child-table">
                                                        <span class="pt-3">
                                                            {{ $t("report_pdf.last_sync") }} : {{ moment(new Date(bleLamp.lamp.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(bleLamp.lamp.last_sync)).format('HH:mm:ss') }}</span>
                                                        <span v-if="plantDetails.controlunits.length > 0" class="m-2">
                                                            <i class="icon__signal-strength"
                                                                v-bind:class="[RssiClass(bleLamp.lamp.rssi)]">
                                                                <span class="bar-1"></span>
                                                                <span class="bar-2"></span>
                                                                <span class="bar-3"></span>
                                                                <span class="bar-4"></span>
                                                                <span class="bar-5"></span>
                                                            </i>
                                                        </span>
                                                        <span
                                                            v-if="bleLamp.lamp.rssi != 0 && directBleVisibility(bleLamp.lamp.rssi) == true"
                                                            class="pt-3">
                                                            <i class="fa fa-1x fa-retweet" style="color:blue;"></i>
                                                        </span>
                                                    </b-row>
                                                </td>
                                                <td>
                                                    <!---slot action -->
                                                </td>
                                                <td class="dettColumnClass">
                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none"
                                                        no-caret right>
                                                        <template slot="button-content">
                                                            <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item @click="showLampDetails(props.row, bleLamp.lamp)">
                                                            {{ $t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                    </b-dropdown>
                                                </td>
                                                <td style="text-align:left">
                                                    <!-- <i class="fa fa-circle" v-bind:class="[onlineClass(props.row)]" /> {{ descrStato(props.row) }} -->
                                                </td>
                                                <td v-if="bleLamp.lamp.model == 9">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_actual_power") }}
                                                    </div>
                                                    <strong>
                                                        {{ bleLamp.lamp.istantaneousPower }} W
                                                    </strong>
                                                </td>
                                                <td v-else>
                                                    <div v-if="bleLamp.lamp.lamp_type != 'SE'"
                                                        class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_sa_dimming") }}</div>
                                                    <span>
                                                        <strong v-if="bleLamp.lamp.sa_dimming == 'SE'">
                                                            {{ bleLamp.lamp.sa_dimming }}</strong>
                                                        <strong v-else>{{ bleLamp.lamp.device_function }}</strong>
                                                    </span>
                                                </td>
                                                <td v-if="bleLamp.lamp.model == 9">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_energy") }}</div>
                                                    <strong>
                                                        {{ bleLamp.lamp.energy / 1000 }} kWh
                                                    </strong>
                                                </td>
                                                <td v-else>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_autonomy") }}</div>
                                                    <strong>
                                                        {{ bleLamp.lamp.autonomy }}
                                                    </strong>
                                                </td>
                                                <td v-if="bleLamp.lamp.model == 9">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_timeon") }}</div>
                                                    <strong>
                                                        {{ bleLamp.lamp.functionHours }}
                                                    </strong>
                                                </td>
                                                <td v-else>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_parity") }}</div>
                                                     <strong>
                                                        {{ $t("param_lamp." + bleLamp.lamp.parity).toUpperCase() }}
                                                     </strong>
                                                </td>
                                                <td>
                                                    <IconErrorLamp :lamp="bleLamp.lamp" scale="fa-2x" scalefont="2.5"></IconErrorLamp>   <!--zone bluetooth lamp desktop-->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-client-table>
                        </b-check-group>
                    </hide-at>

                    <!------------------------------------------->
                    <!-- TABELLA DISPOSITIVI BLUETOOTH MOBILE --->
                    <!------------------------------------------->
                    <show-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="small">
                        <div style="margin-top: 50px; width:100%;">
                            <!-- casella di ricerca -->
                            <b-row
                                style="position: fixed; top: 144px; left: 8px; right: 8px; z-index: 1; background-color: #eee">
                                <b-col class="my-2">
                                    <b-input-group>
                                        <b-form-input type="text" :placeholder="$t('search')" v-model="filters.search"></b-form-input>
                                        <!-- Attach Right button -->
                                        <b-input-group-append>
                                            <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i></b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <b-nav class="mobile-sub-nav"
                                style="background: #eee; padding-left: 16px; position: fixed; top: 194px; left: 8px; right: 8px; z-index: 1; "
                                v-if="$store.getters.userRole == 'installer' || $store.getters.userRole == 'collab'">
                                <!-- select all -->
                                <b-nav-text>
                                    <b-checkbox v-model="selectAllDevices" id="allSelect">{{ $t("select_checkbox.text") }}</b-checkbox>
                                </b-nav-text>
                                <!--actions-->
                                <b-dropdown id="dd-azioni-menu" right disabled>
                                    <template v-slot:button-content>
                                        <span>{{$t('command.actions') }}</span>
                                    </template>
                                </b-dropdown>
                                <!-- + add-central-unit remove-central-unit -->
                                <b-dropdown id="dd-comandi-menu" right no-caret>
                                    <template v-slot:button-content>
                                        <span>+</span>
                                    </template>
                                    <b-dropdown-item>
                                        <AddZone id="add-zone-button" :tableBtData="tableBtData"> </AddZone>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-nav>
                            <b-check-group id="righeSel" v-model="righeSel">
                                <table id="tabDispositiviSmall" class="table table-condensed">
                                    <tbody>
                                    <tr v-for="zone in tableBtData" v-bind:key="zone.zoneId">
                                        <td>
                                            <b-card no-body>
                                                <b-row>
                                                    <b-col cols="2" class="p-3">
                                                        <i class="fa fa-bluetooth fa-3x" style="height:30px; width:auto; color:blue;" />
                                                    </b-col>
                                                    <b-col cols="8" class="pt-3">
                                                        <span v-if="!editingZone"><strong>{{ zone.zoneName }}</strong></span>
                                                            <span v-if="!editingZone"><b-button @click="editNomeZone(zone)"><i class="fa fa-edit"></i></b-button></span>
                                                            <span v-if="editingZone && zone == currentZone">
                                                                <div role="group">
                                                                    <b-form-input type="text" v-model="nomeZone" :maxlength="maxchar"></b-form-input>
                                                                    <b-form-text v-html="zoneNameInfo"></b-form-text>
                                                                </div>
                                                            </span>
                                                            <span v-if="editingZone && zone == currentZone">
                                                                <b-button v-if="!updatingName" @click="saveNomeZone"><i class="fa fa-check"></i></b-button>
                                                                <b-button v-if="!updatingName" @click="abortNomeZone"><i class="fa fa-close"></i></b-button>
                                                                <span v-if="updatingName"><i class="fa fa-spinner fa-spin"></i></span>
                                                            </span>

                                                            <div><span class="dataLabels">{{ $t("bluetooth.zone_number") }}</span>
                                                                : <span class="dataValues">{{ zone.zoneNumber }}</span>
                                                            </div>
                                                    </b-col>
                                                    
                                                    <!-- v-if="zone.bleLamps.length > 0     -->
                                                    <b-col cols="1" class="pt-3">
                                                        <!-- Bottone con icona cestino -->
                                                        <button v-if="zone.bleLamps.length == 0" style="background: transparent; border: none; cursor: pointer;"
                                                            @click="deleteBleZone(zone.plantId, zone.zoneId, zone.plantname)" :aria-label="$t('bluetooth.delete_empty_zone')">
                                                            <i class="fas fa-trash-alt" style="font-size: 20px; color: grey" aria-hidden="true"></i>
                                                        </button>
                                                        <!-- <b-button v-else size="sm"><i :class="clicked ? 'fas fa-angle-down':'fas fa-angle-right'" @click="toggleCollapse(zone.zoneId)" />
                                                        </b-button> -->
                                                        <b-button v-else size="sm" @click="toggleCollapse(zone.zoneId)">
                                                            <i :class="isOpen[zone.zoneId] ? 'fas fa-angle-down':'fas fa-angle-right'"/>
                                                        </b-button>
                                                    </b-col>
                                                </b-row>

                                                <!-------------------------------------------------------->
                                                <!-------------------------------------------------------->
                                                <!-- tabella lampade bluetooth in gateway small, mobile -->
                                                <!-------------------------------------------------------->
                                                <!-------------------------------------------------------->

                                                <b-collapse :id="'collapse-' + zone.zoneId" class="mt-2">
                                                    <b-card v-for="(bleLamp, lampindex) in zone.bleLamps"
                                                        v-bind:key="bleLamp.id"
                                                        :style="{ 'display': (bleLamp['visible'] == false) ? 'none' : 'block' }"
                                                        class="lampCard" no-body>
                                                        <b-row>
                                                            <!--image-->
                                                            <b-col cols="2" class="nopadding">
                                                                <td class="imgColumnClass">
                                                                    <img v-if="bleLamp.lamp.product_image != null && bleLamp.lamp.product_image != ''"
                                                                        :src="pathDeviceImages + bleLamp.lamp.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <div v-else class="ml-1">
                                                                        <img :src="'/img/emergency.jpg'" style="height:auto; width:80px;" />
                                                                    </div>
                                                                </td>
                                                            </b-col>

                                                            <!-- lamp id, desc, order code, se/sa type-->
                                                            <b-col cols="8" class="pl-5">
                                                                <h4>{{ bleLamp.lamp.desc }}<br /></h4>
                                                                <div><span style="font-size:smaller;" class="pr-1">
                                                                        [{{ (lampindex + 1).toString() }}]</span><b>ID: {{ bleLamp.lamp.id }}</b>
                                                                    <span style="padding-left: 20px"></span>
                                                                    <img v-if="bleLamp.lamp.lamp_type == 'SA'" src="/img/SA.png"
                                                                        class="icon-lamp-type" />
                                                                    <img v-if="bleLamp.lamp.lamp_type == 'SE'" src="/img/SE.png"
                                                                        class="icon-lamp-type" />
                                                                </div>
                                                                <div class="dataLabels">Cod. {{ bleLamp.lamp.order_code }} </div>
                                                                <div class="dataLabels">{{ bleLamp.lamp.product_desc }}</div>
                                                            </b-col>

                                                            <b-col cols="1" class="nopadding">
                                                                <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none"
                                                                    no-caret right>
                                                                    <template slot="button-content">
                                                                        <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                                    </template>
                                                                    <b-dropdown-item @click="showLampDetails(zone, bleLamp.lamp)">{{ $t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                                </b-dropdown>
                                                            </b-col>
                                                        </b-row>
                                                        <div> </div>
                                                        <!-- power for ble-illum && modalità for ble-emergency-->
                                                        <b-row v-if="bleLamp.lamp.model == 9">
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_actual_power") }}
                                                            </b-col>
                                                            <b-col cols="5" class="dataValues">
                                                                {{ bleLamp.lamp.istantaneousPower }} W
                                                            </b-col>
                                                        </b-row>
                                                        <b-row v-else>
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_sa_dimming") }}
                                                            </b-col>
                                                            <b-col cols="5" class="dataValues">
                                                                {{ bleLamp.lamp.device_function }}
                                                            </b-col>
                                                        </b-row>
                                                        <!-- energy for ble-illum && autonomy for ble-emergency-->
                                                        <b-row v-if="bleLamp.lamp.model == 9">
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_energy") }}
                                                            </b-col>
                                                            <b-col cols="5" class="dataValues">
                                                                {{ bleLamp.lamp.energy / 1000 }} kWh
                                                            </b-col>
                                                        </b-row>
                                                        <b-row v-else>
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_autonomy") }}
                                                            </b-col>
                                                            <b-col cols="5" class="dataValues">
                                                                {{ bleLamp.lamp.autonomy }}
                                                            </b-col>
                                                        </b-row>
                                                        <!-- timeon for ble-illum && parity for ble-emergency-->
                                                        <b-row v-if="bleLamp.lamp.model == 9">
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_timeon") }}
                                                            </b-col>
                                                            <b-col cols="5" class="dataValues">
                                                                {{ bleLamp.lamp.functionHours }}
                                                            </b-col>
                                                        </b-row>
                                                        <b-row v-else>
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_parity") }}
                                                            </b-col>
                                                            <b-col cols="5" class="dataValues">
                                                                {{ $t("param_lamp." + bleLamp.lamp.parity).toUpperCase() }}
                                                            </b-col>
                                                        </b-row>
                                                        <!---stato-->
                                                        <b-row>
                                                            <b-col cols="4" class="dataLabels">
                                                                {{ $t("details_lamp.lamp_state") }}
                                                            </b-col>
                                                            <b-col cols="1">
                                                                <IconErrorLamp :lamp="bleLamp.lamp" scale="fa-1x" scalefont="1"></IconErrorLamp>   <!--bluetooth lamp-->
                                                            </b-col>
                                                        </b-row>
                                                        <!--rssi-->
                                                        <b-row>
                                                            <b-col cols="12" class="dataLabels">{{ $t("report_pdf.last_sync") }}
                                                                <span>
                                                                    {{ moment(new Date(bleLamp.lamp.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(bleLamp.lamp.last_sync)).format('HH:mm:ss') }}
                                                                </span>
                                                                <span class="m-2">

                                                                    <i class="icon__signal-strength" v-bind:class="[RssiClass(bleLamp.lamp.rssi)]">
                                                                        <span class="bar-1"></span>
                                                                        <span class="bar-2"></span>
                                                                        <span class="bar-3"></span>
                                                                        <span class="bar-4"></span>
                                                                        <span class="bar-5"></span>
                                                                    </i>
                                                                    <span v-if="bleLamp.lamp.rssi == 0" style="margin-left:-10px;color:red;font-weight: 900;">x</span>
                                                                </span>
                                                                <span v-if="bleLamp.lamp.rssi != 0" class="pt-3">{{ bleLamp.lamp.rssi }}</span>
                                                            </b-col>
                                                        </b-row>
                                                    </b-card>
                                                </b-collapse>
                                            </b-card>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </b-check-group>
                        </div>
                    </show-at>
                </b-col>
            </b-row>

            <!----------------------------------------------->
            <!-- TABELLA DISPOSITIVI CENTRALIZZATI DESKTOP--->
            <!----------------------------------------------->
            <b-row v-else id="table-device">
                <b-col cols="12" class="mainDataCol">
                    <!----------------------------------------------->
                    <!----------- CENTRALIZZATI DESKTOP ------------->
                    <!----------------------------------------------->
                    <hide-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="small">

                    <!-- B-CHECK-GROUP -->
                    <b-check-group id="righeSel" v-model="righeSel">
                        <!---- TABLE CENT -->
                        <v-client-table v-if="tableData.length >= 0" :columns="central_columns" :data="tableData"
                            :options="options" :theme="theme" id="dataTable2" ref="table"
                            class="table-dispo borderless text-primary styled">
                            <!--<checkbox for header (prefix column name with h__-->
                            <tr v-if="this.ruoloUtente(this.$store.getters.userId) == 'installer' || this.ruoloUtente(this.$store.getters.userId) == 'collab' || this.$store.state.user.usertype == 'admin'"
                                slot="prependBody">
                                <td></td>
                                <td colspan="100" style="text-align:left;vertical-align:middle; background:none">
                                    <div style="display: flex;align-items: center">

                                            <!-- SELECT ALL  Barra di selezione di tutti i dispositivi, creazione e selezione gruppi -->
                                            <div v-if="!advancedFilters" style="padding-left: 20px; flex-grow: 1">
                                                <div v-if="this.plantDetails.technology !== 'bluetooth'">
                                                    <b-checkbox v-if="selectedGroup == ''" @change="toggleSeleziona()"
                                                        id="allSelect" value="x" class="float-left pr-1 mt-2 mb-2">
                                                        <span class="typo-label">{{ $t("select_checkbox.text") }}</span>
                                                    </b-checkbox>
                                                    <div v-else class="float-left pr-1 mt-1 mb-2">
                                                        <div style="color:#0090CD" class="h6 float-left mt-2">
                                                            {{ $t("select_checkbox.group", { group: selectedGroup }) }}</div>
                                                    </div>
                                                    <!-- <select v-if="lampadeSel.length==0 && centraliSel.length==0 || selectedGroup!=''"  @change="filtra()" class="float-right pr-1 mt-1 mr-2 mb-2" v-model="selectedGroup" style="width:50px;">
                                                    <option v-for="group in groups" :selected="selectedGroup === group">{{ group }}</option>
                                                </select> -->
                                                    <!-- -->
                                                    <b-form-select
                                                        v-if="lampadeSel.length == 0 && centraliSel.length == 0 || selectedGroup != ''"
                                                        :options="groups" @change="filtra()"
                                                        class="float-right pr-1 mt-0 mr-2 mb-2" v-model="selectedGroup"
                                                        style="width:50px;">
                                                        <!-- <b-form-select-option v-for="group in groups" :key="group" :value="group">{{group}}</b-form-select-option> -->
                                                    </b-form-select>
                                                    <label
                                                        v-if="lampadeSel.length == 0 && centraliSel.length == 0 || selectedGroup != ''"
                                                        class="float-right typo-label pr-1 mt-2 ml-3">{{ $t("select_group.text")}}</label>

                                                    <rimuovi-gruppo
                                                        v-if="lampadeSel.length > 0 || centraliSel.length > 0 && selectedGroup == ''"
                                                        class="ml-2 float-right" :sendAction="sendGenericCommandMulti"
                                                        :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts"></rimuovi-gruppo>
                                                    <crea-gruppo
                                                        v-if="lampadeSel.length > 0 || centraliSel.length > 0 && selectedGroup == ''"
                                                        class="float-right" :sendAction="sendGenericCommandMulti"
                                                        :lamp="lampadeSel" :cu="centraliSel" :alerts="alerts"></crea-gruppo>
                                                    <b-button class="noborder-button download float-right"
                                                        @click="createPDF_Impianto()">
                                                        <i class="fas fa fa-1x fa-download mr-3"></i>
                                                        <span v-if="lampadeSel.length == 0 && centraliSel.length == 0">
                                                            {{ this.$t('report_pdf.download_all_pdf') }}</span>
                                                        <span v-if="centraliSel.length > 0 || lampadeSel.length > 0">
                                                            {{ this.$t('report_pdf.download_selected_pdf') }}</span>
                                                    </b-button>
                                                </div>
                                                <div v-else>
                                                    <b-button class="noborder-button download float-right"
                                                        @click="createPDF_ImpiantoBle()">
                                                        <i class="fas fa fa-1x fa-download mr-3"></i>
                                                        <span v-if="lampadeSel.length == 0 && centraliSel.length == 0">
                                                            {{ this.$t('report_pdf.download_all_pdf') }}</span>
                                                        <span v-if="centraliSel.length > 0 || lampadeSel.length > 0">
                                                            {{ this.$t('report_pdf.download_selected_pdf') }}</span>
                                                    </b-button>                                            
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Advanced Filters -->
                                        <b-collapse id="collapse-filter-panel" v-model="advancedFilters">
                                            <b-card header="" header-bg-variant="primary" border-variant="primary"
                                                header-text-variant="white" class="mt-2 mb-0 typo-label">

                                                <template v-slot:header>
                                                    <span>{{ _self.$t('filter.advanced') }}</span>
                                                    <b-button size="sm" variant="primary" @click="hideFilters()"
                                                        class="float-right"><i class="fa fa-close"></i></b-button>
                                                </template>

                                                <b-row>
                                                    <b-col cols="3">
                                                        <b-row>
                                                            <b-col cols="12">
                                                                <b-form-group>
                                                                    <label for="flt-idCentrale">ID Centrale</label>
                                                                    <b-form-input type="text" id="flt-idCentrale"
                                                                        v-model="filters.idCent"></b-form-input>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="12">
                                                                <b-form-group>
                                                                    <label for="flt-nomeCentrale">Nome Centrale</label>
                                                                    <b-form-input type="text" id="flt-nomeCentrale"
                                                                        v-model="filters.nomeCent"></b-form-input>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row class="mt-3">
                                                            <b-col cols="12">
                                                                <b-card class="h-100" header="Tipo Centrale" no-body>
                                                                    <b-form-checkbox-group id="flt-tipoCentrale"
                                                                        name="flt-tipoCentrale" v-model="filters.tipoCent"
                                                                        :checked="['all']" class="px-2 pt-2"
                                                                        @change="tipoCentChanged">
                                                                        <b-form-checkbox 
                                                                            value="all">Tutte</b-form-checkbox>
                                                                        <b-form-checkbox
                                                                            value="cablecom">Cablecom</b-form-checkbox>
                                                                        <b-form-checkbox
                                                                            value="logica">Logica</b-form-checkbox>
                                                                        <b-form-checkbox
                                                                            value="logicafm">LogicaFM</b-form-checkbox>
                                                                        <b-form-checkbox
                                                                            value="sicuro">Sicuro</b-form-checkbox>
                                                                    </b-form-checkbox-group>
                                                                </b-card>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>


                                                    <b-col cols="3">
                                                        <b-row>
                                                            <b-col cols="12">
                                                                <b-form-group>
                                                                    <label for="flt-idLampada">ID Lampada</label>
                                                                    <b-form-input type="text" id="flt-idLampada"
                                                                        v-model="filters.idLamp"></b-form-input>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row>
                                                            <b-col cols="12">
                                                                <b-form-group>
                                                                    <label for="flt-nomeLampada">Nome Lampada</label>
                                                                    <b-form-input type="text" id="flt-nomeLampada"
                                                                        v-model="filters.nomeLamp"></b-form-input>
                                                                </b-form-group>
                                                            </b-col>
                                                        </b-row>
                                                        <b-row class="mt-3">
                                                            <b-col cols="12">
                                                                <b-card class="h-100" header="Tipo Lampada" no-body>
                                                                    <b-form-radio-group id="flt-tipoLamp" :plain="true"
                                                                        v-model="filters.tipoLamp" :options="[
                                                                                { text: 'Tutte', value: 'all' },
                                                                                { text: 'SE', value: 'SE' },
                                                                                { text: 'SA', value: 'SA' },
                                                                                { text: 'UV-Oxy', value: 'oxy' },
                                                                                { text: 'No UV-Oxy', value: 'no-oxy' },
                                                                                { text: 'Illuminazione', value: 'illuminazione' }
                                                                            ]" checked="all" class="px-2 pt-2">
                                                                    </b-form-radio-group>
                                                                </b-card>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>

                                                    <b-col cols="6 mt-4">
                                                        <b-row>
                                                            <b-col cols="6">
                                                                <b-card class="h-100" header="Autonomia" no-body>
                                                                    <b-form-checkbox-group id="flt-autonomia"
                                                                        name="flt-autonomia" v-model="filters.autonomia"
                                                                        :checked="['all']" class="px-2 pt-2"
                                                                        @change="autonomiaChanged">

                                                                        <b-form-checkbox value="all">Tutte</b-form-checkbox>
                                                                        <b-form-checkbox value="1H">1H</b-form-checkbox>
                                                                        <b-form-checkbox value="1H5">1H5</b-form-checkbox>
                                                                        <b-form-checkbox value="2H">2H</b-form-checkbox>
                                                                        <b-form-checkbox value="3H">3H</b-form-checkbox>
                                                                        <b-form-checkbox value="8H">8H</b-form-checkbox>

                                                                    </b-form-checkbox-group>
                                                                </b-card>
                                                            </b-col>
                                                            <b-col cols="6">
                                                                <b-card class="h-100" header="Presenza rete" no-body>
                                                                    <b-form-radio-group id="flt-rete" :plain="true"
                                                                        v-model="filters.rete_se" :options="[
                                                                                { text: 'Tutte', value: 'all' },
                                                                                { text: 'Rete SE presente', value: 'SE_ON' },
                                                                                { text: 'Rete SE assente', value: 'SE_OFF' }
                                                                            ]" checked="all" class="px-2 pt-2">
                                                                    </b-form-radio-group>
                                                                </b-card>
                                                            </b-col>

                                                        </b-row>

                                                        <b-row class="mt-5 mb-3">
                                                            <b-col cols="6">
                                                                <b-card class="h-100" header="Parità" no-body>
                                                                    <b-form-radio-group id="flt-parita" :plain="true"
                                                                        v-model="filters.parita" :options="[
                                                                                { text: 'Tutte', value: 'all' },
                                                                                { text: 'Pari', value: 'PARI' },
                                                                                { text: 'Dispari', value: 'DISPARI' }
                                                                            ]" checked="all" class="px-2 pt-2">
                                                                    </b-form-radio-group>
                                                                </b-card>
                                                            </b-col>

                                                            <b-col cols="6">
                                                                <b-card class="h-100" header="Infinity Mode" no-body>
                                                                    <b-form-radio-group id="flt-infinity" :plain="true"
                                                                        v-model="filters.infinity" :options="[
                                                                                { text: 'Tutte', value: 'all' },
                                                                                { text: 'ON', value: 'ABILITATO' },
                                                                                { text: 'OFF', value: 'DISABILITATO' }
                                                                            ]" checked="all" class="px-2 pt-2">
                                                                    </b-form-radio-group>
                                                                </b-card>
                                                            </b-col>
                                                        </b-row>
                                                    </b-col>
                                                </b-row>

                                                <b-row class="mt-2">
                                                    <b-col class="text-right">
                                                        <b-button size="sm" variant="light" @click="clearFilters()"
                                                            class="mr-4"><i class="fa fa-eraser"></i>
                                                            {{ this.$t('filter.nofilter') }}</b-button>
                                                        <b-button size="sm" variant="primary" @click="filtra()"><i
                                                                class="fa fa-filter"></i>
                                                            {{ this.$t('filter.execute') }}</b-button>
                                                    </b-col>
                                                </b-row>

                                            </b-card>
                                        </b-collapse>
                                    </td>
                                    <!-- </td>
                                
                                </td>                             -->

                                </tr>

                    <!-- TABELLA CENTRALI -->
                            <!-- checkbox for each row-->
                            <div slot="check" slot-scope="props">
                                <b-checkbox :disabled="(!props.row.enabled)"
                                    @change="toggleCentCheckbox" 
                                    :value="'cent-' + (props.index - 1)"
                                    :id="'cent-' + props.row.cu_type + '-' + props.row.cu_id" />
                            </div>
                            <div slot="image" slot-scope="props">
                                <div v-if="props.row.cu_product_image">
                                    <img :src="pathDeviceImages + props.row.cu_product_image"
                                        style="height:30px; width:auto;" />
                                </div>
                                <div v-else>
                                    <img v-if="props.row.cu_type == 'logicafm'" :src="'/img/logicafmsd/centrale.png'"
                                        style="height:30px; width:auto;" />
                                    <img v-if="props.row.cu_type == 'logica'" :src="'/img/logica/centrale.png'"
                                        style="height:30px; width:auto;" />
                                    <img v-if="props.row.cu_type == 'cablecom'" :src="'/img/cablecom/centrale.png'"
                                        style="height:30px; width:auto;" />
                                    <img v-if="props.row.cu_type == 'sicuro'" :src="pathDeviceImages + 'cu_sicuro.jpg'"
                                        style="height:30px; width:auto;" />
                                    <img v-if="props.row.cu_type == 'blegateway'"
                                        :src="'/img/blegateway/bleGateway.jpg'" style="height:30px; width:auto;" />
                                </div>
                            </div>
                            <div slot="desc" slot-scope="props">
                                <b-row class="child-table"><strong><span class="sp_cent_id"
                                            v-if="props.row.cu_desc != '--'">
                                            {{props.row.cu_desc }}</span></strong></b-row>
                                <b-row class="child-table">
                                    <!-- <span v-if="props.row.cu_type === 'sicuro' && props.row.cu_product_desc!=null" class="sp_cent_id">
                                        {{props.row.cu_product_desc[0].toUpperCase() + props.row.cu_product_desc.slice(1).toLowerCase()}} {{props.row.cu_type.toLowerCase() }}</span> -->
                                    <span class="sp_cent_id">
                                        {{ props.row.cu_type != 'blegateway'? $t("central_unit"):"" }} {{ props.row.cu_type != 'blegateway'? props.row.cu_type : props.row.cu_type.toUpperCase()  }}
                                    </span> 
                                    <i v-if="props.row.cu_type != 'blegateway'"
                                        class="fa fa-1x fa-exclamation-circle ml-2"
                                        v-bind:class="[centErrorClass(props.row)]"></i>
                                    <div v-if="respCommand == 'CHECK UPGRADE OTA' && respCu == props.row.cu_id && working(props.row)"
                                        class="p-1 ml-5" style="color:orange">
                                        <i class="fa fa-1x fa-spinner fa-spin" style="color:orange"></i>
                                        {{ $t("check_for_update") }}
                                    </div>
                                    <div v-if="respCommand == 'START UPGRADE OTA' && respCu == props.row.cu_id && working(props.row)"
                                        class="p-1 ml-5" style="color:orange">
                                        <i class="fa fa-1x fa-spinner fa-spin" style="color:orange"></i>
                                        {{ $t("update_in_progress") }}
                                    </div>
                                </b-row>
                                <b-row v-if="props.row.cu_type == 'blegateway'" class="child-table">
                                    {{ $t('serialId') }}: {{ props.row.cu_id }}
                                </b-row>
                            </div>
                            <div slot="dettaglio" slot-scope="props">
                                <b-dropdown v-if="props.row.enabled" variant="link" size="lg"
                                    toggle-class="text-decoration-none" no-caret right id="dropdown-central"
                                    boundary="viewport">
                                    <!-- <template slot="button-content"> -->
                                    <template v-slot:button-content>
                                        <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                    </template>
                                    <!-- <b-dropdown-item> <central-details @click="modalCentShow=true"/>{{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item> -->
                                    <b-dropdown-item @click="showCentDetails(props.row)">
                                        {{$t("cu_table_row.dropdown_dettaglio") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.cu_type == 'blegateway'" @click="showGatewayCommand(props.row)">
                                        {{$t("gateway_command_modal.command") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="props.row.cu_type == 'blegateway'" @click="showGatewayLampsInsert(props.row)">
                                        {{$t("gateway_lamps_insert_modal.configure") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type != 'blegateway' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && !searchlampsactive(props.row)"
                                        @click="showConfigCent(props.row)" :disabled="props.row.cu_type == 'sicuro' ? true : false">
                                        {{ $t("cu_table_row.dropdown_configura") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type == 'logica' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showGroups(props.row)">{{ $t("lamp_details_modal.groups") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type == 'logicafm' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showGroups(props.row)">{{ $t("lamp_details_modal.groups") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type == 'sicuro' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showSicuroGroups(props.row)">{{ $t("lamp_details_modal.groups") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="(props.row.cu_type == 'logicafm' || props.row.cu_type == 'sicuro') && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showAdvanced(props.row)">{{ $t("lamp_details_modal.advanced") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type == 'logica' && props.row.cu_inputs && props.row.cu_relay && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showInputsRelay(props.row)">{{ $t("inputs_cu_modal.title")}}</b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showResetCu(props.row)">{{ $t("reset_cu_button.text") }}
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        v-if="props.row.cu_type != 'blegateway' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        :disabled="props.row.cu_type == 'sicuro' ? true : false"
                                        @click="esportaDescrittivi(props.row)">{{ $t("descrittivi_button.export_text")}}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type != 'blegateway' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        :disabled="props.row.cu_type == 'sicuro' ? true : false"
                                        @click="importaDescrittivi(props.row)">{{ $t("descrittivi_button.import_text")}}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.cu_type != 'blegateway' && props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                        @click="showRemoveCu(props.row)">{{ $t("remove_cu_button.text") }}
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="downloadJson(props.row)">
                                        {{ $t("downloadJson") }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                            <div slot="connesso" slot-scope="props" class="text-left">
                                <i class="fa fa-circle" v-bind:class="[onlineClass(props.row)]" />
                                {{ descrStato(props.row) }}
                            </div>
                            <div v-if="props.row.cu_type != 'blegateway'" slot="centrale" slot-scope="props"
                                class="text-center">
                                <div class="d-flex justify-content-right">{{ $t("id_cu") }}</div>
                                <strong>
                                    <div class="d-flex justify-content-right">{{ props.row.cu_id }}</div>
                                </strong>
                            </div>
                            <div v-if="(props.row.cu_type === 'sicuro') && ((props.row.cu_product_desc != null) && (!props.row.cu_product_desc.toUpperCase().includes('SUBSTATION')))" slot="tensione" slot-scope="props" class="text-center">
                                <div class="d-flex justify-content-center">{{ $t("details_cu_modal.cu_tensione") }}
                                </div>
                                <strong v-if="props.row.cu_error">
                                    <div v-if="props.row.V != null"
                                        class="d-flex justify-content-center"
                                        :class="{'battery-low': props.row.cu_error.error_battery_low === 'ON'}">
                                        {{ props.row.V }} V</div>
                                    <div v-else 
                                        :class="{'battery-low': props.row.cu_error.error_battery_low === 'ON'}"
                                        class="d-flex justify-content-center">
                                        -- V</div>
                                </strong>
                            </div>
                            <div v-if="(props.row.cu_type === 'sicuro') && ((props.row.cu_product_desc != null) && (!props.row.cu_product_desc.toUpperCase().includes('SUBSTATION')))" slot="corrente" slot-scope="props" class="text-center">
                                <div class="d-flex justify-content-center">{{ $t("details_cu_modal.cu_corrente") }}
                                </div>
                                <strong>
                                    <div v-if="props.row.I != null"
                                        class="d-flex justify-content-center">
                                        {{ props.row.I }} mA</div>
                                    <div v-else class="d-flex justify-content-center">-- mA</div>
                                </strong>
                            </div>
                            <div slot="lampade" slot-scope="props">
                                <!--- visualizza il numero delle lampade oppure attende sync della shadow -->
                                <div v-if="deviceTypeFilter() == null && props.row.num_lamp_found >= 0 && searchlampsactive(props.row) == false"
                                    class="d-flex justify-content-center">{{ $t("details_cu_modal.cu_numero_lampade") }}
                                </div>
                                <strong>
                                    <div v-if="deviceTypeFilter() == null && props.row.num_lamp_found >= 0 && searchlampsactive(props.row) == false"
                                        class="d-flex justify-content-center">{{ props.row.num_lamp_found }}</div>
                                </strong>
                                <div v-if="deviceTypeFilter() == null && props.row.cu_type != 'cablecom' && props.row.num_lamp_found >= 0 && props.row.num_lamp_present && props.row.num_lamp_present != props.row.num_lamp_found"
                                    class="justify-content-center d-inline" style="color:orangered; font-size:12px">
                                    {{ props.row.num_lamp_present }} </div>
                                <div v-if="deviceTypeFilter() == null && props.row.cu_type != 'cablecom' && props.row.num_lamp_found >= 0 && props.row.num_lamp_present && props.row.num_lamp_found != props.row.num_lamp_present"
                                    class="justify-content-center d-inline" style="color:orangered; font-size:12px">
                                    {{ $t("lamps_present") }}</div>

                                <!--numero dispositivi di emergenza-->
                                <strong>
                                    <div v-if="props.row.cu_type !== 'sicuro' && props.row.lamps && deviceTypeFilter() == 'emergenza' && props.row.lamps.length >= 0 && searchlampsactive(props.row) == false"
                                        class="d-flex justify-content-center">{{ props.row.lamps.length }}</div>
                                        <div v-if="props.row.cu_type === 'sicuro' && deviceTypeFilter() == 'emergenza'" class="d-flex justify-content-center">{{ props.row.lamps_id.length }}</div>
                                </strong>
                                <div v-if="props.row.cu_type !== 'sicuro' && props.row.lamps && deviceTypeFilter() == 'emergenza' && props.row.lamps.length >= 0 && searchlampsactive(props.row) == false"
                                    class="d-flex justify-content-center">
                                    {{ $t("details_cu_modal.cu_numero_lampade_emergenza") }}
                                </div>
                                <div v-if="props.row.cu_type === 'sicuro' && deviceTypeFilter() == 'emergenza'" class="d-flex justify-content-center">
                                    {{ $t("details_cu_modal.cu_numero_lampade_emergenza") }}
                                </div>

                                <!--numero dispositivi di illuminazione-->
                                <strong>
                                    <div v-if="props.row.lamps_illum && deviceTypeFilter() == 'illuminazione' && props.row.lamps_illum.length >= 0 && searchlampsactive(props.row) == false"
                                        class="d-flex justify-content-center">{{ props.row.lamps_illum.length }}</div>
                                </strong>
                                <div v-if="props.row.lamps_illum && deviceTypeFilter() == 'illuminazione' && props.row.lamps_illum.length >= 0 && searchlampsactive(props.row) == false"
                                    class="d-flex justify-content-center">
                                    {{ $t("details_cu_modal.cu_numero_lampade_illuminazione") }}</div>

                                <!--numero sensori-->
                                <strong>
                                    <div v-if="props.row.sensors && deviceTypeFilter() == 'sensori' && props.row.sensors.length >= 0 && searchlampsactive(props.row) == false"
                                        class="d-flex justify-content-center">{{ props.row.sensors.length }}</div>
                                </strong>
                                <div v-if="props.row.sensors && deviceTypeFilter() == 'sensori' && props.row.sensors.length >= 0 && searchlampsactive(props.row) == false"
                                    class="d-flex justify-content-center">{{ $t("details_cu_modal.cu_numero_sensori") }}
                                </div>


                                <div v-if="props.row.num_lamp_found < 0 || searchlampsactive(props.row)" class="sk-wave"
                                    style="margin:0; width:auto;height:20px">
                                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;
                                    <div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;
                                    <div class="sk-rect sk-rect5"></div>
                                    <div v-if="searchlampsactive(props.row)"><i class="fa fa-search fa-1x"
                                            style="color:blue"></i> {{ $t("searching") }} </div>
                                    <div v-else>{{ $t("wait") }} </div>
                                </div>
                            </div>

                            <!-- specifiche informazioni per ble gateway -->
                            <div v-if="props.row.cu_type == 'blegateway' && deviceTypeFilter() == 'illuminazione'" slot="potenza" slot-scope="props">
                                <div v-if="props.row.cu_type == 'blegateway'" class="d-flex justify-content-center">
                                    {{ $t("details_lamp.lamp_actual_power") }}</div>
                                <strong>
                                    <div class="d-flex justify-content-center">{{ calcolaLampsPower(props.row.lamps_illum) }}
                                    </div>
                                </strong>
                            </div>
                            <div v-if="props.row.cu_type == 'blegateway' && deviceTypeFilter() == 'illuminazione'" slot="energia" slot-scope="props">
                                <div v-if="props.row.cu_type == 'blegateway'" class="d-flex justify-content-center">
                                    {{ $t("details_lamp.lamp_energy") }}</div>
                                <strong>
                                    <div class="d-flex justify-content-center">{{ calcolaLampsEnergy(props.row.lamps_illum) }}
                                    </div>
                                </strong>
                            </div>
                            <div v-if="props.row.cu_type == 'blegateway' && deviceTypeFilter() == 'illuminazione'" slot="ore" slot-scope="props">
                                <div v-if="props.row.cu_type == 'blegateway'" class="d-flex justify-content-center">
                                    {{ $t("details_lamp.lamp_timeon") }}</div>
                                <strong>
                                    <div class="d-flex justify-content-center">{{ calcolaLampsTimeOn(props.row.lamps_illum) }}
                                    </div>
                                </strong>
                            </div>

                            <div slot="errori" slot-scope="props">
                                
                                <!--numero dispositivi di emergenza in errore-->
                                <div v-if="deviceTypeFilter() == 'emergenza' && searchlampsactive(props.row) == false && (props.row.num_lamp_present > 0 || props.row.num_lamp_found > 0)">
                                    <error-lamps-on-cent 
                                    :cent="props.row" 
                                    :errorFilter="errorFilters"
                                    :errorComFilter="errorComFilters"  
                                    :errorLedFilter="errorLedFilters"
                                    :errorHardwareFilter="errorHardwareFilters"
                                    :errorBatteryFilter="errorBatteryFilters"
                                    :errorOtherFilter="errorOtherFilters"
                                    :orphanFilter="orphanFilters" 
                                    :emergencyFilter="emergencyFilters"
                                    lampsType="emergency" ></error-lamps-on-cent>
                                </div>

                                <!--numero dispositivi di illuminazione in errore-->
                                <div v-if="deviceTypeFilter() == 'illuminazione' && searchlampsactive(props.row) == false && (props.row.num_lamp_present > 0 || props.row.num_lamp_found > 0)">
                                    <error-lamps-on-cent 
                                    :cent="props.row" 
                                    :errorFilter="errorFilters"
                                    :errorComFilter="errorComFilters"  
                                    :errorLedFilter="errorLedFilters"
                                    :errorHardwareFilter="errorHardwareFilters"
                                    :errorBatteryFilter="errorBatteryFilters"
                                    :errorOtherFilter="errorOtherFilters"
                                    :orphanFilter="orphanFilters" 
                                    :emergencyFilter="emergencyFilters"
                                    lampsType="lighting" ></error-lamps-on-cent>
                                </div>

                                <!--numero sensori in errore-->
                                <div v-if="deviceTypeFilter() == 'sensori' && searchlampsactive(props.row) == false && (props.row.num_lamp_present > 0 || props.row.num_lamp_found > 0)">
                                    <error-lamps-on-cent 
                                    :cent="props.row" 
                                    :errorFilter="errorFilters"
                                    :errorComFilter="errorComFilters"  
                                    :errorLedFilter="errorLedFilters"
                                    :errorHardwareFilter="errorHardwareFilters"
                                    :errorBatteryFilter="errorBatteryFilters"
                                    :errorOtherFilter="errorOtherFilters"
                                    :orphanFilter="orphanFilters" 
                                    :emergencyFilter="emergencyFilters"
                                    lampsType="sensor" ></error-lamps-on-cent>
                                </div>

                                <!--numero totale dipositivi in errore -->
                                <div v-if="props.row.cu_type!='sicuro' && deviceTypeFilter() == null && searchlampsactive(props.row) == false && (props.row.num_lamp_present > 0 || props.row.num_lamp_found > 0)">
                                    <error-lamps-on-cent 
                                    :cent="props.row" 
                                    :errorFilter="errorFilters"
                                    :errorComFilter="errorComFilters"  
                                    :errorLedFilter="errorLedFilters"
                                    :errorHardwareFilter="errorHardwareFilters"
                                    :errorBatteryFilter="errorBatteryFilters"
                                    :errorOtherFilter="errorOtherFilters"
                                    :orphanFilter="orphanFilters" 
                                    :emergencyFilter="emergencyFilters"
                                    lampsType="all" ></error-lamps-on-cent>
                                </div>

                        <!-- CENTRALI: errori lampade sicuro -->
                                <!-- errore gravi in primo piano -->
                                <div v-if="props.row.cu_type=='sicuro' && seriousErrorCentSicuroDesc(props.row)!=''">
                                    <span class="d-flex justify-content-center" style="color:red">
                                        <i class="fa fa-exclamation-triangle fa-2x"></i>
                                        <strong>{{seriousErrorCentSicuroDesc(props.row)}}</strong>
                                    </span>
                                </div>

                                <div v-if="(props.row.cu_type == 'sicuro') && (props.row.num_lamp_error > 0)">
                                    <strong>
                                        <div class="ml-1 d-flex justify-content-center" style="color:red">
                                            {{numeroErroriSicuro(props.row) + " " + $t("details_cu_modal.cu_lamp_error").toLowerCase()}}</div>
                                    </strong>
                                </div>

                                <div v-else-if="props.row.cu_type === 'sicuro' && erroriPresentiSicuro(props.row)" class="d-flex justify-content-center" style="color:red; font-weight:bold ">
                                    {{ $t("details_cu_modal.error") }}
                                </div>

                                <div v-else-if="(props.row.cu_type === 'sicuro') && seriousErrorCentSicuroDesc(props.row) == ''" class="d-flex justify-content-center" style="color:green;">
                                    {{ $t("details_cu_modal.cu_no_error") }}
                                </div>

                            </div>

                            <div v-if="working(props.row) && props.row.cu_connected || testactive(props.row) || waiting_first_shadow(props.row) || restmodeactive(props.row) || searchlampsactive(props.row)"
                                slot="stato" slot-scope="props">
                                <div
                                    v-if="working(props.row) && props.row.cu_connected && !searchlampsactive(props.row)">
                                    <i class="fa fa-2x fa-spinner fa-spin" style="color:grey"></i>
                                </div>
                                <div v-if="testactive(props.row)">
                                    <div><i class="fa fa-battery-three-quarters" style="color:orange"></i></div>
                                    <div class="typo-icon">{{ $t("param_lamp.TEST IN CORSO") }}</div>
                                </div>
                                <div v-if="waiting_first_shadow(props.row)">
                                    <div><i class="fa fa-2x fa-spinner fa-spin" style="color:orange"></i></div>
                                    <div class="typo-icon"> {{ $t("sync") }}</div>
                                </div>
                                <div v-if="restmodeactive(props.row)">
                                    <div><i class="fa fa-caret-square-down" style="color:orange"></i></div>
                                    <div class="typo-icon">{{ $t("param_lamp.REST MODE ACTIVATED") }}</div>
                                </div>
                                <div v-if="searchlampsactive(props.row)">
                                    <b-button variant="primary" class="typo-butt-add"
                                        @click="props.row.cu_type == 'blegateway' ? openSearchBleLamps(props.row) : reOpenConfigCent(props.row)"><i class="fa fa-1x fa-search"
                                            style="color:white"></i>
                                        {{ $t("config_cu_modal.details").toUpperCase() }}</b-button>
                                </div>
                            </div>

                            <div v-else slot="stato" slot-scope="props">
                                <IconErrorCentral 
                                    :dev="props.row" 
                                    :errorComEnabled="errorComFilters" 
                                    :errorBatteryEnabled="errorBatteryFilters"
                                    :errorHardwareEnabled="errorHardwareFilters" 
                                    :errorLedEnabled="errorLedFilters"
                                    :errorOtherEnabled="errorOtherFilters"
                                     />
                            </div>

                                <div v-if="props.row.enabled" slot="child_row" slot-scope="props">


                                    <!------------------------------------------------->
                                    <!------------------------------------------------->
                                    <!-- TABELLA LAMPADE E DISPOSITIVI DESKTOP--------->
                                    <!------------------------------------------------->
                                    <!------------------------------------------------->

                                    <!------------------------------>
                                    <!----- DISPOSITIVI SICURO ----->
                                    <!------------------------------>
                                    <div v-if="props.row.cu_type == 'sicuro'">
                            <!-- AK -->
                                        <v-client-table v-if="props.row.ak.length > 0" :columns="ak_columns"
                                            :data="filtraAkSwitchChargerVisible(props.row.ak)" :options="optionsAk" :theme="theme"
                                            id="dataTableAk" ref="tableAk" class="">
                                            <!-- checkbox for each row-->
                                            <div slot="check" slot-scope="props">
                                                <b-checkbox 
                                                    :disabled="centSicuroSelObject(props.row.cu_id)"
                                                    @change="toggleAkCheckbox" 
                                                    :value="'ak-' + centDaAk(props.row.cu_id) + '-' + props.row.index"
                                                    :id="'ak-' + centDaAk(props.row.cu_id) + '-' + props.row.index" />
                                            </div>
                                            <div slot="image" slot-scope="props">
                                                <div v-if="props.row.product_image">
                                                    <img :src="pathDeviceImages + props.row.product_image"
                                                        style="height:30px; width:auto;" />
                                                </div>
                                                <div v-else>
                                                    <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                        style="height:30px; width:auto;" />
                                                </div>
                                            </div>
                                            <div slot="desc" slot-scope="props">
                                                <div class="d-flex justify-content-left"><span style="font-size:smaller;"
                                                        class="pr-1">{{ $t("sicuro.ak_index") }} :
                                                    </span><span><strong>{{ props.row.index }}</strong></span></div>
                                                <div class="d-flex justify-content-left"><span style="font-size:smaller;"
                                                        class="pr-1">{{ $t("sicuro.ak_type") }} :
                                                    </span>
                                                    <!-- <span><strong>{{ props.row.device_type_desc }}</strong></span> -->
                                                    <span><strong>{{ props.row.product_desc }}</strong></span>
                                                </div>
                                            </div>
                                            <div slot="action" slot-scope="props">

                                        </div>
                                        <div slot="dettaglio" slot-scope="props">
                                            <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none col-2" no-caret right
                                            id="dropdown-central" boundary="viewport">
                                            <template v-slot:button-content>
                                                <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                            </template>
                                            <b-dropdown-item @click="showAkDetails(props.row,'ak')">
                                                {{ $t("cu_table_row.dropdown_dettaglio") }}
                                            </b-dropdown-item>
                                            <b-dropdown-item @click="renameLines(props.row)">
                                                {{ $t("ak.rename_lines")}}
                                            </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                        <div slot="corrente" slot-scope="props">
                                            <div class="d-flex justify-content-center">{{ $t("sicuro.i_out_real") }}</div>
                                            <strong>
                                                <div class="d-flex justify-content-center">{{ props.row.i_out }}mA
                                                </div>
                                            </strong>
                                        </div>
                                        <div slot="linee" slot-scope="props">
                                            <div class="d-flex justify-content-center">{{ $t("sicuro.num_lines") }}
                                            </div>
                                            <strong>
                                                <div class="d-flex justify-content-center">{{ props.row.num_line }}
                                                </div>
                                            </strong>
                                        </div>
                                        <div slot="lampade" slot-scope="props">
                                            <div class="d-flex justify-content-center">{{ $t("sicuro.num_lamps") }}
                                            </div>
                                            <strong>
                                                <div class="d-flex justify-content-center">{{ props.row.num_lamp_found }}
                                                </div>
                                            </strong>
                                        </div>
                                        <div slot="errori" slot-scope="props">
                                        </div>
                                        <div slot="stato" slot-scope="props">
                                            <IconErrorAkChargerSwitch :dev="props.row" tipo="ak"></IconErrorAkChargerSwitch>
                                        </div>
                                        <div slot="child_row" slot-scope="props">
                            <!-- LINE -->
                                            <v-client-table 
                                                v-if="props.row.lines.length > 0" 
                                                :columns="line_columns"
                                                :options="optionsLine" 
                                                :data="filtraLineVisible(props.row.lines)"
                                                :theme="theme" 
                                                id="dataTableLine" 
                                                ref="tableLine"
                                                class="table-dispo borderless text-primary styled ml-2"
                                            >
                                                <!-- checkbox for each row-->
                                                <div slot="check" slot-scope="props">
                                                    <b-checkbox 
                                                        :disabled="centSicuroSelObject(props.row.cu_id) || akSelObject(props.row.cu_id, props.row.ak)"           
                                                        @change="toggleLineCheckbox"
                                                        :value="'line-' + centDaAk(props.row.cu_id) + '-' + props.row.ak + '-' + props.row.index"
                                                        :id="'line-' + centDaAk(props.row.cu_id) + '-' + props.row.ak + '-' + props.row.index" />
                                                </div>
                                                <div slot="image" slot-scope="props">
                                                    <!-- <div :class="props.row.deactivated == 'ON' ? 'numberLineDeactivated' : 'numberLine'">{{ parseInt(props.row.line_num ? props.row.line_num : props.row.index) }}</div> -->
                                                    <div class='numberLine'>{{ parseInt(props.row.line_num ? props.row.line_num : props.row.index) }}</div>
                                                </div>
                                                <div slot="desc" slot-scope="props">
                                                    <div class="d-flex justify-content-right">
                                                        <strong>{{ $t("sicuro.line") }}
                                                            {{ parseInt(props.row.line_num ? props.row.line_num : props.row.index) }}</strong>
                                                        <i v-if="props.row.errore == '1'"
                                                            class="fa fa-1x fa-exclamation-circle ml-2 cent-error"></i>
                                                    </div>
                                                </div>
                                                <div slot="dettaglio" slot-scope="props">
                                                    <b-dropdown 
                                                        variant="link" 
                                                        size="lg"
                                                        toggle-class="text-decoration-none" 
                                                        no-caret 
                                                        right
                                                        id="dropdown-central" 
                                                        boundary="viewport">
                                                        <template #button-content>
                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                    style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item 
                                                            @click="showLineDetails(props.row)">
                                                            {{ $t("cu_table_row.dropdown_dettaglio")}}
                                                        </b-dropdown-item>
                                                        <b-dropdown-item
                                                            @click="showLineConfig(props.row)">
                                                            {{ $t("cu_table_row.dropdown_configura")}}
                                                        </b-dropdown-item>
                                                        <b-dropdown-item
                                                            :disabled = "props.row.num_lamp_found === 0"
                                                            @click="modificaDesc(props.row)">
                                                            {{ $t("line.modify_lamp_desc")}}
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                                <div slot="funzione" slot-scope="props">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("sicuro.function")}}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            {{ getLineFunctionLabel(props.row.line_function) }}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="linestate" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{ $t("sicuro.linestate") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            <div class=" text-left mr-2">
                                                                <i :class="['fa', 'fa-circle', props.row.deactivated === 'OFF' ? 'dot-connected' : 'dot-disconnected']" />
                                                                    {{ props.row.deactivated == 'OFF' ? $t("on") : $t("off") }}
                                                            </div>
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="acstate" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{ $t("sicuro.acstate") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.line_state === 'OFF' ? $t("off") : $t("on") }}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="corrente" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{ $t("sicuro.i_out_test") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">{{ props.row.i_out }}mA</div>
                                                    </strong>
                                                </div>
                                                <div slot="lampade" slot-scope="props">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("sicuro.num_lamps") }}</div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.num_lamp_found }}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="errori" slot-scope="props">
                                    <!--LINE: numero totale dipositivi in errore -->
                                                </div>
                                                <div slot="stato" slot-scope="props">
                                                    <IconErrorAkChargerSwitch :dev="props.row" tipo="line"></IconErrorAkChargerSwitch>
                                                </div>
                                <!-- LAMPADE EMERGENZA SICURO -->
                                                <!-- :style="{'display': (lamp['visible'] == false) ? 'none':'table-row' }" -->
                                                <div slot="child_row" slot-scope="props">
                                                    <table class="table table-child" id="dataTableChild">
                                                        <tbody>
                                                            <tr v-for="(lamp, lampindex) in props.row.lamps"
                                                                :style="{ 'display': (lamp.visible == false) ? 'none' : 'table-row' }"
                                                                :key="lamp.lamp_id" class="tr_child">
                                                                <td>
                                                                    <div style="display:inline-block; width: 21px">
                                                                    </div>
                                                                </td>
                                                                <td tabindex="0"
                                                                    style="width:80px; max-width: 80px; min-width:80px">
                                                                    <b-checkbox
                                                                        :disabled="centSicuroSelObject(lamp.cu_id) || akSelObject(lamp.cu_id, lamp.ak_index) || 
                                                                            lineSelObject(lamp.cu_id, lamp.ak_index, parseInt(lamp.ak_line))"
                                                                        :value="'lamp' + lamp.lamp_id + '-' + centDaAk(lamp.cu_id) + '-' + (lamp.ak_index) +
                                                                            '-' + (parseInt(lamp.ak_line)) + '-' + lampindex"
                                                                        :id="'lamp' + lamp.lamp_id + '-' + centDaAk(lamp.cu_id) + '-' + (lamp.ak_index) + 
                                                                            '-' + (parseInt(lamp.ak_line)) + '-' + lampindex" />
                                                                </td>
                                                                <td class="imgColumnClass">
                                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                                        :src="lamp.product_image.includes('|') ? pathDeviceImages + lamp.product_image.split('|')[0] : pathDeviceImages + lamp.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <div v-else class="ml-1">
                                                                        <img :src="pathDeviceImages + 'PLM_17210.jpg'"
                                                                            style="height:auto; width:80px;" />
                                                                    </div>
                                                                </td>
                                                                <!--  -->
                                                                <td class="descColumnClass">
                                                                    <b-row v-if="changeLampDesc[`${lamp.cu_id}_${String(Number(lamp.ak_index))}_${String(Number(lamp.ak_line))}`]" class="mb-2">
                                                                        <b-form-group 
                                                                            :label-for="'descInput' + lamp.lamp_id"
                                                                            class="pr-1">    
                                                                            <b-form-input
                                                                                v-model="newDescLamp[lamp.lamp_id]"
                                                                                :placeholder="lamp.lamp_desc"
                                                                                :maxlength="maxchar"
                                                                                :state="inputState(lamp.lamp_id)"
                                                                                class="w-100"
                                                                            />   
                                                                            <b-form-invalid-feedback v-if="inputNameInfo(lamp.lamp_id).error">
                                                                            {{ inputNameInfo(lamp.lamp_id).text }}
                                                                            </b-form-invalid-feedback>

                                                                            <b-form-text v-else>
                                                                            {{ inputNameInfo(lamp.lamp_id).text }}
                                                                            </b-form-text>

                                                                        </b-form-group>
                                                                    </b-row>
                                                                    <b-row v-else class="child-table"><strong>
                                                                        <span v-if="lamp.desc != null">{{ lamp.desc }}</span></strong>
                                                                    </b-row>
                                                                    <!-- <b-row class="child-table"><strong><span
                                                                                v-if="lamp.desc != null">{{ lamp.desc }}</span></strong></b-row> -->
                                                                    <b-row class="child-table">
                                                                        <strong class="float-left"><span
                                                                                style="font-size:smaller;"
                                                                                class="pr-1">

                                                                                <!-- [{{ lampindex + 1 }} - {{(lamp.idx).toString().padStart(3, '0')}}]-->
                                                                                    [{{ restituisciRotary(lamp).toString().padStart(3, '0') }}]
                                                                                </span>
                                                                                    ID:
                                                                                <span>
                                                                                    {{ lamp.lamp_id }} 
                                                                                </span>  
                                                                        </strong>
                                                                    </b-row>
                                                                    <b-row class="child-table">
                                                                        <span v-if="lamp.multiple_products != null"
                                                                            class="pt-2">
                                                                            Cod. {{ lamp.order_code }}
                                                                            <b-dropdown
                                                                                v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                                variant="link" size="lg"
                                                                                toggle-class="text-decoration-none"
                                                                                no-caret right>
                                                                                <template slot="button-content">
                                                                                    <span v-if="!updatingProduct"
                                                                                        :content="$t('details_lamp.lamp_info_alternative')"
                                                                                        v-tippy="{ placement: 'top', arrow: true }">
                                                                                        <b>
                                                                                            <i class="fa fa-1x fa-list"
                                                                                                style="color:primary"></i>
                                                                                        </b>
                                                                                    </span>
                                                                                    <span
                                                                                        v-if="updatingProduct && currentLamp == lamp"><i class="fa fa-spinner fa-spin"></i></span>
                                                                                </template>
                                                                                <b-dropdown-item>
                                                                                    <div class="typo-label"
                                                                                        style="text-align:center;">
                                                                                        <b>{{ $t('details_lamp.alternative_products')}}</b>
                                                                                    </div>
                                                                                </b-dropdown-item>
                                                                                <b-dropdown-item
                                                                                    v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)" :key="key">
                                                                                    <div class="typo-label"
                                                                                        v-on:click="setLampProductByUser(lamp, item)"
                                                                                        style="text-align:center">
                                                                                        {{ item }}</div>
                                                                                </b-dropdown-item>
                                                                            </b-dropdown>
                                                                        </span>
                                                                        <span v-else>
                                                                            Cod. {{ lamp.order_code }}
                                                                        </span>

                                                                       <img v-if="(lamp.lamp_type == 'SA') || (lamp.device_type == 'MANTAINED')"
                                                                            src="/img/SA.png" class="icon-lamp-type" />
                                                                        <img v-if="(lamp.lamp_type == 'SE') || (lamp.device_type == 'NOT MANTAINED')"
                                                                            src="/img/SE.png" class="icon-lamp-type" />
                                                                        <img v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'"
                                                                            src="/img/uvoxyIcon.png"
                                                                            class="icon-lamp-type" />
                                                                    </b-row>
                                                                    <b-row class="child-table"
                                                                        v-if="lamp.product_desc != null && (lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false)">
                                                                        <span v-if="lamp.product_desc.includes('|')">{{lamp.product_desc.split('|')[0]}}</span>
                                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                                    </b-row>
                                                                </td>
                                                                <td>
                                                                    <!---slot action -->
                                                                </td>
                                                                <td class="dettColumnClass">
                                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                                        <template slot="button-content">
                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                    style="color:black"></i></b>
                                                                        </template>
                                                                        <b-dropdown-item
                                                                            @click="showLampDetails(props.row, lamp)">
                                                                            {{ $t("cu_table_row.dropdown_dettaglio")}}
                                                                        </b-dropdown-item>
                                                                        <b-dropdown-item
                                                                            @click="showLampSicuroConfig(props.row, lamp)">
                                                                            {{ $t("cu_table_row.dropdown_configura")}}
                                                                        </b-dropdown-item>
                                                                        <div class="dropdown-divider"
                                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                                        </div>
                                                                        <b-dropdown-item
                                                                            @click="showLampBlink(props.row, lamp)"
                                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                                            {{ $t("cu_table_row.dropdown_blink")}}</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </td> 
                                                                <!-- mode -->
                                                                <td>
                                                                    <div class="d-flex justify-content-center">
                                                                        {{ $t("details_lamp.lamp_sa_dimming") }}</div>
                                                                    <strong>
                                                                        <div>
                                                                            {{ lamp.device_function }}
                                                                        </div>
                                                                    </strong>
                                                                </td>
                                                                <!-- groups -->
                                                                <td>
                                                                    <div class="d-flex justify-content-center">
                                                                        {{ $t("lamp_details_modal.groups") }}</div>
                                                                    <strong>
                                                                        <div v-if="lamp.groups && lamp.groups.length > 0">
                                                                            <span v-for="(grp, idx) in lamp.groups" :key="idx">
                                                                                {{ grp }}
                                                                            </span>
                                                                        </div>
                                                                        <div v-else>-</div>
                                                                    </strong>
                                                                </td>
                                                                <!-- dimmer -->
                                                                <td>
                                                                    <div class="d-flex justify-content-center">
                                                                        {{ $t("details_lamp.lamp_dimming") }}</div>
                                                                    <strong>
                                                                        <div v-if="(lamp.device_function != 'NOT MANTAINED')">
                                                                            {{ lamp.dimming * 10 }}%
                                                                        </div>
                                                                        <div v-else>-</div>
                                                                    </strong>
                                                                </td>
                                                                <!-- stato -->
                                                                <td>
                                                                    <IconErrorLamp :lamp="lamp" scale="fa-2x" scalefont="2.5"></IconErrorLamp> 
                                                                </td>
                                                            </tr>
                                                            <!-- changeLampDesc[`${props.row.cu_id}_${String(Number(props.row.ak))}_${String(Number(props.row.index))}`] -->
                                                            <tr v-if="visButton(props.row)" class="tr_child">
                                                                <td colspan="10" class="text-center">
                                                                    <b-button size="xl" variant="primary" class="mr-2"
                                                                        @click="saveNewLampDesc(props.row)">
                                                                        {{ $t("save") }}
                                                                    </b-button>
                                                                    <b-button size="xl" variant="secondary"
                                                                        @click="chiudiLampDesc(props.row)">
                                                                        {{ $t("cancel") }}
                                                                    </b-button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </v-client-table>
                                        </div>
                                        </v-client-table>
 
                        <!-- AK da ESTERNO -->
                                        <v-client-table v-if="props.row.ak_ext.length > 0" :columns="ak_columns"
                                        :data="filtraAkSwitchChargerVisible(props.row.ak_ext)" :options="optionsAk" :theme="theme"
                                        id="dataTableAk" ref="tableAk" class="">
                                        <!-- checkbox for each row-->
                                        <div slot="check" slot-scope="props">
                                            <b-checkbox 
                                                :disabled="centSicuroSelObject(props.row.cu_id)"
                                                @change="toggleAkExtCheckbox" 
                                                :value="'extak-' + centDaAk(props.row.cu_id) + '-' + props.row.index"
                                                :id="'extak-' + centDaAk(props.row.cu_id) + '-' + props.row.index" />
                                        </div>
                                        <div slot="image" slot-scope="props">
                                            <div v-if="props.row.product_image">
                                                <img :src="pathDeviceImages + props.row.product_image"
                                                    style="height:30px; width:auto;" />
                                            </div>
                                            <div v-else>
                                                <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                    style="height:30px; width:auto;" />
                                            </div>
                                        </div>
                                        <div slot="desc" slot-scope="props">
                                            <div class="d-flex justify-content-left"><span style="font-size:smaller;"
                                                    class="pr-1">{{ $t("sicuro.ak_index") }} :
                                                </span><span><strong>{{ props.row.index }}</strong></span></div>
                                            <div class="d-flex justify-content-left"><span style="font-size:smaller;"
                                                    class="pr-1">{{ $t("sicuro.ak_type") }} :
                                                </span>
                                                <!-- <span><strong>{{ props.row.device_type_desc }}</strong></span> -->
                                                <span><strong>{{ props.row.product_desc }}</strong></span>
                                            </div>
                                        </div>
                                        <div slot="action" slot-scope="props">

                                        </div>
                                        <div slot="dettaglio" slot-scope="props">
                                            <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none col-2" no-caret right
                                            id="dropdown-central" boundary="viewport">
                                                <template v-slot:button-content>
                                                    <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                </template>
                                                <b-dropdown-item @click="showAkDetails(props.row,'akext')">
                                                    {{ $t("cu_table_row.dropdown_dettaglio") }}
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="renameLines(props.row)">
                                                    {{ $t("ak.rename_lines")}}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                        <div slot="corrente" slot-scope="props">
                                            <div class="d-flex justify-content-center">{{ $t("sicuro.i_out_real") }}</div>
                                            <strong>
                                                <div class="d-flex justify-content-center">{{ props.row.i_out }} mA
                                                </div>
                                            </strong>
                                        </div>
                                        <div slot="linee" slot-scope="props">
                                            <div class="d-flex justify-content-center">{{ $t("sicuro.num_lines") }}
                                            </div>
                                            <strong>
                                                <div class="d-flex justify-content-center">{{ props.row.num_lines }}
                                                </div>
                                            </strong>
                                        </div>
                                        <div slot="lampade" slot-scope="props">
                                            <div class="d-flex justify-content-center">{{ $t("sicuro.num_lamps") }}
                                            </div>
                                            <strong>
                                                <div class="d-flex justify-content-center">{{ props.row.num_lamp_found }}
                                                </div>
                                            </strong>
                                        </div>
                                        <div slot="errori" slot-scope="props">
                                            <div v-if="(props.row.num_lamp_error > 0)">
                                                <strong>
                                                    <div class="ml-1 d-flex justify-content-center" style="color:red">
                                                        {{ props.row.num_lamp_error }}</div>
                                                </strong>
                                                <div v-if="props.row.num_lamp_error == 1"
                                                    class="ml-1 d-flex justify-content-center" style="color:red">
                                                    {{ $t("details_cu_modal.cu_error_one").toLowerCase() }}</div>
                                                <div v-else class="ml-1 d-flex justify-content-center"
                                                    style="color:red">
                                                    {{ $t("details_cu_modal.cu_error").toLowerCase() }}</div>
                                            </div>
                                            <div v-if="(props.row.num_lamp_error <= 0) && (presentiLineInError(props.row.lines))"
                                                class="ml-1 d-flex justify-content-center" style="color:red">
                                                    {{ $t("details_cu_modal.error")}}
                                            </div>
                                            <div v-if="(props.row.num_lamp_error <= 0) && (!presentiLineInError(props.row.lines))" class="d-flex justify-content-center" style="color:green">
                                                {{ $t("details_cu_modal.cu_no_error") }}
                                            </div>
                                                <!-- <div v-if="props.row.num_lamp_error <= 0"
                                                class="d-flex justify-content-center" style="color:green">
                                                {{ $t("details_cu_modal.cu_no_error") }}</div> -->
                                        </div>
                                        <div slot="stato" slot-scope="props">
                                            <IconErrorAkChargerSwitch :dev="props.row" tipo="ak"></IconErrorAkChargerSwitch>
                                            <!-- <i v-if="props.row.num_lamp_error > 0 || presentiLineInError(props.row.lines)"
                                                class="fa fa-2x fa-exclamation-circle check-err" />
                                            <i v-else class="fa fa-2x fa-check check-ok" /> -->
                                        </div>
                                        <div slot="child_row" slot-scope="props">
                            <!-- LINE da ESTERNO-->
                                            <v-client-table 
                                                v-if="props.row.lines.length > 0" 
                                                :columns="line_columns"
                                                :options="optionsLine" 
                                                :data="filtraLineVisible(props.row.lines)"
                                                :theme="theme" 
                                                id="dataTableLine" 
                                                ref="tableLine"
                                                class="table-dispo borderless text-primary styled ml-2"
                                            >
                                                <!-- checkbox for each row-->
                                                <div slot="check" slot-scope="props">
                                                    <b-checkbox 
                                                        :disabled="centSicuroSelObject(props.row.cu_id) || akextSelObject(props.row.cu_id, props.row.ak)"
                                                        @change="toggleLineExtCheckbox"
                                                        :value="'extline-' + centDaAk(props.row.cu_id) + '-' + props.row.ak + '-' + props.row.index"
                                                        :id="'extline-' + centDaAk(props.row.cu_id) + '-' + props.row.ak + '-' + props.row.index" />
                                                </div>
                                                <div slot="image" slot-scope="props">
                                                    <div class="numberLine">{{ parseInt(props.row.line_num ? props.row.line_num : props.row.index) }}</div>
                                                </div>
                                                <div slot="desc" slot-scope="props">
                                                    <div class="d-flex justify-content-right">
                                                        <strong>{{ $t("sicuro.line") }}
                                                            {{ parseInt(props.row.line_num ? props.row.line_num : props.row.index) }}</strong>
                                                        <i v-if="props.row.errore == '1'"
                                                            class="fa fa-1x fa-exclamation-circle ml-2 cent-error"></i>
                                                    </div>
                                                </div>
                                                <div slot="dettaglio" slot-scope="props">
                                                    <b-dropdown variant="link" size="lg"
                                                        toggle-class="text-decoration-none" no-caret right
                                                        id="dropdown-central" boundary="viewport">
                                                        <template #button-content>
                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                    style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item 
                                                            @click="showLineDetails(props.row)">
                                                            {{ $t("cu_table_row.dropdown_dettaglio") }}
                                                        </b-dropdown-item>
                                                        <b-dropdown-item
                                                            @click="showLineConfig(props.row)">
                                                            {{ $t("cu_table_row.dropdown_configura")}}
                                                        </b-dropdown-item>
                                                        <b-dropdown-item
                                                            :disabled = "props.row.num_lamp_found === 0"
                                                            @click="modificaDesc(props.row)">
                                                            {{ $t("line.modify_lamp_desc")}}
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </div>
                                                <div slot="corrente" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{ $t("sicuro.i_out_test") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">{{ props.row.i_out }}
                                                            mA</div>
                                                    </strong>
                                                </div>
                                                <div slot="funzione" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{$t("sicuro.function") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            {{ getLineFunctionLabel(props.row.line_function) }}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="linestate" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{ $t("sicuro.linestate") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            <div class=" text-left mr-2">
                                                                <i :class="['fa', 'fa-circle', props.row.deactivated === 'OFF' ? 'dot-connected' : 'dot-disconnected']" />
                                                                    {{ props.row.deactivated == 'OFF' ? $t("on") : $t("off") }}
                                                            </div>
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="acstate" slot-scope="props">
                                                    <div class="d-flex justify-content-center">{{ $t("sicuro.acstate") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.stato == 'OFF' ? $t("off") : $t("on") }}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="lampade" slot-scope="props">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("sicuro.num_lamps") }}</div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.num_lamp_found }}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <div slot="errori" slot-scope="props">
                                                    <div v-if="props.row.num_lamp_error > 0">
                                                        <strong>
                                                            <div class="ml-1 d-flex justify-content-center"
                                                                style="color:red">
                                                                {{ props.row.num_lamp_error }}</div>
                                                        </strong>
                                                        <div v-if="props.row.num_lamp_error == 1"
                                                            class="ml-1 d-flex justify-content-center"
                                                            style="color:red">
                                                            {{ $t("details_cu_modal.cu_error_one").toLowerCase() }}
                                                        </div>
                                                        <div v-else class="ml-1 d-flex justify-content-center"
                                                            style="color:red">
                                                            {{ $t("details_cu_modal.cu_error").toLowerCase() }}
                                                        </div>
                                                    </div>
                                                    <div v-else-if="(props.row.num_lamp_error <= 0) && ((props.row.error_ak_su_current === 'ON') || (props.row.error_line_fuse === 'ON') || (props.row.error_line_isolation === 'ON'))"
                                                        class="ml-1 d-flex justify-content-center" style="color:red">
                                                        {{ $t("details_cu_modal.error") }}
                                                    </div>
                                                    <div v-else-if="props.row.num_lamp_error <= 0 && props.row.num_lamp_found > 0"
                                                        class="d-flex justify-content-center" style="color:green">
                                                        {{ $t("details_cu_modal.cu_no_error") }}</div>
                                                </div>
                                                <div slot="stato" slot-scope="props">
                                                    <IconErrorAkChargerSwitch :dev="props.row" tipo="line"></IconErrorAkChargerSwitch>
                                                    <!-- <i class="fa fa-2x" v-bind:class="dotClassLine(props.row)" /> -->
                                                </div>
                                <!-- LAMPADE EMERGENZA SICURO da ESTERNO -->
                                                <!-- :style="{'display': (lamp['visible'] == false) ? 'none':'table-row' }" -->
                                                <div slot="child_row" slot-scope="props">
                                                    <table class="table table-child" id="dataTableChild">
                                                        <tbody>
                                                            <tr v-for="(lamp, lampindex) in props.row.lamps"
                                                                :style="{ 'display': (lamp.visible == false) ? 'none' : 'table-row' }"
                                                                :key="lamp.lamp_id" class="tr_child">
                                                                <td>
                                                                    <div style="display:inline-block; width: 21px">
                                                                    </div>
                                                                </td>
                                                                <td tabindex="0"
                                                                    style="width:80px; max-width: 80px; min-width:80px">
                                                                    <b-checkbox
                                                                        :disabled="centSicuroSelObject(lamp.cu_id)  || akextSelObject(lamp.cu_id, lamp.ak_index) ||
                                                                            lineextSelObject(lamp.cu_id, lamp.ak_index, parseInt(lamp.ak_line))"
                                                                        :value="'extlamp' + lamp.lamp_id + '-' + centDaAk(lamp.cu_id) + '-' + (lamp.ak_index) +
                                                                            '-' + (parseInt(lamp.ak_line)) + '-' + lampindex"
                                                                        :id="'extlamp' + lamp.lamp_id + '-' + centDaAk(lamp.cu_id) + '-' + (lamp.ak_index) + 
                                                                            '-' + (parseInt(lamp.ak_line)) + '-' + lampindex" />
                                                                </td>
                                                                <td class="imgColumnClass">
                                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                                        :src="lamp.product_image.includes('|') ? pathDeviceImages + lamp.product_image.split('|')[0] : pathDeviceImages + lamp.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <div v-else class="ml-1">
                                                                        <img :src="pathDeviceImages + 'PLM_17210.jpg'"
                                                                            style="height:auto; width:80px;" />
                                                                    </div>
                                                                </td>
                                                                <td class="descColumnClass">
                                                                    <b-row class="child-table"><strong><span
                                                                                v-if="lamp.desc != null">{{ lamp.desc
                                                                                }}</span></strong></b-row>
                                                                    <b-row class="child-table">

                                                                        <strong class="float-left">
                                                                            <span style="font-size:smaller;" class="pr-1">
                                                                                <!-- [{{ lampindex + 1 }} - {{ (lamp.idx).toString().padStart(3,'0') }}] -->
                                                                                [{{ restituisciRotary(lamp).toString().padStart(3, '0') }}]
                                                                            </span>
                                                                            ID:<span>{{ lamp.lamp_id }}</span>
                                                                        </strong>
                                                                    </b-row>
                                                                    <b-row class="child-table">
                                                                        <span v-if="lamp.multiple_products != null"
                                                                            class="pt-2">
                                                                            Cod. {{ lamp.order_code }}
                                                                            <b-dropdown
                                                                                v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                                variant="link" size="lg"
                                                                                toggle-class="text-decoration-none"
                                                                                no-caret right>
                                                                                <template slot="button-content">
                                                                                    <span v-if="!updatingProduct"
                                                                                        :content="$t('details_lamp.lamp_info_alternative')"
                                                                                        v-tippy="{ placement: 'top', arrow: true }">
                                                                                        <b>
                                                                                            <i class="fa fa-1x fa-list"
                                                                                                style="color:primary"></i>
                                                                                        </b>
                                                                                    </span>
                                                                                    <span
                                                                                        v-if="updatingProduct && currentLamp == lamp"><i
                                                                                            class="fa fa-spinner fa-spin"></i></span>
                                                                                </template>
                                                                                <b-dropdown-item>
                                                                                    <div class="typo-label"
                                                                                        style="text-align:center;">
                                                                                        <b>{{$t('details_lamp.alternative_products')}}</b>
                                                                                    </div>
                                                                                </b-dropdown-item>
                                                                                <b-dropdown-item
                                                                                    v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)"
                                                                                    :key="key">
                                                                                    <div class="typo-label"
                                                                                        v-on:click="setLampProductByUser(lamp, item)"
                                                                                        style="text-align:center">
                                                                                        {{ item }}</div>
                                                                                </b-dropdown-item>
                                                                            </b-dropdown>
                                                                        </span>
                                                                        <span v-else>
                                                                            Cod. {{ lamp.order_code }}
                                                                        </span>

                                                                            <!-- modifiche MASSI -->
                                                                            <img v-if="(lamp.lamp_type == 'SA') || (lamp.device_type == 'MANTAINED')"
                                                                                src="/img/SA.png" class="icon-lamp-type" />
                                                                            <img v-if="(lamp.lamp_type == 'SE') || (lamp.device_type == 'NOT MANTAINED')"
                                                                                src="/img/SE.png" class="icon-lamp-type" />
                                                                            <img v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'"
                                                                                src="/img/uvoxyIcon.png"
                                                                                class="icon-lamp-type" />
                                                                        </b-row>
                                                                        <b-row class="child-table"
                                                                            v-if="lamp.product_desc != null && (lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false)">
                                                                            <span v-if="lamp.product_desc.includes('|')">
                                                                            {{lamp.product_desc.split('|')[0]}}</span>
                                                                            <span v-else>{{ lamp.product_desc }}</span>
                                                                        </b-row>
                                                                    </td>
                                                                    <td>
                                                                        <!---slot action -->
                                                                    </td>
                                                                    <td class="dettColumnClass">
                                                                        <b-dropdown variant="link" size="lg"
                                                                            toggle-class="text-decoration-none" no-caret
                                                                            right>
                                                                            <template slot="button-content">
                                                                                <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                        style="color:black"></i></b>
                                                                            </template>
                                                                            <b-dropdown-item
                                                                                @click="showLampDetails(props.row, lamp)">
                                                                                {{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                                                            <div class="dropdown-divider"
                                                                                v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                                            </div>
                                                                            <b-dropdown-item
                                                                                @click="showLampBlink(props.row, lamp)"
                                                                                v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                                                {{ $t("cu_table_row.dropdown_blink")}}</b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </td>
                                                                    <td> <!-- mode -->
                                                                        <div class="d-flex justify-content-center">
                                                                            {{ $t("details_lamp.lamp_sa_dimming") }}</div>
                                                                        <strong>
                                                                            <div>
                                                                                {{ lamp.device_function }}
                                                                            </div>
                                                                        </strong>
                                                                    </td>
                                                                    <td><!-- stato -->
                                                                        <IconErrorLamp :lamp="lamp" scale="fa-2x" scalefont="2.5"></IconErrorLamp>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </v-client-table>
                                            </div>
                                        </v-client-table>

                                        <!-- SWITCH 11KW -->
                                        <v-client-table v-if="props.row.sw_11kw.length > 0" :columns="sicuro_device_columns"
                                            :data="filtraAkSwitchChargerVisible(props.row.sw_11kw)" :options="optionsAk" :theme="theme"
                                            id="dataTableCharger" ref="tableAk" class="">

                                            <div slot="check" slot-scope="props" style="width:20px;">
                                            </div>
                                            <div slot="image" slot-scope="props">
                                                <div v-if="props.row.product_image">
                                                    <img :src="pathDeviceImages + props.row.product_image"
                                                        style="width:30px; margin-left:15px" />
                                                </div>
                                                <div v-else>
                                                    <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                    style="width:30px; margin-left:15px" />
                                                </div>
                                            </div>
                                            <div slot="desc" slot-scope="props" style="width:120px;">
                                                <div class="d-flex justify-content-left"><span style="font-size:smaller;"
                                                        class="pr-1">{{ $t("sicuro.sw11kw_index") }} :
                                                    </span><span><strong>{{ props.row.index }}</strong></span></div>
                                            </div>
                                            <div slot="action" slot-scope="props"></div>
                                            <div slot="dettaglio" slot-scope="props">
                                                <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none col-2" no-caret right
                                                id="dropdown-central" boundary="viewport">
                                                <template v-slot:button-content>
                                                    <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                </template>
                                                <b-dropdown-item @click="showAkDetails(props.row,'sw11kw')">
                                                    {{ $t("cu_table_row.dropdown_dettaglio") }}
                                                </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                            <div slot="param1" slot-scope="props" style="width:120px;">
                                                <div>{{ $t("details_switch.serialid")}}</div>
                                                <div><strong>{{ props.row.serial_ID }}</strong></div>
                                            </div>  
                                            <div slot="param2" slot-scope="props" style="width:120px;">
                                                <div>{{ $t("details_switch.state")}}</div>
                                                <div><strong>{{ props.row.switch_state }}</strong></div>
                                            </div>
                                            <div slot="param3" slot-scope="props" style="width:120px;"></div>
                                            <div slot="errori" slot-scope="props">
                                                <!-- <div v-if="erroriSwitch11kw(props.row)"> -->
                                                <div v-if="props.row.error_com_cpu_switch11kw == 'ON'">   
                                                    <strong>
                                                        <div class="ml-1 d-flex justify-content-center" style="color:red">
                                                            {{ $t("details_cu_modal.cu_error") }}</div>
                                                    </strong>
                                                </div>
                                                <div v-else class="d-flex justify-content-center" style="color:green">
                                                    {{ $t("details_cu_modal.cu_no_error") }}</div>
                                            </div>    
                                            <div slot="stato" slot-scope="props">
                                                <IconErrorAkChargerSwitch :dev="props.row" tipo="switch11kw"></IconErrorAkChargerSwitch>
                                            </div>
                                        </v-client-table>

                                        
                                        <!-- CHARGER -->
                                        <v-client-table v-if="props.row.charger.length > 0" :columns="sicuro_device_columns"
                                            :data="filtraAkSwitchChargerVisible(props.row.charger)" :options="optionsAk" :theme="theme"
                                            id="dataTableCharger" ref="tableAk" class="">

                                            <div slot="check" slot-scope="props" style="width:20px;">
                                            </div>
                                            <div slot="image" slot-scope="props">
                                                <div v-if="props.row.product_image">
                                                    <img :src="pathDeviceImages + props.row.product_image"
                                                        style="width:30px; margin-left:15px" />
                                                </div>
                                                <div v-else>
                                                    <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                    style="width:30px; margin-left:15px" />
                                                </div>
                                            </div>
                                            <div slot="desc" slot-scope="props" style="width:120px;">
                                                <div class="d-flex justify-content-left"><span style="font-size:smaller;"
                                                        class="pr-1">{{ $t("sicuro.charger_index") }} :
                                                    </span><span><strong>{{ props.row.index }}</strong></span></div>
                                            </div>
                                            <div slot="action" slot-scope="props"></div>
                                            <div slot="dettaglio" slot-scope="props">
                                                <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none col-2" no-caret right
                                                id="dropdown-central" boundary="viewport">
                                                <template v-slot:button-content>
                                                    <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                </template>
                                                <b-dropdown-item @click="showChargerDetails(props.row)">
                                                    {{ $t("cu_table_row.dropdown_dettaglio") }}
                                                </b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                            <div slot="param1" slot-scope="props" style="width:120px;">
                                                <div>{{ $t("charger.i_out") }}</div>
                                                <div><strong>{{ props.row.charger_I }}mA</strong></div>
                                            </div>
                                            <div slot="param2" slot-scope="props" style="width:120px;">
                                                <div>{{ $t("charger.v_out") }}</div>
                                                <div><strong>{{ props.row.charger_V }}V</strong></div>
                                            </div>
                                            <div slot="param3" slot-scope="props" style="width:120px;">
                                                <div>{{ $t("charger.temp")}}</div>
                                                <div><strong>{{ props.row.charger_Temp/10 }}°C</strong></div>
                                            </div>
                                            <div slot="errori" slot-scope="props">
                                                <div v-if="erroriCharger(props.row)">
                                                    <strong>
                                                        <div class="ml-1 d-flex justify-content-center" style="color:red">
                                                            {{ $t("details_cu_modal.cu_error") }}</div>
                                                    </strong>
                                                </div>
                                                <div v-else class="d-flex justify-content-center" style="color:green">
                                                    {{ $t("details_cu_modal.cu_no_error") }}</div>
                                            </div>    
                                            <div slot="stato" slot-scope="props">
                                                <IconErrorAkChargerSwitch :dev="props.row" tipo="charger"></IconErrorAkChargerSwitch>
                                            </div>


                                        </v-client-table>

                                        <!-- LSSA -->
                                        <LssaDisplay 
                                            :lssa_array="props.row.lssa"
                                            :editingLssa="editingLssa"
                                            :updatingName="updatingName"
                                            :sendConfig="sendConfigLssaSicuroCommand"
                                            :sendDesc="sendDescLssaSicuroCommand"
                                            @editing-lssa="handleEditingLssa"
                                            @updating-lssa="handleUpdating"
                                        />


                                    </div>

                                    <!------------------------------------------------------>
                                    <!----- DISPOSITIVI CABLECOM/LOGICA/FM/GATEWAYBLE ------>
                                    <!------------------------------------------------------>
                                    <table v-else class="table table-child" id="dataTableChild">

                                        <tbody
                                            v-if="props.row.cu_status.search_lamp == 'OFF'">

                                            <!-- lampade illuminazione -->
                                            <tr v-for="(lamp, lampindex) in props.row.lamps_illum" v-bind:key="lamp.id"
                                                class="tr_child"
                                                :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'table-row' }">
                                                <td>
                                                    <div style="display:inline-block; width: 21px"></div>
                                                </td>
                                                <td tabindex="0" style="width:80px; max-width: 80px; min-width:80px">
                                                    <b-checkbox
                                                        :disabled="!props.row.enabled || centSelObject(props.row) == true || selectedGroup != ''"
                                                        :value="'lampIll' + lamp.id + '-' + (props.index - 1) + '-' + lampindex"
                                                        :id="'lampIll' + lamp.id + '-' + (props.index - 1) + '-' + lampindex" />
                                                </td>
                                                <td class="imgColumnClass">
                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                        :src="pathDeviceImages + lamp.product_image"
                                                        style="height:60px; width:auto;" />
                                                    <div v-else class="ml-1">
                                                        <img :src="'/img/luminary.jpg'" style="height:auto; width:80px;" />
                                                    </div>
                                                </td>
                                                <td class="descColumnClass">
                                                    <b-row class="child-table"><strong><span v-if="lamp.desc != null">
                                                    {{lamp.desc }}</span></strong></b-row>
                                                    <b-row class="child-table">
                                                        <strong class="float-left"><span style="font-size:smaller;" class="pr-1">
                                                                [{{lampindex + 1 }} - {{ props.row.cu_type!='blegateway'? (lamp.index + 1).toString().padStart(3, '0'):props.row.num_lamp_present}}]</span>
                                                            ID:<span>{{ lamp.id }}</span>
                                                            <span v-if="!lamp.nodo_orfano && lamp.nodo_orfano != null"><i
                                                                    class="fa fa-x2 fa-rss ml-2"
                                                                    style="color:green"></i></span>
                                                        </strong>
                                                    </b-row>
                                                    <b-row class="child-table">
                                                        <div v-if="lamp.nodo_orfano == false || lamp.nodo_orfano == null">

                                                            <span
                                                                v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                v-bind:class="[setByUser(lamp.product_rev)]">

                                                                <span v-if="lamp.multiple_products != null">
                                                                    Cod. {{ lamp.order_code }}
                                                                </span>

                                                                <b-dropdown
                                                                    v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                    variant="link" size="lg"
                                                                    toggle-class="text-decoration-none" no-caret right>
                                                                    <template slot="button-content">
                                                                        <span v-if="!updatingProduct"
                                                                            :content="$t('details_lamp.lamp_info_alternative')"
                                                                            v-tippy="{ placement: 'top', arrow: true }">
                                                                            <b>
                                                                                <i class="fa fa-1x fa-list"
                                                                                    style="color:primary"></i>
                                                                            </b>
                                                                        </span>
                                                                        <span
                                                                            v-if="updatingProduct && currentLamp == lamp"><i
                                                                                class="fa fa-spinner fa-spin"></i></span>
                                                                    </template>
                                                                    <b-dropdown-item>
                                                                        <div class="typo-label" style="text-align:center;">
                                                                            <b>{{ $t('details_lamp.alternative_products')}}</b>
                                                                        </div>
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item
                                                                        v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)"
                                                                        :key="key">
                                                                        <div class="typo-label"
                                                                            v-on:click="setLampProductByUser(lamp, item)"
                                                                            style="text-align:center">{{ item }}</div>
                                                                    </b-dropdown-item>
                                                                </b-dropdown>

                                                            </span>

                                                            <span v-else>
                                                                Cod. {{ lamp.order_code }}
                                                            </span>

                                                            <img v-if="lamp.lamp_type == 'SA'" src="/img/SA.png"
                                                                class="icon-lamp-type" />
                                                            <img v-if="lamp.lamp_type == 'SE'" src="/img/SE.png"
                                                                class="icon-lamp-type" />
                                                            <img v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'"
                                                                src="/img/uvoxyIcon.png" class="icon-lamp-type" />
                                                        </div>

                                                    </b-row>
                                                    <b-row class="child-table"
                                                        v-if="lamp.product_desc != null && (lamp.nodo_orfano == false || lamp.nodo_orfano==null)">
                                                        <span v-if="lamp.product_desc.includes('|')">
                                                            {{ lamp.product_desc.split('|')[0] }}</span>
                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                    </b-row>

                                                     <div class="d-flex justify-content-center"
                                                            :content="zonaLampadaDesc(lamp)" 
                                                            v-tippy="{ placement: 'top', arrow: true }">
                                                            {{ zonaLampada(lamp) }}</div>

                                                    <!-- settings for ble ordinary lamps -->    
                                                    <b-row class="child-table pt-1">
                                                        <span v-if="lamp.hasOwnProperty('lightSensor')">
                                                            <img :content="$t('details_lamp.dimmer_auto')+' '+$t('details_lamp.dimmer_disable')" v-tippy="{ placement: 'top', arrow: true }" v-if="lamp.lightSensorPresence && lamp.lightSensorPresence==true && lamp.lightSensor.autodimmerEnabled==false" src="img/fotosensor_disable.png" style="height:15px;" />
                                                            <img :content="lamp.lightSensor.isMaster==true?$t('details_lamp.dimmer_auto')+' '+$t('details_lamp.dimmer_master'):$t('details_lamp.dimmer_auto')" v-tippy="{ placement: 'top', arrow: true }" v-if="lamp.lightSensorPresence && lamp.lightSensorPresence==true && lamp.lightSensor.autodimmerEnabled==true" src="img/fotosensor.png" style="height:15px;" />
                                                            <span v-if="lamp.lightSensorPresence && lamp.lightSensorPresence==true && lamp.lightSensor.autodimmerEnabled==true && lamp.lightSensor.isMaster==true" style="color:#03b0f0; font-weight:400; font-size:13px;">M</span>      
                                                        </span>
                                                        <img :content="$t('details_lamp.input_config_button')" v-tippy="{ placement: 'top', arrow: true }" v-if="lamp.inputStatus && lamp.inputStatus==1" src="img/pushbutton.png" style="height:15px;" class="pl-2" /> 
                                                        <img :content="$t('details_lamp.input_config_sensor')" v-tippy="{ placement: 'top', arrow: true }" v-if="lamp.inputStatus && lamp.inputStatus==2" src="img/person.png" style="height:15px;" class="pl-2" /> 
                                                        <img :content="$t('details_lamp.radio_module_presence')" v-tippy="{ placement: 'top', arrow: true }" v-if="lamp.radioModulePresence && lamp.radioModulePresence==true" src="img/radioFM.png" style="height:15px;" class="pl-2" />    
                                                        <span v-if="lamp.group" class="typo-littleblue pl-2">GROUP: {{ lamp.group }}</span>                                                 
                                                    </b-row>

                                                    <!-- signal strength for ble ordinary lamps-->
                                                    <b-row v-if="props.row.cu_type=='blegateway'" class="child-table">
                                                        
                                                        <span class="pt-2" style="text-align: left;">
                                                            {{$t("report_pdf.last_sync")}} <br> {{ moment(new Date(lamp.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(lamp.last_sync)).format('HH:mm:ss') }}
                                                        </span>
                                                        <span class="ml-2 mt-3">  
                                                            <i class="icon__signal-strength"
                                                                v-bind:class="[RssiClass(lamp.rssi)]">
                                                                <span class="bar-1"></span>
                                                                <span class="bar-2"></span>
                                                                <span class="bar-3"></span>
                                                                <span class="bar-4"></span>
                                                                <span class="bar-5"></span>
                                                            </i>
                                                            <span v-if="lamp.rssi == 0"
                                                                style="margin-left:-10px;color:red;font-weight: 900;">x</span>
                                                        </span>
                                                        <span
                                                            v-if="lamp.rssi != 0 && directBleVisibility(lamp.rssi) == false"
                                                            class="pt-3 mt-2 ml-1">{{ lamp.rssi }}</span>
                                                        <span
                                                            v-if="lamp.rssi != 0 && directBleVisibility(lamp.rssi) == true"
                                                            class="pt-3 mt-2 ml-1">
                                                            {{ lamp.rssi.replaceAll('*', '-') }}
                                                            <i class="fa fa-1x fa-retweet" style="color:blue;"></i>
                                                        </span>
                                                  
                                                    </b-row>
                                                </td>
                                                <td>
                                                    <!---slot action -->
                                                </td>
                                                <td class="dettColumnClass">
                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none"
                                                        no-caret right>
                                                        <template slot="button-content">
                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                    style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item @click="showLampDetails(props.row, lamp)">
                                                            {{ $t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                        <div class="dropdown-divider"
                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                        </div>
                                                        <b-dropdown-item @click="showLampBlink(props.row, lamp)"
                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                            {{ $t("cu_table_row.dropdown_blink") }}</b-dropdown-item>
                                                        <div class="dropdown-divider" v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type!='logica'"></div>
                                                            <b-dropdown-item @click="showAddToMonitoringZone(lamp)" v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') ">{{$t("add_to_monitoring_zone.button_add_to_zone")}}</b-dropdown-item>
                                                            </b-dropdown>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_actual_power") }}</div>
                                                    <strong v-if="lamp.nodo_orfano == false || lamp.nodo_orfano==null">
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.cu_type=='blegateway'? (parseFloat(lamp.istantaneousPower).toFixed(1) + " W") : (parseFloat(lamp.potenza_attuale).toFixed(1) + " W") }}</div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div class="d-flex justify-content-center">--</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_energy") }}
                                                    </div>
                                                    <strong v-if="lamp.nodo_orfano == false || lamp.nodo_orfano==null">
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.cu_type=='blegateway'? ((parseFloat(lamp.energy) / 1000).toFixed(1) + "kWh") :  ((parseFloat(lamp.energia_consumata) / 1000).toFixed(1) + "kWh") }}
                                                        </div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div class="d-flex justify-content-center">--</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_timeon") }}
                                                    </div>
                                                    <strong v-if="lamp.nodo_orfano == false || lamp.nodo_orfano==null">
                                                        <div class="d-flex justify-content-center">
                                                            {{ props.row.cu_type=='blegateway'? (parseFloat(lamp.functionHours).toFixed(0)):(parseFloat(lamp.TimeOn)).toFixed(0) }}</div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div class="d-flex justify-content-center">--</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.monitoring_zone") }}
                                                    </div>
                                                    <strong v-if="zonaLampada(lamp) != null">
                                                        <div class="d-flex justify-content-center"
                                                            :content="zonaLampadaDesc(lamp)" 
                                                            v-tippy="{ placement: 'top', arrow: true }">
                                                            {{ zonaLampada(lamp) }}</div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div class="d-flex justify-content-center">--</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <IconErrorLamp :lamp="lamp" scale="fa-2x" scalefont="2.5"></IconErrorLamp>
                                                </td>
                                            </tr>


                                            <!-- lampade emergenza -->
                                            <tr v-for="(lamp, lampindex) in props.row.lamps" v-bind:key="lamp.id"
                                                class="tr_child"
                                                :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'table-row' }">
                                                <td>
                                                    <div style="display:inline-block; width: 21px"></div>
                                                </td>
                                                <td tabindex="0" style="width:80px; max-width: 80px; min-width:80px">
                                                    <b-checkbox
                                                        :disabled="!props.row.enabled || centSelObject(props.row) == true || selectedGroup != ''"
                                                        :value="'lamp' + lamp.id + '-' + (props.index - 1) + '-' + lampindex"
                                                        :id="'lamp' + lamp.id + '-' + (props.index - 1) + '-' + lampindex" />
                                                </td>
                                                <td class="imgColumnClass">
                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                        :src="lamp.product_image.includes('|') ? pathDeviceImages + lamp.product_image.split('|')[0] : pathDeviceImages + lamp.product_image"
                                                        style="height:60px; width:auto;" />
                                                    <div v-else class="ml-1">
                                                        <img :src="'/img/emergency.jpg'" style="height:auto; width:80px;" />
                                                    </div>
                                                </td>
                                                <td class="descColumnClass">
                                                    <b-row class="child-table"><strong><span v-if="lamp.desc != null">
                                                    {{lamp.desc}}</span></strong></b-row>
                                                    <b-row class="child-table">
                                                        <strong class="float-left"><span style="font-size:smaller;"
                                                                class="pr-1">
                                                                [{{devicesType == null? (props.row.lamps_illum.length + lampindex + 1) : lampindex + 1 }} - {{ props.row.cu_type!='blegateway'? (lamp.index + 1).toString().padStart(3, '0'):props.row.num_lamp_present}}]</span>
                                                            ID:<span>{{ lamp.id }}</span>
                                                            <span v-if="!lamp.nodo_orfano && lamp.nodo_orfano != null"><i
                                                                    class="fa fa-x2 fa-rss ml-2"
                                                                    style="color:green"></i></span>
                                                        </strong>

                                                    </b-row>
                                                    <b-row class="child-table">
                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false">

                                                            <span
                                                                v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                v-bind:class="[setByUser(lamp.product_rev)]">

                                                                <span v-if="lamp.multiple_products != null">
                                                                    Cod. {{ lamp.order_code }}
                                                                </span>

                                                                <b-dropdown
                                                                    v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                    variant="link" size="lg"
                                                                    toggle-class="text-decoration-none" no-caret right>
                                                                    <template slot="button-content">
                                                                        <span v-if="!updatingProduct"
                                                                            :content="$t('details_lamp.lamp_info_alternative')"
                                                                            v-tippy="{ placement: 'top', arrow: true }">
                                                                            <b>
                                                                                <i class="fa fa-1x fa-list"
                                                                                    style="color:primary"></i>
                                                                            </b>
                                                                        </span>
                                                                        <span
                                                                            v-if="updatingProduct && currentLamp == lamp">
                                                                            <i class="fa fa-spinner fa-spin"></i></span>
                                                                    </template>
                                                                    <b-dropdown-item>
                                                                        <div class="typo-label" style="text-align:center;">
                                                                            <b>{{ $t('details_lamp.alternative_products')}}</b>
                                                                        </div>
                                                                    </b-dropdown-item>
                                                                    <b-dropdown-item
                                                                        v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)"
                                                                        :key="key">
                                                                        <div class="typo-label"
                                                                            v-on:click="setLampProductByUser(lamp, item)"
                                                                            style="text-align:center">{{ item }}</div>
                                                                    </b-dropdown-item>
                                                                </b-dropdown>

                                                            </span>

                                                            <span v-else>
                                                                Cod. {{ lamp.order_code }}
                                                            </span>

                                                            <img v-if="lamp.lamp_type == 'SA'" src="/img/SA.png"
                                                                class="icon-lamp-type" />
                                                            <img v-if="lamp.lamp_type == 'SE'" src="/img/SE.png"
                                                                class="icon-lamp-type" />
                                                            <img v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'"
                                                                src="/img/uvoxyIcon.png" class="icon-lamp-type" />
                                                        </div>

                                                    </b-row>
                                                    <b-row class="child-table"
                                                        v-if="lamp.product_desc != null && (lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false)">
                                                        <span v-if="lamp.product_desc.includes('|')">{{lamp.product_desc.split('|')[0]}}</span>
                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                    </b-row>
                                                    
                                                    <!-- signal strength for ble emergency lamps-->
                                                    <b-row v-if="props.row.cu_type=='blegateway'" class="child-table">
                                                        
                                                        <span class="pt-2" style="text-align: left;">
                                                            {{$t("report_pdf.last_sync")}} <br> {{ moment(new Date(lamp.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(lamp.last_sync)).format('HH:mm:ss') }}
                                                        </span>
                                                        <span class="ml-2 mt-3">  
                                                            <i class="icon__signal-strength"
                                                                v-bind:class="[RssiClass(lamp.rssi)]">
                                                                <span class="bar-1"></span>
                                                                <span class="bar-2"></span>
                                                                <span class="bar-3"></span>
                                                                <span class="bar-4"></span>
                                                                <span class="bar-5"></span>
                                                            </i>
                                                            <span v-if="lamp.rssi == 0"
                                                                style="margin-left:-10px;color:red;font-weight: 900;">x</span>
                                                        </span>
                                                        <span
                                                            v-if="lamp.rssi != 0 && directBleVisibility(lamp.rssi) == false"
                                                            class="pt-3 mt-2 ml-1">{{ lamp.rssi }}</span>
                                                        <span
                                                            v-if="lamp.rssi != 0 && directBleVisibility(lamp.rssi) == true"
                                                            class="pt-3 mt-2 ml-1">
                                                            {{ lamp.rssi.replaceAll('*', '-') }}
                                                            <i class="fa fa-1x fa-retweet" style="color:blue;"></i>
                                                        </span>
                                                  
                                                    </b-row>
                                                </td>
                                                <td>
                                                    <!---slot action -->
                                                </td>
                                                <td class="dettColumnClass">
                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none"
                                                        no-caret right>
                                                        <template slot="button-content">
                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                    style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item @click="showLampDetails(props.row, lamp)">
                                                        {{$t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                        <div class="dropdown-divider"
                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                        </div>
                                                        <b-dropdown-item @click="showLampBlink(props.row, lamp)"
                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                            {{ $t("cu_table_row.dropdown_blink") }}</b-dropdown-item>
                                                    </b-dropdown>
                                                </td>
                                                <td style="text-align:left">
                                                    <!-- <i class="fa fa-circle" v-bind:class="[onlineClass(props.row)]" /> {{ descrStato(props.row) }} -->
                                                </td>
                                                <td>
                                                    <div v-if="lamp.lamp_type != 'SE'"
                                                        class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_sa_dimming") }}</div>
                                                    <strong v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false">
                                                        <div v-if="lamp.lamp_type != 'SE' && lamp.shadow_pending"
                                                            v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('sa_dimming'))]">
                                                            {{ lamp.sa_dimming }}
                                                            <i v-if="lamp.sa_dimming != 'SE' && lamp.sa_presence == 'SA PRESENTE'"
                                                                class="fas fa-lightbulb" style="color:gold"></i>
                                                            <i v-if="lamp.sa_dimming != 'SE' && lamp.sa_presence == 'SA NON PRESENTE'"
                                                                class="far fa-lightbulb" style="color:black"></i>
                                                        </div>
                                                        <div v-if="lamp.lamp_type != 'SE' && !lamp.shadow_pending">

                                                            {{ lamp.cu_type == "bluetooth"? (lamp.device_function?$t("param_lamp." + lamp.device_function):'--'):lamp.sa_dimming }}
                                                            
                                                            <i v-if="lamp.sa_dimming != 'SE' && (lamp.sa_presence && lamp.sa_presence == 'SA PRESENTE' || lamp.sa_presence==true)"
                                                                class="fas fa-lightbulb" style="color:gold"></i>
                                                            <i v-if="lamp.sa_dimming != 'SE' && (lamp.sa_presence && lamp.sa_presence == 'SA NON PRESENTE' || lamp.sa_presence==false)"
                                                                class="far fa-lightbulb" style="color:black"></i>
                                                        </div>
                                                    </strong>
                                                    <span v-else>
                                                        --
                                                    </span>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_autonomy") }}
                                                    </div>
                                                    <strong v-if="lamp.shadow_pending"
                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('autonomy'))]">
                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false"
                                                            class="d-flex justify-content-center">
                                                            {{ lamp.autonomy }}
                                                        </div>
                                                        <div v-else>
                                                            --
                                                        </div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div v-if="(lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false) && lamp.autonomy"
                                                            class="d-flex justify-content-center">
                                                            {{ lamp.autonomy }}
                                                        </div>
                                                        <div v-else>
                                                            --
                                                        </div>
                                                    </strong>

                                                </td>
                                                <td
                                                    v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_sanifica") }}
                                                    </div>
                                                    <strong v-if="lamp.shadow_pending"
                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('tuboUV_fase_sanifica'))]">
                                                        <div class="d-flex justify-content-center">
                                                            {{ lamp.tuboUV_fase_sanifica.toUpperCase() }}
                                                        </div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div class="d-flex justify-content-center">
                                                            {{ lamp.tuboUV_fase_sanifica.toUpperCase() }}
                                                        </div>
                                                    </strong>
                                                </td>
                                                <td v-else>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_parity") }}
                                                    </div>
                                                    <strong v-if="lamp.shadow_pending"
                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('parity'))]">
                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false"
                                                            class="d-flex justify-content-center">
                                                            <!-- {{ $t("param_lamp." + lamp.parity ? lamp.parity: '--').toUpperCase() }} -->
                                                              {{ $t("param_lamp." + (lamp.parity ? lamp.parity: '--')).toUpperCase() }}
                                                        </div>
                                                        <div v-else>
                                                            --
                                                        </div>
                                                    </strong>
                                                    <strong v-else>
                                                        <div v-if="(lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false) && lamp.parity"
                                                            class="d-flex justify-content-center">
                                                            <!-- {{ $t("param_lamp." + lamp.parity ? lamp.parity: '--').toUpperCase() }} -->
                                                                {{ $t("param_lamp." + (lamp.parity ? lamp.parity: '--')).toUpperCase() }}
                                                        </div>
                                                        <div v-else>
                                                            --
                                                        </div>
                                                    </strong>
                                                </td>
                                                <td v-if="lamp.lssa && props.row.cu_type.startsWith('cablecom')">
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.lamp_infinity") }}
                                                    </div>
                                                    <strong v-if="lamp.shadow_pending"
                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('lssa'))]">
                                                        <div class="d-flex justify-content-center">{{ $t("param_lamp." + lamp.lssa).toUpperCase() }}</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <IconErrorLamp :lamp="lamp" scale="fa-2x" scalefont="2.5"></IconErrorLamp>    <!-- error lampade emergenza centralizzate desktop view-->
                                                    <IconEmergencyOn :lamp="lamp" scale="2.5"></IconEmergencyOn> <!-- emergency lampade emergenza centralizzate desktop view-->
                                                </td>
                                            </tr>


                                            <!-- sensori -->
                                            <tr v-for="(lamp, lampindex) in props.row.sensors" v-bind:key="lamp.id"
                                                class="tr_child"
                                                :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'table-row' }">
                                                <td>
                                                    <div style="display:inline-block; width: 21px"></div>
                                                </td>
                                                <td tabindex="0" style="width:80px; max-width: 80px; min-width:80px">
                                                    <b-checkbox
                                                        :disabled="!props.row.enabled || centSelObject(props.row) == true || selectedGroup != ''"
                                                        :value="'sensor' + lamp.id + '-' + (props.index - 1) + '-' + lampindex"
                                                        :id="'sensor' + lamp.id + '-' + (props.index - 1) + '-' + lampindex" />
                                                </td>
                                                <td class="imgColumnClass">
                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                        :src="pathDeviceImages + lamp.product_image"
                                                        style="height:60px; width:auto;" />
                                                    <div v-else class="ml-1">
                                                        <img :src="'/img/sensor.png'" />
                                                    </div>
                                                </td>
                                                <td class="descColumnClass">
                                                    <b-row class="child-table"><strong><span v-if="lamp.desc != null">
                                                                {{ lamp.desc }}</span></strong></b-row>
                                                    <b-row class="child-table">
                                                        <strong class="float-left"><span style="font-size:smaller;"
                                                                class="pr-1">
                                                                [{{devicesType == null ? (props.row.lamps_illum.length + props.row.lamps.length + lampindex + 1) : lampindex + 1 }} - {{(lamp.index + 1).toString().padStart(3, '0') }}]</span>
                                                            ID:<span>{{ lamp.id }}</span>
                                                            <span v-if="!lamp.nodo_orfano && lamp.nodo_orfano != null">
                                                                <i class="fa fa-x2 fa-rss ml-2"
                                                                    style="color:green"></i></span>
                                                            <span v-if="lamp.nodo_orfano && lamp.nodo_orfano != null">
                                                                <i id="orphanIcon" class="fa fa-x2 fa-wifi ml-2"
                                                                    style="color:red"></i></span>
                                                        </strong>
                                                    </b-row>
                                                    <b-row class="child-table">
                                                        <span
                                                            v-if="lamp.product_code != null && lamp.nodo_orfano == false">cod.
                                                            {{ lamp.product_code }}</span>
                                                    </b-row>
                                                    <b-row class="child-table"
                                                        v-if="lamp.product_desc != null && lamp.nodo_orfano == false">
                                                        <span>{{ lamp.product_desc }}</span>
                                                    </b-row>
                                                </td>
                                                <td>
                                                    <!---slot action -->
                                                </td>
                                                <td class="dettColumnClass">
                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none"
                                                        no-caret right>
                                                        <template slot="button-content">
                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                    style="color:black"></i></b>
                                                        </template>
                                                        <b-dropdown-item @click="showLampDetails(props.row, lamp)">
                                                        {{$t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                        <div class="dropdown-divider"
                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                        </div>
                                                        <b-dropdown-item @click="showLampBlink(props.row, lamp)"
                                                            v-if="props.row.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && props.row.cu_type != 'logica'">
                                                            {{ $t("cu_table_row.dropdown_blink") }}</b-dropdown-item>
                                                    </b-dropdown>
                                                </td>
                                                <td style="text-align:left">
                                                    <!-- <i class="fa fa-circle" v-bind:class="[onlineClass(props.row)]" /> {{ descrStato(props.row) }} -->
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.sensor_info") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">--</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <div class="d-flex justify-content-center">
                                                        {{ $t("details_lamp.sensor_setting") }}
                                                    </div>
                                                    <strong>
                                                        <div class="d-flex justify-content-center">--</div>
                                                    </strong>
                                                </td>
                                                <td>
                                                    <IconErrorLamp :lamp="lamp" scale="fa-2x" scalefont="2.5"></IconErrorLamp>
                                                </td>
                                            </tr>
                                        </tbody>

                                        
                                    </table>
                                </div>
                            </v-client-table>
                        </b-check-group>
                    </hide-at>

                    <!----------------------------------------------->
                    <!------------ CENTRALIZZATI MOBILE ------------->
                    <!----------------------------------------------->
                    <show-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="small">
                        <div style="margin-top: 124px">
                            <LoaderSmall />
                            <!-- alert per feedback dei comandi -->
                            <b-row class="alert-feeback-command" style="position: fixed; top: 229px; left: 8px; right: 8px; z-index: 500; ">
                                <b-col lg="12" md="12">
                                    <b-alert v-for="(alert, indexA) in alerts" :show="alert.timeLeft" v-bind:key="indexA"
                                        :variant="alert.state" dismissible fade @dismissed="alert.timeLeft = 0"
                                        @dismiss-count-down="alert.countDownChanged">
                                        <div>
                                            <i v-if="alert.state == 'danger'"
                                                class="fa fa-1x fa-exclamation-circle mr-2"></i>
                                            <i v-if="alert.state == 'success'" class="fa fa-1x fa-check-circle mr-2"></i>
                                            <div class="pb-3" style="display:inline; font-size:13px; height:15px;">
                                                {{ alert.msg }}
                                            </div>
                                        </div>
                                    </b-alert>
                                </b-col>
                            </b-row>
                            <!-- search input form-->
                            <b-row style="position: fixed; top: 142px; left: 8px; right: 8px; z-index: 1; background-color: #eee">
                                <b-col class="my-2">
                                    <b-input-group>
                                        <b-form-input type="text" :placeholder="$t('search')"
                                            v-model="filters.search"></b-form-input>
                                        <!-- Attach Right button -->
                                        <b-input-group-append>
                                            <b-button variant="primary" @click="filtra()"><i class="fa fa-search"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <!-- select all and actions -->
                            <b-nav class="mobile-sub-nav"
                                style="background: #eee; padding-left: 16px; position: fixed; top: 193px; left: 8px; right: 8px; z-index: 1;"
                                v-if="$store.getters.userRole == 'installer' || $store.getters.userRole == 'collab'">
                                <!-- select all -->
                                <b-nav-text>
                                    <b-checkbox v-model="selectAllDevices" id="allSelect">{{ $t("select_checkbox.text") }}</b-checkbox>
                                </b-nav-text>
                                <!--actions-->
                                <b-dropdown v-if="this.plantDetails.technology != 'bluetooth'" id="dd-azioni-menu" right>
                                    <template v-slot:button-content>
                                        <span>{{$t('command.actions') }}</span>
                                    </template>
                                    <b-dropdown-item 
                                        :disabled="!emergencySelection || (sicuroSelection && !sicuroCentSelection)"
                                        @click="sendGenericCommand('test_funzionale')">
                                        {{$t('command.test_funzionale') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :disabled="!emergencySelection || (sicuroSelection && !sicuroCentSelection)"
                                        @click="sendGenericCommand('test_autonomia')">
                                        {{$t('command.test_autonomia') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :disabled="!emergencySelection || (sicuroSelection && !sicuroCentSelection)"
                                        @click="sendGenericCommand('stop_test')">
                                        {{$t('command.stop_test') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :disabled="(!emergencySelection || sicuroSelection)"
                                        @click="sendGenericCommand('rest_mode')">
                                        {{ $t('command.rest_mode') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :disabled="((!emergencySelection && !lightingSelection) || sicuroSelection)"
                                        @click="sendGenericCommand('refresh')">
                                        {{ $t('command.refresh') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :disabled="((!emergencySelection && !lightingSelection) || sicuroSelection)"
                                        @click="sendGenericCommand('stop_blink')">
                                        {{$t('command.stop_blink')}}
                                    </b-dropdown-item>
                                    <b-dropdown-item 
                                        :disabled="((!emergencySelection && !lightingSelection) || sicuroSelection)"
                                        @click="$bvModal.show('modal-descrittivo')">
                                        {{ $t('command.set_description') }}
                                    </b-dropdown-item>

                                    
                                    <b-dropdown id="dropdown-2" dropup :disabled="righeSel.length == 0" right>
                                        <template v-slot:button-content>
                                            <span>{{$t('command.more_act') }}</span>
                                        </template>
                                        <!-- class="pull-right" -->
                                        <b-dropdown-item>
                                            <parametri-impianto v-if="(emergencySelection && !sicuroSelection)" id="parametri-button2" :sendAction="sendGenericCommandMulti"
                                                :alerts="alerts" :lamp="lampadeSel" :cu="centraliSel"></parametri-impianto>
                                            <pianifica-test v-if="((emergencySelection && !sicuroSelection) || sicuroCentSelection)" id="pianifica-button2" :sendAction="sendPianificaTest"
                                                :alerts="alerts" :cu="centraliSel"
                                                :timezoneLocation="this.$store.state.timezoneLocation"></pianifica-test>
                                            <parametri-uvoxy v-if="(emergencySelection && !sicuroSelection)" :sendAction="sendGenericCommandMulti" :lamp="lampadeSel"
                                                :cu="centraliSel" :alerts="alerts"></parametri-uvoxy>
                                        </b-dropdown-item>
                                    </b-dropdown>

                                </b-dropdown>
                                <!-- + add-central-unit remove-central-unit -->
                                <b-dropdown v-if="this.plantDetails.technology != 'bluetooth'" id="dd-comandi-menu" right no-caret>
                                    <template v-slot:button-content>
                                        <span>+</span>
                                    </template>
                                    <b-dropdown-item>
                                        <add-central-unit id="add-central-unit-button"> </add-central-unit>
                                        <!-- <remove-central-unit id="remove-central-unit-button"> </remove-central-unit> -->
                                    </b-dropdown-item>

                                </b-dropdown>

                            </b-nav>
                            <!-- collapse usato solo come debug dei comandi e reso invisibile da display: none -->
                            <b-collapse id="commands-collapse">
                                <b-row>
                                    <b-col cols="6" class="text-center">
                                        <b-dropdown id="test_command" class="typo-label mr-1 ml-1 mt-3">
                                            <template slot="button-content">
                                                <i class="fa fa-bolt"></i>
                                                <span class="ml-2 mr-2 typo-label">{{ $t("command_button.test") }}</span>
                                            </template>
                                            <b-dropdown-item @click="sendGenericCommand('test_funzionale')">
                                            {{$t('command.test_funzionale') }}</b-dropdown-item>
                                            <b-dropdown-item @click="sendGenericCommand('test_autonomia')">
                                            {{$t('command.test_autonomia')}}</b-dropdown-item>
                                            <b-dropdown-item @click="sendGenericCommand('stop_test')">
                                            {{$t('command.stop_test')}}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-col>
                                    <b-col cols="6" class="text-center">
                                        <b-dropdown id="generic_command" text="Comandi"
                                            class="typo-label mr-1 ml-1 mt-3">
                                            <template slot="button-content">
                                                <i class="fa fa-paper-plane"></i>
                                                <span class="ml-2 mr-2 typo-label">{{ $t("command_button.command")
                                                    }}</span>
                                            </template>
                                            <b-dropdown-item @click="sendGenericCommand('rest_mode')">
                                            {{$t('command.rest_mode')}}</b-dropdown-item>
                                            <b-dropdown-item @click="sendGenericCommand('refresh')">
                                            {{$t('command.refresh')}}</b-dropdown-item>
                                            <b-dropdown-item @click="sendGenericCommand('stop_blink')">
                                            {{$t('command.stop_blink') }}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-col>
                                    <b-col cols="6" class="text-center">
                                        <parametri-impianto :sendAction="sendGenericCommandMulti" :alerts="alerts"
                                            :lamp="lampadeSel" :cu="centraliSel"></parametri-impianto>
                                    </b-col>
                                    <b-col cols="6" class="text-center">
                                        <pianifica-test :sendAction="sendPianificaTest" :alerts="alerts"
                                            :cu="centraliSel"
                                            :timezoneLocation="this.$store.state.timezoneLocation"></pianifica-test>
                                    </b-col>
                                </b-row>
                            </b-collapse>
                            <!-- CENTRALI MOBILE -->
                            <b-check-group id="righeSel" v-model="righeSel">
                                <table id="tabDispositiviSmall" class="table table-condensed">
                                    <tbody>
                                        <tr v-for="(cent, centIndex) in tableData" v-bind:key="cent.cu_id">
                                            <td>
                                                <b-card no-body>
                                                    <b-row>
                                                        <!-- checkbox -->
                                                        <b-col cols="1" class="nopadding">
                                                            <b-checkbox :disabled="(!cent.enabled)"
                                                                @change="toggleCentCheckbox"
                                                                :value="'cent-' + (centIndex)" 
                                                                :id="'cent-' + cent.cu_id" />
                                                        </b-col>
                                                        <!-- image -->
                                                        <b-col v-if="cent.cu_product_image" cols="2" class="nopadding">
                                                            <img :src="pathDeviceImages + cent.cu_product_image"
                                                                style="height:auto; width:80%" />
                                                        </b-col>
                                                        <b-col v-else cols="2" class="nopadding">
                                                            <img v-if="cent.cu_type == 'logicafm'"
                                                                :src="'/img/logicafmsd/centrale.png'"
                                                                style="height:auto; width:80%;" />
                                                            <img v-if="cent.cu_type == 'logica'"
                                                                :src="'/img/logica/centrale.png'"
                                                                style="height:auto; width:80%;" />
                                                            <img v-if="cent.cu_type == 'cablecom'"
                                                                :src="'/img/cablecom/centrale.png'"
                                                                style="height:auto; width:80%;" />
                                                            <img v-if="cent.cu_type == 'blegateway'"
                                                                :src="'/img/blegateway/bleGateway.jpg'"
                                                                style="height:30px; width:auto;" />
                                                            <img v-if="cent.cu_type == 'sicuro'"
                                                                :src="pathDeviceImages + 'cu_sicuro.jpg'"
                                                                style="height:auto; width:80%;" />
                                                        </b-col>
                                                        <!-- nome, tipo e connessione -->
                                                        <b-col cols="8">
                                                            <h4>{{ cent.cu_desc }}</h4>
                                                            <h5 v-if="cent.cu_type == 'blegateway'">
                                                                <b>{{ cent.cu_type.toUpperCase() }}</b>
                                                            </h5>
                                                            <!-- <h5 v-else-if="cent.cu_type == 'sicuro'">
                                                            {{ cent.cu_product_desc[0].toUpperCase() + cent.cu_product_desc.slice(1).toLowerCase() }} {{ cent.cu_type }}
                                                            </h5> -->
                                                            <h5>{{ $t("central_unit") }} {{ cent.cu_type }}</h5>
                                                            <div class="centStatus">
                                                                <i class="fa fa-circle"
                                                                    v-bind:class="[onlineClass(cent)]" />
                                                                {{ descrStato(cent) }}
                                                            </div>

                                                        </b-col>
                                                        <!-- ellipsis dropdown -->
                                                        <b-col cols="1" class="nopadding">
                                                            <b-dropdown v-if="cent.enabled" variant="link" size="lg"
                                                                toggle-class="text-decoration-none" no-caret right>
                                                                <template slot="button-content">
                                                                    <b><i class="fa fa-1x fa-ellipsis-v"
                                                                            style="color:black"></i></b>
                                                                </template>
                                                                <b-dropdown-item @click="showCentDetails(cent)">
                                                                    {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item v-if="cent.cu_type == 'blegateway'"
                                                                    @click="showGatewayCommand(cent)">
                                                                    {{$t("gateway_command_modal.command") }}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item v-if="cent.cu_type == 'blegateway'"
                                                                    @click="showGatewayLampsInsert(cent)">
                                                                    {{$t("gateway_lamps_insert_modal.configure")}}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item
                                                                    v-if="cent.cu_type != 'blegateway' && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                                                    @click="showConfigCent(cent)" :disabled="cent.cu_type === 'sicuro' ? true : false">
                                                                    {{$t("cu_table_row.dropdown_configura")}}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item
                                                                    v-if="cent.cu_type == 'logica' && cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                                                    @click="showGroups(cent)">
                                                                    {{$t("lamp_details_modal.groups")}}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item
                                                                    v-if="cent.cu_type == 'logicafm' && cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                                                    @click="showGroups(cent)">
                                                                    {{$t("lamp_details_modal.groups") }}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item
                                                                    v-if="(cent.cu_type == 'logicafm' || cent.cu_type == 'sicuro') && cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                                                    @click="showAdvanced(cent)">
                                                                    {{$t("lamp_details_modal.advanced")}}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item
                                                                    v-if="cent.cu_type != 'blegateway' && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab')"
                                                                    @click="showRemoveCu(cent)" :disabled="cent.cu_type === 'sicuro' ? true : false">
                                                                    {{$t("remove_cu_button.text") }}
                                                                </b-dropdown-item>
                                                                <b-dropdown-item
                                                                    v-if="$store.getters.userRole == 'installer' || $store.getters.userRole == 'collab'"
                                                                    @click="showResetCu(cent)" :disabled="cent.cu_type === 'sicuro' ? true : false">
                                                                    {{ $t("reset_cu_button.text")}}
                                                                </b-dropdown-item>
                                                            </b-dropdown>
                                                        </b-col>
                                                    </b-row>
                                                    <!-- riga di visualizzazione icone varie -->
                                                    <b-row> 
                                                        <b-col offset="3">
                                                            <i v-if="(working(cent) && cent.cu_connected)"
                                                                class="fa fa-spinner fa-spin" />
                                                            <div v-if="testactive(cent)"
                                                                style="display: inline; margin-left: 8px">
                                                                <i class="fa fa-battery-three-quarters"
                                                                    style="color:orange"></i>
                                                                <div class="typo-icon" style="display:inline">
                                                                    {{ $t("param_lamp.TEST IN CORSO") }}</div>
                                                            </div>
                                                            <div v-if="restmodeactive(cent)"
                                                                style="display: inline; margin-left: 8px">
                                                                <i class="fa fa-caret-square-o-down"
                                                                    style="color:orange"></i>
                                                                <div class="typo-icon"
                                                                    style="display:inline; margin-left: 8px">
                                                                    {{ $t("param_lamp.REST MODE ACTIVATED") }}</div>
                                                            </div>
                                                            <!-- <div v-if="emergencyactive(cent)">
                                                            <i class="fa fa-2x fa fa-exclamation-circle mr-2 emergency-on"></i> 
                                                    </div>  -->
                                                        </b-col>
                                                    </b-row>
                                                    <!-- riga con id e bottone di attivazione collapse -->
                                                    <b-row class="mt-2">
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{ $t("id_cu") }}
                                                        </b-col>
                                                        <b-col cols="5" class="dataValues">
                                                            {{ cent.cu_id }}
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <b-button size="sm" v-if="cent.enabled" @click="toggleCollapse(cent.cu_type + cent.cu_id)"> 
                                                                <i :class="isOpen[cent.cu_type + cent.cu_id] ? 'fas fa-angle-down':'fas fa-angle-right'"/> 
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                    <!-- riga con device trovati -->
                                                    <b-row>
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            <div v-if="(deviceTypeFilter() == null || cent.cu_type == 'blegateway') && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false"
                                                                class="d-flex">{{ $t("details_cu_modal.cu_numero_lampade") }}
                                                            </div>
                                                            <div v-if="cent.lamps && deviceTypeFilter() == 'emergenza' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false"
                                                                class="d-flex">
                                                                {{ $t("details_cu_modal.cu_numero_lampade_emergenza") }}
                                                            </div>
                                                            <div v-if="cent.lamps_illum && deviceTypeFilter() == 'illuminazione' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false"
                                                                class="d-flex">
                                                                {{ $t("details_cu_modal.cu_numero_lampade_illuminazione") }}
                                                            </div>
                                                            <div v-if="cent.sensors && deviceTypeFilter() == 'sensori' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false"
                                                                class="d-flex">{{ $t("details_cu_modal.cu_numero_sensori") }}
                                                            </div>
                                                        </b-col>
                                                        <b-col cols="3" class="dataValues mb-1">
                                                            <!--- visualizza il numero delle lampade oppure attende sync della shadow -->
                                                            {{ (deviceTypeFilter() == null || cent.cu_type == 'blegateway') && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false ? cent.num_lamp_found : "" }}
                                                            <!--numero dispositivi di emergenza-->
                                                            {{ cent.lamps && deviceTypeFilter() == 'emergenza' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false && cent.cu_type != 'sicuro'? cent.lamps.length : cent.lamps && deviceTypeFilter() == 'emergenza' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false && cent.cu_type == 'sicuro'? cent.lamps_id.length : "" }}
                                                            <!--numero dispositivi di illuminazione-->
                                                            {{ cent.lamps_illum && deviceTypeFilter() == 'illuminazione' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false ? cent.lamps_illum.length : "" }}
                                                            <!--numero sensori-->
                                                            {{ cent.sensors && deviceTypeFilter() == 'sensori' && cent.num_lamp_found >= 0 && searchlampsactive(cent) == false ? cent.sensors.length : "" }}
                                                        </b-col>
                                                    </b-row>
                                                    <!-- riga con lo stato -->
                                                    <b-row>
                                                        <b-col cols="5" offset="1" class="dataLabels">
                                                            {{ $t("details_lamp.lamp_state") }}
                                                        </b-col>

                                                        <b-col v-if="searchlampsactive(cent)">
                                                            <b-button variant="primary" size="sm"
                                                                @click="cent.cu_type == 'blegateway' ? openSearchBleLamps(cent) : reOpenConfigCent(cent)"><i class="fa fa-1x fa-search"
                                                                    style="color:white"></i>
                                                                {{ $t("config_cu_modal.details").toUpperCase() }}</b-button>
                                                        </b-col>

                                                        <b-col v-else-if="(cent.cu_type == 'sicuro') && (seriousErrorCentSicuro(cent) == true)" cols="5" class="dataValues">
                                                            <i class="fa fa-exclamation-triangle check-err"></i>
                                                        </b-col>
                                                        <b-col v-else cols="5" class="dataValues">
                                                            <i class="fa " v-bind:class="[dotClass(cent)]" />
                                                        </b-col>
                                                    </b-row>


                                                    <b-collapse
                                                        :id="'collapse-' + cent.cu_type + cent.cu_id" class="mt-2">
                                                        <!-------------------------------------------------->
                                                        <!------------------ AK mobile --------------------->
                                                        <!-------------------------------------------------->
                                                        <b-card v-for="(ak) in cent.ak" v-bind:key="ak.index"
                                                            :style="{ 'display': (ak['visible'] == false) ? 'none' : 'block' }"
                                                            class="akCard" no-body>
                                                            <b-row>
                                                                <!-- checkbox -->
                                                                <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                    <b-checkbox
                                                                        :disabled="centSelObject(cent)"
                                                                        @change="toggleAkCheckbox"
                                                                        :value="'ak-' + (centIndex) + '-' + ak.index"
                                                                        :id="'ak-' + (centIndex) + '-' + ak.index" />
                                                                </b-col>
                                                                <!-- image -->
                                                                <b-col cols="3" class="nopadding d-flex align-items-center">
                                                                    <img v-if="ak.product_image != null && ak.product_image != ''"
                                                                        :src="ak.product_image.includes('|') ? pathDeviceImages + ak.product_image.split('|')[0] : pathDeviceImages + ak.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <!-- <div v-else class="ml-1"> -->
                                                                        <div v-else >
                                                                        <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                                            style="height:80px; width:auto;" />
                                                                    </div>
                                                                </b-col>
                                                                <!-- desc, nr lines, nr lamps, status (in colonna) -->
                                                                <b-col cols="7">
                                                                    <b-row>
                                                                        <b-col cols="12">
                                                                            <h4>{{ ak.product_desc }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.index")}}
                                                                        </b-col>
                                                                        <b-col cols="7">                                                                        
                                                                            <h4>{{ ak.index }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.num_line")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ ak.num_line }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.num_lamp")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ ak.num_lamp_found }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{ $t("details_lamp.lamp_state") }}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <IconErrorAkChargerSwitch
                                                                                :dev="ak"
                                                                                tipo="ak"
                                                                                scale="fa-1x"
                                                                                scalefont="1"
                                                                            />
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                                <!-- modal detail, pulsante attivazione collapse AK -->
                                                                <b-col cols="1">
                                                                    <b-row>
                                                                        <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                            <b-dropdown variant="link" size="lg"
                                                                                toggle-class="text-decoration-none" no-caret right>
                                                                                <template slot="button-content">
                                                                                    <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                            style="color:black"></i></b>
                                                                                </template>
                                                                                <b-dropdown-item @click="showAkDetails(ak, 'ak')">
                                                                                    {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                </b-dropdown-item>
                                                                                <b-dropdown-item @click="renameLines(ak)">
                                                                                    {{ $t("ak.rename_lines")}}
                                                                                </b-dropdown-item>
                                                                            </b-dropdown>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                            <b-button style="background-color:#f4f4f4" size="sm"  @click="toggleCollapse('ak' + ak.index)" :disabled="(ak.lines.length === 0)" class="ml-1"> 
                                                                                <i :class="isOpen['ak' + ak.index] ? 'fas fa-angle-down':'fas fa-angle-right'" /> 
                                                                            </b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                            </b-row>
                                                            <!-------------------------------------------------->
                                                            <!--------------- LINE SICURO mobile -------------->
                                                            <!-------------------------------------------------->
                                                            <b-collapse
                                                                :id="'collapse-ak' + ak.index" class="mt-2">
                                                                <b-card 
                                                                    v-for="(line, lineIndex) in ak.lines" v-bind:key="line.index"
                                                                    :style="{ 'display': (line['visible'] === false) ? 'none' : 'block' }"
                                                                    class="lineCard" no-body>
                                                                    <b-row>
                                                                        <!-- checkbox -->
                                                                        <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                            <b-checkbox
                                                                                :disabled="centSelObject(cent) || akSelObject(line.cu_id, line.ak)"
                                                                                @change="toggleLineCheckbox"
                                                                                :value="'line-' + centIndex + '-' + line.ak + '-' + lineIndex"
                                                                                :id="'line-' + centIndex + '-' + line.ak + '-' + lineIndex" />
                                                                        </b-col>
                                                                        <!-- Line# -->
                                                                        <b-col cols="3" class="nopadding d-flex align-items-center">
                                                                            <h4 class="mr-1"> {{$t("sicuro.line")}} </h4>
                                                                            <div class="numberLine"> {{parseInt(line.line_num ? line.line_num : line.index)}} </div>
                                                                        </b-col>
                                                                        <!-- desc, function, state, nr lamps, status (in colonna) -->
                                                                        <b-col cols="7">
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro_mobile.description")}}
                                                                                </b-col>
                                                                                <b-col v-if="line.line_desc != null && line.line_desc.length > 0" cols="7">
                                                                                    <h6>{{line.line_desc}}</h6>
                                                                                </b-col>
                                                                                <b-col v-else cols="7">
                                                                                    <h6>-</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro.functionshort")}}
                                                                                </b-col>
                                                                                <b-col cols="7">                                                                        
                                                                                    <h6>{{ getLineFunctionLabel(line.line_function) }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro.linestate_sh")}}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <h6>{{ (lower(line.deactivated) === 'off') ? 'on' : lower(line.deactivated) }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro.acstate_sh")}}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <h6>{{ (lower(line.line_state) === 'ac on') ? 'on' : lower(line.line_state) }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro_mobile.num_lamp")}}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <h6>{{ line.num_lamp_found }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{ $t("details_lamp.lamp_state") }}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <IconErrorAkChargerSwitch
                                                                                        :dev="line"
                                                                                        tipo="line"
                                                                                        scale="fa-1x"
                                                                                        scalefont="1"
                                                                                    />
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-col>
                                                                        <!-- modal detail, pulsante attivazione collapse LAMPS -->
                                                                        <b-col cols="1">
                                                                            <b-row>
                                                                                <b-col cols="12" class="nopadding d-flex align-items-start">
                                                                                    <b-dropdown variant="link" size="lg"
                                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                                        <template slot="button-content">
                                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                                    style="color:black"></i></b>
                                                                                        </template>
                                                                                        <b-dropdown-item 
                                                                                            @click="showLineDetails(line)">
                                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                        </b-dropdown-item>
                                                                                        <b-dropdown-item
                                                                                            @click="showLineConfig(line)">
                                                                                            {{ $t("cu_table_row.dropdown_configura")}}
                                                                                        </b-dropdown-item>
                                                                                        <b-dropdown-item
                                                                                            :disabled = "line.num_lamp_found === 0"
                                                                                            @click="modificaDesc(line)">
                                                                                            {{ $t("line.modify_lamp_desc")}}
                                                                                        </b-dropdown-item>
                                                                                    </b-dropdown>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                                    <b-button style="background-color:#f4f4f4" size="sm" @click="toggleCollapse('line' + line.index)" :disabled="(line.lamps.length === 0)" class="ml-1"> 
                                                                                        <i :class="isOpen['line' + line.index] ? 'fas fa-angle-down':'fas fa-angle-right'"  /> 
                                                                                    </b-button>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <!-------------------------------------------------->
                                                                    <!---------------- LAMP MOBILE --------------------->
                                                                    <!-------------------------------------------------->
                                                                    <b-collapse
                                                                        :id="'collapse-line' + line.index" class="mt-2">
                                                                        <b-card
                                                                            v-for="(lamp, lampindex) in line.lamps" :key="lamp.idx"
                                                                            :style="{ 'display': (line.visible === false) ? 'none' : 'block' }"
                                                                            class="lampCard" no-body>
                                                                            <b-row>
                                                                                <!-- checkbox -->
                                                                                <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                                    <b-checkbox
                                                                                        :disabled="centSelObject(cent) || akSelObject(lamp.cu_id, lamp.ak_index) ||
                                                                                            lineSelObject(lamp.cu_id, lamp.ak_index, lineIndex)"
                                                                                        :value="'lamp'+ lamp.lamp_id + '-' + centIndex + '-' + line.ak + '-' + lineIndex + '-' + lampindex"
                                                                                        :id="'lamp'+ lamp.lamp_id + '-' + centIndex + '-' + line.ak + '-' + lineIndex + '-' + lampindex" />
                                                                                </b-col>
                                                                                <!-- image, product desc,  -->
                                                                                <b-col cols="4">                                                                           
                                                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                                                    :src="lamp.product_image.includes('|') ? pathDeviceImages + lamp.product_image.split('|')[0] : pathDeviceImages + lamp.product_image"
                                                                                    style="height:60px; width:auto;" />
                                                                                    <div v-else class="ml-1">
                                                                                        <img :src="pathDeviceImages + 'PLM_17210.jpg'"
                                                                                        style="height:auto; width:80px;" />
                                                                                    </div>
                                                                                    <b-row v-if="changeLampDesc[`${lamp.cu_id}_${String(Number(lamp.ak_index))}_${String(Number(lamp.ak_line))}`]" class="child-table2">
                                                                                        <!-- class="w-100" -->
                                                                                        <b-form-group 
                                                                                            :label-for="'descInput' + lamp.lamp_id"
                                                                                            class="pr-0">    
                                                                                            <b-form-input
                                                                                                v-model="newDescLamp[lamp.lamp_id]"
                                                                                                :placeholder="lamp.lamp_desc"
                                                                                                :maxlength="maxchar"
                                                                                                :state="inputState(lamp.lamp_id)"
                                                                                                style="width: 125px;"                                                
                                                                                            />   
                                                                                            <b-form-invalid-feedback v-if="inputNameInfo(lamp.lamp_id).error">
                                                                                            {{ inputNameInfo(lamp.lamp_id).text }}
                                                                                            </b-form-invalid-feedback>
                                                                                            <b-form-text v-else>
                                                                                            {{ inputNameInfo(lamp.lamp_id).text }}
                                                                                            </b-form-text>
                                                                                        </b-form-group>
                                                                                    </b-row>
                                                                                    <b-row v-else class="child-table2"><strong>
                                                                                        <span v-if="lamp.desc != null" style="font-size:smaller">{{ lamp.desc }}</span></strong>
                                                                                    </b-row>
                                                                                    <b-row class="child-table2"><strong>
                                                                                        <span v-if="lamp.product_desc != null" style="font-size:.75em">{{ lamp.product_desc }}</span></strong>
                                                                                    </b-row>
                                                                                    <b-row class="child-table2">
                                                                                        <strong class="float-left">
                                                                                            <span style="font-size:smaller;" class="pr-1">
                                                                                                <!-- [{{ lampindex + 1 }} - {{ (lamp.idx).toString().padStart(3,'0') }}] -->
                                                                                                [{{ restituisciRotary(lamp).toString().padStart(3, '0') }}]
                                                                                            </span>         
                                                                                            <span style="font-size:smaller">ID: {{ lamp.lamp_id }}</span>
                                                                                        </strong>
                                                                                    </b-row>
                                                                                </b-col>
                                                                                <b-col cols="2" class="nopadding d-flex align-items-center">
                                                                                    <b-dropdown variant="link" size="lg"
                                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                                        <template slot="button-content">
                                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                                    style="color:black"></i></b>
                                                                                        </template>
                                                                                        <b-dropdown-item @click="showLampDetails(cent, lamp)">
                                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                        </b-dropdown-item>
                                                                                    </b-dropdown>
                                                                                </b-col>
                                                                                <b-col cols="3" class="d-flex-column">  
                                                                                    <b-row><b-col>
                                                                                        <div class="d-flex justify-content-center mt-4">
                                                                                            {{ $t("details_lamp.lamp_sa_dimming") }}
                                                                                        </div></b-col>
                                                                                    </b-row>
                                                                                    <b-row><b-col>
                                                                                        <strong>
                                                                                            <div class="d-flex justify-content-center mt-2" style="font-size:smaller">
                                                                                                {{ lamp.device_function }}
                                                                                            </div>
                                                                                        </strong></b-col>
                                                                                    </b-row>
                                                                                </b-col>
                                                                                <b-col cols="2" class="nopadding d-flex align-items-center justify-content-center">
                                                                                    <div>
                                                                                        <i class="fa fa-1x"
                                                                                            :class="calcolaNumErrori(lamp) == 0 ? 'fa-check check-ok' : 'fa-exclamation-circle check-err'" />
                                                                                    </div>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-card>
                                                                        <b-card v-if="visButtomMobile(line)" no-body class="fixed-card">
                                                                            <div class="d-flex justify-content-center">
                                                                                <b-button-group>
                                                                                    <b-button size="xl" class="mr-4" style="color: green" :aria-label="$t('save')"
                                                                                        @click="saveNewLampDesc(line)">
                                                                                        <i class="fa fa-2x fa-check" aria-hidden="true"></i>
                                                                                    </b-button>
                                                                                    <b-button size="xl" style="color: red" :aria-label="$t('cancel')"
                                                                                        @click="chiudiLampDesc(line)">
                                                                                        <i class="fa fa-2x fa-close" aria-hidden="true"></i>
                                                                                    </b-button>
                                                                                </b-button-group>
                                                                            </div>
                                                                        </b-card>
                                                                    </b-collapse>
                                                                </b-card>
                                                            </b-collapse>
                                                        </b-card>
                                                        <!-------------------------------------------------->
                                                        <!---------------- AK EXT mobile ------------------->
                                                        <!-------------------------------------------------->
                                                        <b-card v-for="(ak_ext) in cent.ak_ext" :key="'ext'+ ak_ext.index"
                                                            :style="{ 'display': (ak_ext['visible'] == false) ? 'none' : 'block' }"
                                                            class="akCard" no-body>
                                                            <b-row>
                                                                <!-- checkbox -->
                                                                <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                    <b-checkbox
                                                                        :disabled="centSelObject(cent)"
                                                                        @change="toggleAkExtCheckbox"
                                                                        :value="'extak-' + (centIndex) + '-' + ak_ext.index"
                                                                        :id="'extak-' + (centIndex) + '-' + ak_ext.index" />
                                                                </b-col>
                                                                <!-- image -->
                                                                <b-col cols="3" class="nopadding d-flex align-items-center">
                                                                    <img v-if="ak_ext.product_image != null && ak_ext.product_image != ''"
                                                                        :src="ak_ext.product_image.includes('|') ? pathDeviceImages + ak_ext.product_image.split('|')[0] : pathDeviceImages + ak_ext.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <!-- <div v-else class="ml-1"> -->
                                                                        <div v-else >
                                                                        <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                                            style="height:80px; width:auto;" />
                                                                    </div>
                                                                </b-col>
                                                                <!-- desc, nr lines, nr lamps, status (in colonna) -->
                                                                <b-col cols="7">
                                                                    <b-row>
                                                                        <b-col cols="12">
                                                                            <h4>{{ ak_ext.product_desc }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.index")}}
                                                                        </b-col>
                                                                        <b-col cols="7">                                                                        
                                                                            <h4>{{ ak_ext.index }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.num_line")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ ak_ext.num_line }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.num_lamp")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ ak_ext.num_lamp_found }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{ $t("details_lamp.lamp_state") }}
                                                                        </b-col>
                                                                         <b-col cols="7">
                                                                            <IconErrorAkChargerSwitch
                                                                                :dev="ak_ext"
                                                                                tipo="ak"
                                                                                scale="fa-1x"
                                                                                scalefont="1"
                                                                            />
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                                <!-- modal detail, pulsante attivazione collapse AK -->
                                                                <b-col cols="1">
                                                                    <b-row>
                                                                        <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                            <b-dropdown variant="link" size="lg"
                                                                                toggle-class="text-decoration-none" no-caret right>
                                                                                <template slot="button-content">
                                                                                    <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                            style="color:black"></i></b>
                                                                                </template>
                                                                                <b-dropdown-item @click="showAkDetails(ak_ext, 'akext')">
                                                                                    {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                </b-dropdown-item>
                                                                                <b-dropdown-item @click="renameLines(ak_ext)">
                                                                                    {{ $t("ak.rename_lines")}}
                                                                                </b-dropdown-item>
                                                                            </b-dropdown>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                            <b-button style="background-color:#f4f4f4" size="sm" @click="toggleCollapse('akext' + ak_ext.index)" :disabled="(ak_ext.lines.length === 0)" class="ml-1"> 
                                                                                <i :class="isOpen['akext' + ak_ext.index] ? 'fas fa-angle-down':'fas fa-angle-right'" /> 
                                                                            </b-button>
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                            </b-row>
                                                            <!-------------------------------------------------->
                                                            <!------------ LINE EXT mobile -------------------->
                                                            <!-------------------------------------------------->  
                                                            <b-collapse
                                                                :id="'collapse-akext' + ak_ext.index" class="mt-2">
                                                                <b-card 
                                                                    v-for="(line, lineIndex) in ak_ext.lines" v-bind:key="line.index"
                                                                    :style="{ 'display': (line['visible'] === false) ? 'none' : 'block' }"
                                                                    class="lineCard" no-body>
                                                                    <b-row>
                                                                        <!-- checkbox -->
                                                                        <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                            <b-checkbox
                                                                                :disabled="centSelObject(cent) || akextSelObject(line.cu_id, line.ak)"
                                                                                @change="toggleLineExtCheckbox"
                                                                                :value="'extline-' + centIndex + '-' + line.ak + '-' + lineIndex"
                                                                                :id="'extline-' + centIndex + '-' + line.ak + '-' + lineIndex" />
                                                                        </b-col>
                                                                        <!-- Line# -->
                                                                        <b-col cols="3" class="nopadding d-flex align-items-center">
                                                                            <h4 class="mr-1"> {{$t("sicuro.line")}} </h4>
                                                                            <div class="numberLine"> {{parseInt(line.line_num ? line.line_num : line.index)}} </div>
                                                                        </b-col>
                                                                        <!-- desc, function, state, nr lamps, status (in colonna) -->
                                                                        <b-col cols="7">
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro_mobile.description")}}
                                                                                </b-col>
                                                                                <b-col v-if="line.line_desc != null && line.line_desc.length > 0" cols="7">
                                                                                    <h6>{{line.line_desc}}</h6>
                                                                                </b-col>
                                                                                <b-col v-else cols="7">
                                                                                    <h6>-</h6>
                                                                                </b-col>
                                                                            </b-row>

                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro.functionshort")}}
                                                                                </b-col>
                                                                                <b-col cols="7">                                                                        
                                                                                    <h6>{{ getLineFunctionLabel(line.line_function) }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro.linestate_sh")}}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <h6>{{ (lower(line.deactivated) === 'off') ? 'on' : lower(line.deactivated) }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro.acstate_sh")}}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <h6>{{ (lower(line.line_state) === 'ac on') ? 'on' : lower(line.line_state) }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{$t("sicuro_mobile.num_lamp")}}
                                                                                </b-col>
                                                                                <b-col cols="7">
                                                                                    <h6>{{ line.num_lamp_found }}</h6>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="5" class="dataLabels">
                                                                                    {{ $t("details_lamp.lamp_state") }}
                                                                                </b-col>
                                                                                 <b-col cols="7">
                                                                                    <IconErrorAkChargerSwitch
                                                                                        :dev="line"
                                                                                        tipo="line"
                                                                                        scale="fa-1x"
                                                                                        scalefont="1"
                                                                                    />
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-col>
                                                                        <!-- modal detail, pulsante attivazione collapse LAMPS -->
                                                                        <b-col cols="1">
                                                                            <b-row>
                                                                                <b-col cols="12" class="nopadding d-flex align-items-start">
                                                                                    <b-dropdown variant="link" size="lg"
                                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                                        <template slot="button-content">
                                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                                    style="color:black"></i></b>
                                                                                        </template>
                                                                                        <b-dropdown-item @click="showLineDetails(line)">
                                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                        </b-dropdown-item>
                                                                                        <b-dropdown-item
                                                                                            @click="showLineConfig(line)">
                                                                                            {{ $t("cu_table_row.dropdown_configura")}}
                                                                                        </b-dropdown-item>
                                                                                        <b-dropdown-item
                                                                                            :disabled = "line.num_lamp_found === 0"
                                                                                            @click="modificaDesc(line)">
                                                                                            {{ $t("line.modify_lamp_desc")}}
                                                                                        </b-dropdown-item>
                                                                                    </b-dropdown>
                                                                                </b-col>
                                                                            </b-row>
                                                                            <b-row>
                                                                                <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                                    <b-button style="background-color:#f4f4f4" size="sm" @click="toggleCollapse('line' + line.index)" :disabled="(line.lamps.length === 0)" class="ml-1"> 
                                                                                        <i :class="isOpen['line' + line.index] ? 'fas fa-angle-down':'fas fa-angle-right'" /> 
                                                                                    </b-button>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <!-------------------------------------------------->
                                                                    <!---------------- Lamps EXT mobile ---------------->
                                                                    <!-------------------------------------------------->
                                                                    <b-collapse
                                                                        :id="'collapse-line' + line.index" class="mt-2">
                                                                        <b-card
                                                                            v-for="(lamp, lampindex) in line.lamps" :key="lamp.idx"
                                                                            :style="{ 'display': (line.visible === false) ? 'none' : 'block' }"
                                                                            class="lampCard" no-body>
                                                                            <b-row>
                                                                                <!-- checkbox -->
                                                                                <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                                    <b-checkbox
                                                                                        :disabled="centSelObject(cent) || akextSelObject(lamp.cu_id, lamp.ak_index) ||
                                                                                            lineextSelObject(lamp.cu_id, lamp.ak_index, lineIndex)"
                                                                                        :value="'extlamp'+ lamp.lamp_id + '-' + centIndex + '-' + line.ak + '-' + lineIndex + '-' + lampindex"
                                                                                        :id="'extlamp'+ lamp.lamp_id + '-' + centIndex + '-' + line.ak + '-' + lineIndex + '-' + lampindex" />
                                                                                </b-col>
                                                                                <!-- image, product desc,  -->
                                                                                <b-col cols="4">                                                                           
                                                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                                                    :src="lamp.product_image.includes('|') ? pathDeviceImages + lamp.product_image.split('|')[0] : pathDeviceImages + lamp.product_image"
                                                                                    style="height:60px; width:auto;" />
                                                                                    <div v-else class="ml-1">
                                                                                        <img :src="pathDeviceImages + 'PLM_17210.jpg'"
                                                                                        style="height:auto; width:80px;" />
                                                                                    </div>
                                                                                    <b-row class="child-table2"><strong>
                                                                                        <span v-if="lamp.desc != null" style="font-size:.75em">{{ lamp.desc }}</span></strong>
                                                                                    </b-row>
                                                                                    <b-row class="child-table2"><strong>
                                                                                        <span v-if="lamp.product_desc != null" style="font-size:.75em">{{ lamp.product_desc }}</span></strong>
                                                                                    </b-row>
                                                                                    <b-row class="child-table2">
                                                                                        <strong class="float-left">
                                                                                            <span style="font-size:smaller;" class="pr-1">
                                                                                                <!-- [{{ lampindex + 1 }} - {{ (lamp.idx).toString().padStart(3,'0') }}] -->
                                                                                                [{{ restituisciRotary(lamp).toString().padStart(3, '0') }}]
                                                                                            </span>              
                                                                                            <span style="font-size:smaller">ID: {{ lamp.lamp_id }}</span>
                                                                                        </strong>
                                                                                    </b-row>
                                                                                </b-col>
                                                                                <b-col cols="2" class="nopadding d-flex align-items-center">
                                                                                    <b-dropdown variant="link" size="lg"
                                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                                        <template slot="button-content">
                                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                                    style="color:black"></i></b>
                                                                                        </template>
                                                                                        <b-dropdown-item @click="showLampDetails(cent, lamp)">
                                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                        </b-dropdown-item>
                                                                                    </b-dropdown>
                                                                                </b-col>
                                                                                <b-col cols="3" class="d-flex-column">  
                                                                                    <b-row><b-col>
                                                                                        <div class="d-flex justify-content-center mt-4">
                                                                                            {{ $t("details_lamp.lamp_sa_dimming") }}
                                                                                        </div></b-col>
                                                                                    </b-row>
                                                                                    <b-row><b-col>
                                                                                        <strong>
                                                                                            <div class="d-flex justify-content-center mt-2" style="font-size:smaller">
                                                                                                {{ lamp.device_function }}
                                                                                            </div>
                                                                                        </strong></b-col>
                                                                                    </b-row>
                                                                                </b-col>
                                                                                <b-col cols="2" class="nopadding d-flex align-items-center justify-content-center">
                                                                                    <div>
                                                                                        <i class="fa fa-1x"
                                                                                            :class="calcolaNumErrori(lamp) == 0 ? 'fa-check check-ok' : 'fa-exclamation-circle check-err'" />
                                                                                    </div>
                                                                                </b-col>
                                                                            </b-row>
                                                                        </b-card>
                                                                    </b-collapse>
                                                                </b-card>
                                                            </b-collapse>
                                                        </b-card>                                                    
                                                        <!-------------------------------------------------->
                                                        <!-------------- SWITCH 11KW mobile ---------------->
                                                        <!-------------------------------------------------->
                                                        <b-card v-for="(sw_11kw) in cent.sw_11kw" :key="'sw' + sw_11kw.index"
                                                            :style="{ 'display': (sw_11kw['visible'] == false) ? 'none' : 'block' }"
                                                            class="sw11kwCard" no-body>
                                                            <b-row>
                                                                <!-- checkbox > NO -->
                                                                <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                </b-col>
                                                                <!-- image -->
                                                                <b-col cols="3" class="nopadding d-flex align-items-center">
                                                                    <img v-if="sw_11kw.product_image != null && sw_11kw.product_image != ''"
                                                                        :src="sw_11kw.product_image.includes('|') ? pathDeviceImages + sw_11kw.product_image.split('|')[0] : pathDeviceImages + sw_11kw.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <!-- <div v-else class="ml-1"> -->
                                                                        <div v-else >
                                                                        <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                                            style="height:80px; width:auto;" />
                                                                    </div>
                                                                </b-col>
                                                                <!-- desc, indice, serial ID, state, status (in colonna) -->
                                                                <b-col cols="7">
                                                                    <b-row>
                                                                        <b-col cols="12">
                                                                            <h4>{{ sw_11kw.product_desc }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.index")}}
                                                                        </b-col>
                                                                        <b-col cols="7">                                                                        
                                                                            <h4>{{ sw_11kw.index }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("details_switch.serialid")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ sw_11kw.serial_ID }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("details_switch.state")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ sw_11kw.switch_state }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{ $t("sicuro_mobile.status") }}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <IconErrorAkChargerSwitch
                                                                                :dev="sw_11kw"
                                                                                tipo="switch11kw"
                                                                                scale="fa-1x"
                                                                                scalefont="1"
                                                                            />
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                                <!-- modal detail -->
                                                                <b-col cols="1">
                                                                    <b-row>
                                                                        <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                            <b-dropdown variant="link" size="lg"
                                                                                toggle-class="text-decoration-none" no-caret right>
                                                                                <template slot="button-content">
                                                                                    <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                            style="color:black"></i></b>
                                                                                </template>
                                                                                <b-dropdown-item @click="showAkDetails(sw_11kw, 'sw11kw')">
                                                                                    {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                </b-dropdown-item>
                                                                            </b-dropdown>
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                            </b-row>
                                                        </b-card>
                                                        <!-------------------------------------------------->
                                                        <!-------------- CHARGER mobile -------------------->
                                                        <!-------------------------------------------------->
                                                        <b-card v-for="(charger) in cent.charger" :key="'chg' + charger.index"
                                                            :style="{ 'display': (charger['visible'] == false) ? 'none' : 'block' }"
                                                            class="chargerCard" no-body>
                                                            <b-row>
                                                                <!-- checkbox > NO -->
                                                                <b-col cols="1" class="nopadding d-flex align-items-center">
                                                                </b-col>
                                                                <!-- image -->
                                                                <b-col cols="3" class="nopadding d-flex align-items-start">
                                                                    <img v-if="charger.product_image != null && charger.product_image != ''"
                                                                        :src="charger.product_image.includes('|') ? pathDeviceImages + charger.product_image.split('|')[0] : pathDeviceImages + charger.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <div v-else >
                                                                        <img :src="pathDeviceImages + 'PLM_17232.jpg'"
                                                                            style="height:80px; width:auto;" />
                                                                    </div>
                                                                </b-col>
                                                                <!-- desc, index, output current, output voltage, temperature, status (in colonna) -->
                                                                <b-col cols="7">
                                                                    <b-row>
                                                                        <b-col cols="12">
                                                                            <h4>{{ charger.product_desc }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.index")}}
                                                                        </b-col>
                                                                        <b-col cols="7">                                                                        
                                                                            <h4>{{ charger.index }}</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.i_out")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ charger.charger_I }}mA</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.v_out")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ charger.charger_V }}V</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{$t("sicuro_mobile.temp")}}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <h4>{{ charger.charger_Temp/10 }}°C</h4>
                                                                        </b-col>
                                                                    </b-row>
                                                                    <b-row>
                                                                        <b-col cols="5" class="dataLabels">
                                                                            {{ $t("sicuro_mobile.status") }}
                                                                        </b-col>
                                                                        <b-col cols="7">
                                                                            <IconErrorAkChargerSwitch
                                                                                :dev="charger"
                                                                                tipo="charger"
                                                                                scale="fa-1x"
                                                                                scalefont="1"
                                                                            />
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                                <!-- modal detail -->
                                                                <b-col cols="1">
                                                                    <b-row>
                                                                        <b-col cols="12" class="nopadding d-flex align-items-center">
                                                                            <b-dropdown variant="link" size="lg"
                                                                                toggle-class="text-decoration-none" no-caret right>
                                                                                <template slot="button-content">
                                                                                    <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                            style="color:black"></i></b>
                                                                                </template>
                                                                                <b-dropdown-item @click="showChargerDetails(charger)">
                                                                                    {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                                </b-dropdown-item>
                                                                            </b-dropdown>
                                                                        </b-col>
                                                                    </b-row>
                                                                </b-col>
                                                            </b-row>
                                                        </b-card>
                                                        <!-------------------------------------------------->
                                                        <!-------------- LSSA mobile ----------------------->
                                                        <!-------------------------------------------------->
                                                        <LssaDisplay 
                                                            :lssa_array="cent.lssa"
                                                            :editingLssa="editingLssa"
                                                            :updatingName="updatingName"
                                                            :sendConfig="sendConfigLssaSicuroCommand"
                                                            :sendDesc="sendDescLssaSicuroCommand"
                                                            @editing-lssa="handleEditingLssa"
                                                            @updating-lssa="handleUpdating"
                                                        />

                                                    </b-collapse>

                                                    <!-------------------------------------------------->
                                                    <!-------------------------------------------------->
                                                    <!-- tabella lampade centralizzate small , mobile -->
                                                    <!-------------------------------------------------->
                                                    <!-------------------------------------------------->
                                                    <b-collapse
                                                        v-if="cent.enabled && cent.cu_type != 'blegateway' && cent.cu_type != 'sicuro'"
                                                        :id="'collapse-' + cent.cu_type + cent.cu_id" class="mt-2">
                                                        <!-- lampade emergenza -->
                                                        <b-card v-for="(lamp, lampindex) in cent.lamps" v-bind:key="lamp.id"
                                                            :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'block' }"
                                                            class="lampCard" no-body>
                                                            <b-row>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-checkbox
                                                                        :disabled="!cent.enabled || centSelObject(cent) || selectedGroup != ''"
                                                                        :value="'lamp' + lamp.id + '-' + (centIndex) + '-' + lampindex"
                                                                        :id="'lamp' + lamp.id + '-' + (centIndex) + '-' + lampindex" />
                                                                </b-col>
                                                                <b-col cols="2" class="nopadding">
                                                                    <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                                        :src="lamp.product_image.includes('|') ? pathDeviceImages + lamp.product_image.split('|')[0] : pathDeviceImages + lamp.product_image"
                                                                        style="height:60px; width:auto;" />
                                                                    <div v-else class="ml-1">
                                                                        <img :src="'/img/emergency.jpg'"
                                                                            style="height:auto; width:80px;" />
                                                                    </div>
                                                                </b-col>
                                                                <b-col cols="8" class="pl-5">
                                                                    <h4>{{ lamp.desc }}<br /></h4>
                                                                    <span
                                                                        v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                        v-bind:class="[setByUser(lamp.product_rev)]">
                                                                        <span v-if="lamp.multiple_products != null">
                                                                            Cod. {{ lamp.order_code }}
                                                                        </span>
                                                                        <b-dropdown
                                                                            v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                                variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                                            <template slot="button-content">
                                                                                <span v-if="!updatingProduct"
                                                                                    :content="$t('details_lamp.lamp_info_alternative')"
                                                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                                                    <b>
                                                                                        <i class="fa fa-1x fa-list"
                                                                                            style="color:primary"></i>
                                                                                    </b>
                                                                                </span>
                                                                                <span
                                                                                    v-if="updatingProduct && currentLamp == lamp">
                                                                                    <i class="fa fa-spinner fa-spin"></i></span>
                                                                            </template>
                                                                            <b-dropdown-item>
                                                                                <div class="typo-label"
                                                                                    style="text-align:center;">
                                                                                    <b>{{ $t('details_lamp.alternative_products')}}</b>
                                                                                </div>
                                                                            </b-dropdown-item>
                                                                            <b-dropdown-item
                                                                                v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)"
                                                                                :key="key">
                                                                                <div class="typo-label"
                                                                                    v-on:click="setLampProductByUser(lamp, item)"
                                                                                    style="text-align:center">{{ item }}
                                                                                </div>
                                                                            </b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </span>
                                                                    <span v-else>
                                                                        Cod. {{ lamp.order_code }}
                                                                    </span>
                                                                    <div v-if="lamp.product_desc != null && (lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false)"
                                                                        class="dataLabels">
                                                                        <span v-if="lamp.product_desc.includes('|')">
                                                                        {{lamp.product_desc.split('|')[0] }}</span>
                                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                                    </div>


                                                                    <h5><span style="font-size:smaller;" class="pr-1">
                                                                    [{{(lamp.index + 1).toString().padStart(3, '0') }}]</span>
                                                                        ID: {{ lamp.id }} <span
                                                                            style="padding-left: 20px"></span>
                                                                        <img v-if="lamp.lamp_type == 'SA'" src="/img/SA.png"
                                                                            class="icon-lamp-type" />
                                                                        <img v-if="lamp.lamp_type == 'SE'" src="/img/SE.png"
                                                                            class="icon-lamp-type" />
                                                                        <img v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'"
                                                                            src="/img/uvoxyIcon.png"
                                                                            class="icon-lamp-type" />
                                                                    </h5>
                                                                </b-col>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-dropdown variant="link" size="lg"
                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                        <template slot="button-content">
                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                    style="color:black"></i></b>
                                                                        </template>
                                                                        <b-dropdown-item
                                                                            @click="showLampDetails(cent, lamp)">
                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                                                        <div class="dropdown-divider"
                                                                            v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type != 'logica'">
                                                                        </div>
                                                                        <b-dropdown-item @click="showLampBlink(cent, lamp)"
                                                                            v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type != 'logica'">
                                                                            {{$t("cu_table_row.dropdown_blink")}}</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_state") }}
                                                                </b-col>
                                                                <b-col cols="1">
                                                                    <IconErrorLamp :lamp="lamp" scale="fa-1x" scalefont="1"></IconErrorLamp> <!-- error lampade emergenza centralizzate mobile view-->
                                                                </b-col>
                                                                <b-col cols="1">    
                                                                    <IconEmergencyOn :lamp="lamp" scale="1"></IconEmergencyOn> <!-- emergency lampade emergenza centralizzate mobile view-->
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("id_cu") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ cent.cu_id }}
                                                                </b-col>
                                                            </b-row>
                                                            <b-row v-if="lamp.lamp_type != 'SE'">
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_sa_dimming") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong
                                                                        v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false">
                                                                        <div v-if="lamp.lamp_type != 'SE' && lamp.shadow_pending"
                                                                            v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('sa_dimming'))]">
                                                                            {{ lamp.sa_dimming }}
                                                                            <i v-if="lamp.sa_dimming != 'SE' && lamp.sa_presence == 'SA PRESENTE'"
                                                                                class="fas fa-lightbulb"
                                                                                style="color:gold"></i>
                                                                            <i v-if="lamp.sa_dimming != 'SE' && lamp.sa_presence == 'SA NON PRESENTE'"
                                                                                class="far fa-lightbulb"
                                                                                style="color:black"></i>
                                                                        </div>
                                                                        <div
                                                                            v-if="lamp.lamp_type != 'SE' && !lamp.shadow_pending">
                                                                            {{ lamp.sa_dimming }}
                                                                            <i v-if="lamp.sa_dimming != 'SE' && lamp.sa_presence == 'SA PRESENTE'"
                                                                                class="fas fa-lightbulb"
                                                                                style="color:gold"></i>
                                                                            <i v-if="lamp.sa_dimming != 'SE' && lamp.sa_presence == 'SA NON PRESENTE'"
                                                                                class="far fa-lightbulb"
                                                                                style="color:black"></i>
                                                                        </div>
                                                                    </strong>
                                                                    <strong v-else>
                                                                        --
                                                                    </strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_autonomy") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong v-if="lamp.shadow_pending"
                                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('autonomy'))]">
                                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false"
                                                                            class="dataValues">{{ lamp.autonomy }}</div>
                                                                        <div v-else>--</div>
                                                                    </strong>
                                                                    <strong v-else>
                                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false"
                                                                            class="dataValues">{{ lamp.autonomy }}</div>
                                                                        <div v-else>--</div>
                                                                    </strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_parity") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong v-if="lamp.shadow_pending"
                                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('parity'))]">
                                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false"
                                                                            class="dataValues">{{ $t("param_lamp." + lamp.parity).toUpperCase() }}</div>
                                                                        <div v-else>--</div>
                                                                    </strong>
                                                                    <strong v-else>
                                                                        <div v-if="lamp.cu_type != 'logicafm' || lamp.nodo_orfano == false"
                                                                            class="dataValues">{{ $t("param_lamp." + lamp.parity).toUpperCase() }}</div>
                                                                        <div v-else>--</div>
                                                                    </strong> </b-col>
                                                            </b-row>
                                                            <b-row v-if="lamp.lssa && cent.cu_type.startsWith('cablecom')">
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_infinity") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong v-if="lamp.shadow_pending"
                                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('lssa'))]">
                                                                        <div class="dataValues">{{ $t("param_lamp." + lamp.lssa).toUpperCase() }}
                                                                        </div>
                                                                    </strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                v-if="lamp.fan_sanifica && lamp.fan_sanifica != '--' && lamp.fan_sanifica != '-'">
                                                                <b-col cols="5" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_sanifica") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong v-if="lamp.shadow_pending"
                                                                        v-bind:class="[shadowPendingClass(lamp.shadow_pending.indexOf('lamp.tuboUV_fase_sanifica'))]">
                                                                        <div>{{ lamp.tuboUV_fase_sanifica.toUpperCase() }}
                                                                        </div>
                                                                    </strong>
                                                                </b-col>
                                                            </b-row>
                                                        </b-card>

                                                        <!-- lampade illuminazione -->
                                                        <b-card v-for="(lamp, lampindex) in cent.lamps_illum"
                                                            v-bind:key="lamp.id"
                                                            :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'block' }"
                                                            class="lampCard" no-body>
                                                            <b-row>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-checkbox
                                                                        :disabled="!cent.enabled || centSelObject(cent) || selectedGroup != ''"
                                                                        :value="'lampIll' + lamp.id + '-' + (centIndex) + '-' + lampindex"
                                                                        :id="'lampIll' + lamp.id + '-' + (centIndex) + '-' + lampindex" />
                                                                </b-col>
                                                                <b-col cols="2" class="nopadding">
                                                                    <img :src="pathDeviceImages + lamp.product_image"
                                                                        style="height:auto; width:100%;" />
                                                                </b-col>
                                                                <b-col cols="8">
                                                                    <h4>{{ lamp.desc }}<br /></h4>
                                                                    <span
                                                                        v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                        v-bind:class="[setByUser(lamp.product_rev)]">
                                                                        <span v-if="lamp.multiple_products != null">
                                                                            Cod. {{ lamp.order_code }}
                                                                        </span>
                                                                        <b-dropdown
                                                                            v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                            variant="link" size="lg"
                                                                            toggle-class="text-decoration-none" no-caret
                                                                            right>
                                                                            <template slot="button-content">
                                                                                <span v-if="!updatingProduct"
                                                                                    :content="$t('details_lamp.lamp_info_alternative')"
                                                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                                                    <b>
                                                                                        <i class="fa fa-1x fa-list"
                                                                                            style="color:primary"></i>
                                                                                    </b>
                                                                                </span>
                                                                                <span
                                                                                    v-if="updatingProduct && currentLamp == lamp"><i
                                                                                        class="fa fa-spinner fa-spin"></i></span>
                                                                            </template>
                                                                            <b-dropdown-item>
                                                                                <div class="typo-label"
                                                                                    style="text-align:center;">
                                                                                    <b>{{$t('details_lamp.alternative_products')}}</b>
                                                                                </div>
                                                                            </b-dropdown-item>
                                                                            <b-dropdown-item
                                                                                v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)"
                                                                                :key="key">
                                                                                <div class="typo-label"
                                                                                    v-on:click="setLampProductByUser(lamp, item)"
                                                                                    style="text-align:center">{{ item }}
                                                                                </div>
                                                                            </b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </span>
                                                                    <span v-else>
                                                                        Cod. {{ lamp.order_code }}
                                                                    </span>
                                                                    <div v-if="lamp.product_desc != null">
                                                                        <span v-if="lamp.product_desc.includes('|')">{{lamp.product_desc.split('|')[0]}}</span>
                                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                                    </div>
                                                                    <h5><span style="font-size:smaller;" class="pr-1">
                                                                    [{{(lamp.index + 1).toString().padStart(3, '0') }}]</span>
                                                                        ID: {{ lamp.id }} </h5>
                                                                </b-col>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-dropdown variant="link" size="lg"
                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                        <template slot="button-content">
                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                    style="color:black"></i></b>
                                                                        </template>
                                                                        <b-dropdown-item
                                                                            @click="showLampDetails(cent, lamp)">
                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}</b-dropdown-item>
                                                                        <div class="dropdown-divider"
                                                                            v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type != 'logica'">
                                                                        </div>
                                                                        <b-dropdown-item @click="showLampBlink(cent, lamp)"
                                                                            v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type != 'logica'">
                                                                            {{$t("cu_table_row.dropdown_blink")}}</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("id_cu") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ cent.cu_id }}
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_state") }}
                                                                </b-col>
                                                                <b-col cols="5">
                                                                    <IconErrorLamp :lamp="lamp" scale="fa-1x" scalefont="1"></IconErrorLamp>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_actual_power") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>
                                                                        {{ (parseFloat(lamp.potenza_attuale).toFixed(1) + "W")}}</strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_energy") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>
                                                                        {{ ((parseFloat(lamp.energia_consumata) / 1000).toFixed(1) + " kWh") }}</strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_timeon") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>
                                                                        {{ (parseFloat(lamp.TimeOn)).toFixed(0)}}</strong>
                                                                </b-col>
                                                            </b-row>

                                                        </b-card>

                                                        <!-- sensori -->
                                                        <b-card v-for="(lamp, lampindex) in cent.sensors"
                                                            v-bind:key="lamp.id"
                                                            :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'block' }"
                                                            class="lampCard" no-body>
                                                            <b-row>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-checkbox
                                                                        :disabled="!cent.enabled || centSelObject(cent) || selectedGroup != ''"
                                                                        :value="'sensor' + lamp.id + '-' + (centIndex) + '-' + lampindex"
                                                                        :id="'sensor' + lamp.id + '-' + (centIndex) + '-' + lampindex" />
                                                                </b-col>
                                                                <b-col cols="2" class="nopadding">
                                                                    <img :src="pathDeviceImages + lamp.product_image"
                                                                        style="height:auto; width:100%;" />
                                                                </b-col>
                                                                <b-col cols="8">
                                                                    <h4>{{ lamp.desc }}<br/></h4>
                                                                    <span>
                                                                        Cod. {{ lamp.order_code }}
                                                                    </span>
                                                                    <div v-if="lamp.product_desc != null">
                                                                        <span v-if="lamp.product_desc.includes('|')">{{lamp.product_desc.split('|')[0]}}</span>
                                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                                    </div>
                                                                    <h5><span style="font-size:smaller;" class="pr-1">
                                                                        [{{(lamp.index + 1).toString().padStart(3, '0') }}]</span>
                                                                        ID: {{ lamp.id }} 
                                                                    </h5>
                                                                </b-col>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-dropdown variant="link" size="lg"
                                                                        toggle-class="text-decoration-none" no-caret right>
                                                                        <template slot="button-content">
                                                                            <b><i class="fa fa-1x fa-ellipsis-v"
                                                                                    style="color:black"></i></b>
                                                                        </template>
                                                                        <b-dropdown-item
                                                                            @click="showLampDetails(cent, lamp)">
                                                                            {{$t("cu_table_row.dropdown_dettaglio")}}
                                                                        </b-dropdown-item>
                                                                    </b-dropdown>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_state") }}
                                                                </b-col>
                                                                <b-col cols="5">
                                                                    <IconErrorLamp :lamp="lamp" scale="fa-1x" scalefont="1"></IconErrorLamp>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.sensor_info") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>
                                                                        --</strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="3" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.sensor_setting") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>
                                                                        --</strong>
                                                                </b-col>
                                                            </b-row>
                                                        </b-card>
                                                    </b-collapse>

                                                    <!-------------------------------------------------------->
                                                    <!-------------------------------------------------------->
                                                    <!-- tabella lampade bluetooth in gateway small, mobile -->
                                                    <!-------------------------------------------------------->
                                                    <!-------------------------------------------------------->

                                                    <b-collapse v-if="cent.enabled && cent.cu_type == 'blegateway'"
                                                        :id="'collapse-' + cent.cu_type + cent.cu_id" class="mt-2">
                                                        <b-card v-for="(lamp, lampindex) in cent.lamps" v-bind:key="lamp.id"
                                                            :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'block' }"
                                                            class="lampCard" no-body>
                                                            <b-row>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-checkbox
                                                                        :disabled="!cent.enabled || centraliSel.length > 0"
                                                                        :value="'lamp' + lamp.id + '-' + (centIndex) + '-' + lampindex"
                                                                        :id="'lamp' + lamp.id + '-' + (centIndex) + '-' + lampindex" />
                                                                </b-col>
                                                                <!--image-->
                                                                <b-col cols="2" class="nopadding">
                                                                    <td v-if="lamp.model == 9 && (plantId == '9a153b8f-8415-4fa9-a841-fa47ad81ba58' || plantId == '8252a057-3297-4a60-a04a-bcddf1ba2836')"
                                                                        class="imgColumnClass">
                                                                        <img v-if="lamp.id != '1F5F' && lamp.id != '312C' && lamp.id != '5426' && lamp.id != '5E13'"
                                                                            :src="pathDeviceImages + 'Led-Panel-RTI-300x1200-product.jpg'"
                                                                            style="height:60px; width:auto;" />
                                                                        <img v-else :src="pathDeviceImages + 'BS-100-SD-LED-product.jpg'"
                                                                            style="height:60px; width:auto;" />
                                                                    </td>
                                                                    <td v-else class="imgColumnClass">
                                                                        <img v-if="lamp.product_image != null && lamp.product_image != ''"
                                                                            :src="pathDeviceImages + lamp.product_image"
                                                                            style="height:60px; width:auto;" />
                                                                        <div v-else class="ml-1">
                                                                            <img :src="'/img/emergency.jpg'" style="height:auto; width:80px;" />
                                                                        </div>
                                                                    </td>
                                                                </b-col>
                                                                <!-- lamp id, desc, order code, se/sa type-->
                                                                <b-col cols="8" class="pl-5">
                                                                    <h4>{{ lamp.desc }}<br /></h4>
                                                                    <div><span style="font-size:smaller;" class="pr-1">[{{ (lampindex + 1).toString() }}]</span><b>ID:
                                                                            {{ lamp.id }}</b>
                                                                        <span style="padding-left: 20px"></span>
                                                                        <img v-if="lamp.lamp_type == 'SA'" src="/img/SA.png" class="icon-lamp-type">
                                                                        <img v-if="lamp.lamp_type == 'SE'" src="/img/SE.png" class="icon-lamp-type">
                                                                    </div>
                                                                    <div class="dataLabels">Cod. {{ lamp.order_code }} </div>
                                                                    <div class="dataLabels">{{ lamp.product_desc }}</div>
                                                                </b-col>

                                                                <b-col cols="1" class="nopadding">
                                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                                        <template slot="button-content">
                                                                            <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                                        </template>
                                                                        <b-dropdown-item @click="showLampDetails(cent, lamp)">{{ $t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </b-col>
                                                            </b-row>
                                                            <div> </div>
                                                            <!-- power for ble-illum && modalità for ble-emergency-->
                                                            <b-row v-if="lamp.model == 9">
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_actual_power") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ lamp.istantaneousPower }} W
                                                                </b-col>
                                                            </b-row>
                                                            <b-row v-else>
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_sa_dimming") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ lamp.device_function }}
                                                                </b-col>
                                                            </b-row>
                                                            <!-- energy for ble-illum && autonomy for ble-emergency-->
                                                            <b-row v-if="lamp.model == 9">
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_energy") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ lamp.energy / 1000 }} kWh
                                                                </b-col>
                                                            </b-row>
                                                            <b-row v-else>
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_autonomy") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ lamp.autonomy }}
                                                                </b-col>
                                                            </b-row>
                                                            <!-- timeon for ble-illum && parity for ble-emergency-->
                                                            <b-row v-if="lamp.model == 9">
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_timeon") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ lamp.functionHours }}
                                                                </b-col>
                                                            </b-row>
                                                            <b-row v-else>
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_parity") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ $t("param_lamp." + lamp.parity).toUpperCase() }}
                                                                </b-col>
                                                            </b-row>
                                                            <!---stato-->
                                                            <b-row>
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_state") }}
                                                                </b-col>
                                                                <b-col cols="1">
                                                                    <IconErrorLamp :lamp="lamp" scale="fa-1x" scalefont="1"></IconErrorLamp>  <!-- bluetooth lamp-->
                                                                </b-col>
                                                            </b-row>
                                                            <!--id cu-->
                                                            <b-row>
                                                                <b-col cols="4" class="dataLabels">
                                                                    {{ $t("id_cu") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataLabels">
                                                                    {{ cent.cu_id }}
                                                                </b-col>
                                                            </b-row>
                                                            <!--rssi-->
                                                            <b-row>
                                                                <b-col cols="12" class="dataLabels">{{ $t("report_pdf.last_sync") }}
                                                                    <span>
                                                                        {{ moment(new Date(lamp.last_sync)).utc().format('DD-MM-YYYY') + " " + moment(new Date(lamp.last_sync)).format('HH:mm:ss') }}
                                                                    </span>
                                                                    <span class="m-2">

                                                                        <i class="icon__signal-strength" v-bind:class="[RssiClass(lamp.rssi)]">
                                                                            <span class="bar-1"></span>
                                                                            <span class="bar-2"></span>
                                                                            <span class="bar-3"></span>
                                                                            <span class="bar-4"></span>
                                                                            <span class="bar-5"></span>
                                                                        </i>
                                                                        <span v-if="lamp.rssi == 0" style="margin-left:-10px;color:red;font-weight: 900;">x</span>
                                                                    </span>
                                                                    <span v-if="lamp.rssi != 0 && directBleVisibility(lamp.rssi) == false" class="pt-3">
                                                                    {{lamp.rssi}}</span>
                                                                    <span v-if="lamp.rssi != 0 && directBleVisibility(lamp.rssi) == true" class="pt-3">
                                                                        {{ lamp.rssi.replaceAll('*', '-') }}
                                                                        <i class="fa fa-1x fa-retweet" style="color:blue;"></i>
                                                                    </span>
                                                                </b-col>
                                                            </b-row>

                                                        </b-card>

                                                        <!-- lampade illuminazione -->
                                                        <b-card v-for="(lamp, lampindex) in cent.lamps_illum" v-bind:key="lamp.id"
                                                            :style="{ 'display': (lamp['visible'] == false) ? 'none' : 'block' }" class="lampCard" no-body>
                                                            <b-row>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-checkbox :disabled="!cent.enabled || centraliSel.length > 0"
                                                                        :value="'lampIll' + lamp.id + '-' + (centIndex) + '-' + lampindex"
                                                                        :id="'lampIll' + lamp.id + '-' + (centIndex) + '-' + lampindex" />
                                                                </b-col>
                                                                <b-col cols="2" class="nopadding">
                                                                    <img :src="pathDeviceImages + lamp.product_image" style="height:auto; width:100%;" />
                                                                </b-col>
                                                                <b-col cols="8">
                                                                    <h4>{{ lamp.desc }}<br /></h4>
                                                                    <span v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                        v-bind:class="[setByUser(lamp.product_rev)]">
                                                                        <span v-if="lamp.multiple_products != null">
                                                                            Cod. {{ lamp.order_code }}
                                                                        </span>
                                                                        <b-dropdown
                                                                            v-if="lamp.order_code != null && lamp.multiple_products && lamp.multiple_products.order_code"
                                                                            variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                                            <template slot="button-content">
                                                                                <span v-if="!updatingProduct" :content="$t('details_lamp.lamp_info_alternative')"
                                                                                    v-tippy="{ placement: 'top', arrow: true }">
                                                                                    <b>
                                                                                        <i class="fa fa-1x fa-list" style="color:primary"></i>
                                                                                    </b>
                                                                                </span>
                                                                                <span v-if="updatingProduct && currentLamp == lamp"><i
                                                                                        class="fa fa-spinner fa-spin"></i></span>
                                                                            </template>
                                                                            <b-dropdown-item>
                                                                                <div class="typo-label" style="text-align:center;">
                                                                                    <b>{{ $t('details_lamp.alternative_products') }}</b>
                                                                                </div>
                                                                            </b-dropdown-item>
                                                                            <b-dropdown-item
                                                                                v-for="(item, key) in getListProductCode(lamp.multiple_products.order_code)" :key="key">
                                                                                <div class="typo-label" v-on:click="setLampProductByUser(lamp, item)"
                                                                                    style="text-align:center">
                                                                                    {{ item }}</div>
                                                                            </b-dropdown-item>
                                                                        </b-dropdown>
                                                                    </span>
                                                                    <span v-else>
                                                                        Cod. {{ lamp.order_code }}
                                                                    </span>
                                                                    <div v-if="lamp.product_desc != null">
                                                                        <span v-if="lamp.product_desc.includes('|')">{{ lamp.product_desc.split('|')[0] }}</span>
                                                                        <span v-else>{{ lamp.product_desc }}</span>
                                                                    </div>
                                                                    <h5>
                                                                        <span style="font-size:smaller;" class="pr-1">
                                                                            [{{ (lamp.index + 1).toString().padStart(3, '0') }}]
                                                                        </span> ID: {{ lamp.id }} 
                                                                    </h5>
                                                                </b-col>
                                                                <b-col cols="1" class="nopadding">
                                                                    <b-dropdown variant="link" size="lg" toggle-class="text-decoration-none" no-caret right>
                                                                        <template slot="button-content">
                                                                            <b><i class="fa fa-1x fa-ellipsis-v" style="color:black"></i></b>
                                                                        </template>
                                                                        <b-dropdown-item @click="showLampDetails(cent, lamp)">
                                                                        {{$t("cu_table_row.dropdown_dettaglio") }}</b-dropdown-item>
                                                                        <div class="dropdown-divider"
                                                                            v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type != 'logica'">
                                                                        </div>
                                                                        <b-dropdown-item @click="showLampBlink(cent, lamp)"
                                                                            v-if="cent.enabled && ($store.getters.userRole == 'installer' || $store.getters.userRole == 'collab') && cent.cu_type != 'logica'">
                                                                            {{$t("cu_table_row.dropdown_blink")}}
                                                                        </b-dropdown-item>
                                                                    </b-dropdown>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="5" offset="1" class="dataLabels">
                                                                    {{ $t("id_cu") }}
                                                                </b-col>
                                                                <b-col cols="5" class="dataValues">
                                                                    {{ cent.cu_id }}
                                                                </b-col>
                                                                <b-col cols="1">
                                                                    <IconErrorLamp :lamp="lamp" scale="fa-1x" scalefont="1"></IconErrorLamp>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="5" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_actual_power") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>{{ (parseFloat(lamp.potenza_attuale).toFixed(1) + " W") }}</strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="5" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_energy") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>{{ ((parseFloat(lamp.energia_consumata) / 1000).toFixed(1) + " kWh") }}</strong>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row>
                                                                <b-col cols="5" offset="1" class="dataLabels">
                                                                    {{ $t("details_lamp.lamp_timeon") }}
                                                                </b-col>
                                                                <b-col cols="6">
                                                                    <strong>{{ (parseFloat(lamp.TimeOn)).toFixed(0) }}</strong>
                                                                </b-col>
                                                            </b-row>
                                                        </b-card>
                                                    </b-collapse>
                                                </b-card>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-check-group>
                        </div>
                    </show-at>
                </b-col>
            </b-row>
        </div>

        <!-- Multiple products on list device modal -->
        <b-modal size="md" id="multiple-products-modal" no-close-on-backdrop :title="$t('change_product.warning')"
            @ok="handleOk" ref="multiModal">
            <b-row>
                <b-col class="pl-4 pb-2"> <b>{{this.multipleProductsChecked.length}}</b>  {{$t('change_product.selected_product')}}</b-col>
            </b-row>
            <b-row>
                <b-col class="pl-4"> <b>{{this.multipleProductsSelection.length}}</b>  {{$t('change_product.changed_product')}}</b-col>
            </b-row>       
        </b-modal>

        <!-- Configura Centrale -->
        <b-modal 
            v-if="currentCent != null" size="md"
            :hide-footer="configInProgress > 0 || configCompleted == true || delete_sn == true" 
            id="config-cent-modal"
            no-close-on-backdrop 
            :title="$t('config_cu_modal.title', { tipo: currentCent.cu_type, id: currentCent.cu_id })"
            :ok-only="true"
            :ok-title="(this.selected_modalita_logica == 'logica_delete') ? $t('config_cu_modal.button_logica_delete') : $t('config_cu_modal.button_config')"
            @ok="sendConfigCent($event, currentCent.cu_type, currentCent.cu_id)" 
            @close="stopGetDati()"
        >
            <b-row>
                <b-col v-if="currentCent.cu_product_image" cols="3">
                    <img :src="pathDeviceImages + currentCent.cu_product_image" style="height:60px; width:auto;" />
                </b-col>
                <b-col v-else cols="3">
                    <img v-if="currentCent.cu_type == 'logicafm'" :src="'/img/logicafmsd/centrale.png'" style="height:60px; width:auto;" />
                    <img v-if="currentCent.cu_type == 'logica'" :src="'/img/logica/centrale.png'" style="height:60px; width:auto;" />
                    <img v-if="currentCent.cu_type == 'cablecom'" :src="'/img/cablecom/centrale.png'" style="height:60px; width:auto;" />
                    <img v-if="currentCent.cu_type == 'sicuro'" :src="pathDeviceImages + 'cu_sicuro.jpg'" style="height:auto; width:80%;" />
                </b-col>
                <b-col cols="3">
                    <b-row>
                        <b-col>
                            {{ $t("details_cu_modal.cu_type") }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <strong>{{currentCent.cu_type }}</strong>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3">
                    <b-row>
                        <b-col>
                            {{ $t("details_cu_modal.cu_id") }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <strong>{{ currentCent.cu_id}}</strong>
                    </b-row>
                </b-col>
                <b-col cols="3">
                    <b-row>
                        <b-col>
                            {{ $t("details_cu_modal.cu_descrizione") }}
                        </b-col>
                    </b-row>
                    <b-row>
                        <strong>{{currentCent.cu_desc }}</strong>
                    </b-row>
                </b-col>
            </b-row>
            <hr>

            <!-- cablecom config lamp -->
            <b-row v-if="currentCent.cu_type == 'cablecom' && !this.reopenConfig">
                <b-form-group class="ml-5 mt-4">
                    <label class="h6">{{ $t("config_cu_modal.seleziona_numero_lampade") }}</label>
                    <b-form-select v-model="selected_num_lamp" :options="options_lamp">

                    </b-form-select>
                </b-form-group>
                <b-form-group class="ml-5 mt-2 mb-5">
                    <label class="h6">{{ $t("config_cu_modal.seleziona_ore_autonomia") }}</label>
                    <b-form-select v-model="selected_ore_autonomia" :options="options_ore_autonomia"></b-form-select>
                </b-form-group>
            </b-row>

            <!-- logica config lamp -->
            <b-row v-if="(currentCent.cu_type == 'logica' || currentCent.cu_type == 'logicafm') && !this.reopenConfig">
                <b-form-group class="ml-4 mt-2 mb-4 mr-4">
                    <label class="h6">{{ $t("config_cu_modal.modalita_configurazione_logica") }}</label>
                    <b-row>
                        <b-col cols="12">
                            <b-form-select v-if="currentCent.cu_type == 'logica'" v-model="selected_modalita_logica"
                                :options="options_modalita_logica"></b-form-select>
                            <b-form-select v-if="currentCent.cu_type == 'logicafm'" v-model="selected_modalita_logica"
                                :options="options_modalita_logica_fm"></b-form-select>
                        </b-col>
                    </b-row>

                    <!-- logicafm creazione rete radio -->
                    <div v-if="selected_modalita_logica == 'network_create'" class="mt-4 float-left ml-2 mr-4">
                        <label for="cu-list-device" class="typo-label mb-2">{{
                            $t("config_cu_modal.logica_sn_list") }}</label>
                        <b-form-textarea id="cu-list-device" :disabled=true v-model="logica_cu_list" :state=true rows="10">
                        </b-form-textarea>
                    </div>
                    <div v-if="selected_modalita_logica == 'network_create'" class="mt-4 ml-3 float-left">
                        <label for="select_plant_code" class="typo-label mb-2">{{ $t("config_cu_modal.plant_code") }}
                            <!--<span class="infoTip" :content="$t('config_cu_modal.plant_code_info')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-1x fa-info-circle" style="color:#009DE0" ></i></span>-->
                        </label>
                        <!--<b-form-select v-model="selected_plant_code">
                                    <option v-for="t in maxPlantCode" :value="t" :key="t">
                                        {{ t }}
                                    </option>
                                </b-form-select>-->
                        <div style="border:solid 1px" class="p-1"><strong>{{ this.selected_plant_code }}</strong></div>
                    </div>

                    <!-- :state=true  -->
                    <!-- logica inserimento serial number manualmente -->
                    <b-row>
                        <b-col cols="6">
                            <div v-if="selected_modalita_logica == 'logica_preset'" class="mt-4 float-left ml-2 mr-4">
                                <label for="cu-list-device" class="typo-label mb-2">{{
                                    $t("config_cu_modal.logica_sn_list") }}</label>
                                <b-form-textarea id="cu-list-device" :disabled=true v-model="logica_cu_list" rows="10" style="font-family:Monospace">
                                </b-form-textarea>
                            </div>
                        </b-col>

                        <b-col cols="6">
                            <div v-if="selected_modalita_logica == 'logica_preset'" class="mt-4 ml-3 float-left">
                                <label v-if="centQrLamps.length > 0 && !editingCSV" class="typo-label mb-2 mr-2">
                                    {{$t("config_cu_modal.logica_sn_addlist")}}</label>
                                <label v-if="centQrLamps.length <= 0 && !editingCSV" class="typo-label mb-2 mr-2">
                                    {{$t("config_cu_modal.logica_sn_enter")}}
                                </label>
                                <label v-if="editingCSV" for="file-list-device" class="typo-label mb-2">
                                    {{$t("config_cu_modal.logica_sn_input")}}
                                    <span class="infoTip" :content="$t('config_cu_modal.logica_sn_input_info')"
                                        v-tippy="{ placement: 'top', arrow: true }">
                                        <i class="fa fa-1x fa-info-circle" style="color:#009DE0"></i>
                                    </span>
                                </label>
                                <label v-if="scanningQrLamp" class="typo-label mb-2">{{$t("config_cu_modal.logica_sn_scan_qr")}}
                                    <b-button size="sm" @click="stopScanQrLamp" class="ml-2" variant="secondary"><i
                                            class="fa fa-1x fa-check" /></b-button>
                                </label>

                                <qrcode-stream v-if="scanningQrLamp || scanLampInitialized" @decode="onDecodeQrLamp2"
                                    @init="onInitQrLamp"
                                    v-bind:style="{ height: '160px', width: '190px', display: (scanningQrLamp) ? 'block' : 'none' }"></qrcode-stream>
                                <div v-if="scanningQrLamp || scanLampInitialized"
                                    style="border: 1px solid #ccc; padding: 4px">
                                    {{$t("config_cu_modal.logica_sn_code_read")}} <strong>{{ qrScanned }}</strong>
                                </div>
                                <b-form-textarea v-if="editingCSV" id="file-list-device" v-model="logica_config_sn"
                                    placeholder="" rows="10" style="font-family:Monospace" :formatter="TextAreaFormatter" autofocus>
                                </b-form-textarea>
                                <b-button v-if="editingCSV" size="sm" @click="endEditCSV()" class="btn-block mt-1"
                                    variant="primary"><i class="fa fa-1x fa-save mr-1" /><span>{{$t("config_cu_modal.logica_sn_stop_in")}}</span>
                                </b-button>
                                <b-button v-if="editingCSV" size="sm" @click="cancella()" class="btn-block mt-1"
                                    variant="info"><i class="fa fa-1x fa-close mr-1" /><span>{{$t("config_cu_modal.logica_sn_cancel")}}</span>
                                </b-button>
                                <div class="QrLampsContainer"
                                    v-if="!editingCSV && !scanningQrLamp && centQrLamps.length > 0"
                                    style="height: 224px; width: 190px">
                                    <div v-for="(qrLamp, indexQr) in centQrLamps" v-bind:key="'qrLamp' + qrLamp"
                                        class="QrLampRow">
                                        <span style="flex-grow: 1; font-weight: bold" class="ml-2">{{ qrLamp }}</span>
                                        <b-button @click="eliminaLampQr(indexQr)">
                                            <i class="fa fa-trash" style="color: #cc0000"></i>
                                        </b-button>
                                    </div>
                                </div>

                                <div>
                                    <span v-if="!editingCSV && !scanningQrLamp">
                                        <div><b-button size="sm" variant="primary" @click="startEditCSV"
                                                class="mb-1 btn-block"><i class="fa fa-1x fa-edit mr-2" />
                                                {{$t("config_cu_modal.logica_sn_write_serialid")}}
                                            </b-button>
                                        </div>
                                        <b-button v-if="currentCent.cu_type == 'logicafm'" @click="startScanQrLamp" size="sm" variant="primary" class="mb-1 btn-block">
                                            <i class="fa fa-1x fa-qrcode mr-2">
                                                {{$t("config_cu_modal.logica_sn_read_qrcode")}}
                                            </i>
                                        </b-button>
                                    </span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-form-group>
            </b-row>



            <b-row v-if="selected_modalita_logica == 'logica_preset'">
                <b-col cols="12">
                    <div v-if="currentCent.cu_type == 'logicafm'" class="ml-4 float-left typo-label">
                        {{ $t("config_cu_modal.modalita_append") }}</div>
                    <b-form-group v-if="currentCent.cu_type == 'logica'" class="ml-4 float-left typo-label"
                        :label='$t("config_cu_modal.modalita_inserimento")' v-slot="{ ariaDescribedby }">
                        <b-form-radio v-if="currentCent.cu_type == 'logica'" v-model="manual_mode_logica"
                            :aria-describedby="ariaDescribedby" name="some-radios" value="append">{{
                            $t("config_cu_modal.modalita_append") }}</b-form-radio>
                        <b-form-radio v-if="currentCent.cu_type == 'logica'" v-model="manual_mode_logica"
                            :aria-describedby="ariaDescribedby" name="some-radios" value="overwrite">{{
                            $t("config_cu_modal.modalita_overwrite") }}</b-form-radio>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-if="selected_modalita_logica == 'logica_substitute' || selected_modalita_logica == 'logica_delete'">
                <b-col cols="4" class="ml-1 mb-1">
                    <b-input-group size="sm">
                        <b-form-input type="text" v-model="filtraDevices" style="text-transform:uppercase"></b-form-input>
                        <template #append>
                            <b-input-group-text><i class="fa fa-search"></i></b-input-group-text>
                        </template>   
                    </b-input-group>
                </b-col>
            </b-row>
            <!-- logica sostituzione e cancellazione serial number -->
            <b-row>
                <b-col cols="6">
                    <div v-if="selected_modalita_logica == 'logica_substitute' || selected_modalita_logica == 'logica_delete'">
                        <label for="cu-list-device" class="typo-label mb-2">{{ $t("config_cu_modal.logica_sn_list") }} </label>
                        <b-form-checkbox v-if="selected_modalita_logica == 'logica_delete'" v-model="deleteAllLamps" id="all_lamp_sel">
                            {{ $t("config_cu_modal.logica_sn_delete_all") }}</b-form-checkbox>
                        <div
                            style="border: 1px solid #ddd; overflow-y: auto; height: 240px; width: 150px; padding-left: 8px; margin-bottom: 8px; ">
                            <b-form-checkbox-group 
                                id="lamp_selection_group" 
                                v-model="substituteLampsSelection"                          
                                :options="showDeletableSerialId" 
                                :disabled="deleteAllLamps" 
                                stacked
                            >
                            </b-form-checkbox-group>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div v-if="selected_modalita_logica == 'logica_substitute'" class="ml-3 float-left">
                        <label for="file-list-device" class="typo-label mb-2">{{ $t("config_cu_modal.logica_sn_input") }}
                            <span class="infoTip" :content="$t('config_cu_modal.logica_sn_substitute_info')"
                                v-tippy="{ placement: 'top', arrow: true }"> <i class="fa fa-1x fa-info-circle"
                                    style="color:#009DE0"></i></span>
                        </label>
                        <b-form-textarea
                            style="height:240px; width: 140px; position: absolute; float: right; margin-left: 59px; font-size: 11pt; padding-top: 6px"
                            id="file-list-device" v-model="logica_config_sn" placeholder="--" rows="10" :formatter="TextAreaFormatter">
                        </b-form-textarea>
                        <div style="width: 60px; height:240px; border: 1px solid #ddd; padding-top: 6px; font-size: 11pt;">
                            <span v-for="(lampId, index) in substituteLampsSelection" :key="index"
                                style="display:block; padding-left: 8px;">{{ lampId }}</span>
                        </div>
                    </div>
                    <div v-if="selected_modalita_logica == 'logica_delete'" class="ml-3 float-left">
                        <label for="file-list-device" class="typo-label mb-2">
                            {{ $t("config_cu_modal.logica_sn_delete_list")}}</label>
                        <div style="width: 150px; height:240px; border: 1px solid #ddd; padding-top: 6px; font-size: 11pt; margin-top: 20px; overflow-y: scroll">
                            <span v-for="(lampId, index) in substituteLampsSelection" :key="index"
                                style="display:block; padding-left: 8px;">{{ lampId }}</span>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-alert v-if="this.delete_sn" variant="danger" show style="clear: both;">
                <i class="fa fa-1x fa-exclamation-circle mr-2"></i>
                {{ $t("config_cu_modal.logica_sn_delete_multi_alert") }}
                <div class="text-right">
                    <b-button variant="primary" class="mr-4" @click="() => { delete_sn = false }">No</b-button>
                    <b-button variant="primary" class="" @click="sendDeleteLgSerial()">Yes</b-button>
                </div>
            </b-alert>

            <!-- alert per errore in caso di inserimento serial ID lampade -->
            <b-row
                v-if="selected_modalita_logica == 'logica_preset' || selected_modalita_logica == 'logica_substitute' || selected_modalita_logica == 'logica_delete'"
                class="alert-feeback-command" style="clear: both;">
                <b-col lg="12" md="12">
                    <b-alert v-for="(alert, indexA) in validation_alerts" :show="alert.timeLeft" v-bind:key="indexA"
                        :variant="alert.state" dismissible fade @dismissed="alert.timeLeft = 0"
                        @dismiss-count-down="alert.countDownChanged">
                        <div>
                            <i v-if="alert.state == 'danger'" class="fa fa-1x fa-exclamation-circle mr-2"></i>
                            <i v-if="alert.state == 'success'" class="fa fa-1x fa-check-circle mr-2"></i>
                            <div class="pb-3" style="display:inline; font-size:13px; height:15px;">{{ alert.msg }}</div>
                        </div>
                    </b-alert>
                </b-col>
            </b-row>

            <b-row v-if="configInProgress > 0">
                <b-col sm="3" class="mx-right">
                    <div class="sk-circle mx-right">
                        <div class="sk-circle1 sk-child"></div>
                        <div class="sk-circle2 sk-child"></div>
                        <div class="sk-circle3 sk-child"></div>
                        <div class="sk-circle4 sk-child"></div>
                        <div class="sk-circle5 sk-child"></div>
                        <div class="sk-circle6 sk-child"></div>
                        <div class="sk-circle7 sk-child"></div>
                        <div class="sk-circle8 sk-child"></div>
                        <div class="sk-circle9 sk-child"></div>
                        <div class="sk-circle10 sk-child"></div>
                        <div class="sk-circle11 sk-child"></div>
                        <div class="sk-circle12 sk-child"></div>
                    </div>
                </b-col>
                <b-col v-if="this.createNetworkInProgress" sm="9" class="my-auto mx-left">
                    <h5>{{ $t("config_cu_modal.network_create_progress") }}</h5>
                    <h5>{{ $t("config_cu_modal.device_found") }} : {{ lamp_found }}</h5>
                </b-col>
                <b-col v-else sm="9" class="my-auto mx-left">
                    <h5 v-html="$tc('config_cu_modal.config_in_corso', lamp_found)"></h5>
                </b-col>
                <b-col sm="12">
                    <b-button variant="primary" class="type-add-button float-right" @click="stopSearching(currentCent)">{{
                        $t("config_cu_modal.end_search").toUpperCase() }}</b-button>
                </b-col>
            </b-row>

            <b-row v-if="configError == true && configRetry == 0">
                <b-col offset="1" sm="10">
                    <div class="text-center"><i class="fa fa-4x fa-exclamation-circle" style="color:red"
                            aria-hidden="true"></i>
                    </div>
                    <div class="text-center mt-3 mb-3 h5" style="color:red">
                        {{ $t("config_cu_modal.error", {cuid: currentCent.cu_id}) }}
                    </div>
                </b-col>
            </b-row>

            <b-row v-if="configError == true && configRetry > 0">
                <b-col offset="1" sm="8">
                    <div class="text-center"><i class="fa fa-4x fa-exclamation-triangle" style="color:orange"
                            aria-hidden="true"></i></div>
                    <div class="text-center mt-3 mb-3">
                        {{ $t("config_cu_modal.config_lamp_impostate", {
                            selected_num_lamp:selected_num_lamp, 
                            lamp_found: lamp_found}) }}
                    </div>
                </b-col>
            </b-row>

            <b-row v-if="configError == false && configCompleted == true">
                <b-col offset="1" sm="10">
                    <div class="text-center"><i class="fa fa-4x fa-check" style="color:green" aria-hidden="true"></i></div>
                    <div class="text-center h5 mt-2 mb-4" v-html="$tc('config_cu_modal.config_completed', lamp_found)">
                    </div>
                </b-col>
            </b-row>

        </b-modal>

        <!-- Blink Lampada -->
        <b-modal v-if="currentLamp != null" id="blink-lamp-modal" no-close-on-backdrop hide-header-close
            :title="$t('lamp_details_modal.blink', { id: currentLamp.id })" :ok-only="true" :ok-title="$t('close')"
            @ok="closeLampBlink">
            <b-row>
                <b-col sm="3" class="ml-4"><img :src="pathDeviceImages + currentLamp.product_image"
                        style="height:30px; width:auto; float: left; margin-right: 10px" /></b-col>
                <b-col sm="6"><b-row><b-col>{{ $t("details_lamp.lamp_prod_desc") }}</b-col></b-row><b-row><b-col><strong>{{
                                currentLamp.product_desc }}</strong></b-col></b-row></b-col>
                <b-col sm="2"><b-row><b-col>{{ $t("details_lamp.lamp_id") }}</b-col></b-row><b-row><b-col><strong>{{
                                currentLamp.id }}</strong></b-col></b-row></b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col sm="3" class="ml-4"></b-col>
                <b-col sm="6">
                    <b-row>
                        <b-col>{{ $t("details_lamp.lamp_desc") }}</b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="10"><strong>{{ currentLamp.desc }}</strong></b-col>
                    </b-row>
                </b-col>
                <b-col sm="2">
                </b-col>
            </b-row>
            <hr>
            <b-row class="m-2">
                <b-col v-if="!blinking" sm="12" class="typo-label">{{ $t("lamp_details_modal.how_blink") }}</b-col>
                <b-col v-if="blinking" sm="12" class="typo-label">{{ $t("lamp_details_modal.blinking") }}</b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <div>
                        <b-button v-if="!blinking" class="typo-butt-command mr-1 ml-1 mt-3 but-oval"
                            @click="sendGenericCommand('blink')"><i class="fa fa-1x fa-play mr-2"></i>{{
                            $t("lamp_details_modal.button_blink") }}</b-button>
                        <!--<b-button v-if="blinking" class="typo-butt-command mr-1 ml-1 mt-3 but-oval" @click="sendGenericCommand('stop_blink')"><i class="fa fa-1x fa-stop mr-2"></i>{{$t("lamp_details_modal.button_stop")}}</b-button>-->
                    </div>
                </b-col>
                <!--<b-col cols="7">
                    <div v-if="blinking"> 
                        <h1 class="mt-2">{{this.blinkActive}}</h1>
                    </div>
                </b-col> -->
            </b-row>
        </b-modal>

        <!-- imposta descrittivi lampade -->
        <b-modal id="modal-descrittivo" :title="$t('comandi_impianto_modal.title_change_desc')" @ok="impostaDescrittivo">
            <b-row>
                <b-col>
                    {{$t("comandi_impianto_modal.desc") }}
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col>
                    <b-form-input type="text" id="frm-descrittivo" v-model="descrittivo"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-form-checkbox id="checkbox-descrittivo" v-model="autoIncrDescrittivo" name="checkbox-1" value="true" unchecked-value="false">
                        {{$t("comandi_impianto_modal.progressivo") }}
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-modal>

        <!-- importa descrittivi lampade -->
        <b-modal id="modal-import-descrittivi" title="Importa Descrittivi Lampade" @ok="importaDescr">
            <b-row>
                <b-col>
                    Selezionare il file con i descrittivi
                </b-col>
            </b-row>
            <b-row class="mt-1">
                <b-col>
                    <b-form-file accept="text/plain, text/csv" v-model="importDescrFile" :state="Boolean(importDescrFile)"
                        placeholder="Seleziona il file" drop-placeholder="Trascina il file qui..."></b-form-file>
                </b-col>
            </b-row>

        </b-modal>


    </div>
</template>

<script>

import Vue from 'vue'
import { ClientTable, Event } from 'vue-tables-2'
Vue.use(ClientTable)

import NavBarMain from '@/components/NavBarMain'
import NavBarDispositivi from '@/components/NavBarDispositivi'
import AddCentralUnit from '@/components/AddCentralUnit'
import DimmingDialog from '@/components/DimmingDialog'
import CreateSceneDialog from '@/components/CreateSceneDialog'
import RemoveCentralUnit from '@/components/RemoveCentralUnit'
import ResetCentralUnit from '@/components/ResetCentralUnit'
import GatewayCommand from '@/components/GatewayCommand'
import GatewayLampsInsert from '@/components/GatewayBle/GatewayLampsInsert'
import GroupsCentralUnit from '@/components/GroupsCentralUnit'
import AdvancedCentralUnit from '@/components/AdvancedCentralUnit'
import InputsCentralUnit from '@/components/InputsCentralUnit'
import ParametriImpianto from '@/components/ParametriImpianto'
import ParametriUvoxy from '@/components/ParametriUvoxy'
import CreaAggregazione from '@/components/CreaAggregazione'
import CreaGruppo from '@/components/CreaGruppo'
import RimuoviGruppo from '@/components/RimuoviGruppo'
import PianificaTest from '@/components/PianificaTest'
import { showAt, hideAt } from 'vue-breakpoints'
import BannerPro from '@/components/BannerPro'
import BannerProExpired from '@/components/BannerProExpired'
import { QrcodeStream } from "vue-qrcode-reader";
import AddToMonitoringZone from '@/components/MonitoringZone/AddToMonitoringZone'
import MultipleAddToMonitoringZone from '@/components/MonitoringZone/MultipleAddToMonitoringZone'
import AkDetails from '@/components/AkDetails'
import CentralDetails from '@/components/CentralDetails.vue'
import LampDetails from '@/components/LampDetails.vue'
import LssaDisplay from '@/components/LssaDisplay.vue'
import LineDetails from '@/components/LineDetails.vue'
import ChargerDetails from '@/components/ChargerDetails.vue'
import IconErrorLamp from '@/components/IconErrorLamp.vue'
import IconEmergencyOn from '@/components/IconEmergencyOn.vue'
import ErrorLampsOnCent from '@/components/ErrorLampsOnCent.vue'
import AddZone from '@/components/AddZone.vue'
import IconErrorAkChargerSwitch from '@/components/IconErrorAkChargerSwitch.vue'
import ErrorBanner from '@/components/ErrorBanner.vue'
import LampConfig from '@/components/LampConfig.vue'
import LineConfig from '@/components/LineConfig.vue'
import IconErrorCentral from '@/components/IconErrorCentral.vue'
import GroupsSicuroCentralUnit from './GroupsSicuroCentralUnit.vue'
import GatewayLampsSearch from '@/components/GatewayBle/GatewayLampsSearch.vue'
import LoaderSmall from '@/components/LoaderSmall.vue'

//Template for print pdf
import jsPDF from 'jspdf';
import JsPDFAutotable from 'jspdf-autotable';

import { mapState } from 'vuex';

const TIMEOUT_CONFIGGRUPPI = 2000; //2secondi

export default {
    name: 'DispositiviImpianto',
    components: {
        IconErrorCentral,
        NavBarMain,
        NavBarDispositivi,
        AddCentralUnit,
        DimmingDialog,
        CreateSceneDialog,
        RemoveCentralUnit,
        ResetCentralUnit,
        GatewayLampsInsert,
        GatewayCommand,
        GroupsCentralUnit,
        AdvancedCentralUnit,
        InputsCentralUnit,
        AddToMonitoringZone,
        MultipleAddToMonitoringZone,
        ParametriImpianto,
        ParametriUvoxy,
        CreaGruppo,
        RimuoviGruppo,
        CreaAggregazione,
        BannerPro,
        BannerProExpired,
        PianificaTest,
        ClientTable,
        Event,
        hideAt,
        showAt,
        QrcodeStream,
        jsPDF,
        JsPDFAutotable,
        AkDetails,
        CentralDetails,
        LampDetails,
        LssaDisplay,
        LineDetails,
        ChargerDetails,
        IconErrorLamp,
        IconEmergencyOn,
        ErrorLampsOnCent,
        AddZone,
        IconErrorAkChargerSwitch,
        ErrorBanner,
        LampConfig,
        LineConfig,
        GroupsSicuroCentralUnit,
        GatewayLampsSearch,
        LoaderSmall
    },
    props: ['plantId', 'devicesType'],
    data()
    {
        return {
            importDescrFile: null,
            importCent: null,
            descrittivo: '',
            autoIncrDescrittivo: false,
            configRetry: 0,
            delimiter_undefined_product: "|",
            reopenConfig: false,
            updatingProduct: false,
            cuToRemove: null,
            cuToReset: null,
            lampToAdd: null,
            lampsToAdd:[], 
            gatewayToCommand: null,
            gatewayInsert: null,
            zonesInPlant: [],
            modalRemoveCuVisible: false,
            modalResetCuVisible: false,
            modalGatewayCommandVisible: false,
            modalGatewayLampsInsertVisible: false,
            addToZone: null,
            modalAddToZone: false,
            resetAddToZone: false,
            modalMultipleAddToZone: false,
            resetMultipleAddToZone: false,
            cuGroups: null,
            cuAdvanced: null,
            cuInputs: null,
            modalGroupsCuVisible: false,
            modalAdvancedCuVisible: false,
            modalInputsCuVisible: false,
            advancedFilters: false,
            orphanFilters: false,
            errorFilters: false,
            errorComFilters: false,
            errorBatteryFilters: false,
            errorHardwareFilters: false,
            errorLedFilters: false,
            errorOtherFilters: false,
            emergencyFilters: false,
            pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
            pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                        //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
            filters: {
                search: '',
                idCent: '',
                nomeCent: '',
                idLamp: '',
                nomeLamp: '',
                tipoCent: ['all'],
                tipoLamp: 'all',
                autonomia: ['all'],
                parita: 'all',
                infinity: 'all',
                rete_se: 'all'
            },
            selectedGroup: '',
            // groups: Array.from([1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]),
            groups: [{ text: '-', value: '' }, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
            alerts: [],
            validation_alerts: [],
            currentCent: null,
            currentLamp: null,
            currentBleLamp: null,
            selected_num_lamp: "1",
            selected_ore_autonomia: "1H",
            selected_modalita_logica: null,
            substituteLampsSelection: [],
            manual_mode_logica: "append",
            list_validation_error: null,
            hasValidationError: false,
            delete_sn: false,
            deleteAllLamps: false,
            logica_cu_list: '',
            logica_cu_array: [],
            logica_config_sn: '',
            currentLampImage: "",
            status: 'none_selected',
            righeSel: [],
            ble_zone_columns: ['check', 'image', 'desc', 'num', 'gateway', 'lamps', 'potenza', 'energia', 'ore', 'errori', 'stato'],
            central_columns: ['check', 'image', 'desc', 'zona', 'action', 'prodotto', 'dettaglio', 'connesso', 'centrale', 'tensione', 'corrente', 'lampade', 'potenza', 'energia', 'ore', 'errori', 'stato'],
            ak_columns: ['check', 'image', 'desc', 'action', 'dettaglio', 'corrente', 'linee', 'lampade', 'errori', 'stato'],
            line_columns: ['check', 'image', 'desc', 'dettaglio', 'funzione', 'linestate', 'acstate', 'corrente', 'lampade', 'errori', 'stato'],
            sicuro_device_columns: ['check','image', 'desc', 'action', 'dettaglio', 'param1', 'param2', 'param3', 'errori', 'stato'],
            lssa_columns: ['check','image', 'desc', 'action', 'dettaglio', 'param1', 'param2', 'param3', 'param4', 'param5','param6', 'param7', 'param8'],
            tempLampDescInfos: null,
            configInProgress: 0,
            createNetworkInProgress: false,
            lamp_found: 0,
            configError: false,
            configCompleted: false,
            headerClose: true,
            maxchar: 30,
            updatingName: false,
            editingCent: false,
            editingLamp: false,
            editingZone: false,
            editingLssa: false,
            nomeCent: '',
            nomeLamp: '',
            nomeZone: '',
            cmdPianificaTest: null,
            loop: 0,
            respCu: "",
            respCommand: "",
            blinking: false,
            blinkActive: 0,
            blinkDuration: 15,
            qrScanned: "",
            scanning: false,
            scannerInitialized: false,
            replacingCovidLamp: false,
            tableData: [],
            tableBtData: [],
            lineData: ["1", "2", "3", "4"],
            editingCSV: false,
            scanningQrLamp: false,
            scanLampInitialized: false,
            maxPlantCode: 92,
            selected_plant_code: null,
            modalAkDetail: false,
            akInfo: null,
            modalCentDetailShow: false,
            modalLampDetailShow: false,
            modalLineDetailShow: false,
            modalLampConfigShow: false,
            modalLineConfigShow: false,
            currentLine: null,
            currentAk:null,
            currentCharger:null,
            modalChargerDetailShow: false,
            modalAkDetailShow: false,
            multipleProductsChecked: [],
            multipleProductsSelection: [],
            multipleProductsOrderCodeSelected: "",
            filtraDevices: "",
            optionsBle: {
                uniqueKey: 'zoneId'
            },
            optionsAk: {
                filterByColumn: false,
                uniqueKey: 'index',
                pagination: {
                    show: false
                },
            },
            optionsLine: {
                filterByColumn: false,
                uniqueKey: 'index',
                pagination: {
                    show: false
                },
                //Sembra che questa opzione crei problemi con il rendering dei <b-dropdown>
                // rowClassCallback: (row) => {
                //     return row.deactivated === 'ON' ? 'row-deactivated' : '';
                // }
            },
            options: {
                rowClassCallback: this.centRowClass,
                filterByColumn: false,
                uniqueKey: 'cu_id',
                columnsClasses: { 'desc': 'descColumnClass', 'image': 'imgColumnClass', 'check': 'chkColumnClass', 'dettaglio': 'dettColumnClass' },
                pagination: {
                    show: false
                },
                headings: {
                    check: '',
                    image: '',
                    desc: '',
                    action: '',
                    prodotto: '',
                    dettaglio: '',
                    connesso: '',
                    centrale: '',
                    errori: '',
                    stato: '',
                    lampade: ''
                }
            },
            theme: 'bootstrap4',
            template: 'default',
            options_lamp: [
                { value: 1, text: '1' },
                { value: 2, text: '2' },
                { value: 3, text: '3' },
                { value: 4, text: '4' },
                { value: 5, text: '5' },
                { value: 6, text: '6' },
                { value: 7, text: '7' },
                { value: 8, text: '8' },
                { value: 9, text: '9' },
                { value: 10, text: '10' },
                { value: 11, text: '11' },
                { value: 12, text: '12' },
                { value: 13, text: '13' },
                { value: 14, text: '14' },
                { value: 15, text: '15' },
                { value: 16, text: '16' },
                { value: 17, text: '17' },
                { value: 18, text: '18' },
                { value: 19, text: '19' },
                { value: 20, text: '20' },
                { value: 21, text: '21' },
                { value: 22, text: '22' },
                { value: 23, text: '23' },
                { value: 24, text: '24' },
                { value: 25, text: '25' },
                { value: 26, text: '26' },
                { value: 27, text: '27' },
                { value: 28, text: '28' },
                { value: 29, text: '29' },
                { value: 30, text: '30' },
                { value: 31, text: '31' },
                { value: 32, text: '32' }
            ],
            options_ore_autonomia: [
                { value: "1H", text: '1H' },
                { value: "1H5", text: '1H5' },
                { value: "2H", text: '2H' },
                { value: "3H", text: '3H' },
                { value: "8H", text: '8H' }
            ],
            options_modalita_logica: [  
                { value: "logica_append", text: this.$t("config_cu_modal.logica_append") },
                { value: "logica_zero", text: this.$t("config_cu_modal.logica_zero") },                                  
                { value: "logica_preset", text: this.$t("config_cu_modal.logica_insert") },
                { value: "logica_delete", text: this.$t("config_cu_modal.logica_delete") },
                { value: "logica_substitute", text: this.$t("config_cu_modal.logica_substitute") },                         
            ],
            options_modalita_logica_fm: [               
                { value: "logica_preset", text: this.$t("config_cu_modal.logica_insert") },
                { value: "logica_delete", text: this.$t("config_cu_modal.logica_delete") },
                { value: "logica_substitute", text: this.$t("config_cu_modal.logica_substitute") },
                { value: "network_create", text: this.$t("config_cu_modal.network_create") },
                { value: "logica_append", text: this.$t("config_cu_modal.logica_append") },
            ],
            options_plant_code_fm: [
                { value: "1", text: this.$t("config_cu_modal.logica_append") },
                { value: "logica_preset", text: this.$t("config_cu_modal.logica_insert") },
                { value: "logica_delete", text: this.$t("config_cu_modal.logica_delete") },
                { value: "network_create", text: this.$t("config_cu_modal.network_create") },
            ],
            imgData: 'data:image/jpeg;base64,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',
            selectAllDevices: false,
            isDropdown2Visible: false,
            isOpen: {}, //così fatto: {'sicuro000002': true, 'ak01': false, 'line03': true, 'lamp345678': true, ecc}
            clicked: false,
            // Data properties to hold the loaded font strings
            robotoRegular: null,
            robotoBold: null,
            modalGroupsSicuroCuVisible: false,
            riapriModalGroupsSicuroCu: false,
            cuSicuroId: null,
            cuSicuroType: null,
            cmdResult: '',
            changeLampDesc: {},
            newDescLamp: {},
            changeLineDesc: {},
            newDescLine: {},
            modalGatewayLampsSearchVisible: false,
            currentGateway: null,
            searchingBleLamps: false,
            dataFromPolling: null
        }

    },

    computed: {
        ...mapState(['loading', 'error', 'commandsPending', 'commandResponse']),

        
        // inputNameInfo(name) {
        //     console.log("inputNameInfo, name: ", name);
        //     const nc = (name && name.length) ? name.length : 0;
        //     const validChars = /^[\p{L}\p{N}\s']*$/u.test(name);

        //     if (!validChars) {
        //         return { text: 'Sono presenti caratteri non ammessi', error: true };
        //     }

        //     if (nc > 30) {
        //         return { text: `${nc}/30 Caratteri`, error: true };
        //     }

        //     return { text: `${nc}/30 Caratteri`, error: false };
        // },

        monitoringZonesDetails() {
            return this.$store.state.monitoringZones;
        },
        //restituisce il numero di lampade BLE senza errori di un impianto
        numLampsBleOk() {
            var numLampOk=0;
            if (this.zonesDetails == null || this.zonesDetails.length == 0) return 0;
            for (let k=0;k<this.zonesDetails.length;k++)
            {
               if(this.zonesDetails[k].bleLamps.length>0)
                    for (let j=0;j<this.zonesDetails[k].bleLamps.length;j++)
                    { 
                        if(this.zonesDetails[k].bleLamps[j].lamp.errorBallastCom=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.lampFail=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_com=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_batt_short=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_batt_test=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_batt_test_auto=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_hardware=="OFF"
                           && this.zonesDetails[k].bleLamps[j].lamp.error_led=="OFF"                                
                        )              
                            numLampOk=numLampOk+1;
                    }
            }
            console.log("Lamps Ble OK: " ,numLampOk);
            return numLampOk;
        },

        //restituisce i dispositivi presenti in una centrale oppure i dispositivi filtrati rispetto a "filtroImpianto" con ricerca su tutto l'elenco
        showDeletableSerialId() {
            if (this.filtraDevices == '') {
                return this.showDeleteSerialId(this.currentCent)
            }                
            else {
                return this.showDeleteSerialId(this.currentCent).filter( (disp) => {
                    if (this.filtraDevices != '') {
                        //filtro sul nome dell'impianto
                        if (disp.toLowerCase().includes(this.filtraDevices.toLowerCase().trim())) {
                            return true;
                        }
                    } else {
                        return true;
                    }
                })
            }       
        },
        //fornisce la lista degli AK selezionati
        akSel() {
            return this.righeSel.filter( (v) => (v.substring(0, 2).toLowerCase() == 'ak'))
        },
        //fornisce la lista degli AKEXT selezionati        
        akextSel() {
            return this.righeSel.filter( (v) => (v.substring(0,5).toLowerCase() == 'extak'))
        },
        //restituisce la lista delle LINEE selezionate
        lineSel() {
            return this.righeSel.filter( (v) => (v.substring(0, 4).toLowerCase() == 'line'))
        },
        //restituisce la lista delle LINEE EXT selezionate
        lineextSel() {
            return this.righeSel.filter( (v) => (v.substring(0, 7).toLowerCase() == 'extline'))
        },        
        centraliSel()
        {
            return this.righeSel.filter( (v) => (v.substring(0, 4).toLowerCase() == 'cent'))
        },
        //restituisce la lista delle LAMPADE selezionate
        lampadeSel()
        {
            return this.righeSel.filter( (v) => (v.substring(0, 4).toLowerCase() == 'lamp' || v.substring(0, 4).toLowerCase() == 'sens'))
        },
        //restituisce la lista delle LAMPADE EXT selezionate
        lampadeextSel()
        {
            return this.righeSel.filter( (v) => (v.substring(0, 7).toLowerCase() == 'extlamp'))
        },
        //restituisce la lista delle zone selezionate
        zoneSel()
        {
            return this.righeSel.filter( (v) => (v.substring(0, 4).toLowerCase() == 'zone'))
        },
        gruppoSel()
        {
            console.log("Selected group", this.selectedGroup);
            return this.selectedGroup
        },
        plantDetails()
        {
            const plant = this.$store.state.currentPlant;
            if (plant == null)
            {
                //this.tableData = [];
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
        centQrLamps()
        {
            console.log("centQrLamps:", this.currentCent);
            /*if (this.currentCent != null && this.currentCent.qr_lamps_id == null) {
                this.currentCent.qr_lamps_id = [];
            }*/
            if (this.currentCent != null && this.currentCent.qr_lamps_id != null)
            {
                console.log("ci sono lampade qr:" + this.currentCent.qr_lamps_id.length);
                return this.currentCent.qr_lamps_id;
            }
            return [];
        },
        clientDetails()
        {
            var plant = this.$store.state.currentPlant;
            console.log("currentPlant: ", plant);
            if (plant != null && plant.clientData != null)
            {
                var cl = plant.clientData;
                let plantClient = {
                    clientPicked: cl.type,
                    clientEmail: cl.email,
                    clientPiva: cl.piva,
                    clientPhone: cl.phone,
                    clientStreet: cl.address.street,
                    clientNumber: cl.address.housenumber,
                    clientCity: cl.address.city,
                    clientCap: cl.address.cap,
                    clientProv: cl.address.prov,
                    clientbusinessName: cl.businessname,
                    clientName: cl.name,
                    clientSurname: cl.surname,
                    clientCountry: cl.address.country,
                }
                return plantClient
            }
            return null;
        },
        //output: true se ho selezionato una centrale Sicuro
        sicuroCentSelection() {
            return this.centraliSel.some((csel) => {
                let c = csel.split("-");
                let cent = this.tableData[parseInt(c[1])];
                return cent.cu_type === "sicuro";
            });
        },
        //output: true se ho selezionato una o più centreli sicuro, oppure uno o più apparati o lampade sicuro
        sicuroSelection() {
            let cs = this.centraliSel;
            let ls = this.lampadeSel;
            let ak = this.akSel;
            let akext = this.akextSel;
            let line = this.lineSel;
            let lineext = this.lineextSel;
            console.log("sicuroSelection-> righe Sel:", this.righeSel);

            var validSel = true;
            //verifico se la/e centrali selezionate sono 'sicuro'
            if (cs.length > 0)
            {
                //centraliSel contiene record di questo tipo: cent-0, cent-1, ...
                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    console.log("cent:", cent);
                    let cutype = cent.cu_type;
                    if (cutype != "sicuro")
                    {
                        validSel = false;
                        break;
                    }
                }

            } else if (ls.length > 0)
            {
                for (const lsel of ls) {
                    //trasforma la stringa, pe 'lamp-0-5', in un array di token, pe, [lamp, 0, 5]
                    let l = lsel.split("-");
                    //se è una lampada di tipo sicuro, allora contiene 5 token (lampXYZ, #centrale, #ak, #linea, #lamp)
                    //altrimenti non è di un impianto sicuro e devo restituire false
                    if (l.length != 5)
                    {
                        validSel = false;
                        break;
                    }
                }
            } else if (!(ak.length > 0 || akext.length > 0 || line.length > 0 || lineext.length > 0))
            {
                //se non ho selezionato ak, akext, linee, lineeext, allora sono sicuro che non ho selezionato nulla di tipo sicuro
                console.log("sicuroSelection-> ak:" + ak.length + " akext:" + akext.length + " line:" + line.length + " lineext:" + lineext.length);
                validSel = false;
            } 
            return validSel;
        },
        //output: true se ho selezionato una o più centrali Logica, Sicuro, ecc ed FM con lampade d'emergenza  oppure una o più lampade d'emergenza
        emergencySelection()
        {
            let cs = this.centraliSel;
            let ls = this.lampadeSel;
            console.log("emergencySelection-> righe Sel:", this.righeSel);
            console.log("emergencySelection-> centrali sel:", cs);
            console.log("emergencySelection-> emergency lampadeSel:", ls);
            var validSel = false;
            if (cs.length > 0)
            {
                validSel = true;
                //centraliSel contiene record di questo tipo: cent-0, cent-1, ...
                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    console.log("cent:", cent);
                    let cutype = cent.cu_type;
                    if (cutype == "logicafm")
                    {
                        if (cent.lamps == null || cent.lamps.length == 0)
                        {
                            validSel = false;
                            break;
                        }
                    }
                }

            } else if (ls.length > 0)
            {
                validSel = true;
                for (const lsel of ls) {
                    //trasforma la stringa, pe 'lamp-0-5', in un array di token, pe, [lamp, 0, 5]
                    let l = lsel.split("-");
                    //se anche solo una lampada è di tipo illuminazione, restituisco false
                    if (l[0].includes("lampIll"))
                    {
                        validSel = false;
                        break;
                    }
                }
            }
            return validSel
        },
        //output: true se ho selezionato una o più centrale FM  oppure una o più lampade FM
        lightingSelection()
        {
            let cs = this.centraliSel;
            let ls = this.lampadeSel;
            console.log("lightingSelection-> centrali sel:", cs);
            console.log("lightingSelection-> lighting lampadeSel:", ls);
            var validSel = false;
            //verifico se ho selezionato una centrale FM
            if (cs.length > 0)
            {
                validSel = true;

                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    console.log("lightingSelection-> cent:", cent);
                    let cutype = cent.cu_type;
                    if (cutype == "cablecom" || cutype == "logica" || cutype == "sicuro")
                    {
                        validSel = false;
                        break;
                    } else if (cutype == "logicafm")
                    {
                        if (cent.lamps_illum.length <= 0)
                        {
                            validSel = false;
                            break;
                        }
                    }
                }

            } else if (ls.length > 0)
            {
                validSel = true;
                for (const lsel of ls) {
                    //trasforma la stringa, pe 'lamp-0-5', in un array di token, pe, [lamp, 0, 5]
                    let l = lsel.split("-");
                    //se anche solo una lampada non è di tipo illuminazione o sensor, restituisco false
                    if ((!l[0].includes("lampIll")) && (!l[0].includes("sensor")))
                    {
                        validSel = false;
                        break;
                    }
                }
            }
            return validSel
        },
        unitsDetails()
        {
            return this.$store.state.plantUnits;
        },
        zonesDetails()
        {
            return this.$store.state.plantZones;
        },
        allTableData()
        {
            return this.$store.state.plantUnits || [];
        },

        allBleData()
        {
            return this.$store.state.plantZones || [];
        },
        numUnits()
        {
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            return this.unitsDetails.length;
        },
        //restituisce il numero di zone presenti in un impianto bluetooth
        numZones()
        {
            if ((this.zonesDetails == null) || (this.zonesDetails.length == 0)) return 0;
            return this.zonesDetails.length;
        },
        //restituisce il numero di lampade contenute nell'impianto bluetooth
        totalLampsBle() {
            const initValue = 0;
            if ((this.zonesDetails == null) || (this.zonesDetails.length == 0)) return 0;
            return this.zonesDetails.reduce(
                (total, z) => total + z.bleLamps.length,
                initValue
            );
        },

        totalLamps()
        {
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0
            return this.unitsDetails.reduce(function (total, u)
            {
                //return total + ((u.lamps_id == null) ? 0 : u.lamps_id.length);
                if (u.cu_type == "cablecom" || u.cu_type == "sicuro")
                    return total + (u.num_lamp_found | 0);
                else
                    return total + (u.num_lamp_present | 0);
            }, 0);
        },
        // centNameInfo()
        // {
        //     const nc = this.nomeCent.length;
        //     const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.nomeCent);
        //     if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
        //     if (nc > 30 || !validChars)
        //     {
        //         return "<b style=\"color:red\">" + nc + "/30 Caratteri</b>";
        //     }
        //     return "" + nc + "/30 Caratteri";
        // },
        lampNameInfo()
        {
            const nl = this.nomeLamp.length;
            const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.nomeLamp);
            if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
            if (nl > 30 || !validChars)
            {
                return "<b style=\"color:red\">" + nl + "/30 Caratteri</b>";
            }
            return "" + nl + "/30 Caratteri";
        },
        zoneNameInfo()
        {
            const nl = this.nomeZone.length;
            const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.nomeZone);
            if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
            if (nl > 30 || !validChars)
            {
                return "<b style=\"color:red\">" + nl + "/30 Caratteri</b>";
            }
            return "" + nl + "/30 Caratteri";
        },
    },

    async mounted()
    {
        // //inizializzo isOpen considerando tutti i dispositivi di unitsDetails
        // //pongo tutti a false, che significa che il rispettivo <b-collapse> è chiuso
        // console.log("mounted, unitsDetails:" + this.unitsDetails)
        // this.unitsDetails.forEach(cu => {
        //     this.$set(this.isOpen, cu.cu_type + cu.cu_id, false);
        //     cu.ak.forEach(ak => {
        //         this.$set(this.isOpen, 'ak' + ak.index, false);
        //         ak.lines.forEach(line => {
        //             this.$set(this.isOpen, 'line' + line.index, false);
        //         })
        //     });
        // })

        console.log("dispositiviImpianto mounted, idImpianto=" + this.plantId + ", devicesType:" + this.devicesType + ", plantDetails:" + this.plantDetails + ", allTableData:" + this.allTableData + ", tableData:" + this.tableData + ", user:" + this.$store.state.user)
        if (this.$store.state.user != null && this.error == null && this.plantDetails == null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected)
        {
            console.log("Mounted1, loadPlantDetails");
            this.$store.dispatch('loadPlantDetails', this.plantId)
        }
        else if (this.plantDetails != null && this.$store.getters.isCentralized && this.allTableData != null && this.tableData.length == 0)
        {

            if (this.$store.state.plantUnits == null)
            {
                console.log("Mounted2, loadPlantDetails");
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else
            {
                this.tableData = this.allTableData;
                this.filtra(); //serve per imporre la property 'visible' a true
                console.log("Mounted3, filtra");
            }

        }
        else if (this.plantDetails != null && this.$store.getters.isBluetooth && this.allTableData != null && this.tableBtData.length == 0)
        {

            if (this.$store.state.plantZones == null)
            {
                this.$store.dispatch('loadPlantZones', this.plantId)
            } else
            {
                this.tableBtData = this.allBleData;
                console.log("aggiornato tableData for Bluetooth", this.tableBtData);
            }

        }

        //devo caricare le zone di monitoraggio per poter compilare la colonna 'Monitoring zone'
        if (this.monitoringZonesDetails == null && this.plantDetails != null && this.plantDetails.technology != "bluetooth") {
            console.log("Mounted4, carico zone di monitoraggio");
            this.$store.dispatch('loadPlantMonitoringZones', this.plantId);
        }

        //per usare un multilevel dropdown devo intercettare il click sul dropdown e mostrare il menu a tendina
        this.$root.$on('bv::dropdown::show', bvEvent => {
            // console.log("show dropdown", bvEvent.componentId);
            if(bvEvent.componentId === 'dropdown-2') {
                this.isDropdown2Visible = true;
            }
        })
        this.$root.$on('bv::dropdown::hide', bvEvent => {
            // console.log("hide dropdown", bvEvent.componentId);
            if(bvEvent.componentId === 'dropdown-2') {
                this.isDropdown2Visible = false;
            }
            if(this.isDropdown2Visible) {
                bvEvent.preventDefault();
            }
        })
        // Call the method to load fonts when the component is mounted
        await this.loadFonts();

    },
    beforeDestroy()
    {
        console.log("dispositiviImpianto unmounted, idImpianto=" + this.plantId + ", devicesType:" + this.devicesType + ", plantDetails:" + this.plantDetails + ", allTableData:" + this.allTableData + ", tableData:" + this.tableData + ", user:" + this.$store.state.user)
        this.$root.$off('bv::dropdown::show')
        this.$root.$off('bv::dropdown::hide')
    },
    updated()
    {
        console.log("dispositiviImpianto updated, idImpianto=" + this.plantId + ", plantDetails=", this.plantDetails, ", error:" + this.error)
        if (this.plantDetails == null && this.error == null && this.$store.state.user != null)
        {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        }
        //this.filtra(); //nel caso di aggiornamento da shadow, devo reimporre i visible corretti
    },
    watch: {
    
        //usato per gestire il checkbox che seleziona la selezione di tutti i dispositivi
        selectAllDevices(newval, oldval) {
            console.log("select all device, newval: ", newval + " oldval: ", oldval)
            if (newval) {
                this.selezionaAllCentrali();
            }
            else
            {
                this.azzeraSelezione();
            }
 
        },
        //usato per gestire il checkbox che seleziona la cancellazione di tutti i dispositivi
        deleteAllLamps(newval, oldval) {
            console.log("deleteAllLamps: newval: ", newval + " oldval: ", oldval)
            if (newval)
            {
                this.substituteLampsSelection = this.showDeleteSerialId(this.currentCent);
            }
            else
            {
                this.substituteLampsSelection = [];
            }
        },
        '$route'()
        {
            // TODO: react to navigation event.
            // params cotains the current route parameters
            console.log("route changed!", this.$route.params, this.devicesType);
            this.$nextTick(function ()
            {
                this.righeSel = [];
                if (this.devicesType == "zoneBluetooth") {
                    if (this.$store.state.plantZones == null) {
                        this.$store.dispatch('loadPlantZones', this.plantId)
                    }
                    else {
                        this.tableBtData = this.allBleData;
                        console.log("aggiornato tableData for Bluetooth", this.tableBtData);
                    }
                }
                this.filtra();
            });

        },
        loading(val)
        {
            console.log("Loading changed:" + val + ", error=" + this.error + ", loop=" + this.loop);
            //if (this.loop > 50) return;
            if (val == false && this.plantDetails == null && this.error == null)
            {
                console.log("Loading, carico plant details")
                this.$store.dispatch('loadPlantDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.$store.getters.isCentralized && this.unitsDetails == null && this.error == null)
            {
                console.log("Loading, carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
            } else if (val == false && this.plantDetails != null && this.$store.getters.isBluetooth && this.zonesDetails == null && this.error == null)
            {
                console.log("Loading, carico zone bluetooth");
                this.$store.dispatch('loadPlantZones', this.plantId);
            }
        },
        unitsDetails(val, oldval)
        {
            console.log("aggiornato unitsDetails", val, oldval);
            console.log("Ruolo utente", this.$store.state.user.usertype);
            this.filtra();
        },
        zonesDetails(val, oldval)
        {
            console.log("WATCH: aggiornato zonesDetails", val, oldval);
            this.tableBtData = this.allBleData;
            console.log("WATCH: tableBtData: ", this.tableBtData);
        },
        commandResponse(val)
        {
            console.log("cambiata commandResponse ->", val);
            let resp = val; //this.$store.state.commandResponse
            this.respCommand = resp.command;
            this.respCu = resp.cu;
            var alert = {};
            console.log("analizzo la risposta, loop= " + this.loop, resp);
            if (!resp.pending && resp.command != null && !resp.command.includes('Monitoring'))
            {
                if (resp.error != null && resp.error != "")
                {
                    //se il comando inviato non riceve risposta, anche dopo varie ripetizioni, allora viene restituito un errore di 'communication_error'
                    if (resp.error.includes('communication_error')) {
                        alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: "Errore di comunicazione con centrale " + resp.cu,
                            countDownChanged: function (cd)
                            {
                                //timeLeft = cd;
                                console.log("countdownchanged:" + cd)
                            }
                        }
                        this.editingCent = false;
                        this.editingLamp = false;
                        this.updatingName = false;
                    } else {
                        console.log("resp error", resp.error);
                        alert = {
                            timeLeft: 10,
                            state: "danger",
                            msg: 'ERROR: ' + resp.error + ((resp.cu != "") ? (" - Centrale " + (resp.cu || resp.commandInfo.cu_id)) : ""),
                            countDownChanged: function (cd)
                            {
                                //timeLeft = cd;
                                console.log("countdownchanged:" + cd)
                            }
                        }
                    }
                    this.alerts.push(alert);
                    if (this.riapriModalGroupsSicuroCu) {
                        setTimeout(() => {
                            this.cmdResult = 'fail';
                            this.riapriModalGroupsSicuroCu = false;
                            this.modalGroupsSicuroCuVisible = true;
                        }, TIMEOUT_CONFIGGRUPPI);
                    }
                } else
                {
                    console.log("risposta ok per comando " + resp.command + ", cu:" + resp.cu, resp);
                    if (resp.command == "importedLampDescriptions")
                    {
                        console.log("ricarico dati");
                        this.$store.dispatch('loadUnitsDetails', this.plantId)
                        return;
                    }
                    if (resp.command == "updatedCentQrLamps")
                    {
                        if (this.currentCent != null)
                        {
                            console.log("aggiorno qrLamps:", resp.response.qrLampInfos.lamps);
                            this.currentCent.qr_lamps_id = resp.response.qrLampInfos.lamps;
                            this.$forceUpdate();
                        }
                    }
                    if (resp.cu != null)
                    {
                        alert = {
                            timeLeft: 5,
                            state: "success",
                            msg: "Eseguito comando " + resp.command + " su " + resp.cu,
                            countDownChanged: function (cd)
                            {
                                //timeLeft = cd;
                                console.log("countdownchanged:" + cd)
                            }
                        }
                        this.alerts.push(alert);
                    }
                    if (this.riapriModalGroupsSicuroCu) {
                        setTimeout(() => {
                            this.cmdResult = 'success';
                            this.riapriModalGroupsSicuroCu = false;
                            this.modalGroupsSicuroCuVisible = true;                           
                        }, TIMEOUT_CONFIGGRUPPI);
                    }
                    if (this.loop > 500)
                    {
                        console.log("Esito loop!");
                        return;
                    } else
                    {
                        this.loop = this.loop + 1;

                        switch (resp.command)
                        {
                            case 'removeZone':
                                {
                                    console.log("removedZone", resp);
                                    this.$store.dispatch('loadPlantZones', this.plantId);
                                }
                                break;
                            case 'SET CENTRAL UNIT NAME':
                            case 'SET CU NAME':
                                {
                                    console.log("setCuName", resp);
                                    this.currentCent.cu_desc = this.nomeCent;
                                    this.editingCent = false;
                                    this.updatingName = false;
                                    let self = this;
                                    //occorre aggiornare la descrizione della centrale anche nella tabella tableData usata per la visualizzazione grafica
                                    this.tableData.forEach(function (c)
                                    {
                                        if (c.cu_id == self.currentCent.cu_id && c.cu_type == self.currentCent.cu_type)
                                        {
                                            c.cu_desc = self.currentCent.cu_desc;
                                            self.$nextTick(function ()
                                            {

                                            });
                                        }
                                    })
                                }
                                break;
                            case 'SET DATE TIME PROX FUNCTIONAL TEST':
                                if (this.cmdPianificaTest != null)
                                {
                                    let self = this;
                                    let cuid = resp.cu;
                                    let type = resp.type;
                                    setTimeout(function ()
                                    {
                                        if (type != "logicafm" && type != "sicuro")
                                        {
                                            console.log("invio comando periodicità a centrale " + resp.cu);
                                            self.$store.dispatch('sendCablecomCommand', { cu_command: { command: 'setPeriodFunzionale', period_functional: self.cmdPianificaTest.period_functional }, cu_type: type, cu_id: cuid });
                                        }
                                    }, 2000);

                                }
                                break;
                            case 'SET PERIOD FUNCTIONAL TEST':
                                if (this.cmdPianificaTest != null && this.cmdPianificaTest.set_autonomy != "")
                                {
                                    let self = this;
                                    let cuid = resp.cu
                                    let type = resp.type;
                                    setTimeout(function ()
                                    {
                                        console.log("invio comando test autonomia " + resp.cu);
                                        self.$store.dispatch('sendCablecomCommand', { cu_command: { command: 'setDateTimeAutonomia', set_autonomy: self.cmdPianificaTest.set_autonomy }, cu_type: type, cu_id: cuid });
                                    }, 2000);

                                }
                                break;
                            case 'SET DATE TIME PROX AUTONOMY TEST':
                                if (this.cmdPianificaTest != null)
                                {
                                    let self = this;
                                    let cuid = resp.cu
                                    let type = resp.type;
                                    setTimeout(function ()
                                    {
                                        if (type != "logicafm" && type != "sicuro")
                                        {
                                            console.log("invio comando periodicità autonomia a centrale " + resp.cu);
                                            self.$store.dispatch('sendCablecomCommand', { cu_command: { command: 'setPeriodAutonomia', period_autonomy: self.cmdPianificaTest.period_autonomy, differito: self.cmdPianificaTest.differito }, cu_type: type, cu_id: cuid });
                                        }
                                    }, 2000);

                                }
                                break;
                            case 'updateZone':
                                console.log("elaboro saved zone", this.editingZone);
                                if (this.editingZone)
                                {
                                    this.currentZone.zoneName = this.nomeZone;
                                    this.editingZone = false;
                                    let self = this;

                                    this.tableBtData.forEach(function (z)
                                    {
                                        if (z.zoneId == self.currentZone.zoneId)
                                        {
                                            z.zoneName = self.currentZone.zoneName;
                                            console.log("aggiornata zone name  -->" + z.zoneName);
                                            self.$nextTick(function ()
                                            {

                                            });

                                        }
                                    });

                                }
                                this.updatingName = false;
                                break;
                            case 'saveZone':
                                if (resp.response != false) {
                                    //devo ricaricare i dati
                                    this.$store.dispatch('loadPlantZones', this.plantId);
                                } else {
                                    alert = {
                                        timeLeft: 5,
                                        state: "danger",
                                        msg: "Fallito comando " + resp.command ,
                                        countDownChanged: function (cd)
                                        {
                                            //timeLeft = cd;
                                            console.log("countdownchanged:" + cd)
                                        }
                                    }
                                    this.alerts.push(alert);                                    
                                }
                                break;
                            case 'savedLampDescription':
                            {  
                                this.editingLamp = false;
                                let self = this;
                                //il campo 'response' contiene la nuova descrizione della lampada
                                self.currentLamp.desc=resp.response;
                                console.log("savedLampDescription, currentLamp:",self.currentLamp);
                                var trovato = false;
                                //occorre aggiornare la descrizione della lampada anche nella tabella tableData usata per la visualizzazione grafica
                                if (this.currentLamp.cu_type == "sicuro") {
                                    this.tableData.some((c) => {
                                        if ((c.cu_type + "#" + c.cu_id) == self.currentLamp.cu_id) {
                                            c.ak.some((ak) => {
                                                ak.lines.some((l) => {
                                                    l.lamps.some((lamp) => {
                                                        if (lamp.lamp_id == this.currentLamp.lamp_id) {
                                                            trovato = true
                                                            lamp.desc = this.currentLamp.desc;
                                                            self.$nextTick();
                                                        }
                                                        return trovato;
                                                    });
                                                    return trovato;
                                                });
                                                return trovato;
                                            });
                                        }
                                        return trovato;
                                    });
                                }
                                else {
                                    this.tableData.some(function (c)
                                    {
                                        if ((c.cu_type + "#" + c.cu_id) == self.currentLamp.cu_id)
                                        {
                                            c.lamps.some(function (l)
                                            {
                                                if (l.id == self.currentLamp.id)
                                                {
                                                    l.desc = self.currentLamp.desc;
                                                    trovato = true;
                                                    self.$nextTick(function () {});
                                                }
                                                return trovato;
                                            });
                                        }
                                        return trovato;
                                    });
                                }

                                if (this.currentLamp.cu_type == "bluetooth")
                                {
                                    this.tableBtData.forEach(function (z)
                                    {
                                        z.bleLamps.forEach(function (l)
                                        {
                                            if (l.id == self.currentLamp.lamp_id)
                                            {
                                                self.$nextTick(function ()
                                                {

                                                });
                                                console.log("ora lamp " + l.id + " -->" + l.desc);
                                                console.log("current lamp desc: ", self.currentLamp.desc);
                                                l.desc = self.currentLamp.desc;
                                                l.lamp.desc = self.currentLamp.desc;
                                                console.log("aggiornata lamp " + l.id + " -->" + l.desc);
                                                self.$nextTick(function ()
                                                {

                                                });

                                            }
                                        });
                                    });
                                }
                            
                                this.updatingName = false;
                                break;
                            }
                            case 'updatedProduct':
                               
                                if (this.updatingProduct)
                                {
                                    let self = this;
                                    var lamps_updated = resp.response.data.lamps;
                                    this.tableData.forEach((cu) => {
                                            lamps_updated.forEach((l) => {
                                                if(l.cu_id == cu.cu_type+'#'+cu.cu_id)
                                                {
                                                    cu.lamps.forEach((lmp) => {
                                                        if(lmp.id==l.id)
                                                        {
                                                            console.log("matched updated lamp", l.id);
                                                            lmp.order_code=l.order_code;
                                                            lmp.product_code=l.product_code;
                                                            lmp.product_desc=l.product_desc;
                                                            lmp.product_image=l.product_image;
                                                            lmp.product_pdf=l.product_pdf;
                                                            lmp.battery_code=l.battery_code;
                                                            lmp.battery_desc=l.battery_desc;
                                                        }
                                                    })
                                                }
                                            });
                                    });
                                    

                                    self.$nextTick(function ()
                                    {

                                    });
                                }
                                this.updatingProduct = false;
                                break;
                        }
                    }
                }
            }
        },
        commandsPending(val, oldval)
        {
            console.log("commandsPending ->" + val + ", old:" + oldval + ", false:" + (false + 0) + ",configInProgress =" + this.configInProgress);
            if (val <= 0 && this.configInProgress > 0)
            {
                var cmdRes = this.$store.state.commandResponse;
                console.log("actual cmdRes:", cmdRes);
                if (cmdRes == null || cmdRes.command == null)
                {
                    cmdRes = this.$store.state.commandResponses["" + this.currentCent.cu_id];
                    console.log("actual cmdRes2:", cmdRes);
                }
                if (cmdRes.cu == this.currentCent.cu_id)
                {

                    if (cmdRes.command == "config" && (cmdRes == null || (cmdRes.error != null && cmdRes.error != "")))
                    {
                        if (this.configRetry > 0)
                        {
                            const self = this;
                            this.configRetry = this.configRetry - 1;
                            this.configInProgress = setTimeout(function ()
                            {
                                let num_lamp = self.selected_num_lamp;
                                let ore_autonomia = self.selected_ore_autonomia;
                                let centType = self.currentCent.cu_type;
                                let centId = self.currentCent.cu_id;
                                self.$store.dispatch('sendCablecomConfigCommand', { centType, centId, num_lamp, ore_autonomia });
                            }, 3500);
                            return;
                        }
                        console.log("config impianto in errore!");

                        this.configCompleted = true;
                        this.configError = true;
                        if (this.configInProgress != 0) clearTimeout(this.configInProgress);  //ALEX
                        this.configInProgress = 0;
                        return;
                    } else if (cmdRes.command == "GET DATI IMPIANTO")
                    {
                        console.log("GET DATI IMPIANTO: arrivata response", cmdRes);
                        //cmdRes = this.$store.state.commandResponses[""+this.currentCent.cu_id];
                        if (cmdRes == null || (cmdRes.error != null && cmdRes.error != ""))
                        {

                            if (this.configRetry > 0)
                            {
                                this.configRetry = this.configRetry - 1;
                                if (cmdRes.type == "logicafm")
                                {
                                    this.configInProgress = setTimeout(this.checkConfigStatus, 10000);
                                    console.log("Invio comando check config ogni 10 sec su logica fm");
                                }
                                else
                                {
                                    this.configInProgress = setTimeout(this.checkConfigStatus, 3500);
                                    console.log("Invio comando check config ogni 3.5 sec su cablecom o logica filare");
                                }
                                return;
                            }

                            console.log("Get dati impianto in errore!");
                            // const self = this;
                            this.configCompleted = true;
                            this.configError = true;
                            if (this.configInProgress != 0) clearTimeout(this.configInProgress);  //ALEX
                            this.configInProgress = 0;
                            /*setTimeout(function() {
                                self.currentCent = null;
                                self.configCompleted = false;
                                self.configInProgress = false;
                                self.$bvModal.hide('config-cent-modal');
                                self.headerClose = true;
                            },3000);*/

                            return;
                        }

                        this.configRetry = 3;

                        this.lamp_found = cmdRes.response.lamp_found;

                        //non mostro le lampade in tabella mentre è in corso l'acqusiizione
                        this.tableData = this.allTableData.filter(cent =>
                        {
                            if (cent.cu_id != this.currentCent.cu_id)
                            {
                                return cent;
                            }
                            else
                            {
                                if (cent.cu_type == this.currentCent.cu_type)
                                {
                                    cent.lamps = [];
                                    cent.working = true;
                                    cent.num_lamp_found = -1;
                                    return cent;
                                }
                                else
                                {
                                    return cent;
                                }
                            }
                        });

                        console.log("GET DATI IMPIANTO: stato della configurazione ", cmdRes.response.status_config.searching);
                        console.log("GET DATI IMPIANTO: stato della creazione rete radio ", cmdRes.response.status_config.configuring);
                        if (cmdRes.response.status_config.searching == "1")
                        {

                            console.log("GET DATI IMPIANTO: sta ancora cercando le lampade", cmdRes.response.status_config.searching, this.lamp_found);
                            if (this.configInProgress != 0) clearTimeout(this.configInProgress);   //ALEX
                            if (cmdRes.type == "logicafm")
                            {
                                this.configInProgress = setTimeout(this.checkConfigStatus, 10000);
                                console.log("GET DATI IMPIANTO: Invio comando check config su crea rete ogni 10 sec su logica fm");
                            }
                            else
                            {
                                this.configInProgress = setTimeout(this.checkConfigStatus, 3500);
                                console.log("GET DATI IMPIANTO: Invio comando check config ogni 3.5 sec su cablecom o logica filare");
                            }
                        } else
                        {
                            if (cmdRes.response.status_config.configuring == "0")
                            {
                                console.log("GET DATI IMPIANTO: ho finito di cercare o fare la rete, trovate: " + this.lamp_found + ", cercate: " + this.selected_num_lamp);
                                if (this.lamp_found != this.selected_num_lamp && cmdRes.type == "cablecom")
                                {
                                    this.configError = true;
                                    if (this.configInProgress != 0) clearTimeout(this.configInProgress);   //ALEX
                                    this.configInProgress = 0;
                                    this.headerClose = true;
                                } else
                                {
                                    const self = this;
                                    this.configCompleted = true;
                                    this.configError = false;
                                    if (this.configInProgress != 0) clearTimeout(this.configInProgress);  //ALEX
                                    this.configInProgress = 0;
                                    setTimeout(function ()
                                    {
                                        self.currentCent = null;
                                        self.configCompleted = false;
                                        self.configInProgress = false;
                                        self.$bvModal.hide('config-cent-modal');
                                        self.headerClose = true;
                                    }, 3000);
                                }
                            }
                            else
                            {
                                this.createNetworkInProgress = true;
                                console.log("GET DATI IMPIANTO: sto creando la rete, lampade trovate: " + cmdRes.response.lamp_found + ", cercate: " + cmdRes.response.lamps_installed);
                                if (cmdRes.type == "logicafm")
                                {
                                    console.log("GET DATI IMPIANTO: Invio comando check config ogni 10 sec su crea rete su logica fm");
                                    this.configInProgress = setTimeout(() =>
                                    {
                                        console.log("GET DATI IMPIANTO: check config status...", Date.now() / 1000);
                                        this.$store.dispatch('sendCablecomConfigStatusCommand', { cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id });
                                    }, 15000);

                                }
                            }
                        }
                    }
                }
            } 
        }

    },


    methods: {
        //funzione che riceve da GatewayLampsInsert i dati del polling del gateway
        handleDataFromGateway(dataFromGateway) {
            console.log("Centrali, handleDataFromGateway", dataFromGateway);
            this.dataFromPolling = dataFromGateway;
        },

        //funzione che visualizza il modal che mostra lo stato di avanzamento della ricerca di lampade da parte del Gateway
        openSearchBleLamps(gateway) {
            this.currentGateway = gateway;
            this.searchingBleLamps = true;
            this.modalGatewayLampsSearchVisible = true
        },

        // //converte l'indice di lampada interno alla centrale, nel rotary effettivo della lampada
        // restituisciRotary(lamp) {
        //     return (lamp.idx + 1) - (32 * Number(lamp.ak_line - 1) - (128 * Number(lamp.ak_index - 1)));
        // },
        //funzione che scarica in formato json i dati della centrale cent
        downloadJson(cent) {
            this.$bvModal.msgBoxConfirm(this.$t('JSON_data_download'), {
                title: this.$t('downloadJson'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                if (value) {
                    //creo una deep copy di cent
                    const modifiedCent = JSON.parse(JSON.stringify(cent));
                    //elementi di centrale da eliminare
                    delete modifiedCent.working;
                    delete modifiedCent.SalvareTuttiGliStati;
                    delete modifiedCent.plantId;
                    delete modifiedCent.config_processing;
                    delete modifiedCent.cu_dimension;
                    delete modifiedCent.cu_product_code;
                    delete modifiedCent.cu_product_desc;
                    delete modifiedCent.cu_product_image;
                    delete modifiedCent.cu_product_pdf;
                    delete modifiedCent.cu_battery_code;
                    delete modifiedCent.cu_battery_desc;
                    delete modifiedCent.cu_connected;
                    delete modifiedCent.enabled;

                    //elementi di lampada da eliminare
                    for (let i = 0; i < modifiedCent.lamps.length; i++)
                    {
                        delete modifiedCent.lamps[i].multiple_products;
                        delete modifiedCent.lamps[i].product_code;
                        delete modifiedCent.lamps[i].product_desc;
                        delete modifiedCent.lamps[i].product_image;
                        delete modifiedCent.lamps[i].product_pdf;
                        delete modifiedCent.lamps[i].product_rev;
                        delete modifiedCent.lamps[i].shadow_pending;
                        delete modifiedCent.lamps[i].shadow_pending_autonomy;
                        delete modifiedCent.lamps[i].shadow_pending_lssa;
                        delete modifiedCent.lamps[i].shadow_pending_parity;
                        delete modifiedCent.lamps[i].shadow_pending_sa_dimming;
                        delete modifiedCent.lamps[i].visible;
                    }
                    for (let i = 0; i < modifiedCent.lamps_illum.length; i++)
                    {
                        delete modifiedCent.lamps_illum[i].multiple_products;
                        delete modifiedCent.lamps_illum[i].product_desc;
                        delete modifiedCent.lamps_illum[i].product_image;
                        delete modifiedCent.lamps_illum[i].product_pdf;
                        delete modifiedCent.lamps_illum[i].product_code;
                        delete modifiedCent.lamps_illum[i].product_rev;
                        delete modifiedCent.lamps_illum[i].shadow_pending;
                        delete modifiedCent.lamps_illum[i].shadow_pending_autonomy;
                        delete modifiedCent.lamps_illum[i].shadow_pending_lssa;
                        delete modifiedCent.lamps_illum[i].shadow_pending_parity;
                        delete modifiedCent.lamps_illum[i].shadow_pending_sa_dimming;
                        delete modifiedCent.lamps_illum[i].visible;
                    }
                    //l’oggetto modifiedCent è convertito in JSON string, senza replacer function e con due spazi di indentazione
                    const dataStr = JSON.stringify(modifiedCent, null, 2);
                    //viene inserito in un blob (binary large object) che rappresenta un file di dati, specificando di tipo json
                    const blob = new Blob([dataStr], { type: 'application/json' });
                    //si crea un URL temporaneo (solo nella current session del browser) che punta ai dati nel blob
                    const url = URL.createObjectURL(blob);

                    //si crea in memoria un elemento HTML anchor
                    const link = document.createElement("a");
                    //gli si assegna l'url
                    link.href = url;
                    //si impone il download invece che la navigazione (default)
                    link.download = this.$t("device") + "_" + modifiedCent.cu_id + ".json";
                    //si simula un click sul link per avviare il download
                    link.click();
                    //si liberano la memoria e le risorse associate all'url del blob temporaneo
                    URL.revokeObjectURL(url);
                }
            })
        },
        //Loads all required fonts and stores them in component data.
        async loadFonts() {
            try {
                // Assumes fonts are in your 'public' folder
                this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
                this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
                //console.log('Fonts loaded successfully.');
            } catch (error) {
                console.error('Failed to load fonts:', error);
            }
        },        
        // Helper function to load a font from a URL and convert it to Base64
        async loadFontAsBase64(url) {
            const response = await fetch(url);
            // console.log("fetch font: ", response);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Get the Base64 string, but strip the "data:..." prefix
                    const base64data = reader.result.split(',')[1];
                    resolve(base64data);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        //Restituisce il valore rotary (0-31) della lampada all'interno della linea
        //in Centrale viene utilizzato un indice crescente legato alla posizione fisica della lampada, quindi AK, Linea, Lampada
        restituisciRotary(lamp) {
            return (Number(lamp.idx) + 1) - (32 * (Number(lamp.ak_line) - 1)) - (128 * (Number(lamp.ak_index) - 1));
        },
        //ritorna true se la visualizzazione della modifica delle desc delle lampade della linea 'line' è attiva (versione mobile)
        visButtomMobile(line) {
            //console.log("debug changeLampDesc:", this.changeLampDesc);          
            let indiceLine = String(Number(line.index) - (4 * (Number(line.ak) - 1)));
            //console.log("my indice: ",`${line.cu_id}_${String(Number(line.ak))}_${indiceLine}`);
            return this.changeLampDesc[`${line.cu_id}_${String(Number(line.ak))}_${indiceLine}`];
        },
        //ritorna true se la visualizzazione della modifica delle desc delle lampade della linea 'row' è attiva (versione desktop)
        visButton(row) {
            // console.log("debug changeLampDesc:", this.changeLampDesc);
            // console.log("indice: ",`${row.cu_id}_${String(Number(row.ak))}_${String(Number(row.index))}`);
            let indiceLine = String(Number(row.index) - (4 * (Number(row.ak) - 1))); //si può usare direttamente 'row.line_num'
            return this.changeLampDesc[`${row.cu_id}_${String(Number(row.ak))}_${indiceLine}`];
        },
        //salva le desc delle lampade di una linea
        saveNewLampDesc(line) {
            var params = {};
            params.command = "setLampDesc";
            params.cu_type = line.cu_type;
            params.cu_id = line.cu_id.split("#")[1];
            params.lamps = [];
            params.num_lamps = Object.keys(this.newDescLamp).length;
            for (let i=0; i < params.num_lamps; i++) {
                params.lamps[i] = { id: line.lamps[i].idx, name: this.newDescLamp[line.lamps[i].lamp_id]};
            }
            console.log("saveNewLampDesc, params: ", params);
            this.sendDescLampSicuroCommand(params);
            this.chiudiLampDesc(line);
        },
        //chiude la visualizzazione che consente di cambiare le desc delle lampade di una linea
        chiudiLampDesc(line) {
            let indiceLine = String(Number(line.index) - (4 * (Number(line.ak) - 1))); //si può usare direttamente 'row.line_num'
            let indiceAk = String(Number(line.ak));
            this.changeLampDesc[`${line.cu_id}_${indiceAk}_${indiceLine}`] = false;
        },
        //funzione che abilita la modifica delle descrizioni delle linee di una determinata AK
        renameLines(ak) {
            console.log("renameLines, ak:", ak);
            this.newDescLine = {};
            //devo inizializzare con i valori attuali di descrizione e renderli reattivi
            ak.lines.forEach(line => {
                this.$set(this.newDescLine, line.index, line.line_desc)
            });
            console.log("newDescLine: ", this.newDescLine);
        },
        //funzione che abilita la modifica della descrizione delle lampade di una determinata LINEA
        modificaDesc(line) {
            this.newDescLamp = {};
            //devo inizializzare con i valori attuali di descrizione e renderli reattivi
            console.log("line: ", line);
            line.lamps.forEach(lamp => {
                this.$set(this.newDescLamp, lamp.lamp_id, lamp.desc)
                // this.newDescLamp[lamp.lamp_id] = lamp.desc;
            })
            console.log("newDescLamp: ", this.newDescLamp);
            let indiceLine = String(Number(line.index) - (4 * (Number(line.ak) - 1)));
            let indiceAk = String(Number(line.ak));
            this.$set(this.changeLampDesc, `${line.cu_id}_${indiceAk}_${indiceLine}`, true);         
            const table = this.$refs.tableLine;
            if (table != null && !table.openChildRows.includes(line.index)) {
                table.toggleChildRow(line.index);
            }
            //nel caso di visualizzazione a card, apro il collapse degli ingressi
            if ((this.isOpen['line' + line.index] === false) || (this.isOpen['line' + line.index] === undefined)) {
                this.toggleCollapse('line' + line.index);
            }
            console.log("changelampDesc: ", this.changeLampDesc);
         },

        inputNameInfo(id) {
            const name = this.newDescLamp[id] || '';
            const nc = name.length;
            const validChars = /^[\p{L}\p{N}\s']*$/u.test(name);

            if (!validChars) {
                return { text: 'Sono presenti caratteri non ammessi', error: true };
            }
            if (nc == 0) {
                return { text: `${nc}/${this.maxchar} Caratteri`, error: null };
            }
            if (nc > this.maxchar) {
                return { text: `${nc}/${this.maxchar} Caratteri`, error: true };
            }

            return { text: `${nc}/${this.maxchar} Caratteri`, error: false };
        },
        inputState(id) {
            const info = this.inputNameInfo(id);
            return info.error === false ? true : (info.error === true ? false : null);
        },

        //funzione che gestisce l'evento emesso dal componente LssaDisplay per comunicare se si sta modificando il nome della LSSA
        handleEditingLssa(payload) {
            console.log("Centrali, handleEditingLssa, payload:", payload);
            this.editingLssa = payload.editingLssa;
        },
        //funzione che gestisce l'evento emesso dal componente LssaDisplay per comunicare se si sta salvando il nome della LSSA
        handleUpdating(payload) {
            this.updatingName = payload.updatingName; 
            this.nomeLssa = payload.nomeLssa;
        },
        //funzione che data una stringa che rappresenta la funzione della linea, restituisce la stringa corretta (mantained diventa maintained...)
        getLineFunctionLabel(lineFunction) {
            const value = lineFunction.toLowerCase();
            // console.log("Valore originale:", lineFunction);
            // console.log("Valore normalizzato:", value);

            if (value === 'mantained') return this.$t("details_line.line_function_maintained");
            if (value === 'not mantained') return this.$t("details_line.line_function_not_maintained");
            if (value === 'switchable') return this.$t("details_line.line_function_switchable");
            if (value === 'time switch') return this.$t("details_line.line_function_time_switch");
            if (value === 'stairway pushbutton') return this.$t("details_line.line_function_stairway_pushbutton");

            // console.log("Valore non riconosciuto:", value);
            return lineFunction;
        },

        errorDesc(cent) {
            let lista_err = [];
            let errori = cent.cu_error
            for (const property in errori)
            {
                if (property.includes("error") && (errori[property] === "ON"))
                {
                    lista_err.push(property);
                }
            }
            console.log("errorDesc, lista errori:", lista_err);
            return lista_err;
        },

        //output: se la lampada è già presente in una zona, ritorna il numero della zona in cui è presente, oppure null
        zonaLampada(lamp) {
            let numZonaTrovata = null;
            let trovato = false;
            if(this.monitoringZonesDetails!=null)
            {
                this.monitoringZonesDetails.some((zone) => {
                if (zone.lamps.length == 0) {
                    return false;
                } 
                else {
                    zone.lamps.some((lampInZone) => {
                    if (lampInZone.id == lamp.id && lampInZone.cu_id == lamp.cu_id) {
                        numZonaTrovata = zone.zoneNumber;
                        trovato = true;
                    }
                    return trovato;
                    });
                    return trovato;
                }
                })
            }
            return numZonaTrovata;
        },
        //output: se la lampada è già presente in una zona, ritorna il nome della zona in cui è presente, oppure null
        zonaLampadaDesc(lamp) {
            let zonaTrovata = null;
            let trovato = false;
            if(this.monitoringZonesDetails!=null)
            {
                this.monitoringZonesDetails.some((zone) => {
                if (zone.lamps.length == 0) {
                    return false;
                } 
                else {
                    zone.lamps.some((lampInZone) => {
                    if (lampInZone.id == lamp.id && lampInZone.cu_id == lamp.cu_id) {
                        zonaTrovata = zone.zoneName;
                        trovato = true;
                    }
                    return trovato;
                    });
                    return trovato;
                }
                })
            }
            return zonaTrovata;
        },

        //restituisce l'indice della centrale a cui appartiene l'AK (indice di unitsDetails)
        //necessario perché con v-client-table, quando si scende su un child_row, si perde la visibilità del parent
        centDaAk(id) {
            var indice = 0;
            //id è nella forma, pe, 'sicuro#000177'
            const cu_id = id.substring(id.indexOf('#') + 1);
            this.unitsDetails.some( (cent) => {
                if (cent.cu_id === cu_id) return true; //indice trovato, esco
                else {
                    indice++;
                    return false;
                }
            });
            return indice;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            this.ChangeProductInfoByUser();
        },
        //execute change product Info by user
        ChangeProductInfoByUser()
        {
            let self=this;
            self.updatingProduct = true;
            setTimeout(() => self.$store.dispatch("dbUpdateProductCode", {
                        lamps: self.multipleProductsSelection,
                        order_code: self.multipleProductsOrderCodeSelected
                    }), 1000);
                            // Hide the modal manually
            this.$nextTick(() => {
                this.$refs.multiModal.hide();
            });
        },

        //formatter che trasforma i valori inseriti in una textarea in maiuscoli
        TextAreaFormatter(value) {
            return value.toUpperCase();
        },
        //verifica se la Centrale presenta degli errori, controllando cu_error --< DA ELIMINARE
        CentralSicuroInError(cent) 
        {
            if(cent.cu_error)
            return cent.cu_error.error_general === 'ON'
        },

        //restituisce TRUE se il Charger presenta errori
        erroriCharger(charger)
        {
            return (charger.error_all_charger_or_fuse == 'ON' || charger.error_hardware == 'ON' || charger.error_overtemperature == 'ON' ||
                    charger.error_com_cpu_charger == 'ON')
        },

        showChargerDetails(charger)
        {
            this.currentCharger = charger;
            this.modalChargerDetailShow = true;
        },

        // //restituisce TRUE se lo Switch11Kw presenta errori
        // erroriSwitch11kw(sw)
        // {
        //     //return (charger.errore_comunicazione == 'ON' || charger.errore_hardware == 'ON' || charger.errore_sovratemperatura == 'ON')
        //     return false
        // },

        //visualizza il modal AKDetail
        showAkDetails(ak,type)
        {
            ak.type=type;
            this.currentAk = ak;
            console.log("Mostro dettagli ak: ",ak);
            this.modalAkDetailShow = true;
        },
        lower(val)
        {
            if (val != null) {
                return (val.toLowerCase());
            } else
            {
                return "";
            } 
        },

        numeroErroriSicuro(cent)
        {
           //return this.trovaNumLampInError(cent);
           return cent.num_lamp_error;
        },
        //restituisce true se ci sono errori nel sistema Sicuro (ak, linee, charger, cpu, lssa) escluse le lampade e gli errori serious,
        //cioè battery_symmetry, battery_fuse e power_supply_broken
        erroriPresentiSicuro(cent)
        {   
            if(cent.cu_error)   
            return ( (cent.num_ak_error > 0) ||  (cent.num_ak_ext_error > 0) || (cent.num_switch11kw_error > 0) || 
                     (cent.num_line_ext_error > 0) || (cent.num_line_ext_fuse_error > 0) || (cent.num_line_ext_isolation_error > 0) || (cent.num_line_ext_overcurrent > 0) ||
                     (cent.num_line_error > 0) || (cent.num_line_fuse_error > 0) || (cent.num_line_isolation_error > 0) || (cent.num_line_overcurrent > 0) ||
                     (cent.num_charger_error > 0) || (cent.num_lssa_error > 0) || 
                     ((cent.cu_error.error_general == 'ON') && (!this.seriousErrorCentSicuro(cent))));
        },
        //restituisce un array con i soli AK, SWITCH o CHARGER che non hanno ESPLICITAMENTE la property visible == false
        filtraAkSwitchChargerVisible(arr)
        {
            //non devono essere resytituite solo i dispositivi che ESPLICITAMENTE hanno visible == false;
            //se visible non è definita, allora il dispositivo deve essere visibile
            return arr.filter((disp) =>
            {
                //return disp.visible
                if (disp.visible != null && disp.visible != undefined)
                {
                    return disp.visible;
                }
                else
                {
                    return true; //se non ho specificato visibilità, l'AK è visibile
                }
            })
        },
        //restituisce un array con le sole LINEE che non hanno ESPLICITAMENTE la property visible == false
        filtraLineVisible(arrayLine)
        {
            return arrayLine.filter((line) =>
            {
                //console.log("filtraLineVisible, con lampade line: ", line.line_desc, line.visible);
                if (line.visible != null && line.visible != undefined)
                {
                    return line.visible;
                }
                else
                {
                    return true; //se non ho specificato visibilità, la linea è visibile
                }
            })
        },
        //verifica la presenza di errori nella batteria
        trovaBatteryInError(cent)
        {
            return (cent.cu_error.error_battery_fuse === 'ON') ||
                (cent.cu_error.error_battery_low === 'ON') ||
                (cent.cu_error.error_battery_temperature === 'ON') ||
                (cent.cu_error.error_battery_symmetry === 'ON') ||
                (cent.cu_error.error_cabinet_isominus === 'ON') ||
                (cent.cu_error.error_cabinet_isoplus === 'ON');
        },
        //verifica la presenza di errori nei caricatori
        trovaChargerInError(cent)
        {
            return (cent.cu_error.error_chargers == 'ON') || (cent.cu_error.warning_charger_off_by_temperature == 'ON');
        },

        // //Verifica la presenza di errori negli AK del sistema Sicuro --> DA ELIMINARE
        // AKconLineInErrore(disp)
        // {
        //     var bPresentiErr = false;

        //     disp.ak.forEach((ak) => { bPresentiErr = bPresentiErr || this.presentiLineInError(ak.lines) });
        //     disp.ak_ext.forEach((ak_ext) => { bPresentiErr = bPresentiErr || this.presentiLineInError(ak_ext.lines) });
        //     return bPresentiErr;
        // },

        //verifica se una delle Linee presenta un errore --> DA ELIMINARE
        presentiLineInError(lines)
        {
            let inErrore = false;
            lines.forEach((line) =>
            {
                if ((line.error_ak_su_current === 'ON') || (line.error_com_cpu_ak === 'ON') || (line.error_line_fuse === 'ON') || (line.error_line_isolation === 'ON'))
                    inErrore = true;
            });
            return inErrore;
        },
        // //funzione che restituisce il numero di lampade in errore in un sistema SICURO a livello di centrale, andando a leggere gli errori nei suoi AK --> DA ELIMINARE       
        // trovaNumLampInError(param)
        // {
        //     var num = 0;
        //     var num_ext = 0;
        //     param.ak.forEach((element) => { num = num + element.num_lamp_error });
        //     param.ak_ext.forEach((el) => { num_ext = num_ext + el.num_lamp_error });
        //     return (num + num_ext);
        // },

        //calcola il numero di errori di una dispositivo Sicuro
        calcolaNumErrori(disp)
        {
            let num = 0;
            for (const property in disp)
            {
                if ((property.includes("error_")) && (disp[property] === "ON"))
                {
                    num++;
                }
            }
            return num;
        },

        //verifica se è presente almeno 1 errore e poi esce per efficienza
        verificaErrori(disp)
        {
            let trovato = false;
            for (const property in disp)
            {
                if ((property.includes("err")) && (disp[property] === "ON"))
                {
                    trovato = true;
                    break;
                }
                //console.log("PROPERTY: ", property, trovato);
            }
            return trovato;
        },

        directBleVisibility(rssiVal)
        {
            if (rssiVal && rssiVal.toString().startsWith("*"))
                return true;
            else
                return false;
        },
        gatewayUpdateTableData()
        {

            //Cerco tutte le lampade Ble dell'impianto e le salvo nell'array arrayLampsBlePlant
            //Cerco tutte le info di zona e le metto in infoZones per avere anche il nome della zona
            var arrayLampsBlePlant = [];
            var arrayZonesInfo = [];
            this.tableBtData.forEach(function (z)
            {
                z.bleLamps.forEach(function (l)
                {
                    arrayLampsBlePlant.push(l);
                });
                var infoZone = {};
                infoZone.zoneNumber = z.zoneNumber;
                infoZone.zoneName = z.zoneName;
                arrayZonesInfo.push(infoZone);
            });
            console.log("agg lamps in all zones of plant: ", arrayLampsBlePlant);

            //Associo al gateway solo le lampade Ble di competenza e aggiungo nome zona
            this.tableData.forEach(function (u)
            {
                u.lamps = [];
                Array.prototype.push.apply(u.device_0_31, u.device_32_63);
                u.lamps_id = u.device_0_31;

                //aggiungo lmapade di competenza
                arrayLampsBlePlant.forEach(function (d)
                {
                    if (u.lamps_id.includes(d.lamp.lamp_id))
                        u.lamps.push(d);
                });

                //aggiungo nome zona
                arrayZonesInfo.forEach(function (z)
                {
                    if (z.zoneNumber == u.zone)
                    {
                        u.zoneName = z.zoneName;
                    }

                });

            });

            console.log("agg lamps in table Data Ble: ", this.tableData);
            this.tableData = this.tableData.sort((a, b) => a.cu_id - b.cu_id);
        },
        calcolaLampsPower(lamps)
        {
            var PowerLampsGateway = 0;
            for (var n = 0; n < lamps.length; n++)
            {
                if (lamps[n].lamp)  //zone bluetooth bleLamp.lamp
                    PowerLampsGateway = PowerLampsGateway + lamps[n].lamp.istantaneousPower;
                else                //gateway bluetooth lamps
                    PowerLampsGateway = PowerLampsGateway + lamps[n].istantaneousPower;
            }
            return PowerLampsGateway + " W";
        },
        calcolaLampsEnergy(lamps)
        {
            var EnergyLampsGateway = 0;
            for (var n = 0; n < lamps.length; n++)
            {
                if (lamps[n].lamp)  //zone bluetooth bleLamp.lamp
                    EnergyLampsGateway = EnergyLampsGateway + lamps[n].lamp.energy;
                else           
                    EnergyLampsGateway = EnergyLampsGateway + lamps[n].energy;
            }
            return EnergyLampsGateway / 1000 + " kWh";
        },
        calcolaLampsTimeOn(lamps)
        {
            var TimeOnLampsGateway = 0;
            for (var n = 0; n < lamps.length; n++)
            {
                if (lamps[n].lamp)  //zone bluetooth bleLamp.lamp
                    TimeOnLampsGateway = TimeOnLampsGateway + lamps[n].lamp.functionHours;
                else   
                    TimeOnLampsGateway = TimeOnLampsGateway + lamps[n].functionHours;
            }
            return TimeOnLampsGateway;
        },

        async esportaDescrittivi(cent)
        {
            console.log("cent:", cent);

            // let self = this;
            this.$bvModal.msgBoxConfirm("Esportare i descrittivi lampada?", {
                title: 'Conferma',
                okVariant: 'primary',
                okTitle: 'ESPORTA',
                cancelTitle: 'ANNULLA',
                centered: true
            }).then((value) =>
            {
                var l, lamp;
                if (value == true)
                {

                    var descr = "";
                    if (cent.lamps != null && cent.lamps.length > 0)
                    {
                        for (l in cent.lamps)
                        {
                            lamp = cent.lamps[l];
                            descr += lamp.lamp_id + "|" + (lamp.desc || '') + "\r\n";
                        }
                    }
                    if (cent.lamps_illum != null && cent.lamps_illum.length > 0)
                    {
                        for (l in cent.lamps_illum)
                        {
                            lamp = cent.lamps_illum[l];
                            descr += lamp.lamp_id + "|" + (lamp.desc || '') + "\r\n";
                        }
                    }
                    if (cent.sensors != null && cent.sensors.length > 0)
                    {
                        for (l in cent.sensors)
                        {
                            lamp = cent.sensors[l];
                            descr += lamp.lamp_id + "|" + (lamp.desc || '') + "\r\n";
                        }
                    }

                    const blob = new Blob([descr], { type: 'text/plain' });
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = downloadUrl;
                    a.download = 'descrittivi_centrale_' + cent.cu_type + '_' + cent.cu_id + '.txt';
                    a.click();
                    URL.revokeObjectURL(a.href)
                }
            });
        },
        importaDescrittivi(cent)
        {
            this.importCent = cent;
            this.importDescrFile = null;
            this.$bvModal.show('modal-import-descrittivi');
        },
        async importaDescr()
        {
            if (this.importDescrFile == null)
            {
                this.$bvModal.msgBoxOk("Nessun file selezionato!");
                return;
            }
            //console.log("importo", this.importDescrFile);
            let fileText = await this.importDescrFile.text();
            let fileRows = fileText.split("\n");
            if (fileRows[0].indexOf('|') < 0)
            {
                this.$bvModal.msgBoxOk("Formato file non valido.Il file deve contenere id lampade e descrittivo, uno per riga, separati da '|'");
                return;
            }
            this.$store.dispatch('importLampDescr', { cu_id: this.importCent.cu_id, cu_type: this.importCent.cu_type, descr: fileText });

            //console.log(fileText);

        },
        async impostaDescrittivo()
        {
            console.log("imposto descrittivo:" + this.descrittivo + ", auto inc:" + this.autoIncrDescrittivo, (this.autoIncrDescrittivo == 'true'));

            const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.descrittivo);
            if (!validChars) {
                console.log("Invalid chars");
                this.$bvModal.msgBoxOk("Il descrittivo lampada non può contenere caratteri speciali e lettere accentate");
                return;
            }
            let maxLen = (this.autoIncrDescrittivo == 'true') ? 27 : 30;
            if (this.descrittivo.length > maxLen)
            {
                console.log("Troppo lunga");
                this.$bvModal.msgBoxOk("Il descrittivo lampada non può superare i " + maxLen + " caratteri");
                return;
            }


            let cs = this.centraliSel;
            let ls = this.lampadeSel;
            console.log("centrali sel:", cs);
            console.log("lampadeSel:", ls);

            let self = this;
            var prg = 0;
            var i, l, lamp, progr, nomeLamp, alert;
            if (cs != null && cs.length > 0)
            {
                for (i = 0; i < cs.length; i++)
                {
                    let c = cs[i].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    console.log("cent:", cent);
                    // let cutype = cent.cu_type;
                    if (cent.lamps != null)
                    {
                        for (l in cent.lamps)
                        {
                            lamp = cent.lamps[l];
                            console.log("l:", lamp);
                            progr = (self.autoIncrDescrittivo == 'true') ? (" " + (++prg)) : "";
                            nomeLamp = self.descrittivo + progr;
                            let dati = { cu_type: cent.cu_type, cu_id: cent.cu_id, lamp_id: lamp.id, lamp_type: 'e', lamp_desc: nomeLamp };
                            let esito = await self.$store.dispatch('asyncDbSaveLampDescription', dati);
                            console.log("esito salvataggio nome lamp:", esito);
                            if (esito.error != null)
                            {
                                self.$store.state.loading = false;
                                alert = {
                                    timeLeft: 10,
                                    state: "danger",
                                    msg: "Salvataggio descrittivo lampada " + lamp.id + ", centrale " + cent.cu_id + " fallito",
                                    countDownChanged: function (cd)
                                    {
                                        //timeLeft = cd;
                                        console.log("countdownchanged:" + cd)
                                    }
                                }
                                this.alerts.push(alert);
                                return;
                            } else
                            {
                                lamp.desc = nomeLamp;
                            }
                        }
                    }
                    if (cent.lamps_illum != null && cent.lamps_illum.length > 0)
                    {
                        for (l in cent.lamps_illum)
                        {
                            lamp = cent.lamps_illum[l];
                            console.log("l:", lamp);
                            progr = (self.autoIncrDescrittivo == 'true') ? (" " + (++prg)) : "";
                            nomeLamp = self.descrittivo + progr;
                            let dati = { cu_type: cent.cu_type, cu_id: cent.cu_id, lamp_id: lamp.id, lamp_type: 'i', lamp_desc: nomeLamp };
                            let esito = await self.$store.dispatch('asyncDbSaveLampDescription', dati);
                            console.log("esito salvataggio nome lamp:", esito);
                            if (esito.error != null)
                            {
                                self.$store.state.loading = false;
                                alert = {
                                    timeLeft: 10,
                                    state: "danger",
                                    msg: "Salvataggio descrittivo lampada " + lamp.id + ", centrale " + cent.cu_id + " fallito",
                                    countDownChanged: function (cd)
                                    {
                                        //timeLeft = cd;
                                        console.log("countdownchanged:" + cd)
                                    }
                                }
                                this.alerts.push(alert);
                                return;
                            } else
                            {
                                lamp.desc = nomeLamp;
                            }
                        }
                    }
                    if (cent.sensors != null && cent.sensors.length > 0)
                    {
                        for (l in cent.sensors)
                        {
                            lamp = cent.sensors[l];
                            console.log("l:", lamp);
                            progr = (self.autoIncrDescrittivo == 'true') ? (" " + (++prg)) : "";
                            nomeLamp = self.descrittivo + progr;
                            let dati = { cu_type: cent.cu_type, cu_id: cent.cu_id, lamp_id: lamp.id, lamp_type: 's', lamp_desc: nomeLamp };
                            let esito = await self.$store.dispatch('asyncDbSaveLampDescription', dati);
                            console.log("esito salvataggio nome lamp:", esito);
                            if (esito.error != null)
                            {
                                self.$store.state.loading = false;
                                alert = {
                                    timeLeft: 10,
                                    state: "danger",
                                    msg: "Salvataggio descrittivo lampada " + lamp.id + ", centrale " + cent.cu_id + " fallito",
                                    countDownChanged: function (cd)
                                    {
                                        //timeLeft = cd;
                                        console.log("countdownchanged:" + cd)
                                    }
                                }
                                this.alerts.push(alert);
                                return;
                            } else
                            {
                                lamp.desc = nomeLamp;
                            }
                        }
                    }


                }
            }
            if (ls != null && ls.length > 0)
            {
                for (i = 0; i < ls.length; i++)
                {
                    progr = (self.autoIncrDescrittivo == 'true') ? (" " + (++prg)) : "";
                    nomeLamp = self.descrittivo + progr;

                    let l = ls[i].split("-")
                    let cent = self.tableData[parseInt(l[1])]
                    var lindex = parseInt(l[2])
                    var limit = (cent.lamps.length || 0) + (cent.lamps_illum.length || 0) + (cent.sensors.length || 0);
                    console.log("cent:", cent, "lindex=" + lindex + ", limit:" + limit);
                    var lampType;


                    if (lindex >= limit)
                    {
                        lamp = null;
                    } else
                    {
                        console.log("lamp valida");
                        if (l[0].indexOf('lampIll') >= 0)
                        {
                            lampType = 'i';
                            lamp = cent.lamps_illum[lindex]
                        } else if (l[0].indexOf('sens') >= 0)
                        {
                            lampType = 's';
                            lamp = cent.sensors[lindex]
                        } else
                        {
                            lampType = 'e';
                            lamp = cent.lamps[lindex]
                        }

                    }

                    console.log("lamp:", lamp);

                    if (lamp != null)
                    {
                        let dati = { cu_type: cent.cu_type, cu_id: cent.cu_id, lamp_id: lamp.id, lamp_type: lampType, lamp_desc: nomeLamp };
                        let esito = await self.$store.dispatch('asyncDbSaveLampDescription', dati);
                        console.log("esito salvataggio nome lamp:", esito);
                        if (esito.error != null)
                        {
                            self.$store.state.loading = false;
                            alert = {
                                timeLeft: 10,
                                state: "danger",
                                msg: "Salvataggio descrittivo lampada " + lamp.id + ", centrale " + cent.cu_id + " fallito",
                                countDownChanged: function (cd)
                                {
                                    //timeLeft = cd;
                                    console.log("countdownchanged:" + cd)
                                }
                            }
                            this.alerts.push(alert);
                            return;
                        } else
                        {
                            lamp.desc = nomeLamp;
                        }
                    }
                }
            }


            alert = {
                timeLeft: 5,
                state: "success",
                msg: "Salvataggio descrittivi lampade completato",
                countDownChanged: function (cd)
                {
                    //timeLeft = cd;
                    console.log("countdownchanged:" + cd)
                }
            }
            this.alerts.push(alert);

            self.$store.state.loading = false;

        },
        stopGetDati()
        {
            console.log("GET DATI:Stop")
        },
        deviceTypeFilter()
        {
            //console.log("DEVICES TYPE: ", this.devicesType);
            if (this.devicesType != null && this.devicesType != undefined)
                return this.devicesType;
            else
                return null;
        },
        //restituisce la stringa che descrive un errore serio della Centrale Sicuro
        seriousErrorCentSicuroDesc(cent)
        {
            var err_desc="";
            if (cent.cu_error) {
                if (cent.cu_error.error_battery_symmetry == "ON") {
                    err_desc = this.$t('details_cu_modal.cu_error_batt_simm');
                } else if (cent.cu_error.error_battery_fuse == 'ON') {
                    err_desc = this.$t('details_cu_modal.cu_error_batt_fuse')
                } else if (cent.cu_error.error_power_supply_broken == 'ON') {
                    err_desc = this.$t('details_cu_modal.cu_error_batt_fuse')
                }
            }
            return err_desc;    
        },
        //restituisce true se è presente un errore serio in una Centrale Sicuro
        seriousErrorCentSicuro(cent)
        {
            if (cent.cu_error) 
            return ((cent.cu_error.error_battery_symmetry == "ON") || (cent.cu_error.error_battery_fuse == 'ON') || (cent.cu_error.error_power_supply_broken == 'ON'));
        },
        
        //restituisce il numero di lampade in errore, per il tipo lampType, presenti in una centrale
        numErrorOnCent(cent, lampType)
        {
            var total = 0;

            if (lampType == "emergency")
            {
                cent.lamps.forEach((l) =>
                {
                    if (l.error_batt_short == "ON" || l.error_batt_test == "ON"
                        || l.error_batt_test_auto == "ON" || l.error_tubo_UV == "ON"
                        || l.error_com == "ON" || l.error_led == "ON"
                        || l.error_comm_radio_lamp == "ON"
                        || l.error_hardware == "ON"
                        || l.error_overpower == "ON"
                        || l.error_underpower == "ON"
                        || l.error_overvoltage == "ON"
                        || l.error_undervoltage == "ON")
                        total = total + 1;
                });
            }

            if (lampType == "lighting")
            {
                cent.lamps_illum.forEach((l) =>
                {
                    if (l.error_batt_short == "ON" || l.error_batt_test == "ON"
                        || l.error_batt_test_auto == "ON" || l.error_tubo_UV == "ON"
                        || l.error_com == "ON" || l.error_led == "ON" || l.error_comm_radio_lamp == "ON"
                        || l.error_hardware == "ON"
                        || l.error_overpower == "ON"
                        || l.error_underpower == "ON"
                        || l.error_overvoltage == "ON"
                        || l.error_undervoltage == "ON")
                        
                        total = total + 1;
                });
            }

            // if (lampType == "sensor")
            // {
            //     cent.sensors.forEach((l) =>
            //     {

            //     });
            // }


            if (lampType == "all")
            {
                total = cent.num_lamp_error;

            }

            return total;

        },
        numOrphanOnCent(cent, lampType)
        {
            var total = 0;

            if (lampType == "emergency")
            {
                cent.lamps.forEach((l) =>
                {
                    if (l.nodo_orfano == true)
                        total = total + 1;
                });
            }

            if (lampType == "lighting")
            {
                cent.lamps_illum.forEach((l) =>
                {
                    if (l.nodo_orfano == true)
                        total = total + 1;
                });
            }

            if (lampType == "sensor")
            {
                cent.sensors.forEach((l) =>
                {
                    if (l.nodo_orfano == true)
                        total = total + 1;
                });
            }


            if (lampType == "all")
            {
                if (cent.cu_type == "logicafm" && cent.num_nodi_orfani)
                    total = total + cent.num_nodi_orfani;
            }
            return total;

        },
        // numEmergencyOnCent(cent, lampType)
        // {
        //     var total = 0;

        //         cent.lamps.forEach((l) =>
        //         {
        //             if (l.emer_active=="EMERGENZA IN CORSO")
        //                 total = total + 1;
        //         });
            
        //     return total;
        // },
        startEditCSV()
        {
            this.logica_config_sn = (this.currentCent.qr_lamps_id || []).join("\r\n");
            this.editingCSV = true;
        },
        sendDeleteLgSerial()
        {
            console.log('Delete all lamps', this.deleteAllLamps);
            this.sendDeleteMultiLogicaSerialId(this.currentCent.cu_type, this.currentCent.cu_id);
        },
        getListProductCode(order_code)
        {
            var array_code = order_code.split(this.delimiter_undefined_product);
            return array_code
        },

        setLampProductByUser(lamp, order_code)
        {
            this.multipleProductsSelection=[];
            this.multipleProductsChecked=[];
            this.multipleProductsOrderCodeSelected=order_code;
            this.currentLamp=lamp;
            
            if(this.lampadeSel.length>1)
            {

                console.log("multiple change multiple products");
                for (var lsel in this.lampadeSel)
                {
                    let l = this.lampadeSel[lsel].split("-");
                    let cent = this.tableData[parseInt(l[1])];
                    let lampChecked = cent.lamps[parseInt(l[2])];

                    this.multipleProductsChecked.push(lampChecked);

                    if(lampChecked.multiple_products.order_code && lampChecked.multiple_products.order_code!="")
                        var indice = this.getListProductCode(lampChecked.multiple_products.order_code).indexOf(order_code);
                    else
                        indice=-1;    
                    if(indice!= -1)
                    {
                        this.multipleProductsSelection.push(lampChecked);
                    }
                }
          
                console.log("multiple checkedLamp: ", this.multipleProductsChecked);
                console.log("multiple relArrayLamp: ", this.multipleProductsSelection);

                //Nel caso in cui le lampade alle quali applicare il cambio codice non siano coerenti
                //viene mostrato un modal , altrimenti si procede
                if(this.multipleProductsChecked.length > this.multipleProductsSelection.length)
                {
                    this.$bvModal.show('multiple-products-modal');
                }
                else
                {
                    this.ChangeProductInfoByUser();
                }                
            }
            else
            {
                this.updatingProduct = true;

                //Nel caso in cui sia selezionata una singola lampada si aggiunge all'array e si procede
                this.multipleProductsSelection.push(lamp);
                this.ChangeProductInfoByUser();
            }
        },

        lampFunction: function (lamp)
        {
            if (lamp.cu_type != "bluetooth")
                return (lamp.device_function || "EMERGENZA").toUpperCase();
            else
                return (lamp.model == 9 ? "ILLUMINAZIONE-BLE" : "EMERGENZA");
        },


        numUnitsOk()
        {
            var CuOk = [];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;

            for (let k = 0; k < this.unitsDetails.length; k++)
            {
                if (this.unitsDetails[k].cu_error)
                {
                    if ((this.unitsDetails[k].num_lamp_error === 0) && (this.calcolaNumErrori(this.unitsDetails[k].cu_error) === 0) && (this.unitsDetails[k].cu_connected == true))
                    {
                        CuOk.push(this.unitsDetails[k].cu_id);
                    }
                }
            }
            console.log("CU funzionanti", CuOk);
            return CuOk.length;
        },

        numUnitsDisconnected()
        {
            var CuDisconnected = [];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k = 0; k < this.unitsDetails.length; k++)
            {
                if (this.unitsDetails[k].cu_connected == false)
                    CuDisconnected.push(this.unitsDetails[k].cu_id);
            }
            console.log("CU non raggiungibili", CuDisconnected);
            return CuDisconnected.length;
        },

        numUnitsFail()
        {
            var CuFail = [];
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k = 0; k < this.unitsDetails.length; k++)
            {
                if (this.unitsDetails[k].cu_error)
                {
                    if (((this.unitsDetails[k].num_lamp_error !== 0) || (this.verificaErrori(this.unitsDetails[k].cu_error) === true)) && (this.unitsDetails[k].cu_connected == true))
                    {
                        CuFail.push(this.unitsDetails[k].cu_id);
                    }
                }
            }
            console.log("CU in errore", CuFail);
            return CuFail.length;

        },

        numLampsDisconnected()
        {
            var numLampDisconnected = 0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k = 0; k < this.unitsDetails.length; k++)
            {
                if (this.unitsDetails[k].cu_connected == false)
                    numLampDisconnected = numLampDisconnected + this.unitsDetails[k].lamps.length;
            }
            console.log("CU LAMP non raggiungibili: ", numLampDisconnected);
            return numLampDisconnected;
        },

        numLampsFail()
        {
            var numLampFail = 0;
            if (this.unitsDetails == null || this.unitsDetails.length == 0) return 0;
            for (let k = 0; k < this.unitsDetails.length; k++)
            {
                if (this.unitsDetails[k].cu_connected == true) {
                    numLampFail = numLampFail + this.unitsDetails[k].num_lamp_error;
                }
            }
                    
                    
            console.log("CU LAMP in errore: ", numLampFail);
            return numLampFail;
        },

        numLampsOk()
        {
            return this.totalLamps - this.numLampsFail() - this.numLampsDisconnected();
        },

        async getImage(imageUrl)
        {
            return new Promise((resolve) =>
            {

                var img = new Image();
                img.crossOrigin = "anonymous";
                img.src = imageUrl;

                img.onload = function ()
                {
                    resolve(img);
                }
            });
        },

        async getImageData(logo)
        {
            logo.crossOrigin = "anonymous";
            await logo.decode();
            //console.log("immagine:" + logo.width+"x"+logo.height ,logo);
            var canvas = document.createElement("canvas");
            canvas.width = logo.width;
            canvas.height = logo.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(logo, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            console.log("lodo dataurl:" + dataURL);
            return dataURL;

        },

        //restituisce TRUE se la lampada presenta un errore
        erroriPresentiLamp(lamp) {
            return ((lamp.error_com_ak_lamp == 'ON') || (lamp.error_dali_com == 'ON') || (lamp.error_dali_hardware == 'ON') || (lamp.error_dali_lamp == 'ON') ||
                    (lamp.error_hardware == 'ON') || (lamp.error_id_duplicate == 'ON') || (lamp.error_lamp_programming == 'ON') || (lamp.error_led_full_short == 'ON') ||
                    (lamp.error_led_open == 'ON') || (lamp.error_led_partial_short == 'ON') || (lamp.error_low_voltage == 'ON') || (lamp.error_plarity_reverse == 'ON') ||
                    (lamp.error_under_threshold == 'ON') );
        },
        //crea Pdf Impianto
        async createPDF_Impianto()
        {
            let self = this;

            //Define header and table name

            let plant_header = this.plantDetails.plantname;
            var date_now = new Date();
            let table_name = plant_header;

            // Only pt supported (not mm or in)
            //var doc = new jsPDF('p', 'pt');
            const doc = new jsPDF({ 
                orientation: 'p', 
                unit: 'pt', 
                format: 'a4', 
                putOnlyUsedFonts: true, 
                floatPrecision: 16 
            });

            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
            // Use 'Identity-H' encoding for the font registration to enable Unicode support
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

            if (this.plantDetails.logoId != null)
            {
                console.log("Esiste il logo!");
                //let logoUrl = process.env.VUE_APP_ROOT_URL + "/img/loghi/Logo_" + this.plantDetails.id + '.jpg?rnd=' + Math.random();
                let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id=" + this.plantDetails.id + "&rnd=" + Math.random();
                //var logoImg = await this.getImage(logoUrl);
                //console.log("logoImg=",logoImg, logoImg.width, logoImg.height);
                var logoImg = new Image();
                logoImg.src = logoUrl;
                var logoData = await this.getImageData(logoImg);
                var w = 60 * logoImg.width / logoImg.height;
                //var x = (doc.internal.pageSize.getWidth() - w ) / 2;
                doc.addImage(logoData, 'PNG', 38, 15, w, 60);

            } else
            {
                doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
            }


            //doc.setFont("helvetica");
            doc.setFont("Roboto");

            //Creation date info
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.title_create_date') + " : " + date_now.toLocaleDateString() + date_now.toLocaleTimeString(), 400, 70);

            //Plant header
            doc.setFontType("bold");
            doc.setFontSize(12);
            doc.text(this.plantDetails.plantname, 38, 95);

            //Info number cu and num lamps
            doc.setFontType("normal");
            doc.setFontSize(10);
            doc.text(this.plantDetails.address.street + " " + this.plantDetails.address.housenumber, 38, 110);
            doc.text(this.plantDetails.address.cap + " - " + this.plantDetails.address.city + " (" + this.plantDetails.address.prov + ") " + this.plantDetails.address.country, 38, 125);

            // Client info
            let client = this.clientDetails;
            console.log("Client Details: ", client);
            if (client != null)
            {
                var currentClientName = client.type == 'company' ? client.clientbusinessName : client.clientSurname + ' ' + client.clientName;

                doc.setFontType("bold");
                doc.text(this.$t('report_pdf.plant_client') + " : " + currentClientName, 38, 160);
                doc.setFontType("normal");
                doc.text(client.clientStreet + " " + client.clientNumber, 38, 180);

                let citySeparator = " ";
                if (client.clientCity)
                    citySeparator = " - ";

                let provSeparator = " ";
                if (client.clientProv)
                    provSeparator = " (" + client.clientProv + ") ";

                doc.text(client.clientCap + citySeparator + client.clientCity + provSeparator + client.clientCountry, 38, 200);
                doc.text(this.$t('report_pdf.plant_client_phone') + " : " + client.clientPhone, 38, 220);
                doc.text(this.$t('report_pdf.plant_client_email') + " : " + client.clientEmail, 38, 240);
            }

            doc.setFontType("bold");
            doc.text(this.$t('report_pdf.num_centrali') + " : " + self.numUnits, 38, 280);
            doc.setFontType("normal");
            // doc.text(this.$t('report_pdf.num_centrali_ok') + " : " + self.numUnitsOk(), 38, 300);
            // doc.text(this.$t('report_pdf.num_centrali_fail') + " : " + self.numUnitsFail(), 38, 320);
            doc.text(this.$t('report_pdf.num_centrali_no_err') + " : " + self.numUnitsOk(), 38, 300);
            doc.text(this.$t('report_pdf.num_centrali_with_err') + " : " + self.numUnitsFail(), 38, 320);
            doc.text(this.$t('report_pdf.num_centrali_disconnected') + " : " + self.numUnitsDisconnected(), 38, 340);

            doc.setFontType("bold");
            doc.text(this.$t('report_pdf.num_lampade') + " : " + self.totalLamps, 38, 380);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.num_lampade_ok') + " : " + self.numLampsOk(), 38, 400);
            doc.text(this.$t('report_pdf.num_lampade_fail') + " : " + self.numLampsFail(), 38, 420);
            doc.text(this.$t('report_pdf.num_lampade_disconnected') + " : " + self.numLampsDisconnected(), 38, 440);

            var centData = [];
            var cent
            if (self.centraliSel.length > 0)
            {
                for (var i = 0; i < self.centraliSel.length; i++)
                {
                    var centId = self.centraliSel[i].substr(5);
                    cent = self.tableData[centId];
                    console.log("centId", centId, cent);
                    centData.push(cent);
                }
            } else
            {
                centData = centData.concat(self.unitsDetails);
            }
            console.log("centData:", centData);
            //console.log("unitsDetails: ", this.unitsDetails);

            //si ciclano le centrali dell'impianto
            for (var p = 0; p < centData.length; p++)
            {
                doc.addPage();
                cent = centData[p];

                var num_lamp_found = cent.num_lamp_found;
                var num_lamp_error = cent.num_lamp_error;

                //Info number cu and num lamps
                doc.setFontType("bold");
                doc.setFontSize(12);
                doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id, 38, 50);
                doc.setFontType("normal");
                doc.setFontSize(10);
                doc.text(this.$t('report_pdf.centrale_desc') + " : " + cent.cu_desc, 38, 65);
                doc.setFontSize(8);
                doc.text(this.$t('details_cu_modal.cu_numero_lampade') + " : " + num_lamp_found, 38, 90);
                doc.text(this.$t('details_cu_modal.cu_numero_lampade_errore') + " : " + num_lamp_error, 38, 102);
                // doc.text(this.$t('details_cu_modal.cu_prossimo_test_funzionale') + " : " + cent.cu_next_funct_test, 38, 120);
                // doc.text(this.$t('details_cu_modal.cu_prossimo_test_autonomia') + " : " + cent.cu_next_auto_test, 38, 132);
                doc.text(this.$t('details_cu_modal.cu_prossimo_test_funzionale') + " : " + this.moment(String(new Date(cent.cu_next_funct_test))).format('DD MMM YYYY - HH:mm'), 38, 120);
                doc.text(this.$t('details_cu_modal.cu_prossimo_test_autonomia') + " : " + this.moment(String(new Date(cent.cu_next_auto_test))).format('DD MMM YYYY - HH:mm'), 38, 132);
                var distanza_top_pag = 144;
                const altezza_linea = 12;
                if (cent.cu_period_funct_test != null)
                {
                    doc.text(this.$t('details_cu_modal.cu_periodicita_test_funzionale') + " : " + cent.cu_period_funct_test + " gg", 38, distanza_top_pag);
                    distanza_top_pag += altezza_linea;
                }
                if (cent.cu_period_auto_test != null)
                {
                    doc.text(this.$t('details_cu_modal.cu_periodicita_test_autonomia') + " : " + cent.cu_period_auto_test + " gg", 38, distanza_top_pag);
                    distanza_top_pag += altezza_linea;
                }
                if (cent.cu_status.test_differito != null)
                {
                    doc.text(this.$t('details_cu_modal.test_differito') + " : " + cent.cu_status.test_differito + " gg", 38, distanza_top_pag);
                    distanza_top_pag += altezza_linea;
                }
                doc.text(this.$t('details_cu_modal.prima_installazione') + " : " + self.moment(String(new Date(cent.first_installation_timestamp))).format('DD MMM YYYY - HH:mm'), 38, distanza_top_pag);

                //inserimento tabella con i vari dispositivi
                var rows = [];
                var columns = [];
                var tablePage = 0;
                var maxPageLamps = 30;
                var tLamps = 0;
                
                if (cent.cu_type === 'sicuro') {
                    tLamps = cent.num_lamp_found;
                } else {
                    tLamps = cent.lamps.length;
                } 
                var currLampsCount = 0;
                var r, l;

                console.log("Centrale: ", cent.cu_type, tLamps);

                //----------
                //EMERGENZA
                //---------

                //se la centrale è di tipo Sicuro, devo costruire l'array con tutte le lampade dei vari AK e delle rispettive LINEE
                if (cent.cu_type == "sicuro")
                {
                    var lampsSicuro = [];
                    for (r = 0; r < cent.ak.length; r++)
                    {
                        for (i = 0; i < cent.ak[r].lines.length; i++)
                        {
                            for (var j = 0; j < cent.ak[r].lines[i].lamps.length; j++)
                            {
                                lampsSicuro.push(cent.ak[r].lines[i].lamps[j]);
                            }
                        }
                    }

                    for (r = 0; r < cent.ak_ext.length; r++)
                    {
                        for (i = 0; i < cent.ak_ext[r].lines.length; i++)
                        {
                            for (j = 0; j < cent.ak_ext[r].lines[i].lamps.length; j++)
                            {
                                lampsSicuro.push(cent.ak_ext[r].lines[i].lamps[j]);
                            }
                        }
                    }

                    cent.lamps = lampsSicuro; //side effect che può servire o meno....

                    columns = [
                        { title: "AK", dataKey: "ak" },
                        { title: "LINE", dataKey: "line" },
                        { title: "ID", dataKey: "id" },
                        { title: "Desc.", dataKey: "desc" },
                        { title: "Order code", dataKey: "code" },
                        { title: "Mode", dataKey: "mode" },
                        { title: "Stato", dataKey: "status" }
                    ];
                    while (currLampsCount < tLamps)
                    {
                        rows = [];
                        for (r = currLampsCount; r < Math.min(tLamps, currLampsCount + maxPageLamps); r++)
                        {
                            l = cent.lamps[r];
                            rows.push({
                                ak: l.ak_index? l.ak_index:"",
                                line: l.ak_line,
                                id: l.lamp_id,
                                desc: l.desc,
                                code: l.order_code,
                                mode: l.device_function,
                                status: (this.erroriPresentiLamp(l) ? "error" : "ok"),
                            })
                        }
                        if (tablePage > 0)
                        {
                            doc.addPage();
                            doc.setFontType("bold");
                            doc.setFontSize(12);
                            doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id + ", Lampade Emergenza: " + (currLampsCount + 1) + " - " + Math.min(tLamps, currLampsCount + maxPageLamps), 38, 50);
                        }

                        doc.autoTable({
                            columns,
                            body: rows,
                            startY: (tablePage > 0) ? 80 : 190,
                            theme: 'striped',
                            styles: {
                                fontSize: 7,
                                //font: "helvetica", // helvetica, times, courier
                                font: "Roboto",
                                fontStyle: 'normal', // normal, bold, italic, bolditalic
                                halign: 'left', // left, center, right
                            },
                            headStyles: {},
                            bodyStyles: {},
                            alternateRowStyles: {},
                            columnStyles: {}
                        });

                        doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);

                        tablePage += 1;
                        currLampsCount += maxPageLamps;
                        maxPageLamps = 35;
                    }
                } else
                {
                    columns = [
                        { title: "ID", dataKey: "id" },
                        { title: "Desc.", dataKey: "desc" },
                        { title: "Order code", dataKey: "code" },
                        { title: "Tipo", dataKey: "type" },
                        { title: "Autonomia", dataKey: "autonomia" },
                        { title: "Parità", dataKey: "parita" },
                        { title: "Stato", dataKey: "status" }
                    ];

                    while (currLampsCount < tLamps)
                    {
                        rows = [];
                        for (r = currLampsCount; r < Math.min(tLamps, currLampsCount + maxPageLamps); r++)
                        {
                            // var l;
                            l = cent.lamps[r];
                            rows.push({
                                id: l.id,
                                desc: l.desc,
                                code: l.order_code,
                                type: l.lamp_type,
                                autonomia: l.autonomy,
                                parita: l.parity,
                                status: (l.emer_active == 'EMERGENZA IN CORSO') ? "emergency" : (l.error_batt_short == "OFF" && l.error_batt_test == "OFF" && (!l.error_batt_test_auto || l.error_batt_test_auto == "OFF") && (!l.error_tubo_UV || l.error_tubo_UV == "OFF") && l.error_com == "OFF" && (!l.error_comm_radio_lamp || l.error_comm_radio_lamp == "OFF") && l.error_hardware == "OFF" && l.error_led == "OFF") ? "ok" : "error"
                            })
                        }
                        if (tablePage > 0)
                        {
                            doc.addPage();
                            doc.setFontType("bold");
                            doc.setFontSize(12);
                            doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id + ", Lampade Emergenza: " + (currLampsCount + 1) + " - " + Math.min(tLamps, currLampsCount + maxPageLamps), 38, 50);
                        }

                        doc.autoTable({
                            columns,
                            body: rows,
                            startY: (tablePage > 0) ? 80 : 190,
                            theme: 'striped',
                            styles: {
                                fontSize: 7,
                                //font: "helvetica", // helvetica, times, courier
                                font: "Roboto",
                                fontStyle: 'normal', // normal, bold, italic, bolditalic
                                halign: 'left', // left, center, right
                            },
                            headStyles: {},
                            bodyStyles: {},
                            alternateRowStyles: {},
                            columnStyles: {}
                        });

                        doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);

                        tablePage += 1;
                        currLampsCount += maxPageLamps;
                        maxPageLamps = 35;
                    }
                }
                // const awsmobile = {
                //     "aws_project_region": "eu-west-1",
                //     "aws_cognito_identity_pool_id": "eu-west-1:ac56ca42-d583-4851-99dc-0e842fc55a04",
                //     "aws_cognito_region": "eu-west-1",
                //     "aws_user_pools_id": "eu-west-1_RP238eErD",
                //     "aws_user_pools_web_client_id": "5iguuetft1issssof1o76jrqb5",
                //     "oauth": {}
                // };

                //-----------------
                // ILLUMINAZIONE
                //-----------------
                columns = [
                    { title: "ID", dataKey: "id" },
                    { title: "Desc.", dataKey: "desc" },
                    { title: "Order code", dataKey: "code" },
                    { title: "Potenza", dataKey: "power" },
                    { title: "Energia", dataKey: "energy" },
                    { title: "Ore funzionamento", dataKey: "hours" },
                    { title: "Stato", dataKey: "status" }
                ];
                tLamps = cent.lamps_illum.length;
                currLampsCount = 0;

                while (currLampsCount < tLamps)
                {
                    rows = [];
                    for (r = currLampsCount; r < Math.min(tLamps, currLampsCount + maxPageLamps); r++)
                    {
                        // var l;
                        l = cent.lamps_illum[r];
                        rows.push({
                            id: l.id,
                            desc: l.desc,
                            code: l.order_code,
                            power: parseFloat(l.potenza_attuale).toFixed(1) + " W",
                            energy: parseFloat(l.energia_consumata / 1000).toFixed(0) + " kWh",
                            hours: parseFloat(l.TimeOn).toFixed(0) + " h",
                            status: (l.error_com == "OFF" && l.error_hardware == "OFF" && l.error_led == "OFF" && l.error_overpower == "OFF" && l.nodo_orfano == false &&
                                l.error_overvoltage == "OFF" && l.error_underpower == "OFF" && l.error_undervoltage == "OFF" && l.error_comm_radio_lamp == "OFF") ? "ok" : "error"
                        })
                    }
                    if (tablePage > 0)
                    {
                        doc.addPage();
                        doc.setFontType("bold");
                        doc.setFontSize(12);
                        doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id + ", Lampade Illuminazione: " + (currLampsCount + 1) + " - " + Math.min(tLamps, currLampsCount + maxPageLamps), 38, 50);
                    }

                    doc.autoTable({
                        columns,
                        body: rows,
                        startY: (tablePage > 0) ? 80 : 190,
                        theme: 'striped',
                        styles: {
                            fontSize: 7,
                            //font: "helvetica", // helvetica, times, courier
                            font: "Roboto",
                            fontStyle: 'normal', // normal, bold, italic, bolditalic
                            halign: 'left', // left, center, right
                        },
                        headStyles: {},
                        bodyStyles: {},
                        alternateRowStyles: {},
                        columnStyles: {}
                    });

                    doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);

                    tablePage += 1;
                    currLampsCount += maxPageLamps;
                    maxPageLamps = 35;
                }

                //-----------------
                // I/O SENSORS
                //-----------------
                tLamps = cent.sensors.length;
                currLampsCount = 0;

                while (currLampsCount < tLamps)
                {
                    rows = [];
                    for (r = currLampsCount; r < Math.min(tLamps, currLampsCount + maxPageLamps); r++)
                    {
                        l;
                        l = cent.sensors[r];
                        rows.push({
                            id: l.id,
                            desc: l.desc,
                            code: l.order_code,
                            type: l.lamp_type,
                            autonomia: l.autonomy,
                            parita: l.parity,
                            status: (l.emer_active == 'EMERGENZA IN CORSO') ? "emergency" : (l.error_batt_short == "OFF" && l.error_batt_test == "OFF" && (!l.error_batt_test_auto || l.error_batt_test_auto == "OFF") && (!l.error_tubo_UV || l.error_tubo_UV == "OFF") && l.error_com == "OFF" && l.error_hardware == "OFF" && l.error_led == "OFF") ? "ok" : "error"
                        })
                    }
                    if (tablePage > 0)
                    {
                        doc.addPage();
                        doc.setFontType("bold");
                        doc.setFontSize(12);
                        doc.text(this.$t('report_pdf.title_centrale') + " : " + cent.cu_type + " " + cent.cu_id + ", Sensori: " + (currLampsCount + 1) + " - " + Math.min(tLamps, currLampsCount + maxPageLamps), 38, 50);
                    }

                    doc.autoTable({
                        columns,
                        body: rows,
                        startY: (tablePage > 0) ? 80 : 190,
                        theme: 'striped',
                        styles: {
                            fontSize: 7,
                            //font: "helvetica", // helvetica, times, courier
                            font: "Roboto",
                            fontStyle: 'normal', // normal, bold, italic, bolditalic
                            halign: 'left', // left, center, right
                        },
                        headStyles: {},
                        bodyStyles: {},
                        alternateRowStyles: {},
                        columnStyles: {}
                    });

                    doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);

                    tablePage += 1;
                    currLampsCount += maxPageLamps;
                    maxPageLamps = 35;
                }


            }


            doc.save(table_name);


        },
        //crea Pdf Impianto BLE
        async createPDF_ImpiantoBle() {
            let plant_header = this.plantDetails.plantname;
            var date_now = new Date();
            let table_name = plant_header;

            console.log("plantDetails: ", this.plantDetails);

            // Only pt supported (not mm or in)
            var doc = new jsPDF('p', 'pt');
            
            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
            // Use 'Identity-H' encoding for the font registration to enable Unicode support
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');

            if (this.plantDetails.logoId != null)
            {
                console.log("Esiste il logo!");
                let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id=" + this.plantDetails.id + "&rnd=" + Math.random();
                var logoImg = new Image();
                logoImg.src = logoUrl;
                var logoData = await this.getImageData(logoImg);
                var w = 60 * logoImg.width / logoImg.height;
                doc.addImage(logoData, 'PNG', 38, 15, w, 60);

            } else
            {
                doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
            }


            //doc.setFont("helvetica");
            doc.setFont("Roboto");

            //Creation date info
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.title_create_date') + " : " + date_now.toLocaleDateString() + date_now.toLocaleTimeString(), 400, 70);

            //Plant header
            doc.setFontType("bold");
            doc.setFontSize(12);
            doc.text(this.plantDetails.plantname, 38, 95);

            //Info number cu and num lamps
            doc.setFontType("normal");
            doc.setFontSize(10);
            doc.text(this.plantDetails.address.street + " " + this.plantDetails.address.housenumber, 38, 110);
            doc.text(this.plantDetails.address.cap + " - " + this.plantDetails.address.city + " (" + this.plantDetails.address.prov + ") " + this.plantDetails.address.country, 38, 125);

            // Client info
            let client = this.clientDetails;
            console.log("Client Details: ", client);
            if (client != null)
            {
                var currentClientName = client.type == 'company' ? client.clientbusinessName : client.clientSurname + ' ' + client.clientName;

                doc.setFontType("bold");
                doc.text(this.$t('report_pdf.plant_client') + " : " + currentClientName, 38, 160);
                doc.setFontType("normal");
                doc.text(client.clientStreet + " " + client.clientNumber, 38, 180);

                let citySeparator = " ";
                if (client.clientCity)
                    citySeparator = " - ";

                let provSeparator = " ";
                if (client.clientProv)
                    provSeparator = " (" + client.clientProv + ") ";

                doc.text(client.clientCap + citySeparator + client.clientCity + provSeparator + client.clientCountry, 38, 200);
                doc.text(this.$t('report_pdf.plant_client_phone') + " : " + client.clientPhone, 38, 220);
                doc.text(this.$t('report_pdf.plant_client_email') + " : " + client.clientEmail, 38, 240);
            }

            doc.setFontType("bold");
            doc.text(this.$t('bluetooth.num_zone') + " : " + this.numZones, 38, 280);
            doc.text(this.$t('report_pdf.num_lampade') + " : " + this.totalLampsBle, 38, 300);
            doc.setFontType("normal");
            doc.text(this.$t('report_pdf.num_lampade_ok') + " : " + this.numLampsBleOk, 38, 320);
            doc.text(this.$t('report_pdf.num_lampade_fail') + " : " + (this.totalLampsBle - this.numLampsBleOk), 38, 340);

            doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);

            //preparazione di 2 tabelle: una per le lampade di illuminazione ed una per quelle di emergenza
            var rows_ill = [[]];
            var index_ill = 0;
            var rows_emerg = [[]];
            var index_emerg = 0;
            var columns_emerg = [
                { title: "ID", dataKey: "id" },
                { title: "Desc", dataKey: "desc" },
                { title: "Order code", dataKey: "code" },
                { title: this.$t('details_lamp.lamp_sa_dimming'), dataKey: "mode" },
                { title: this.$t('details_lamp.lamp_autonomy'), dataKey: "autonomy"},
                { title: this.$t('details_lamp.lamp_parity'), dataKey: "parity" },
                { title: this.$t('zone.label_zone_name'), dataKey: "zone_name" },
                { title: this.$t('bluetooth.zone_number'), dataKey: "zone_number"},
                { title: this.$t('details_lamp.lamp_state'), dataKey: "status"}
            ];
            var columns_ill = [
                { title: "ID", dataKey: "id" },
                { title: "Desc.", dataKey: "desc" },
                { title: "Order code", dataKey: "code" },
                { title: this.$t('details_lamp.lamp_actual_power'), dataKey: "power" },
                { title: this.$t('details_lamp.lamp_energy'), dataKey: "energy" },
                { title: this.$t('details_lamp.lamp_timeon'), dataKey: "hours" },
                { title: this.$t('zone.label_zone_name'), dataKey: "zone_name" },
                { title: this.$t('bluetooth.zone_number'), dataKey: "zone_number"},
                { title: this.$t('details_lamp.lamp_state'), dataKey: "status" }                
            ];
            const maxPageLamps = 35;            
            var currLampIllCount = 0; //contatore lampade di illuminazione
            var currLampEmergCount = 0; //contatore lampade di emergenza
            
            //ciclo su ogni singola zona dell'impianto
            for (var p = 0; p < this.tableBtData.length; p++)
            {               
                let zone = this.tableBtData[p];
                const tLamps = zone.bleLamps.length;
                var l;
                var currLampsCount = 0; //contatore lampade generale
                //ciclo su ogni lampada della zona e separo illuminazione ed emergenza, riempiendo le rispettive rows
                while (currLampsCount < tLamps)
                {
                    //carico effettivamente la lampada
                    l = zone.bleLamps[currLampsCount].lamp;
                    //verifico se è di illuminazione o di emergenza (tramite le proprietà autonomy e model)
                    if ((l.autonomy != "??") && (l.model != 9))  {
                        //lampada di emergenza
                        //verifico se ho già raggiunto il numero max di elementi per tabella/pagina
                        if (currLampEmergCount == maxPageLamps) {
                            //se sì, passo alla riga/tabella successiva
                            index_emerg++;
                            currLampEmergCount = 0; //azzero il conteggio relativo di num max lampade per tabella/pagina
                            rows_emerg[index_emerg] = []; //aggiungo il nuovo array vuoto per consentire il corretto push
                        }
                        //console.log("arrivato qui 1");
                        //introduco una nuova riga
                        rows_emerg[index_emerg].push({
                            id: l.lamp_id,
                            desc: l.desc,
                            code: l.order_code,
                            mode: l.lamp_type,
                            autonomy: l.autonomy,
                            parity: l.parity,
                            zone_name: zone.zoneName,
                            zone_number: zone.zoneNumber,
                            status: (l.emer_active == 'EMERGENZA IN CORSO') ? "emergency" : (l.error_batt_short == "OFF" && l.error_batt_test == "OFF" && (!l.error_batt_test_auto || l.error_batt_test_auto == "OFF") && (!l.error_tubo_UV || l.error_tubo_UV == "OFF") && l.error_com == "OFF" && l.error_hardware == "OFF" && l.error_led == "OFF") ? "ok" : "error"
                        });
                        //incremento il contatore delle lampade di emergenza inserite
                        currLampEmergCount++;
                        //incremento il contatore complessivo di lampade inserite
                        currLampsCount++;
                    } else {
                        //lampada di illuminazione
                        if (currLampIllCount == maxPageLamps) {
                            index_ill++;
                            currLampIllCount = 0;                            
                            rows_ill[index_ill] = []; 
                        }
                        //console.log("illum, rows_ill ", rows_ill, " e index_ill ", index_ill);
                        rows_ill[index_ill].push({
                            id: l.lamp_id,
                            desc: l.desc,
                            code: l.order_code,
                            power: (l.istantaneousPower != null ? l.istantaneousPower : "-") + " W",
                            energy: parseFloat(l.energy / 1000).toFixed(0) + " kWh",
                            hours: (l.functionHours != null ? l.functionHours : "-") + " h",
                            zone_name: zone.zoneName,
                            zone_number: zone.zoneNumber,
                            status: (l.error_com == "OFF" && l.errorBallastCom == "OFF" && l.lampFail =="OFF") ? "ok" : "error"
                        });
                        currLampIllCount++;
                        currLampsCount++;
                    }
                }    
            }
            //inserisco nel doc le diverse tabelle di lampade di illuminazione
            for (var i = 0; i < rows_ill.length; i++) {
                doc.addPage(); //nuova pagina
                doc.setFontType("bold");
                doc.setFontSize(12);
                doc.text(this.$t('details_cu_modal.cu_numero_lampade_illuminazione'), 38, 50);
                doc.autoTable({
                    columns: columns_ill,
                    body: rows_ill[i],
                    startY: 80,
                    theme: 'striped',
                    styles: {
                        fontSize: 7,
                        //font: "helvetica", // helvetica, times, courier
                        font: "Roboto",
                        fontStyle: 'normal', // normal, bold, italic, bolditalic
                        halign: 'left', // left, center, right
                    },
                    headStyles: {},
                    bodyStyles: {},
                    alternateRowStyles: {},
                    columnStyles: {}
                });
                doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);
            }
            //idem con quelle di emergenza
            for (i = 0; i < rows_emerg.length; i++) {
                doc.addPage(); //nuova pagina
                doc.setFontType("bold");
                doc.setFontSize(12);
                doc.text(this.$t('details_cu_modal.cu_numero_lampade_emergenza'), 38, 50);
                doc.autoTable({
                    columns: columns_emerg,
                    body: rows_emerg[i],
                    startY: 80,
                    theme: 'striped',
                    styles: {
                        fontSize: 7,
                        //font: "helvetica", // helvetica, times, courier
                        font: "Roboto",
                        fontStyle: 'normal', // normal, bold, italic, bolditalic
                        halign: 'left', // left, center, right
                    },
                    headStyles: {},
                    bodyStyles: {},
                    alternateRowStyles: {},
                    columnStyles: {}
                });
                doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width / 2 - 35), doc.internal.pageSize.height - 40, 70, 20);
            }

            doc.save(table_name);
        },

        validateSubstituteList(value)
        {
            var reg4, reg6, reg8; //Serial ID a 4, 6, 8 byte
            var alert;
            var lampArr = [];
            var i;

            if (this.substituteLampsSelection == null || this.substituteLampsSelection.length == 0)
            {
                alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: this.$t("config_cu_modal.logica_sn_empty_selection"),
                    countDownChanged: function (cd)
                    {
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.validation_alerts.push(alert);
                console.log("errore 1");
                return false;
            }
            //creo un array con i codici che nella stringa sono separati da 'carriagereturn' o ','
            var array_serial = value.split(/[\r\n,]+/gm);
            if (array_serial.toString() == "" || array_serial.length == 0)
            {
                alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: this.$t("config_cu_modal.logica_sn_empty_error"),
                    countDownChanged: function (cd)
                    {
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.validation_alerts.push(alert);
                return false
                //this.logica_array_sn = [];
                //return true;
            }

            for (i = 0; i < array_serial.length; i++)
            {
                //pulisce ogni stringa da spazi vuoti e carriagereturn
                array_serial[i] = array_serial[i].trim().replaceAll(/[\r\n]+/gm, "");
                if (array_serial[i] == "") continue;
                if (this.currentCent.cu_type == "logicafm") {
                    //logicafm può avere 6 o 8 caratteri
                    reg6 = array_serial[i].match(/^[a-f0-9]{6}$/i);
                    reg8 = array_serial[i].match(/^[a-f0-9]{8}$/i)
                } else {
                    reg4 = array_serial[i].match(/^[a-f0-9]{4}$/i);
                }
                //se non vengono verificate nessuna delle 3 condizioni, cioè ID a 4, 6 o 8 byte, allora segnalo errore   
                if (reg4 == null && reg6 == null && reg8 == null)
                {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_format_error") + ' (ID = ' + array_serial[i] + ')',
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    return false
                }
                //se è stato inserito un ID a 8 cifre, devo verificare che gli ultimi 2 byte siano ottenuti con alcuni calcoli dai primi 6
                //poi occorre eliminare queste ultime 2 cifre
                var dato = array_serial[i];
                if (reg8 != null) {
                    var serial = dato.substring(0,6);
                    var codice = parseInt(serial, 16); //converto da stringa hex in intero
                    codice = (codice * 100) % 97; //calcolo il resto della divisione intera
                    var check = 98 - codice; //calcolo del check
                    //verifico che le ultime due cifre coincidano con il valore di check trovato
                    if (parseInt(dato.substring(6), 10) != check) {
                        alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: this.$t("config_cu_modal.logica_sn_failchecksum") + ' ( ID = ' + dato + ' )',
                            countDownChanged: function (cd)
                            {
                                console.log("countdownchanged:" + cd)
                            }
                        }
                        this.validation_alerts.push(alert);
                        return false
                    } else {
                        array_serial[i] = serial; //salvo solo la parte utile
                    }   
                }

                // lampArr.push(array_serial[i].toUpperCase());
                lampArr.push(array_serial[i]);
            }

            if (lampArr.length != this.substituteLampsSelection.length)
            {
                alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: this.$t("config_cu_modal.logica_sn_invalid_id_selection"),
                    countDownChanged: function (cd)
                    {
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.validation_alerts.push(alert);
                return false
            }

            //non devono esserci id doppi e nemmeno id già presenti
            for (i = 0; i < lampArr.length; i++)
            {
                //verifico se l'id esista già tra gli id presenti nella centrale
                if (this.currentCent.lamps_id.indexOf(lampArr[i]) >= 0)
                {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_id_already_present") + lampArr[i],
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    return false
                }
                //verifico che non sia già stato inserito
                if (lampArr.indexOf(lampArr[i]) != i)
                {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_duplicated_error"),
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    return false
                }
            }


            console.log("check ok!");
            this.logica_array_sn = lampArr;

            return true;

        },

        //funzione che valida i Serial ID inseriti
        validateSerialList(value, cuType)
        {
            var reg4, reg6, reg8; //Serial ID a 4, 6, 8 byte
            console.log("verifico lampade inserite");
            var alert, pos;
            this.logica_array_sn = [];
            this.list_validation_error = null;

            //creo un array con i codici separati da 'carriagereturn' o ','
            var array_serial = value.split(/[\r\n,]+/gm);

            //reg expression hexadecimal 4 char oppure n:XXXX per poter forzare una posizione
            //    var trovatoForzaPos = false;
            var overWriteMode = (this.manual_mode_logica == 'overwrite');

            //verifico la stringa vuota, cioè nessun codice inserito, ed esco con un array vuoto e TRUE in modo che si chiuda la textarea
            if (array_serial.toString() == "" || array_serial.length == 0)
            {
                this.logica_array_sn = [];
                return true;
            }

            //se sono stati effettivamente inseriti dei codici, procedo con la verifica
            var j = 0;
            while (array_serial[j] != "" && array_serial[j] != null)
            {
                console.log("SERIAL: ", array_serial[j]);
                //pulisce ogni stringa da spazi vuoti e carriagereturn
                array_serial[j] = array_serial[j].trim().replaceAll(/[\r\n]+/gm, "")
                if (cuType == "logica") {
                    //logica (default) ha 4 byte
                    reg4 = array_serial[j].match(/^([0-9]{1,3}:)?[a-f0-9]{4}$/i);
                    // reg4 = array_serial[j].match(/^[a-f0-9,]{4}$/i);
                }   
                if (cuType == "logicafm") {
                    //logicafm può avere 6 o 8 caratteri
                    //reg = array_serial[j].match(/^([0-9]{1,3}:)?[a-f0-9,]{6}$/i);
                    // reg = array_serial[j].match(/^([0-9]{1,3}:)?(([a-f0-9]{6})|([a-f0-9]{8})){1}$/i);
                    reg6 = array_serial[j].match(/^([0-9]{1,3}:)?([a-f0-9]{6}){1}$/i);
                    reg8 = array_serial[j].match(/^([0-9]{1,3}:)?([a-f0-9]{8}){1}$/i);
                    // reg6 = array_serial[j].match(/^([a-f0-9]{6}){1}$/i);
                    // reg8 = array_serial[j].match(/^([a-f0-9]{8}){1}$/i);
                }
                //se non vengono verificate nessuna delle 3 condizioni, cioè ID a 4, 6 o 8 byte (con eventuale indice posizionale), allora segnalo errore
                if (reg4 == null && reg6 == null && reg8 == null)
                {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_format_error") + ' (ID = ' + array_serial[j] + ')',
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    return false
                }
                

                //inoltre verifico se è stato inserito un indice di posizione (xyz:), e se questo rientra nel range corretto 1-128
                var dato = array_serial[j];
                if (dato.indexOf(":") > 0)
                {
                    pos = parseInt(dato.substr(0, dato.indexOf(":")), 10);
                    if (pos < 1 || pos > 128)
                    {
                        alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: this.$t("config_cu_modal.logica_sn_position_error"),
                            countDownChanged: function (cd)
                            {
                                console.log("countdownchanged:" + cd)
                            }
                        }
                        this.validation_alerts.push(alert);
                        return false
                    } else {
                        dato = dato.substring(dato.indexOf(":") + 1); //elimino l'indice per le eventuali verifiche di checksum
                    }
                }
                //se è stato inserito un ID a 8 cifre, devo verificare che gli ultimi 2 byte siano ottenuti con alcuni calcoli dai primi 6
                //poi occorre eliminare queste ultime 2 cifre
                if (reg8 != null) {
                    var serial = dato.substring(0,6);
                    var codice = parseInt(serial, 16); //converto da stringa hex in intero
                    codice = (codice * 100) % 97; //calcolo il resto della divisione intera
                    var check = 98 - codice; //calcolo del check
                    //verifico che le ultime due cifre coincidano con il valore di check trovato
                    if (parseInt(dato.substring(6), 10) != check) {
                        alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: this.$t("config_cu_modal.logica_sn_failchecksum") + ' ( ID = ' + dato + ' )',
                            countDownChanged: function (cd)
                            {
                                console.log("countdownchanged:" + cd)
                            }
                        }
                        this.validation_alerts.push(alert);
                        return false
                    } else {
                        array_serial[j] = serial; //salvo solo la parte utile
                    }   
                }
                j++;
            }
            var arr_len = j--;
            //elimino una eventuale ultima stringa vuota, nel caso si inserisca un codice con un CR finale, come succede di frequente
            array_serial = array_serial.slice(0,arr_len); 

            console.log("step1");

            //Controllo id duplicati compatibile con la presenza di posizioni forzate 
            var dopArray = [];
            var posArray = [];
            for (var i = 0; i < array_serial.length; i++)
            {
                var ser = array_serial[i]
                var dp = ser.indexOf(":");
                if (dp > 0)
                {
                    pos = ser.substr(0, dp);
                    if (posArray[pos] != null)
                    {
                        alert = {
                            timeLeft: 5,
                            state: "danger",
                            msg: this.$t("config_cu_modal.logica_pos_duplicated_error") + ' ( pos = ' + pos + ' )',
                            countDownChanged: function (cd)
                            {
                                console.log("countdownchanged:" + cd)
                            }
                        }
                        this.validation_alerts.push(alert);
                        return false
                    }
                    posArray[pos] = pos;
                    ser = ser.substr(dp + 1);
                }
                if (dopArray[ser] != null)
                {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_duplicated_error") + ' ( ID = '+ ser + ' )',
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    return false
                }

                //Se sono in append non posso avere lampade duplicate rispetto a quelle già presenti
                if (!overWriteMode && this.logica_cu_list.indexOf(ser) >= 0)
                {
                    alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_existing_error") + ' ( ID = '+ ser + ' )',
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    return false
                }

                dopArray[ser] = ser;
            }
            console.log("step2");

            console.log("check finito ok!");


            this.logica_array_sn = array_serial;
            return true
        },
        lampadeSelObject()
        {
            let lamp;
            for (var csel in this.lampadeSel)
            {
                let c = this.lampadeSel[csel].split("-")
                lamp = this.tableData[parseInt(c[1])]
            }
            console.log("Triggered lamp", lamp);
            return lamp;
        },
        // Ritorna TRUE se la Zona zone è nell'elenco delle Zone selezionate
        zoneSelObject(zone) {
            if (this.zoneSel.length > 0)
            {
                let z;
                for (var zsel in this.zoneSel)
                {
                    let zindex = this.zoneSel[zsel].split("-")[1];
                    z = this.tableBtData[parseInt(zindex)];
                    if (zone == z.zoneNumber)
                    {
                        return true
                    }
                }
            }
            return false;
        },
        // Ritorna TRUE se la Centrale cu è nell'elenco delle Centrali selezionate
        centSelObject(cu)
        {    
            //console.log("controllo se ", cu, " è presente in centSelObject: ", this.centraliSel);
            if (this.centraliSel.length > 0)
            {
                let cent;
                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    cent = this.tableData[parseInt(c[1])]
                    if (cu.cu_id == cent.cu_id && cu.cu_type == cent.cu_type)
                    {
                        return true
                    }
                }
            }
            return false;
        },

        //Ritorna TRUE se la Centrale Sicuro cu è nell'elenco delle centrali selezionate
        //cu è nella forma: 'sicuro#123456' con cu_id=123456
        centSicuroSelObject(cu) { 
            let trovato = false;
            let cu_id = cu.split('#')[1];
            if (this.centraliSel.length > 0) {                
                //ciclo sulla lista di centrali selezionate
                this.centraliSel.some( (csel) => {
                    let cindex = csel.split('-')[1]; //isolo l'indice della centrale
                    let cent = this.tableData[parseInt(cindex)];
                    if (cent.cu_id == cu_id) {
                        trovato = true;
                        return true;
                    } else {
                        return false;
                    }
                })
            }
            return trovato;
        },
        //Input:  cu_id nella forma 'sicuro#00423', ak index come stringa, pe, '01'
        //Output: TRUE se l'AK è nell'elenco degli AK selezionati
        //Nota: gli AK sono
        akSelObject(cu, ak) {
            //console.log("akSelObject, akextSel: ", this.akextSel, " akSel: ", this.akSel);
            let trovato = false;
            if (this.akSel.length > 0) {
                this.akSel.some( (aksel) => {
                    let akselToken = aksel.split('-');
                    let cuIndex = akselToken[1]; //isolo l'indice della centrale
                    let akIndex = akselToken[2]; //isolo l'indice dell'AK
                    let centId = this.tableData[parseInt(cuIndex)].cu_id; //recupero l'id della centrale memorizzata all'indice cuIndex
                    if ((cu.split('#')[1] == centId) && (ak == akIndex)) {
                        trovato = true;
                        return true;
                    } else {
                        return false;
                    }
                })
            }
            return trovato;
        },
        //Input: cu (cu_id) nella forma 'sicuro#00423', akext index come stringa, pe, '01'
        //Output: TRUE se l'AK_EXT è nell'elenco degli AK_EXT selezionati
        akextSelObject(cu, ak) {
            let trovato = false;            
            if (this.akextSel.length > 0) {
                this.akextSel.some( (akextsel) => {
                    let akselToken = akextsel.split('-');
                    let cuIndex = akselToken[1]; //isolo l'indice della centrale
                    let akIndex = akselToken[2]; //isolo l'indice dell'AK
                    let centId = this.tableData[parseInt(cuIndex)].cu_id; //recupero l'id della centrale memorizzata all'indice cuIndex
                    if ((cu.split('#')[1] == centId) && (ak == akIndex)) {
                        trovato = true;
                        return true;
                    } else {
                        return false;
                    }
                })
            }
            return trovato;
        },        
        //Input: cu (cu_id) nella forma 'sicuro#00423', ak index come stringa, pe, '01', line index
        //Output: TRUE se la LINEA è nell'elenco delle LINEE selezionate
        lineSelObject(cu, ak, line) {
            //console.log("lineSelObject, cu:", cu, " ak:", ak, " line:", line );
            let trovato = false;
            if (this.lineSel.length > 0) {
                this.lineSel.some( (linesel) => {
                    let lineselToken = linesel.split('-');
                    let cuIndex = lineselToken[1]; //isolo l'indice della centrale
                    let akIndex = lineselToken[2]; //isolo l'indice dell'AK
                    let lineIndex = lineselToken[3]; //isolo l'indice della LINE
                    let centId = this.tableData[parseInt(cuIndex)].cu_id; //recupero l'id della centrale memorizzata all'indice cuIndex
                    if ((cu.split('#')[1] == centId) && (ak == akIndex) && (line == lineIndex)) {
                        console.log("centrale",centId," ak:", ak, " line:", line);
                        console.log("lampada cu:",centId," ak:", akIndex, " line:", lineIndex);
                        trovato = true;
                        return true;
                    } else {
                        return false;
                    }
                })
            }
            return trovato;
        },
        //Input: cu (cu_id) nella forma 'sicuro#00423', ak index come stringa, pe, '01', line index
        //Output: TRUE se la LINEA è nell'elenco delle LINEE selezionate
        lineextSelObject(cu, ak, line) {
            let trovato = false;
            if (this.lineextSel.length > 0) {
                this.lineextSel.some( (linesel) => {
                    let lineselToken = linesel.split('-');
                    let cuIndex = lineselToken[1]; //isolo l'index della centrale
                    let akIndex = lineselToken[2]; //isolo l'indice dell'AK
                    let lineIndex = lineselToken[3]; //isolo l'indice dell'AK
                    let centId = this.tableData[parseInt(cuIndex)].cu_id; //recupero l'id della centrale memorizzata all'indice cuIndex
                    if ((cu.split('#')[1] == centId) && (ak == akIndex) && (line == lineIndex)) {
                        trovato = true;
                        return true;
                    } else {
                        return false;
                    }
                })
            }
            return trovato;            
        },
        centRowClass(cent)
        {
            //console.log("centRowClass ", dataItem, index);
            if (!cent.enabled) return "cent-disabled";
            return "";
        },
        autonomiaChanged(newVal)
        {
            console.log("autonomiaChanged", newVal, this.filters.autonomia);
            let self = this;
            Vue.nextTick(function ()
            {
                if (self.filters.autonomia.length == 0)
                {
                    self.filters.autonomia = ['all'];
                } else if (self.filters.autonomia.length > 1 && self.filters.autonomia[0] == 'all')
                {
                    self.filters.autonomia.shift();
                } else if (self.filters.autonomia.length > 1 && self.filters.autonomia[self.filters.autonomia.length - 1] == 'all')
                {
                    self.filters.autonomia = ['all'];
                }
                console.log("autonomia->", self.filters.autonomia);
            })


        },
        //funzione che viene invocata quando cambia il filtro di tipo centrale
        //in questo caso, se il filtro è vuoto, lo imposto a 'all', altrimenti se è 'all' e ce ne sono altri, lo tolgo
        //se l'ultimo elemento è 'all' e ce ne sono altri, tolgo tutti gli altri e lascio 'all'
        tipoCentChanged(newVal)
        {
            console.log("tipoCentChanged", newVal, this.filters.tipoCent);
            let self = this;
            Vue.nextTick(function ()
            {
                if (self.filters.tipoCent.length == 0)
                {
                    self.filters.tipoCent = ['all'];
                } else if (self.filters.tipoCent.length > 1 && self.filters.tipoCent[0] == 'all')
                {
                    self.filters.tipoCent.shift();
                } else if (self.filters.tipoCent.length > 1 && self.filters.tipoCent[self.filters.tipoCent.length - 1] == 'all')
                {
                    self.filters.tipoCent = ['all'];
                }
                console.log("tipoCent->", self.filters.tipoCent);
            })


        },
        errorFilter()
        {
            if (this.errorFilters == true)
            {
                this.errorFilters = false;
                this.errorComFilters = false;
                this.errorBatteryFilters = false;
                this.errorHardwareFilters = false;
                this.errorLedFilters = false;
                this.errorOtherFilters = false;
            }
            else
            {
                this.errorFilters = true;
                this.errorComFilters = true;
                this.errorBatteryFilters = true;
                this.errorHardwareFilters = true;
                this.errorLedFilters = true;
                this.errorOtherFilters = true;
            }
            this.filtra();
        },
        errorComFilter()
        {
            if (this.errorComFilters == true)
            {
                this.errorComFilters = false;
            }
            else
            {
                this.errorComFilters = true;
            }
            this.filtra();
        },
        errorBatteryFilter()
        {
            if (this.errorBatteryFilters == true)
            {
                this.errorBatteryFilters = false;
            }
            else
            {
                this.errorBatteryFilters = true;
            }
            this.filtra();
        },
        errorHardwareFilter()
        {
            if (this.errorHardwareFilters == true)
            {
                this.errorHardwareFilters = false;
            }
            else
            {
                this.errorHardwareFilters = true;
            }
            this.filtra();
        },
        errorLedFilter()
        {
            if (this.errorLedFilters == true)
            {
                this.errorLedFilters = false;
            }
            else
            {
                this.errorLedFilters = true;
            }
            this.filtra();
        },
        errorOtherFilter()
        {
            if (this.errorOtherFilters == true)
            {
                this.errorOtherFilters = false;
            }
            else
            {
                this.errorOtherFilters = true;
            }
            this.filtra();
        },
        orphanFilter()
        {
            if (this.orphanFilters == true)
                this.orphanFilters = false;
            else
                this.orphanFilters = true;
            this.filtra();
        },
        emergencyOnFilter()
        {
            if (this.emergencyFilters == true)
                this.emergencyFilters = false;
            else
                this.emergencyFilters = true;
            this.filtra();
        },

        //non serve
        // advancedFilter()
        // {
        //     console.log("ADVANCED FILTER INVOKED!!!");
        //     if (this.advancedFilters == true)
        //         this.advancedFilters = false;
        //     else
        //         this.advancedFilters = true;
        //     this.filtra();
        // },

        filtra()
        {
            let self = this;
            let devType = (self.devicesType == null) ? null : "" + self.devicesType; //variabile che contiene il tipo di dispositivo per il FILTRO DI TIPO
            var found, filtLamps;
            var match;
            var f, i;
            var match_emergenza, match_illuminazione, match_sensori; //variabili di match per i filtri EMERGENZA, ILLUMINAZIONE e SENSORI


            console.log("filtra ingresso -> tableData: ", this.tableData);

            //FILTRAGGIO rispetto a errorFilters, emergencyFilters e orphanFilters
            this.tableData = this.devicesType == 'zoneBluetooth' ? this.allBleData : this.allTableData.filter(cent => {
                match = false;

                if (cent.cu_type == 'sicuro') {
                    match_emergenza = false;
                    match_illuminazione = false;
                    match_sensori = false;

                    // Filtraggio solo rispetto a errorFilters, mentre emergencyFilter non è applicabile nel sistema Sicuro: 
                    // se errorFilters==true vengono visualizzate Centrali, Ak, Linee e Lampade solo con errori
                    // altrimenti, si visualizzano tutte, imponendo visible=true
                    var visCentAk = false;
                    for (var j = 0; j < cent.ak.length; j++) {
                        // AK[j]
                        var visualizzaCent = false;
                        for (var k = 0; k < cent.ak[j].lines.length; k++) {
                            // LINES[k]
                            //SIDE-EFFECT: dato che se non ci sono lampade, l'array lamps non viene neppure inizializzato a [], non posso utilizzare length
                            //faccio allora una verifica preventiva eppoi, in caso sia null, impongo l'array vuoto []
                            if (cent.ak[j].lines[k].lamps === null) {
                                cent.ak[j].lines[k].lamps = [];
                            }
                            filtLamps = 0; //azzero
                            for (var w = 0; w < cent.ak[j].lines[k].lamps.length; w++) {
                                // LAMPS[w]
                                if (!this.errorFilters) {
                                    //introduco una ridondanza-->
                                    // devo reintrodurre la property 'visible' nelle lamp per compatibilità con Advanced Filter
                                    cent.ak[j].lines[k].lamps[w].visible = true;
                                    filtLamps++;
                                } else {
                                    if (this.calcolaNumErrori(cent.ak[j].lines[k].lamps[w]) > 0) {
                                        cent.ak[j].lines[k].lamps[w].visible = true;
                                        filtLamps++;
                                    } else {
                                        cent.ak[j].lines[k].lamps[w].visible = false;
                                    }
                                }
                                //console.log("LAMP: ", cent.ak[j].lines[k].lamps[w].lamp_id,  cent.ak[j].lines[k].lamps[w].visible, filtLamps)
                            }
                            if (filtLamps > 0) { //se ci sono errori, allora metto questi nella linea e cancello gli altri
                                cent.ak[j].lines[k].visible = true;
                                visualizzaCent = true;
                                //if (devType == null || devType == 'emergenza') {
                                if (devType === 'emergenza') {
                                    match_emergenza = true;
                                }
                            } else { //se non ce ne sono, allora tengo la linea solo se ha lei stessa degli errori, altrimenti devo eliminarla
                                //if ((cent.ak[j].lines[k].line_error === '0') && (this.errorFilters))
                                if ((this.calcolaNumErrori(cent.ak[j].lines[k]) === 0) && (this.errorFilters)) { //se la linea non ha errori
                                    cent.ak[j].lines[k].visible = false;
                                } else {
                                    cent.ak[j].lines[k].visible = true;
                                    visualizzaCent = true;
                                }
                            }
                            //console.log("LINE ", cent.ak[j].lines[k].index, cent.ak[j].lines[k].visible);
                        }
                        //ho controllato tutte le linee, eliminando quelle che non hanno errori

                        if ((visualizzaCent === false) && (this.errorFilters)) {
                            cent.ak[j].visible = false;
                        } else {
                            cent.ak[j].visible = true;
                            visCentAk = true;
                        }
                        //console.log("AK ", cent.ak[j].index, cent.ak[j].visible);
                    }
                    //AK_EXT
                    var visCentAkExt = false;
                    for (j = 0; j < cent.ak_ext.length; j++) {
                        // AK[j]
                        visualizzaCent = false;
                        for (k = 0; k < cent.ak_ext[j].lines.length; k++) {
                            // LINES[k]
                            //SIDE-EFFECT: dato che se non ci sono lampade, l'array lamps non viene neppure inizializzato a [], non posso utilizzare length
                            //faccio allora una verifica preventiva eppoi, in caso sia null, impongo l'array vuoto []
                            if (cent.ak_ext[j].lines[k].lamps === null) {
                                cent.ak_ext[j].lines[k].lamps = [];
                            }
                            filtLamps = 0; //azzero
                            for (w = 0; w < cent.ak_ext[j].lines[k].lamps.length; w++) {
                                // LAMPS[w]
                                if (!this.errorFilters) {
                                    cent.ak_ext[j].lines[k].lamps[w].visible = true;
                                    filtLamps++;
                                } else {
                                    if (this.calcolaNumErrori(cent.ak_ext[j].lines[k].lamps[w]) > 0) {
                                        cent.ak_ext[j].lines[k].lamps[w].visible = true;
                                        filtLamps++;
                                    } else {
                                        cent.ak_ext[j].lines[k].lamps[w].visible = false;
                                    }
                                }
                            }
                            if (filtLamps > 0) { //se ci sono errori, allora metto questi nella linea e cancello gli altri
                                cent.ak_ext[j].lines[k].visible = true;
                                visualizzaCent = true;
                                //if (devType == null || devType == 'emergenza') {
                                if (devType === 'emergenza') {
                                    match_emergenza = true;
                                }
                            } else { //se non ce ne sono, allora tengo la linea solo se ha errori, altrimenti devo eliminarla
                                //if ((cent.ak_ext[j].lines[k].line_error === '0') && (this.errorFilters))
                                if ((this.calcolaNumErrori(cent.ak_ext[j].lines[k]) === 0) && (this.errorFilters)) { //se la linea non ha errori
                                    cent.ak_ext[j].lines[k].visible = false;
                                } else {
                                    cent.ak_ext[j].lines[k].visible = true;
                                    visualizzaCent = true;
                                }
                            }
                        }
                        //ho controllato tutte le linee, eliminando quelle che non hanno errori

                        if ((visualizzaCent === false) && (this.errorFilters)) {
                            cent.ak_ext[j].visible = false;
                        } else {
                            cent.ak_ext[j].visible = true;
                            visCentAkExt = true;
                        }
                    }

                    //SWITCH_11KW
                    var visSw11kw = false;
                    for (i = 0; i < cent.sw_11kw.length; i++) {
                        if (this.errorFilters) { //sw_11kw non ha errori
                            cent.sw_11kw[i].visible = false;
                        } else {
                            cent.sw_11kw[i].visible = true;
                            visSw11kw = true;
                        }
                    }

                    //LSSA
                    var visLssa = false;
                    for (i = 0; i < cent.lssa.length; i++) {
                        if (((cent.lssa[i].device_type === 'LSSA_IO') || cent.lssa[i].error_com_cpu_lssa === "OFF") && (this.errorFilters)) { //se lssa non ha errori
                            cent.lssa[i].visible = false;
                        } else {
                            cent.lssa[i].visible = true;
                            visLssa = true;
                        }
                        // if (devType == 'sensori')
                        // {
                        //     match_sensori = true;
                        // }
                    }

                    //CHARGER
                    var visCharger = false;
                    for (i = 0; i < cent.charger.length; i++) {
                        if ((this.calcolaNumErrori(cent.charger[i]) === 0) && (this.errorFilters)) { //se charger non ha errori
                            cent.charger[i].visible = false;
                        } else {
                            cent.charger[i].visible = true;
                            visCharger = true;
                        }
                    }
                    //i filtri 'errori presenti' e 'lampade FM non trovate' vanno in OR: nel caso 'sicuro', il filtro orphan restituirà sempre un false
                    if (this.errorFilters) {
                        if (cent.cu_error)
                            return (visCentAk || visCentAkExt || visLssa || visCharger || visSw11kw || (cent.cu_error.error_general === 'ON'))
                    } else {
                        if (this.orphanFilters) {
                            return false;
                        } else {
                            if (this.emergencyFilters) {
                                return false; //non abbiamo il dato di lampade in emergenza
                            } else {
                                //verifico i filtri con devType
                                if (match_emergenza || match_illuminazione || match_sensori || (devType === null)) {
                                    //se ho trovato lampade in emergenza, illuminazione, sensori, o se non ho filtri, allora visualizzo
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    }
                } else {
                    if (devType == null || devType == 'emergenza') {
                        if (cent.lamps != null) {
                            match_emergenza = true;
                            found = false;
                            cent.lamps.forEach(lamp => {
                                if (!this.errorFilters && !this.orphanFilters && !this.emergencyFilters && !this.errorComFilters && !this.errorBatteryFilters && !this.errorLedFilters && !this.errorHardwareFilters && !this.errorOtherFilters)
                                    lamp['visible'] = true;
                                else {
                                    match_emergenza = false;
                                    //  filtri errori    
                                    if ((this.errorHardwareFilters && lamp.error_hardware == "ON")
                                        || (this.errorComFilters && lamp.error_com == "ON")
                                        || (this.errorBatteryFilters && (lamp.error_batt_short == "ON" || lamp.error_batt_test == "ON" || lamp.error_batt_test_auto == "ON"))
                                        || (this.errorLedFilters && lamp.error_led == "ON")
                                        || (this.errorOtherFilters && (lamp.error_tubo_UV == "ON" || lamp.error_comm_radio_lamp == "ON")))
                                        {
                                            lamp['visible'] = true;
                                            found = true;
                                        } 
                                        else {
                                              //filtra orfani
                                              if (this.orphanFilters && lamp.nodo_orfano == true) {
                                                    lamp['visible'] = true;
                                                    found = true;
                                              }
                                              else {
                                                    //filtra lampade in emergenza
                                                    if (this.emergencyFilters && lamp.emer_active == 'EMERGENZA IN CORSO') {
                                                          lamp['visible'] = true;
                                                          found = true;
                                                    }
                                                    else {
                                                           lamp['visible'] = false;
                                                    }

                                                    }
                                              }
                                    }
                                    if (found)
                                        match_emergenza = true;
                            });

                        }
                        else if (cent.lamps.length == 0 && !this.errorFilters && !this.orphanFilters && !this.emergencyFilters) 
                        {
                            //match_emergenza = true;
                            match_emergenza = false;
                        }
                    } else
                    {
                        if (cent.lamps != null && cent.lamps.length > 0)
                        {
                            cent.lamps.forEach(lamp =>
                            {
                                lamp['visible'] = false;
                            });
                        }
                    }
                    if (devType == null || devType == 'illuminazione')
                    {

                        if (cent.lamps_illum != null && cent.lamps_illum.length > 0)
                        {
                            console.log("mostro lamp emergenza su cent: ", cent.cu_id);
                            match_illuminazione = true;
                            found = false;
                            cent.lamps_illum.forEach(lamp =>
                            {
                                 if (!this.errorFilters && !this.orphanFilters && !this.emergencyFilters && !this.errorComFilters && !this.errorBatteryFilters && !this.errorLedFilters && !this.errorHardwareFilters && !this.errorOtherFilters)
                                    lamp['visible'] = true;
                                else
                                {
                                    match_illuminazione = false;
                                    if ((this.errorHardwareFilters && (lamp.error_hardware == "ON" || lamp.errorBallastCom == "ON"))
                                        || (this.errorComFilters && lamp.error_com == "ON")
                                        || (this.errorBatteryFilters && (lamp.error_batt_short == "ON" || lamp.error_batt_test == "ON" || lamp.error_batt_test_auto == "ON"))
                                        || (this.errorLedFilters && lamp.error_led == "ON")
                                        || (this.errorOtherFilters && (lamp.error_tubo_UV == "ON" || lamp.error_comm_radio_lamp == "ON" || lamp.error_overpower == "ON" || lamp.error_overvoltage == "ON" || lamp.error_underpower == "ON" || lamp.error_undervoltage == "ON" )))
                                        {
                                            lamp['visible'] = true;
                                            found = true;
                                        } 
                                        else {
                                            if (this.orphanFilters && lamp.nodo_orfano == true) {
                                                lamp['visible'] = true;
                                                found = true;
                                            }
                                            else {
                                                lamp['visible'] = false;
                                            }
                                        }
                                    }    
                                    if (found)
                                        match_illuminazione = true;
                            });
                        }

                        // if (cent.cu_type == "logicafm" && !this.errorFilters && !this.orphanFilters && !this.emergencyFilters) 
                        if (cent.lamps_illum.length == 0 && !this.errorFilters && !this.orphanFilters && !this.emergencyFilters) 
                            //match_illuminazione = true;
                            match_illuminazione = false;
                    } else
                    {
                        if (cent.lamps_illum != null && cent.lamps_illum.length > 0)
                        {

                            cent.lamps_illum.forEach(lamp =>
                            {
                                lamp['visible'] = false;
                            });
                        }
                    }
                    if (devType == null || devType == 'sensori')
                    {
                        if (cent.sensors != null && cent.sensors.length > 0)
                        {
                            match_sensori = true;
                            found = false;
                            cent.sensors.forEach(lamp =>
                            {
                                if (!this.errorFilters && !this.orphanFilters && !this.emergencyFilters && !this.errorComFilters && !this.errorBatteryFilters && !this.errorLedFilters && !this.errorHardwareFilters && !this.errorOtherFilters)
                                    lamp['visible'] = true;
                                else {
                                    match_sensori = false;
                                    if ((this.errorHardwareFilters && lamp.error_hardware == "ON")
                                        || (this.errorComFilters && lamp.error_com == "ON")) {
                                        lamp['visible'] = true;
                                        found = true;
                                    }
                                    else {

                                        if (this.orphanFilters && lamp.nodo_orfano == true) {
                                            lamp['visible'] = true;
                                            found = true;
                                        }
                                        else {
                                            lamp['visible'] = false;
                                        }
                                    }
                                    if (found)
                                        match_sensori = true;
                                }
                            });
                        }
                        // if (cent.cu_type == "logicafm" && !this.errorFilters && !this.orphanFilters && !this.emergencyFilters) 
                        //     match_sensori = true;
                        if (cent.sensors.length == 0 && !this.errorFilters && !this.orphanFilters && !this.emergencyFilters) 
                            match_sensori = false;
                    } else
                    {
                        if (cent.sensors != null && cent.sensors.length > 0)
                        {

                            cent.sensors.forEach(lamp =>
                            {
                                lamp['visible'] = false;
                            });
                        }
                    }

                    if (match_emergenza == true || match_illuminazione == true || match_sensori == true || devType == null)
                        match = true;

                    return match;
                }
            });

            console.log("filtra uscita -> tableData:", this.tableData);

            if (!this.advancedFilters)
            {
                //FILTRAGGIO con il tag INPUT (filtro semplice)
                let fltArr = this.filters.search.trim().toLowerCase().split(",", -1);
                console.log("filtro semplice:", fltArr, "devType = " + devType);


                if (this.filters.search.trim() != '')
                {
                    console.log("filtro semplice -> filtro totale: ", fltArr);
                    this.tableData = this.tableData.filter(cent =>
                    {
                        match = false;
                        var f = 0;
                        while ((!match) && (f < fltArr.length))
                        {
                            let flt = fltArr[f].trim();
                            console.log("filtro semplice -> filtro: ", flt);
                            var found = (cent.cu_id === flt) || ((cent.cu_desc || '').toLowerCase().includes(flt));
                            if (found)
                            {
                                match = true;
                            } else {
                                if (cent.cu_type === "sicuro") {
                                    //Centrali SICURO
                                    var i, j, visAk, visLine;
                                    if ((devType == null || devType == 'emergenza')) {
                                        //visito gli AK
                                        for (i = 0; i < cent.ak.length; i++) {
                                            visAk = false;
                                            for (j = 0; j < cent.ak[i].lines.length; j++) {
                                                visLine = false;
                                                cent.ak[i].lines[j].lamps.forEach(lamp =>
                                                {
                                                    if (lamp.lamp_id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                                                    {
                                                        lamp['visible'] = true;
                                                        match = true;
                                                        visAk = true;
                                                        visLine = true;
                                                        console.log(`filtro semplice -> matching: ${lamp.lamp_id} in cent ${cent.cu_id} in ak ${cent.ak[i].index} in line ${cent.ak[i].lines[j].index}`);
                                                    } else
                                                    {
                                                        lamp['visible'] = false;
                                                    }
                                                });
                                                if (visLine) {
                                                    cent.ak[i].lines[j]['visible'] = true;
                                                } else {
                                                    cent.ak[i].lines[j]['visible'] = false;
                                                }
                                            }
                                            if (visAk) {
                                                cent.ak[i]['visible'] = true;
                                            } else {
                                                cent.ak[i]['visible'] = false;
                                            }
                                        }
                                        //visito gli AK_EXT
                                        for (i = 0; i < cent.ak_ext.length; i++) {
                                            visAk = false;
                                            for (j = 0; j < cent.ak_ext[i].lines.length; j++) {
                                                visLine = false;
                                                cent.ak_ext[i].lines[j].lamps.forEach(lamp =>
                                                {
                                                    if (lamp.lamp_id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                                                    {
                                                        lamp['visible'] = true;
                                                        match = true;
                                                        visAk = true;
                                                        visLine = true;
                                                    } else
                                                    {
                                                        lamp['visible'] = false;
                                                    }
                                                });
                                                if (visLine) {
                                                    cent.ak_ext[i].lines[j]['visible'] = true;
                                                } else {
                                                    cent.ak_ext[i].lines[j]['visible'] = false;
                                                }
                                            }
                                            if (visAk) {
                                                cent.ak_ext[i]['visible'] = true;
                                            } else {
                                                cent.ak_ext[i]['visible'] = false;
                                            }
                                        }
                                        //LSSA, Charger e Sw11kw vengono esclusi dalla ricerca
                                        for (i = 0; i < cent.sw_11kw.length; i++) {
                                            cent.sw_11kw[i]['visible'] = false;
                                        }
                                        for (i = 0; i < cent.lssa.length; i++) {
                                            cent.lssa[i]['visible'] = false;
                                        }
                                        for (i = 0; i < cent.charger.length; i++) {
                                            cent.charger[i]['visible'] = false;
                                        }
                                    } else {
                                        match = false;
                                    }
                                } else {
                                    if ((devType == null || devType == 'emergenza') && cent.lamps != null && cent.lamps.length > 0)
                                    {
                                        cent.lamps.forEach(lamp =>
                                        {
                                            if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                                            {
                                                lamp['visible'] = true;
                                                match = true;
                                            } else
                                            {
                                                lamp['visible'] = false;
                                            }
                                        });
                                    }

                                    if ((devType == null || devType == 'illuminazione') && cent.lamps_illum != null && cent.lamps_illum.length > 0)
                                    {
                                        cent.lamps_illum.forEach(lamp =>
                                        {
                                            if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                                            {
                                                lamp['visible'] = true;
                                                match = true;
                                            } else
                                            {
                                                lamp['visible'] = false;
                                            }
                                        });
                                    }

                                    if ((devType == null || devType == 'sensori') && cent.sensors != null && cent.sensors.length > 0)
                                    {
                                        cent.sensors.forEach(lamp =>
                                        {
                                            if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                                            {
                                                lamp['visible'] = true;
                                                match = true;
                                            } else
                                            {
                                                lamp['visible'] = false;
                                            }
                                        });
                                    }
                                }
                            }
                            f++;
                        }
                        // for (var f = 0; f < fltArr.length; f++)
                        // {
                        //     let flt = fltArr[f].trim();
                        //     var found = (cent.cu_id === flt) || ((cent.cu_desc || '').toLowerCase().includes(flt));
                        //     if (found)
                        //     {
                        //         match = true;
                        //         break;
                        //     }
                        //     if ((devType == null || devType == 'emergenza') && cent.lamps != null && cent.lamps.length > 0)
                        //     {
                        //         cent.lamps.forEach(lamp =>
                        //         {
                        //             if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                        //             {
                        //                 lamp['visible'] = true;
                        //                 found = true;
                        //             } else
                        //             {
                        //                 lamp['visible'] = false;
                        //             }
                        //         });
                        //     }

                        //     if ((devType == null || devType == 'illuminazione') && cent.lamps_illum != null && cent.lamps_illum.length > 0)
                        //     {
                        //         cent.lamps_illum.forEach(lamp =>
                        //         {
                        //             if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                        //             {
                        //                 lamp['visible'] = true;
                        //                 found = true;
                        //             } else
                        //             {
                        //                 lamp['visible'] = false;
                        //             }
                        //         });
                        //     }

                        //     if ((devType == null || devType == 'sensori') && cent.sensors != null && cent.sensors.length > 0)
                        //     {
                        //         cent.sensors.forEach(lamp =>
                        //         {
                        //             if (lamp.id.toLowerCase() == flt || (lamp.desc || '').toLowerCase().includes(flt))
                        //             {
                        //                 lamp['visible'] = true;
                        //                 found = true;
                        //             } else
                        //             {
                        //                 lamp['visible'] = false;
                        //             }
                        //         });
                        //     }

                        //     if (found)
                        //     {
                        //         match = true;
                        //         break;
                        //     }
                        // }
                        return match;
                    });
                    console.log("tableData:", this.tableData);
                }

            } else
            {
                console.log("filtri avanzati:", this.filters);
                this.tableData = this.tableData.filter(cent =>
                {
                    var centOk = true;
                    //Filtri su Centrale
                    //ID Centrale
                    if (self.filters.idCent.trim() != '')
                    {
                        let fltArr = self.filters.idCent.trim().toLowerCase().split(',', -1);
                        var match = false;
                        for (f = 0; f < fltArr.length; f++)
                        {
                            let flt = fltArr[f].trim();
                            found = (cent.cu_id == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found)
                            {
                                match = true;
                                break;
                            }
                        }
                        if (!match) centOk = false;
                    }
                    //Nome Centrale
                    if (centOk && self.filters.nomeCent.trim() != '')
                    {
                        let fltArr = self.filters.nomeCent.trim().toLowerCase().split(',', -1);
                        match = false;
                        for (f = 0; f < fltArr.length; f++)
                        {
                            let flt = fltArr[f].trim();
                            found = (cent.cu_desc || '').toLowerCase().includes(flt);
                            if (found)
                            {
                                match = true;
                                break;
                            }
                        }
                        if (!match) centOk = false;
                    }
                    //Tipo Centrale
                    if (centOk && self.filters.tipoCent.length > 0 && self.filters.tipoCent[0] != 'all')
                    {
                        found = false;
                        self.filters.tipoCent.forEach(tipoCent =>
                        {
                            if (cent.cu_type == tipoCent) found = true;
                        });
                        if (!found) centOk = false;
                    }
                    //Filtri su Lampade
                    var oneLampVisible = false;
                    if (centOk && (devType == null || devType == 'emergenza') && cent.lamps != null && cent.lamps.length > 0)
                    {

                        cent.lamps.forEach(lamp =>
                        {
                            var visible = true;
                            //ID Lamp
                            if (self.filters.idLamp.trim() != '')
                            {
                                let fltArr = self.filters.idLamp.trim().toLowerCase().split(',', -1);
                                var match = false;
                                for (var f = 0; f < fltArr.length; f++)
                                {
                                    let flt = fltArr[f].trim();
                                    found = (lamp.id.toLowerCase() == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                                    if (found)
                                    {
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) visible = false;
                            }
                            //Nome Lamp
                            if (visible && self.filters.nomeLamp.trim() != '')
                            {
                                let fltArr = self.filters.nomeLamp.trim().toLowerCase().split(',', -1);
                                match = false;
                                for (f = 0; f < fltArr.length; f++)
                                {
                                    let flt = fltArr[f].trim();
                                    found = (lamp.desc || '').toLowerCase().includes(flt);
                                    if (found)
                                    {
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) visible = false;
                            }
                            //Tipo Lamp
                            if (visible && self.filters.tipoLamp != 'all')
                            {
                                if (self.filters.tipoLamp == 'oxy' && lamp.sanificaaria != true)
                                {
                                    visible = false;
                                } else if (self.filters.tipoLamp != 'oxy' && lamp.sanificaaria == true)
                                {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'SA' && lamp.lamp_type != 'SA')
                                {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'SE' && lamp.lamp_type != 'SE')
                                {
                                    visible = false;
                                } else if (self.filters.tipoLamp == 'illuminazione')
                                {
                                    visible = false;
                                }
                            }
                            //Rete SE
                            if (visible && self.filters.rete_se != 'all')
                            {
                                if (self.filters.rete_se == 'SE_ON' && lamp.emer_active != 'NO')
                                {
                                    visible = false;
                                } else if (self.filters.rete_se == 'SE_OFF' && lamp.emer_active == 'NO')
                                {
                                    visible = false;
                                }
                            }
                            //Autonomia
                            if (visible && self.filters.autonomia.length > 0 && self.filters.autonomia[0] != 'all')
                            {
                                found = false;
                                self.filters.autonomia.forEach(aut =>
                                {
                                    if (lamp.autonomy == aut) found = true;
                                });
                                if (!found) visible = false;
                            }
                            //Parità
                            if (visible && self.filters.parita != 'all')
                            {
                                if (lamp.parity != self.filters.parita) visible = false;
                            }
                            //Infinity
                            if (visible && self.filters.infinity != 'all')
                            {
                                if (lamp.lssa != self.filters.infinity) visible = false;
                            }

                            if (visible) oneLampVisible = true;
                            lamp['visible'] = visible;
                        });
                        //if (!oneLampVisible) centOk = false;
                    }
                    //FILTRI su Lampade SICURO
                    var oneSicurLampVisible = false;
                    if (centOk && (devType === null || devType === 'emergenza') && (cent.cu_type === 'sicuro') && (cent.ak != null && cent.ak.length > 0))
                    {
                        //AK
                        var visible, visibleAk;
                        var filtLamp;

                        cent.ak.forEach((ak) =>
                        {
                            if (ak.lines != null && ak.lines.length > 0)
                            {
                                visibleAk = false;
                                ak.lines.forEach((line) =>
                                {                                   
                                    filtLamp = 0;
                                    if (line.lamps != null && line.lamps.length > 0)
                                    {
                                        line.lamps.forEach((lamp) =>
                                        {
                                            visible = true;
                                            //ID Lamp
                                            if (this.filters.idLamp.trim() != '')
                                            {
                                                let fltArr = this.filters.idLamp.trim().toLowerCase().split(',', -1);
                                                var match = false;
                                                var f = 0;
                                                while (!match && (f < fltArr.length))
                                                {
                                                    let flt = fltArr[f].trim();
                                                    match = (lamp.lamp_id.toLowerCase() === flt);
                                                    f++;
                                                }

                                                if (!match)
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Nome Lamp
                                            if (visible && this.filters.nomeLamp.trim() != '')
                                            {
                                                let fltArr = this.filters.nomeLamp.trim().toLowerCase().split(',', -1);
                                                match = false;
                                                while (!match && (f < fltArr.length))
                                                {
                                                    let flt = fltArr[f].trim();
                                                    match = (lamp.desc || '').toLowerCase().includes(flt);
                                                    f++;
                                                }
                                                if (!match)
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Tipo Lamp
                                            if (visible && this.filters.tipoLamp !== 'all')
                                            {
                                                if (this.filters.tipoLamp === 'oxy' && lamp.sanificaaria !== true)
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp !== 'oxy' && lamp.sanificaaria === true)
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp === 'SA' && lamp.device_function !== 'MANTAINED' && lamp.device_function !== 'SWITCHABLE')
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp === 'SE' && lamp.device_function !== 'NOT MANTAINED')
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp === 'illuminazione')
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Rete SE
                                            if (visible && this.filters.rete_se !== 'all')
                                            {
                                                if (this.filters.rete_se === 'SE_ON' && lamp.emer_active !== 'NO')
                                                {
                                                    visible = false;
                                                } else if (this.filters.rete_se === 'SE_OFF' && lamp.emer_active === 'NO')
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Autonomia
                                            if (visible && (this.filters.autonomia.length > 0) && (this.filters.autonomia[0] !== 'all'))
                                            {
                                                found = false;
                                                this.filters.autonomia.forEach(aut =>
                                                {
                                                    if (lamp.autonomy === aut) found = true;
                                                });
                                                if (!found) visible = false;
                                            }
                                            //Parità
                                            if (visible && this.filters.parita != 'all')
                                            {
                                                if (lamp.parity !== this.filters.parita) visible = false;
                                            }
                                            //Infinity
                                            if (visible && this.filters.infinity !== 'all')
                                            {
                                                if (lamp.lssa !== this.filters.infinity) visible = false;
                                            }

                                            if (visible)
                                            {
                                                oneSicurLampVisible = true;
                                                filtLamp++;
                                            }
                                            lamp.visible = visible;
                                        }); //forEach lamp
                                        if (filtLamp > 0)
                                        {
                                            line.visible = true;
                                            visibleAk = true;
                                            // console.log("line " + line.index + " filtLamp: " + filtLamp + " visibile: " + line.visible);
                                        }
                                        else {
                                            line.visible = false;
                                            // console.log("line " + line.index + " filtLamp: " + filtLamp + " visibile: " + line.visible);
                                        }
                                    }
                                }); // forEach Line
                                if (visibleAk)
                                {                                    
                                    ak.visible = true;
                                    // console.log("ak " + ak.index + " visibile: " + ak.visible);
                                } else {
                                    ak.visible = false;
                                    // console.log("ak " + ak.index + " visibile: " + ak.visible);
                                }
                            }
                        }); // forEach AK

                        cent.ak_ext.forEach((ak_ext) =>
                        {
                            if (ak_ext.lines != null && ak_ext.lines.length > 0)
                            {
                                visibleAk = false;
                                ak_ext.lines.forEach((line) =>
                                {                                   
                                    filtLamp = 0;
                                    if (line.lamps != null && line.lamps.length > 0)
                                    {
                                        line.lamps.forEach((lamp) =>
                                        {
                                            visible = true;
                                            //ID Lamp
                                            if (this.filters.idLamp.trim() != '')
                                            {
                                                let fltArr = this.filters.idLamp.trim().toLowerCase().split(',', -1);
                                                var match = false;
                                                var f = 0;
                                                while (!match && (f < fltArr.length))
                                                {
                                                    let flt = fltArr[f].trim();
                                                    match = (lamp.lamp_id.toLowerCase() === flt);
                                                    f++;
                                                }

                                                if (!match)
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Nome Lamp
                                            if (visible && this.filters.nomeLamp.trim() != '')
                                            {
                                                let fltArr = this.filters.nomeLamp.trim().toLowerCase().split(',', -1);
                                                match = false;
                                                while (!match && (f < fltArr.length))
                                                {
                                                    let flt = fltArr[f].trim();
                                                    match = (lamp.desc || '').toLowerCase().includes(flt);
                                                    f++;
                                                }
                                                if (!match)
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Tipo Lamp
                                            if (visible && this.filters.tipoLamp !== 'all')
                                            {
                                                if (this.filters.tipoLamp === 'oxy' && lamp.sanificaaria !== true)
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp !== 'oxy' && lamp.sanificaaria === true)
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp === 'SA' && lamp.device_function !== 'MANTAINED')
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp === 'SE' && lamp.device_function !== 'NOT MANTAINED')
                                                {
                                                    visible = false;
                                                } else if (this.filters.tipoLamp === 'illuminazione')
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Rete SE
                                            if (visible && this.filters.rete_se !== 'all')
                                            {
                                                if (this.filters.rete_se === 'SE_ON' && lamp.emer_active !== 'NO')
                                                {
                                                    visible = false;
                                                } else if (this.filters.rete_se === 'SE_OFF' && lamp.emer_active === 'NO')
                                                {
                                                    visible = false;
                                                }
                                            }
                                            //Autonomia
                                            if (visible && (this.filters.autonomia.length > 0) && (this.filters.autonomia[0] !== 'all'))
                                            {
                                                found = false;
                                                this.filters.autonomia.forEach(aut =>
                                                {
                                                    if (lamp.autonomy === aut) found = true;
                                                });
                                                if (!found) visible = false;
                                            }
                                            //Parità
                                            if (visible && this.filters.parita != 'all')
                                            {
                                                if (lamp.parity !== this.filters.parita) visible = false;
                                            }
                                            //Infinity
                                            if (visible && this.filters.infinity !== 'all')
                                            {
                                                if (lamp.lssa !== this.filters.infinity) visible = false;
                                            }

                                            if (visible)
                                            {
                                                oneSicurLampVisible = true;
                                                filtLamp++;
                                            }
                                            lamp.visible = visible;
                                        }); //forEach lamp
                                        if (filtLamp > 0)
                                        {
                                            line.visible = true;
                                            visibleAk = true;
                                            console.log("line " + line.index + " filtLamp: " + filtLamp + " visibile: " + line.visible);
                                        }
                                        else {
                                            line.visible = false;
                                            console.log("line " + line.index + " filtLamp: " + filtLamp + " visibile: " + line.visible);
                                        }
                                    }
                                }); // forEach Line
                                if (visibleAk)
                                {                                    
                                    ak_ext.visible = true;
                                    console.log("ak_ext " + ak_ext.index + " visibile: " + ak_ext.visible);
                                } else {
                                    ak_ext.visible = false;
                                    console.log("ak_ext " + ak_ext.index + " visibile: " + ak_ext.visible);
                                }
                            }
                        }); // forEach AK
                        //LSSA, CHARGER, SW_11K per ora non sono mai visibili
                        if (cent.lssa != null && cent.lssa.length > 0)
                        {
                            cent.lssa.forEach((lssa) =>
                            {
                                if (this.filters.idLamp.trim() != '' || this.filters.nomeLamp.trim() != '' || this.filters.tipoLamp != 'all' || this.filters.parita != 'all' || this.filters.infinity != 'all' || this.filters.rete_se != 'all' || (this.filters.autonomia.length > 0 && this.filters.autonomia[0] != 'all'))
                                {
                                    lssa.visible = false;
                                } else {
                                    lssa.visible = true;
                                }
                            });
                        }
                        if (cent.charger != null && cent.charger.length > 0)
                        {
                            cent.charger.forEach((charger) =>
                            {
                                if (this.filters.idLamp.trim() != '' || this.filters.nomeLamp.trim() != '' || this.filters.tipoLamp != 'all' || this.filters.parita != 'all' || this.filters.infinity != 'all' || this.filters.rete_se != 'all' || (this.filters.autonomia.length > 0 && this.filters.autonomia[0] != 'all'))
                                {
                                    charger.visible = false;
                                } else {
                                    charger.visible = true;
                                }
                            });
                        }
                        if (cent.sw_11kw != null && cent.sw_11kw.length > 0)
                        {
                            cent.sw_11kw.forEach((sw_11kw) =>
                            {
                                if (this.filters.idLamp.trim() != '' || this.filters.nomeLamp.trim() != '' || this.filters.tipoLamp != 'all' || this.filters.parita != 'all' || this.filters.infinity != 'all' || this.filters.rete_se != 'all' || (this.filters.autonomia.length > 0 && this.filters.autonomia[0] != 'all'))
                                {
                                    sw_11kw.visible = false;
                                } else {
                                    sw_11kw.visible = true;
                                }
                            });
                        }
                    }

                    //filtri su lampade illum
                    if (centOk && (devType == null || devType == 'illuminazione') && cent.lamps_illum != null && cent.lamps_illum.length > 0)
                    {

                        cent.lamps_illum.forEach(lamp =>
                        {
                            var visible = true;

                            if (self.filters.idLamp.trim() != '')
                            {
                                let fltArr = self.filters.idLamp.trim().toLowerCase().split(',', -1);
                                var match = false;
                                for (var f = 0; f < fltArr.length; f++)
                                {
                                    let flt = fltArr[f].trim();
                                    found = (lamp.id.toLowerCase() == flt); // || (cent.cu_desc || '').toLowerCase().includes(flt);
                                    if (found)
                                    {
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) visible = false;
                            }
                            if (visible && self.filters.nomeLamp.trim() != '')
                            {
                                let fltArr = self.filters.nomeLamp.trim().toLowerCase().split(',', -1);
                                match = false;
                                for (f = 0; f < fltArr.length; f++)
                                {
                                    let flt = fltArr[f].trim();
                                    var found = (lamp.desc || '').toLowerCase().includes(flt);
                                    if (found)
                                    {
                                        match = true;
                                        break;
                                    }
                                }
                                if (!match) visible = false;
                            }
                            if (visible && self.filters.tipoLamp != 'all' && self.filters.tipoLamp != 'illuminazione')
                            {
                                visible = false;
                            }
                            if (visible && self.filters.rete_se != 'all')
                            {
                                visible = false;
                            }
                            if (visible && self.filters.autonomia.length > 0 && self.filters.autonomia[0] != 'all')
                            {
                                visible = false;
                            }
                            if (visible && self.filters.parita != 'all')
                            {
                                visible = false;
                            }
                            if (visible && self.filters.infinity != 'all')
                            {
                                visible = false;
                            }
                            if (visible) oneLampVisible = true;
                            lamp['visible'] = visible;
                        });

                    }

                    if (!oneLampVisible && !oneSicurLampVisible) centOk = false;

                    //???
                    if (centOk && (devType == null || devType == 'emergenza') && (cent.lamps == null || cent.lamps.length == 0) && cent.cu_type !== 'sicuro')
                    {
                        if (self.filters.idLamp.trim() != '' || self.filters.nomeLamp.trim() != '' || self.filters.tipoLamp != 'all' || self.filters.parita != 'all' || self.filters.infinity != 'all' || self.filters.rete_se != 'all' || (self.filters.autonomia.length > 0 && self.filters.autonomia[0] != 'all'))
                        {
                            centOk = false;
                        }
                    }

                    return centOk;
                });
                console.log("tableData:", this.tableData);
            }

            if (this.selectedGroup != "")
            {
                // let self = this;
                let sg = parseInt(this.selectedGroup);
                console.log("devo filtrare anche per gruppo " + this.selectedGroup);
                this.tableData = this.tableData.filter(cent =>
                {
                    //console.log("cent:",cent);
                    if (cent.cu_type == 'cablecom' || cent.lamps == null || cent.lamps.length == 0) return false;
                    var lampGroups = cent.lamps.filter((lamp) =>
                    {
                        if (lamp.groups == null || lamp.groups.length == 0) return false;
                        return lampGroups = lamp.groups.includes(sg);
                    })
                    console.log("filtr centrale " + cent.cu_id + " lamp groups:", lampGroups);
                    for (i = 0; i < this.tableData.length; i++)
                    {
                        if (this.tableData[i].cu_id == cent.cu_id)
                        {
                            for (var k = 0; k < this.tableData[i].lamps.length; k++)
                            {
                                this.tableData[i].lamps[k]['visible'] = false
                            }
                        }
                    }

                    for (i = 0; i < lampGroups.length; i++)
                    {
                        lampGroups[i]['visible'] = true;
                    }

                    return (lampGroups != null && lampGroups.length > 0);
                });
            }

        },

        clearFilters()
        {
            this.filters = {
                search: '',
                idCent: '',
                nomeCent: '',
                idLamp: '',
                nomeLamp: '',
                tipoCent: ['all'],
                tipoLamp: 'all',
                autonomia: ['all'],
                rete_se: 'all',
                parita: 'all',
                infinity: 'all'
            };
            this.filtra();
        },
        showFilters()
        {
            console.log("mostro filtri avanzati");
            this.advancedFilters = true;
            this.clearFilters();

        },
        hideFilters()
        {
            console.log("nascondo filtri avanzati");
            this.advancedFilters = false;
            this.clearFilters();
        },
        onDecode(decodedString)
        {
            console.log("codeScanned:", decodedString);
            this.qrScanned = decodedString;
            //setTimeout(function() {
            this.scanning = false;
            //},2000);

        },
        async onInit(promise)
        {
            try
            {
                await promise;
                this.scannerInitialized = true;
            } catch (error)
            {
                console.log("error on init", error);
                this.qrScanned = "" + error;
            }
        },
        async startScan()
        {
            if (this.scannerInitialized)
            {
                this.scannerInitialized = false;
                await this.$nextTick();

            }
            this.qrScanned = ''
            this.scanning = true;
        },

        eliminaLampQr(lampIndex)
        {
            let self = this;
            this.$bvModal.msgBoxConfirm("Eliminare questo codice lampada?", {
                title: 'Conferma',
                okVariant: 'danger',
                okTitle: 'ELIMINA',
                cancelTitle: 'ANNULLA',
                centered: true
            }).then((value) =>
            {
                if (value == true)
                {

                    self.currentCent.qr_lamps_id.splice(lampIndex, 1);

                    self.$store.dispatch("dbUpdateQrLamps", {
                        cu_id: self.currentCent.cu_id,
                        cu_type: self.currentCent.cu_type,
                        plantId: self.$store.state.currentPlant.id,
                        lamps: self.currentCent.qr_lamps_id
                    });
                }
            });
        },

        onDecodeQrLamp2(decodedString)
        {
            let self = this;
            console.log("qr codeScanned:", decodedString);
            if (decodedString.trim().length < 6) return;
            let lampId = decodedString.trim().substr(0, 6);
            this.qrScanned = lampId;
            //if (this.currentCent.qr_lamps_id.indexOf(lampId) < 0) {

            let centType = this.currentCent.cu_type;
            self.hasValidationError = false;
            this.logica_config_sn = this.centQrLamps().join("\r\n") + "\r\n" + lampId;

            if (this.validateSerialList(this.logica_config_sn, centType))
            {
                //metto i codici in lista qr e termino editing

                //console.log("codici:",this.logica_array_sn);
                this.currentCent.qr_lamps_id = this.logica_array_sn;
                let alert = {
                    timeLeft: 2,
                    state: "success",
                    msg: "Codice " + lampId + " aggiunto correttamente",
                    // countDownChanged: function(cd) {
                    //     //console.log("countdownchanged:" + cd)
                    // }
                }
                this.validation_alerts.push(alert);

            } else
            {
                setTimeout(function ()
                {
                    self.hasValidationError = true;
                }, 100);
                return false;
            }




            //this.currentCent.qr_lamps_id.push(lampId);
            /*self.$store.dispatch("dbUpdateQrLamps", {
                            cu_id: self.currentCent.cu_id,
                            cu_type: self.currentCent.cu_type,
                            plantId: self.$store.state.currentPlant.id,
                            lamps: self.currentCent.qr_lamps_id
                        });*/
            //}


        },

        onDecodeQrLamp(decodedString)
        {
            let self = this;
            console.log("qr codeScanned:", decodedString);
            let lampId = decodedString.substr(0, 6);
            if (this.currentCent.qr_lamps_id == null) this.currentCent.qr_lamps_id = [];
            if (this.currentCent.qr_lamps_id.indexOf(lampId) < 0)
            {
                this.currentCent.qr_lamps_id.push(lampId);
                self.$store.dispatch("dbUpdateQrLamps", {
                    cu_id: self.currentCent.cu_id,
                    cu_type: self.currentCent.cu_type,
                    plantId: self.$store.state.currentPlant.id,
                    lamps: self.currentCent.qr_lamps_id
                });
            }
            //this.qrScanned = decodedString;
            //setTimeout(function() {
            //this.scanning = false;
            //},2000);

        },
        async onInitQrLamp(promise)
        {
            try
            {
                await promise;
                this.scanLampInitialized = true;
            } catch (error)
            {
                console.log("error on init qr lamp", error);
                //this.qrScanned = "" + error;
            }
        },
        async startScanQrLamp()
        {
            if (this.scanningQrLamp)
            {
                this.scanningQrLamp = false;
                this.scanLampInitialized = false;
                await this.$nextTick();
                return;
            }
            if (this.scanLampInitialized)
            {
                this.scanLampInitialized = false;
                await this.$nextTick();

            }
            this.qrScanned = ''
            this.scanningQrLamp = true;
        },

        async stopScanQrLamp()
        {
            this.scanningQrLamp = false;
            this.scanLampInitialized = false;
            let self = this;
            await this.$nextTick();
            if (!this.hasValidationError) this.$store.dispatch("dbUpdateQrLamps", {
                cu_id: self.currentCent.cu_id,
                cu_type: self.currentCent.cu_type,
                plantId: self.$store.state.currentPlant.id,
                lamps: self.currentCent.qr_lamps_id
            });
        },

        replaceCovidLamp()
        {
            let self = this;
            this.$bvModal.msgBoxConfirm("Confermi l'avvenuta sostituzione della lampada Covid con il ricambio n° " + self.qrScanned + " ?", {
                title: 'Conferma sostituzione lampada',
                okVariant: 'success',
                okTitle: 'Sostituisci',
                cancelTitle: 'CHIUDI',
                centered: true
            }).then((value) =>
            {
                if (value == true)
                {
                    self.replacingCovidLamp = true;
                    setTimeout(function ()
                    {
                        self.replacingCovidLamp = false;
                        self.qrScanned = "";
                    }, 5000);
                    //self.$store.dispatch('updateUserValidation', {callerId: callerId, userId: user.id, validationStatus: 'validated'});
                }
            });
        },
        descrStato(value)
        {
            return (value.cu_connected) ? this.$t("connessa") : this.$t("disconnessa")
        },
        tipoCentrale(value)
        {
            if (value == 'cablecom') return this.$("central_unit") + " CableCom"
            return this.$("central_unit") + " " + value
        },
        ruoloUtente(id)
        {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function (u)
            {
                return u.userid == id;
            });
            if (user != null && user.length > 0) return user[0].role;
            return "?";
        },
        passaAPro()
        {
            this.$router.push({
                name: "GeneraliImpianto",
                params: { plantId: this.$store.state.currentPlant.id }
            });
        },
        // Funzione che apre il <b-collapse> riferito all'id e, 
        // al contempo, inizializza lo specifico elemento di isOpen per visualizzare l'icona corretta:
        // fa-angle-down se true (opened),
        // fa-angle-right se false (closed)
        toggleCollapse(id)
        {    
            if (!(id in this.isOpen)) {
                this.$set(this.isOpen, id, true); // initialize if missing
            } else {
                this.isOpen[id] = !this.isOpen[id];
            }
            console.log("Collapse-" + id);
            this.$root.$emit('bv::toggle::collapse', 'collapse-' + id);
        },
     
        editNomeLamp()
        {
            this.nomeLamp = this.currentLamp.desc;
            this.editingLamp = true;
        },
        editNomeZone(zone)
        {
            this.currentZone = zone;
            this.nomeZone = zone.zoneName;
            this.editingZone = true;
        },
        abortNomeLamp()
        {
            this.editingLamp = false;
        },
        abortNomeZone() {
            this.editingZone = false;
        },
        saveNomeZone() {
           console.log("Save nome: ", this.nomeZone , "su zona :" , this.currentZone);
           const validChars = /^[\x20-\x7F]*$/.test(this.nomeZone);
            if (!validChars) {
                console.log("Invalid chars");
                this.$bvModal.msgBoxOk("La descrizione della zona non può contenere caratteri speciali e lettere accentate");
                return;
            }

            if (this.nomeZone.length > 30) {
                console.log("Troppo lunga");
                this.$bvModal.msgBoxOk("La descrizione della zona non può superare i 30 caratteri");
                return;
            }

            this.currentZone.zoneName=this.nomeZone;
            this.$store.dispatch("updateZone", this.currentZone);
            console.log("Zone Description param to save",this.currentZone);
            this.updatingZone = true;
        },
        // saveNomeLamp() {
        // console.log("Provo a salvare il nome della lampada",this.currentCent);
        // const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.nomeLamp);
        //     if (!validChars) {
        //         console.log("Invalid chars");
        //         this.$bvModal.msgBoxOk("La descrizione della lampada non può contenere caratteri speciali e lettere accentate");
        //         return;
        //     }

        //     if (this.nomeLamp.length > 30)
        //     {
        //         console.log("Troppo lunga");
        //         this.$bvModal.msgBoxOk("La descrizione della centrale non può superare i 30 caratteri");
        //         return;
        //     }

        //     if (this.currentLamp.cu_type == "bluetooth") 
        //     {
        //         var lamps = [];
        //         this.currentBleLamp.desc = this.nomeLamp;
        //         this.currentBleLamp.lamp.desc = this.nomeLamp;
        //         lamps.push(this.currentBleLamp);
        //         this.tempLampDescInfos = { plantId: this.currentLamp.cu_id.split("#")[1], zoneId: this.currentLamp.cu_id.split("#")[2], lamps: lamps };
        //         this.$store.dispatch("updateZoneLamps", this.tempLampDescInfos);
        //     }
        //     else
        //     {
        //         this.tempLampDescInfos = { cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, lamp_id: this.currentLamp.lamp_id, lamp_desc: this.nomeLamp };
        //         this.$store.dispatch("dbSaveLampDescription", this.tempLampDescInfos);
        //     }

        //     console.log("Lamp Description param to save", this.tempLampDescInfos);

        //     //this.currentCent.cu_desc = this.nomeCent;
        //     //this.editingName = false;
        //     this.updatingName = true;
        //     // let self = this;
        //     /*setTimeout(function(){
        //         self.currentCent.cu_desc = self.nomeCent;
        //         self.editingName = false;
        //         self.updatingName = false;
        //     },3000);*/
        // },
        // editNomeCent()
        // {
        //     this.nomeCent = this.currentCent.cu_desc;
        //     this.editingCent = true;
        // },
        // abortNomeCent()
        // {
        //     this.editingCent = false;
        // },
        // saveNomeCent()
        // {

        //     const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.nomeCent);
        //     if (!validChars) {
        //         this.$bvModal.msgBoxOk("La descrizione della centrale non può contenere caratteri speciali e lettere accentate");
        //         return;
        //     }

        //     if (this.nomeCent.length > 30)
        //     {
        //         this.$bvModal.msgBoxOk("La descrizione della centrale non può superare i 30 caratteri");
        //         return;
        //     }

        //     this.$store.dispatch('sendCablecomCommand', { cu_command: 'setCuName', cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, cuName: this.nomeCent });
        //     //this.currentCent.cu_desc = this.nomeCent;
        //     //this.editingName = false;
        //     this.updatingName = true;
        //     // let self = this;
        //     /*setTimeout(function(){
        //         self.currentCent.cu_desc = self.nomeCent;
        //         self.editingName = false;
        //         self.updatingName = false;
        //     },3000);*/
        // },
        startFwUpgrade()
        {
            this.$store.dispatch('sendLogicaCommand', { cu_command: 'startFwUpgrade', cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id });
            let self = this
            Vue.nextTick(function ()
            {
                self.$bvModal.hide('dett-cent-modal');
            });
        },
        checkFwUpgrade()
        {
            this.$store.dispatch('sendLogicaCommand', { cu_command: 'checkFwUpgrade', cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id });
            let self = this
            Vue.nextTick(function ()
            {
                self.$bvModal.hide('dett-cent-modal');
            });
        },
        mostraPaginaCentrali()
        {
            this.$router.push({ name: 'Centrali', params: { pid: this.$store.state.currentPlant.id } })
        },
        mostraPaginaTuttiDispositivi()
        {
            this.$router.push({ name: 'TuttiDispositivi', params: { pid: this.$store.state.currentPlant.id } })
        },
        mostraPaginaPlanimetrie()
        {
            this.$router.push({ name: 'Planimetrie', params: { pid: this.$store.state.currentPlant.id } })
        },
        mostraPaginaAmbienti()
        {
            this.$router.push({ name: 'Ambienti', params: { pid: this.$store.state.currentPlant.id } })
        },
        mostraPaginaZone()
        {
            this.$router.push({ name: 'Zone', params: { pid: this.$store.state.currentPlant.id } })
        },

        sendGenericCommand(cu_command)
        {
            let self = this
            this.respCommand = "";
            this.respCu = "";
            if (cu_command == "blink")
            {
                this.blinking = true;
                //---rimosso timer blinking
                //this.blinkActive=this.blinkDuration;
                //let self=this;
                //self.blinkingTimer();
                this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, addr: this.currentLamp.id });
            }
            else if (cu_command == "stop_blink_single")
            {
                this.blinking = false;
                cu_command = "stop_blink";
                if (this.currentCent.cu_type == "logicafm")
                    this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, addr: this.currentLamp.id });
                else
                    this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, addr: "FFFF" });

            }
            else if (this.centraliSel.length > 0)
            {
                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    if (this.selectedGroup == "")
                    {
                        if (cu_command == "stop_blink" && cent.cu_type == "logicafm")
                        {
                            this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, addr: cent.lamps_id.concat(cent.lamps_illum_id) })
                        }
                        else
                        {
                            console.log("mando comando a centrale " + cu_command + ', ' + cent.cu_id + ", " + cent.cu_type + ", addr: FFFF");
                            this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, addr: 'FFFF' })
                        }
                    }
                    else
                    {
                        var groupAddress = "FFE" + (parseInt(this.selectedGroup) - 1).toString(16).toUpperCase();
                        this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, addr: groupAddress })
                    }
                }
            }
            else if (this.lampadeSel.length > 0)
            {
                var delay = 100;
                var array_lamp_fm = [];
                for (var lsel in this.lampadeSel)
                {
                    let l = this.lampadeSel[lsel].split("-")
                    let cent = this.tableData[parseInt(l[1])]
                    let lamp = cent.lamps[parseInt(l[2])]

                    if (cent.cu_type == "logica" || cent.cu_type == "cablecom")
                    {
                        console.log("mando comando a centrale " + cent.cu_id + ", " + cent.cu_type + ", lampada: " + lamp.id)
                        setTimeout(function ()
                        {
                            self.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, addr: lamp.id })
                        }, delay)
                        delay += 2000
                    }
                    else
                    {
                        array_lamp_fm.push(l);
                    }
                }

                if (array_lamp_fm.length > 0)
                {
                    var cent_temp = null;
                    var array_lamp = [];
                    for (var k in array_lamp_fm) 
                    {
                        let l = this.lampadeSel[k].split("-")
                        let cent = this.tableData[parseInt(l[1])]
                        let lamp = cent.lamps[parseInt(l[2])]
                        if (cent_temp == null)
                        {
                            cent_temp = cent;
                        }
                        if (cent == cent_temp)
                        {
                            array_lamp.push(lamp.id);
                        }
                        if (cent_temp != null && (cent != cent_temp || k == array_lamp_fm.length - 1))
                        {
                            console.log("mando comando multiplo a centrale fm " + cent_temp.cu_id + ", lampade " + array_lamp);
                            self.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent_temp.cu_type, cu_id: cent_temp.cu_id, addr: array_lamp });
                            array_lamp = [];
                            cent_temp = cent;
                        }
                    }
                }
            }
            else
            {
                var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: "Nessun dispositivo selezionato",
                    countDownChanged: function (cd)
                    {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);
            }
        },
        //funzione che invia il comando di setting delle description di lssa sicuro
        sendDescLssaSicuroCommand(value) {
            console.log("sendDescLssaSicuroCommand -> command: ", value.command);
            this.$store.dispatch('sendSicuroCommand',   
                                    { 
                                        command: { 
                                            command: value.command,
                                        },
                                        data: {
                                            topic: value.topic,
                                            module_desc: value.module_desc, 
                                            desc: value.desc,
                                        },
                                        addr: {
                                            lssa_module_index: value.lssa_module_index,                                           
                                        },
                                        retry: 1, //non vogliamo retry nei comandi di configurazione
                                        cu_id: value.cu_id // serve per recuperare l'oggetto centrale e poter settare la property 'working'
                                    });
        },
        //funzione che invia il comando di configurazione lssa sicuro
        sendConfigLssaSicuroCommand(value) {
            console.log("sendConfigLssaSicuroCommand -> command: ", value.command);
            this.$store.dispatch('sendSicuroCommand',   
                                    { 
                                        command: { 
                                            command: value.command,
                                        },
                                        data: {
                                            topic: value.topic,
                                            functions: value.functions, 
                                            addresses: value.addresses,
                                            negated: value.negated,
                                        },
                                        addr: {
                                            lssa_module_index: value.lssa_module_index,                                           
                                        },
                                        retry: 1, //non vogliamo retry nei comandi di configurazione
                                        cu_id: value.cu_id // serve per recuperare l'oggetto centrale e poter settare la property 'working'
                                    });
        },
        //funzione che invia il comando di descrizione linea sicuro
        sendDescLineSicuroCommand(value) {

        },
        //funzione che invia il comando di configurazione linea sicuro
        sendConfigLineSicuroCommand(value) {
            console.log("sendConfigLineSicuroCommand -> command: ", value.command);
            this.$store.dispatch('sendSicuroCommand',   
                                    { 
                                        command: { 
                                            command: value.command,
                                        }, 
                                        data: { 
                                            function: value.function, 
                                            deactivated: value.deactivated,
                                            ts: (value.ts != null) ? value.ts : null,
                                            sp: (value.sp != null) ? value.sp : null,
                                            duration: (value.duration != null) ? value.duration : null,
                                            ls_1: (value.ls_1 != null) ? value.ls_1 : null,
                                            ls_2: (value.ls_2 != null) ? value.ls_2 : null,
                                            ls_3: (value.ls_3 != null) ? value.ls_3 : null,
                                            ls_4: (value.ls_4 != null) ? value.ls_4 : null,
                                            sd_1: (value.sd_1 != null) ? value.sd_1 : null,
                                            sd_2: (value.sd_2 != null) ? value.sd_2 : null,
                                            sd_3: (value.sd_3 != null) ? value.sd_3 : null,
                                            sd_4: (value.sd_4 != null) ? value.sd_4 : null,
                                            dl_1: (value.dl_1 != null) ? value.dl_1 : null,
                                            dl_2: (value.dl_2 != null) ? value.dl_2 : null,
                                            dl_3: (value.dl_3 != null) ? value.dl_3 : null,
                                            dl_4: (value.dl_4 != null) ? value.dl_4 : null,
                                            mr_1: (value.mr_1 != null) ? value.mr_1 : null,
                                            mr_2: (value.mr_2 != null) ? value.mr_2 : null,
                                            mr_3: (value.mr_3 != null) ? value.mr_3 : null,
                                            mr_4: (value.mr_4 != null) ? value.mr_4 : null,
                                            topic: value.cu_type + "_" + value.cu_id
                                        },
                                        addr: {
                                            line_index: value.line_index,                                           
                                        },
                                        retry: 1, //non vogliamo retry nei comandi di configurazione
                                        cu_id: value.cu_id // serve per recuperare l'oggetto 'centrale' e poter settare la property 'working'
                                    });
        },
        //funzione che invia il comando di configurazione lampada Sicuro
        sendConfigLampSicuroCommand(value) {
            console.log("sendConfigLampSicuroCommand -> command: ", value.command);
            this.$store.dispatch('sendSicuroCommand',   
                                    { 
                                        command: { 
                                            command: value.command,
                                        }, 
                                        data: { 
                                            function: value.function, 
                                            dimmer: value.dimmer, 
                                            group_1: (value.groups != null && value.groups[0]) ? value.groups[0] : null,
                                            group_2: (value.groups != null && value.groups[1]) ? value.groups[1] : null,
                                            group_3: (value.groups != null && value.groups[2]) ? value.groups[2] : null,
                                            group_4: (value.groups != null && value.groups[3]) ? value.groups[3] : null,
                                            topic: value.cu_type + "_" + value.cu_id
                                        },
                                        addr: {
                                            lamp_index: value.lamp_index,                                           
                                        },
                                        retry: 1, //non vogliamo retry nei comandi di configurazione
                                        cu_id: value.cu_id // serve per recuperare l'oggetto centrale e poter settare la property 'working'
                                    });
        },
        //funzione che invia il comando di configurazione gruppi Sicuro
        sendConfigGruppiSicuroCommand(value) {
            let cmd = {
                command: { 
                    command: value.command,
                }, 
                data: { 
                    function: value.function, 
                    ts: (value.ts != null) ? value.ts : null,
                    sp: (value.sp != null) ? value.sp : null,
                    duration: (value.duration != null) ? value.duration : null,
                    ls_1: (value.ls_1 != null) ? value.ls_1 : null,
                    ls_2: (value.ls_2 != null) ? value.ls_2 : null,
                    ls_3: (value.ls_3 != null) ? value.ls_3 : null,
                    ls_4: (value.ls_4 != null) ? value.ls_4 : null,
                    sd_1: (value.sd_1 != null) ? value.sd_1 : null,
                    sd_2: (value.sd_2 != null) ? value.sd_2 : null,
                    sd_3: (value.sd_3 != null) ? value.sd_3 : null,
                    sd_4: (value.sd_4 != null) ? value.sd_4 : null,
                    dl_1: (value.dl_1 != null) ? value.dl_1 : null,
                    dl_2: (value.dl_2 != null) ? value.dl_2 : null,
                    dl_3: (value.dl_3 != null) ? value.dl_3 : null,
                    dl_4: (value.dl_4 != null) ? value.dl_4 : null,
                    mr_1: (value.mr_1 != null) ? value.mr_1 : null,
                    mr_2: (value.mr_2 != null) ? value.mr_2 : null,
                    mr_3: (value.mr_3 != null) ? value.mr_3 : null,
                    mr_4: (value.mr_4 != null) ? value.mr_4 : null,
                    topic: value.cu_type + "_" + value.cu_id
                },
                addr: {
                    group_index: value.group_index, 
                    group_desc: value.group_desc,                                          
                },
                retry: 1, //non vogliamo retry nei comandi di configurazione
                cu_id: value.cu_id // serve per recuperare l'oggetto 'centrale' e poter settare la property 'working'
            };
            console.log("sendConfigGruppiSicuroCommand -> cmd: ", cmd);
            this.$store.dispatch('sendSicuroCommand', cmd);
            this.riapriModalGroupsSicuroCu = true;
        },

        //funzione che invia il comando di modifica del descrittivo di lampada Sicuro (da 1 a n lampade)
        sendDescLampSicuroCommand(value) {
            console.log("sendDescLampSicuroCommand -> command: ", value);
            let lamp_desc = {};
            //mi aspetto un array di oggetti con idnice e nome
            for (let i = 0; i < value.num_lamps; i++) {
                if (value.lamps[i] != null) {
                    lamp_desc[`Lamp${value.lamps[i].id}_desc`] = value.lamps[i].name;
                }
            }
            let cmd = {
                command: { 
                    command: value.command,
                }, 
                data: { 
                    topic: value.cu_type + "_" + value.cu_id,
                    lamp_desc: lamp_desc
                },
                retry: 1, //non vogliamo retry nei comandi di configurazione
                cu_id: value.cu_id // serve per recuperare l'oggetto 'centrale' e poter settare la property 'working'
            };
            console.log("sendDescLampSicuroCommand -> cmd: ", cmd);
            this.$store.dispatch('sendSicuroCommand', cmd);
        },

        sendPianificaTest(cu_command)
        {
            console.log("sendPianificaTest -> cu_commnd: ", cu_command);
            // let self = this
            if (this.centraliSel.length > 0)
            {

                this.cmdPianificaTest = cu_command;

                if (cu_command.set_functional != "")
                {
                    cu_command.command = "setDateTimeFunzionale";
                } else
                {
                    cu_command.command = "setDateTimeAutonomia";
                }

                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    //cu_command.command="pianificaTest";
                    console.log("Set Pianifica test", cu_command, cent.cu_type, cent.cu_id);
                    this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, addr: 'FFFF' })
                }
            }
            else
            {
                var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: "Nessuna centrale selezionata",
                    countDownChanged: function (cd)
                    {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);
            }
        },

        /*async sendDeleteLogicaSerialId(centType,centId) {
           let self = this;
           var cu_command = {};
           Vue.nextTick(function () {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.lamp_found = 0;
                    })
            cu_command.command="setLgSerialId";        
            console.log("invio comando logica per reset lista lampade");
            var resp = await self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: centType, cu_id: centId, page: 255,  lamp_id: ["0000"], initialRetry: 3});
            console.log("ricevuta risposta da promise!!!", resp);
            if (resp.error != null && resp.error != "") {
                    console.log("comando fallito!");
                    return;
                }
                setTimeout(function() {
                    self.currentCent = null;
                    self.configCompleted = false;
                    self.configInProgress = false;
                    self.$bvModal.hide('config-cent-modal');
                    self.headerClose = true;
                },1000);
        },*/


        async sendDeleteMultiLogicaSerialId(centType, centId)
        {
            let self = this;
            Vue.nextTick(function ()
            {
                self.headerClose = false;
                self.configError = false;
                self.configCompleted = false;
                self.lamp_found = 0;
            })
            var lampId = this.currentCent.lamps_id;
            var cu_command = {};
            var error_preset = false;
            var pages = [];
            var page;
            var resp;

            if (centType == "logica")
            {
                cu_command.command = "setLgSerialId";
                console.log("invio comando logica per reset lista lampade");
                resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: 255, lamp_id: ["0000"], initialRetry: 3 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    error_preset = true;
                    return;
                }
                if (!this.deleteAllLamps)
                {

                    var fillArray = Array(128).fill("0000");


                    //poi riempo i buchi
                    var index = 0;
                    for (var i = 0; i < lampId.length; i++)
                    {
                        var ser = lampId[i];
                        if (this.substituteLampsSelection.indexOf(ser) >= 0)
                        {
                            console.log("rimuovo lampada " + ser);
                            continue;
                        }

                        while (fillArray[index] != "0000" && index < 128) index++;
                        if (index < 128)
                        {
                            fillArray[index] = ser;
                            page = Math.floor(index / 32);
                            if (pages.indexOf(page) < 0) pages.push(page);
                        }
                        index++;
                    }

                    console.log("array lampid rivisitato:", fillArray, pages);


                    for (var p = 0; p < pages.length; p++)
                    {
                        page = pages[p];

                        var lampsId = fillArray.slice(page * 32, Math.min((page + 1) * 32, fillArray.length))

                        console.log("invio comando logica per pagina " + page, lampsId);
                        resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: page, lamp_id: lampsId, initialRetry: 3 });
                        console.log("ricevuta risposta da promise!!!", resp);
                        if (resp.error != null && resp.error != "")
                        {
                            console.log("comando fallito!");
                            error_preset = true;
                            break;
                        }
                    }
                }
            }

            if (centType == "logicafm")
            {
                console.log("cancellazione logicaFm, allLamps:" + this.deleteAllLamps);
                cu_command.command = "deleteLgSerialId";
                self.$bvModal.hide('config-cent-modal');
                if (this.currentCent.cu_type == 'logicafm' && this.deleteAllLamps == true)
                    resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, lamp_id: ['FFFF'], initialRetry: 0 });
                else
                    resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, lamp_id: this.substituteLampsSelection, initialRetry: 0 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    error_preset = true;
                }
                else
                {
                    if (this.deleteAllLamps == true)
                    {
                        this.currentCent.lamps_illum = [];
                        this.currentCent.sensors = [];
                        this.currentCent.lamps = [];
                        this.currentCent.lamps_altro_id = [];
                        this.currentCent.lamps_altro_indexes = [];
                        this.currentCent.lamps_emer_indexes = [];
                        this.currentCent.lamps_id = [];
                        this.currentCent.lamps_illum_id = [];
                        this.currentCent.lamps_illum_indexes = [];

                        var cent = this.$store.state.plantUnits.find((c) => c.cu_id == self.currentCent.cu_id);
                        //console.log("cent=",cent);
                        if (cent != null)
                        {
                            cent.lamps_illum = [];
                            cent.sensors = [];
                            cent.lamps = [];
                            cent.lamps_altro_id = [];
                            cent.lamps_altro_indexes = [];
                            cent.lamps_emer_indexes = [];
                            cent.lamps_id = [];
                            cent.lamps_illum_id = [];
                            cent.lamps_illum_indexes = [];
                        }


                        //console.log("curentCent ora=" + JSON.stringify(this.currentCent) ,this.currentCent, this.$store.state.plantUnits);
                        setTimeout(function ()
                        {
                            //console.log("ri-filtro");
                            self.filtra();
                            //console.log("forzo update");
                            self.$forceUpdate();
                        }, 5000);
                    }
                    console.log("comando cancellazione serial Id eseguito correttamente!");
                    self.currentCent = null;
                }

            }

            if (error_preset == false && centType != "logicafm")
            {
                console.log("comando setting buffer serial Id completato! Invio la ricerca con logica preset");
                let modalita_config_logica = "logica_preset";
                this.$store.dispatch('sendLogicaConfigCommand', { centType, centId, modalita_config_logica });
            }
            setTimeout(function ()
            {
                self.currentCent = null;
                self.configCompleted = false;
                if (self.configInProgress != 0) clearTimeout(self.configInProgress);   //ALEX
                self.configInProgress = false;
                self.$bvModal.hide('config-cent-modal');
                self.headerClose = true;
            }, 1000);

        },

        async sendPresetLogicaSerialId(serialId_list, centType, centId)
        {
            let self = this;
            Vue.nextTick(function ()
            {
                self.headerClose = false;
                self.configError = false;
                self.configCompleted = false;
                self.lamp_found = 0;
            })
            var lampId = serialId_list;
            var cu_command = {};
            cu_command.command = "setLgSerialId";
            var error_preset = false;
            var pages = [];
            var i, ser, pd, page, resp;

            if (centType == "logica")
            {
                if (this.manual_mode_logica != "overwrite")
                {
                    //devo aggiungere le lampade già presenti alla mia lista
                    //var cent_lamps_array = []
                    for (var n = 0; n < this.currentCent.lamps_id.length; n++)
                    {
                        //cent_lamps_array.push(this.currentCent.lamps_id[n]);
                        //lampId.push(this.currentCent.lamps_id[n]);
                        lampId.unshift(this.currentCent.lamps_id[this.currentCent.lamps_id.length - 1 - n]);
                    }
                    //lampId = lampId.concat(cent_lamps_array);
                }

                //if (this.manual_mode_logica == 'overwrite') {
                console.log("invio comando logica per reset lista lampade");
                resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: 255, lamp_id: ["0000"], initialRetry: 3 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    error_preset = true;
                    return;
                }
                var fillArray = Array(128).fill("0000");

                //prima riempo le posizioni forzate
                for (i = 0; i < lampId.length; i++)
                {
                    ser = lampId[i];
                    pd = ser.indexOf(":");
                    if (pd > 0)
                    {
                        var pos = parseInt(ser.substr(0, pd), 10);
                        fillArray[pos - 1] = ser.substr(pd + 1);
                        page = Math.floor(pos / 32);
                        if (pages.indexOf(page) < 0) pages.push(page);
                    }
                }
                //poi riempo i buchi
                var index = 0;
                for (i = 0; i < lampId.length; i++)
                {
                    ser = lampId[i];
                    pd = ser.indexOf(":");
                    if (pd > 0)
                    {
                        //le lampade con posizione fissa le ho già gestite
                        continue;
                    }
                    while (fillArray[index] != "0000" && index < 128) index++;
                    if (index < 128)
                    {
                        fillArray[index] = ser;
                        page = Math.floor(index / 32);
                        if (pages.indexOf(page) < 0) pages.push(page);
                    }
                    index++;
                }

                console.log("array lampid rivisitato:", fillArray, pages);

                for (var p = 0; p < pages.length; p++)
                {
                    page = pages[p];

                    var lampsId = fillArray.slice(page * 32, Math.min((page + 1) * 32, fillArray.length))

                    console.log("invio comando logica per pagina " + page, lampsId);
                    resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: page, lamp_id: lampsId, initialRetry: 3 });
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "")
                    {
                        console.log("comando fallito!");
                        error_preset = true;
                        break;
                    }
                }
            }

            if (centType == "logicafm")
            {
                console.log("invio comando logicafm con serial ID " + serialId_list);
                self.$bvModal.hide('config-cent-modal');
                resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: 0, lamp_id: serialId_list, initialRetry: 0 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    error_preset = true;
                }
                else
                {
                    console.log("comando scrittura serial Id eseguito correttamente!");
                    self.currentCent = null;
                }
            }


            if (error_preset == false)
            {
                console.log("comando setting buffer serial Id completato! Invio la ricerca con logica preset");
                let modalita_config_logica = "logica_preset";
                this.$store.dispatch('sendLogicaConfigCommand', { centType, centId, modalita_config_logica });
            }
            setTimeout(function ()
            {
                self.currentCent = null;
                self.configCompleted = false;
                if (self.configInProgress != 0) clearTimeout(self.configInProgress);   //ALEX
                self.configInProgress = false;
                self.$bvModal.hide('config-cent-modal');
                self.headerClose = true;
            }, 1000);

        },

        async sendSubstituteLogicaSerialId(serialId_list, centType, centId)
        {
            let self = this;
            Vue.nextTick(function ()
            {
                self.headerClose = false;
                self.configError = false;
                self.configCompleted = false;
                self.lamp_found = 0;
            })
            var lampId = this.currentCent.lamps_id;
            var cu_command = {};
            cu_command.command = "setLgSerialId";
            var error_preset = false;
            var pages = [];
            var i, resp, page;

            for (i = 0; i < serialId_list.length; i++)
            {
                var oldId = this.substituteLampsSelection[i];
                var oldPos = lampId.indexOf(oldId);
                if (oldPos >= 0)
                {
                    lampId[oldPos] = serialId_list[i];
                }
            }

            if (centType == "logica")
            {
                console.log("invio comando logica per reset lista lampade");
                resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: 255, lamp_id: ["0000"], initialRetry: 3 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    error_preset = true;
                    return;
                }

                var fillArray = Array(128).fill("0000");

                //poi riempo i buchi
                var index = 0;
                for (i = 0; i < lampId.length; i++)
                {
                    var ser = lampId[i];
                    while (fillArray[index] != "0000" && index < 128) index++;
                    if (index < 128)
                    {
                        fillArray[index] = ser;
                        page = Math.floor(index / 32);
                        if (pages.indexOf(page) < 0) pages.push(page);
                    }
                    index++;
                }

                console.log("per Logica array lampid rivisitato:", fillArray, pages);
            }
            else
            {
                console.log("per Logica FM Id lampade da sostituire", this.substituteLampsSelection);
                console.log("per Logica FM Id lampade sostitute", this.logica_array_sn);
            }

            if (centType == "logica")
            {
                for (var p = 0; p < pages.length; p++)
                {
                    page = pages[p];

                    var lampsId = fillArray.slice(page * 32, Math.min((page + 1) * 32, fillArray.length))

                    console.log("invio comando logica per pagina " + page, lampsId);
                    resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, page: page, lamp_id: lampsId, initialRetry: 3 });
                    console.log("ricevuta risposta da promise!!!", resp);
                    if (resp.error != null && resp.error != "")
                    {
                        console.log("comando fallito!");
                        error_preset = true;
                        break;
                    }
                }
            }
            else
            {
                cu_command.command = "substituteLogicaFM";
                resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, old: this.substituteLampsSelection, new: this.logica_array_sn, initialRetry: 3 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    error_preset = true;
                }
            }

            if (error_preset == false)
            {
                console.log("comando setting buffer serial Id completato! Invio la ricerca con logica preset");
                let modalita_config_logica = "logica_preset";
                this.$store.dispatch('sendLogicaConfigCommand', { centType, centId, modalita_config_logica });
            }
            setTimeout(function ()
            {
                self.currentCent = null;
                self.configCompleted = false;
                self.configInProgress = false;
                self.$bvModal.hide('config-cent-modal');
                self.headerClose = true;
            }, 1000);

        },

        configViewParam()
        {
            var numCentWithInfinity = 0;
            var numCent = 0;
            if (this.centraliSel.length > 0)
            {
                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-")
                    let cent = this.tableData[parseInt(c[1])]
                    if (cent.cu_type == "cablecom")
                        numCentWithInfinity++;
                }
                numCent = this.centraliSel.length;
            }
            if (this.lampadeSel.length > 0)
            {
                for (var lsel in this.lampadeSel)
                {
                    let l = this.lampadeSel[lsel].split("-")
                    let cent = this.tableData[parseInt(l[1])]
                    numCent++;
                    if (cent.cu_type == "cablecom")
                        numCentWithInfinity++;
                }
            }
            if (numCentWithInfinity == 0)
                return null
            else if (numCentWithInfinity == numCent)
                return "infinity"
            else if (numCentWithInfinity < numCent)
                return "infinity-mixed"
            return null
        },

        async sendGenericCommandMulti(cu_command)
        {
            let self = this
            this.respCommand = "";
            this.respCu = "";
            var indexes = [];
            var pages = [];
            var k, resp, p, page;
            var lampPageIndexes, resp_batch, cu_command_new;

            if (this.centraliSel.length > 0)
            {
                console.log("SELEZIONE SU CENTRALI", this.centraliSel);
                for (var csel in this.centraliSel)
                {
                    let c = this.centraliSel[csel].split("-");
                    let cent = this.tableData[parseInt(c[1])];
                    indexes = [];
                    pages = [];
                    for (k = 0; k < cent.lamps.length; k++)
                    {
                        let lamp = cent.lamps[k];
                        indexes.push(lamp.index);
                        let lampPage = Math.floor(lamp.index / 32);
                        if (!pages.includes(lampPage)) pages.push(lampPage);
                    }
                    if (cent.cu_type == 'logica')
                    {
                        //create 32 indexes for broadcast command on a central unit logica
                        indexes = [];
                        for (k = 0; k < 32; k++)
                        {
                            indexes.push(k);
                        }
                        //setting page=255 for broadcast command on a central unit logica
                        resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, page: 255, indexes: indexes, initialRetry: 3 });
                    } else
                    {
                        self.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, indexes: indexes });
                    }

                    console.log("Multi: ", cu_command);
                    console.log("Multi: mando comando a centrale " + cent.cu_id + ", lampade: " + indexes);
                }
            } if (this.lampadeSel.length > 0)
            {
                console.log("SELEZIONE SU LAMPADE", this.lampadeSel);
                var cent = null;
                var tempCentId = null;
                var tempCentType = null;
                indexes = [];
                pages = [];
                for (var lsel in this.lampadeSel)
                {
                    let l = this.lampadeSel[lsel].split("-");
                    cent = this.tableData[parseInt(l[1])];
                    console.log("MULTI sono su cent", cent.cu_id);
                    if (tempCentId != cent.cu_id || tempCentType != cent.cu_type)
                    {
                        if (tempCentId != null && tempCentType != null)
                        {
                            if (tempCentType == 'logica')
                            {
                                for (p = 0; p < pages.length; p++)
                                {
                                    page = pages[p];
                                    //estraggo gli indici di questa pagina
                                    lampPageIndexes = indexes.filter(function (lampIdx)
                                    {
                                        let pidx = Math.floor(lampIdx / 32);
                                        return pidx == page;
                                    });
                                    console.log("invio comando logica per pagina " + page + " indici:" + lampPageIndexes);
                                    resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: tempCentType, cu_id: tempCentId, page: page, indexes: lampPageIndexes, initialRetry: (p == 0) ? 3 : 41 });
                                    console.log("ricevuta risposta da promise!!!", resp);
                                    if (resp.error != null && resp.error != "")
                                    {
                                        console.log("comando fallito!");
                                        // error_loop_page=true;
                                        break;
                                    }
                                }
                            } else
                            {
                                self.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: tempCentType, cu_id: tempCentId, indexes: indexes });
                            }
                            console.log("MULTI 1 mando comando a centrale " + tempCentId + ", lampade: " + indexes);
                        }

                        indexes = [];
                        pages = [];
                    }
                    tempCentId = cent.cu_id;
                    tempCentType = cent.cu_type;
                    let lamp = cent.lamps[parseInt(l[2])];
                    indexes.push(lamp.index);
                    let lampPage = Math.floor(lamp.index / 32);
                    if (!pages.includes(lampPage)) pages.push(lampPage);

                    console.log("MULTI lamp,indexes su cent", cent.cu_id + " indexes " + indexes + " lamps " + lamp.index + " pages: ", pages);
                }
                if (cent.cu_type == 'logica')
                {

                    var error_batch = false;
                    if (pages.length > 1)
                    {
                        //Invio comando di apertura batch se comando multi su più pagine param=01 (apertura store batch)
                        var temp_command = cu_command;
                        cu_command_new = {};
                        cu_command_new.command = "setBatch";
                        console.log("Apro batch comandi", cu_command);
                        resp_batch = await self.$store.dispatch('sendLogicaCommand', { cu_command_new, cu_type: cent.cu_type, cu_id: cent.cu_id, param: "01", initialRetry: 3 });
                        cu_command_new = temp_command;

                        if (resp_batch.error != null && resp_batch.error != "")
                        {
                            console.log("comando batch fallito!");
                            error_batch = true;
                        }
                    }

                    if (error_batch == false)
                    {
                        for (p = 0; p < pages.length; p++)
                        {
                            page = pages[p];
                            //estraggo gli indici di questa pagina
                            lampPageIndexes = indexes.filter(function (lampIdx)
                            {
                                let pidx = Math.floor(lampIdx / 32);
                                return pidx == page;
                            });
                            console.log("invio comando logica per pagina " + page + " indici:" + lampPageIndexes);
                            resp = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: cent.cu_type, cu_id: tempCentId, page: page, indexes: lampPageIndexes, initialRetry: 3 });
                            console.log("ricevuta risposta da promise!!!", resp);
                            if (resp.error != null && resp.error != "")
                            {
                                console.log("comando fallito!");
                                resp_batch = await self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, param: "02", initialRetry: 3 });
                                break;
                            }

                            if (p == pages.length - 1 && pages.length > 1)
                            {
                                //Invio comando di esecuzione batch (chiusura batch comandi + esecuzione) param=03 (esegui batch)
                                cu_command_new = {};
                                cu_command_new.command = "setBatch";
                                console.log("Chiudo batch comandi", cu_command_new);
                                resp_batch = await self.$store.dispatch('sendLogicaCommand', { cu_command_new, cu_type: cent.cu_type, cu_id: cent.cu_id, param: "03", initialRetry: 3 });
                                if (resp_batch.error != null && resp_batch.error != "")
                                    console.log("comando batch fallito!");
                            }

                        }
                    }
                } else
                {
                    self.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: tempCentId, indexes: indexes });
                }

                console.log("MULTI 2 mando comando a centrale after " + tempCentId + ", lampade: " + indexes);



            } if (this.centraliSel.length <= 0 && this.lampadeSel.length <= 0)
            {
                var alert = {
                    timeLeft: 5,
                    state: "danger",
                    msg: "Nessun dispositivo selezionato",
                    countDownChanged: function (cd)
                    {
                        //timeLeft = cd;
                        console.log("countdownchanged:" + cd)
                    }
                }
                this.alerts.push(alert);
            }
        },

        async sendFmCommand(cu_command)
        {
            console.log("Send Fm Command: ", cu_command, " on ", this.cuAdvanced.cu_id);
            let self = this;
            self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: this.cuAdvanced.cu_type, cu_id: this.cuAdvanced.cu_id, initialRetry: 0 });
        },
        async sendCommand(cu_command)
        {
            console.log("Send Command: ", cu_command, " on ");
            // let self=this;
            //self.$store.dispatch('sendLogicaCommand', {cu_command,cu_type: this.cuAdvanced.cu_type, cu_id: this.cuAdvanced.cu_id,initialRetry: 0});
        },
        //azzera tutte le selezioni con checkbox, ponendo a array vuoto la prop usata nel v-model del <b-checkbox-group>
        azzeraSelezione()
        {
            this.righeSel = [];
        },
        //inserisce nella prop usata nel v-model del <b-checkbox-group>, tutte le centrali dell'impianto
        selezionaAllCentrali()
        {

            this.righeSel = []
            for (var i = 0; i < this.tableData.length; i++)
            {
                // if (this.tableData[i].enabled) this.righeSel.push("cent-"+i);
                if ((this.tableData[i].enabled) && (this.tableData[i].cu_type != 'sicuro')) this.righeSel.push("cent-" + i);
            }
            //console.log("righeSel:",this.righeSel);

        },
        toggleSeleziona(ev)
        {
            let c = document.getElementById("allSelect");
            console.log("toggleSeleziona ev", ev, c.checked);
            //console.log ("STATUS", this.status);
            if (c.checked)
            {
                this.selezionaAllCentrali();

            }
            else
            {
                this.azzeraSelezione();

                //this.status = "none_selected";
            }
            //let self = this;


        },
        selezionaAllLamp()
        {
            this.righeSel = [];
            for (var i = 0; i < this.tableData.length; i++)
            {
                let c = this.tableData[i];
                for (var l = 0; l < c.lamps.length; l++)
                {
                    this.righeSel.push("lamp-" + i + "-" + l)
                }
            }
        },
        //Elimina dalla lista dei dispositivi selezionati con checkbox, nel caso venga selezionata la loro Zona, le lampade e i sensori presenti 
        toggleZoneCheckbox(checked)
        {
            console.log("Toggle zone, checked: ", checked, " lampadeSel: ", this.lampadeSel);
            if (this.lampadeSel.length > 0)
            {
                //poiché l'evento 'change' viene emesso prima che venga aggiornata la property v-model 'righeSel', qui non troviamo la zona selezionata,
                //per cui occorre aggiungerla
                if (!this.righeSel.includes(checked)) {
                    this.righeSel.push(checked);
                }
                this.zoneSel.forEach( (zone) => {
                    //isolo l'indice, cioè il numero dopo il carattere '-'
                    const indiceZona = zone.substring(zone.indexOf('-') + 1);
                    this.righeSel = this.righeSel.filter( (riga) => {
                        //suddivido la stringa rispetto a '-'
                        const arr = riga.split("-");
                        //controllo lampade, sensori, ak e linee
                        if (arr[0].substring(0,4).toLowerCase() == 'lamp') {                            
                            //isolo indiceDisp
                            const indiceDisp = arr[1];
                            if (indiceDisp === indiceZona) {
                                //se il dispositivo appartiene alla centrale, lo filtro
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    });
                });
            }
            console.log("righe:", this.righeSel);
        },
        //Elimina dalla lista dei dispositivi selezionati con checkbox, nel caso venga selezionata la loro Centrale, le lampade e i sensori presenti 
        toggleCentCheckbox(checked)
        {
            console.log("Toggle cent, checked: ", checked, " lampadeSel: ", this.lampadeSel);
            if ((this.lineSel.length > 0) || (this.lampadeSel.length > 0) || (this.akSel.length > 0) ||
                (this.akextSel.length > 0) || (this.lineextSel.length > 0) || (this.lampadeextSel.length > 0))
            {
                //poiché l'evento 'change' viene emesso prima che venga aggiornata la property v-model 'righeSel', qui non troviamo la centrale selezionata,
                //per cui occorre aggiungerla
                if (!this.righeSel.includes(checked)) {
                    this.righeSel.push(checked);
                }
                //Caso generale: per ogni centrale selezionata, tolgo le rispettive lampade eventualmente selezionate
                //le centrali sono registrate in questa forma: 'cent-(centIndex)' con centIndex='indice di dataTable'
                //per esmepio cent-0, cent-1, ecc
                //le lampade sono registrate in questa forma: 'lamp(lampId)-(centIndex)-(lampIndex)' con lampIndex='indice dell'array lamps della centrale di appartenenza'
                //per esempio lamp2468-0-0, lamp3579-0-1, ecc
                //stesso discorso per i sensori, ak, line ,ak_ext, line_ext
                this.centraliSel.forEach( (cent) => {
                    //isolo l'indice, cioè il numero dopo il carattere '-'
                    const indiceCent = cent.substring(cent.indexOf('-') + 1);
                    this.righeSel = this.righeSel.filter( (riga) => {
                        //suddivido la stringa rispetto a '-'
                        const arr = riga.split("-");
                        //controllo lampade, sensori, ak e linee
                        if (riga.substring(0,4).toLowerCase() == 'lamp' || riga.substring(0,4).toLowerCase() == 'sens' ||
                            riga.substring(0,2).toLowerCase() == 'ak' || riga.substring(0,4).toLowerCase() == 'line' ||
                            riga.substring(0,7).toLowerCase() == 'extlamp' || riga.substring(0,7).toLowerCase() == 'extline' ||
                            riga.substring(0,5).toLowerCase() == 'extak' ) {                            
                            //isolo indiceDisp
                            const indiceDisp = arr[1];
                            if (indiceDisp === indiceCent) {
                                //se il dispositivo appartiene alla centrale, lo filtro
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    });
                });
            }
            console.log("righe:", this.righeSel);
        },
        //Elimina dalla lista dei dispositivi selezionati con checkbox, nel caso venga selezionata il loro AK, le lampade e le linee presenti 
        toggleAkCheckbox(checked) {
            console.log("Toggle AK, checked: ", checked, " lineSel: ", this.lineSel);
            if ((this.lineSel.length > 0) || (this.lampadeSel.length > 0))
            {
                //poiché l'evento 'change' viene emesso prima che venga aggiornata la property v-model 'righeSel', qui non troviamo l'AK selezionato,
                //per cui occorre aggiungerlo
                if (!this.righeSel.includes(checked)) {
                    this.righeSel.push(checked);
                }
                //Caso generale: per ogni AK selezionato, tolgo le rispettive linee e lampade eventualmente selezionate
                this.akSel.forEach( (ak) => {
                    //isolo index(ak)
                    const indiceAk = ak.split('-')[2];
                    this.righeSel = this.righeSel.filter( (riga) => {
                        //isolo linee e lampade (valido per centrali SICURO)
                        if (riga.substring(0,4).toLowerCase() == 'lamp' || riga.substring(0,4).toLowerCase() == 'line') {
                            //suddivido la stringa rispetto a '-'
                            const arr = riga.split("-");
                            const indiceDisp = arr[2]; //AK
                            if (indiceDisp === indiceAk) {
                                //se il dispositivo appartiene alla centrale, lo filtro
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    });
                });
            }
        },

        //Elimina dalla lista dei dispositivi selezionati con checkbox, nel caso venga selezionata il loro AKEXT, le lampade e le linee presenti 
        toggleAkExtCheckbox(checked) {
            if ((this.lineextSel.length > 0) || (this.lampadeextSel.length > 0)) {
                //poiché l'evento 'change' viene emesso prima che venga aggiornata la property v-model 'righeSel', qui non troviamo l'AK selezionato,
                //per cui occorre aggiungerlo
                if (!this.righeSel.includes(checked)) {
                    this.righeSel.push(checked);
                }
                //Caso generale: per ogni AKEXT selezionato, tolgo le rispettive linee e lampade eventualmente selezionate
                this.akextSel.forEach( (extak) => {
                    //isolo index(ak)
                    const indiceAk = extak.split('-')[2];
                    this.righeSel = this.righeSel.filter( (riga) => {
                        //isolo linee e lampade (valido per centrali SICURO)
                        if (riga.substring(0,7).toLowerCase() == 'extlamp' || riga.substring(0,7).toLowerCase() == 'extline') {
                            //suddivido la stringa rispetto a '-'
                            const arr = riga.split("-");
                            const indiceDisp = arr[2]; //AK
                            if (indiceDisp === indiceAk) {
                                //se il dispositivo appartiene alla centrale, lo filtro
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    });
                });
            }
        },
        //Elimina dalla lista dei dispositivi selezionati con checkbox, nel caso venga selezionata il loro AKEXT, le lampade e le linee presenti 
        toggleLineExtCheckbox(checked)  {
            console.log("Toggle LineExt");
            if (this.lampadeextSel.length > 0)
            {
                //poiché l'evento 'change' viene emesso prima che venga aggiornata la property v-model 'righeSel', qui non troviamo l'AK selezionato,
                //per cui occorre aggiungerlo
                if (!this.righeSel.includes(checked)) {
                    this.righeSel.push(checked);
                }
                //Caso generale: per ogni LINE selezionato, tolgo le lampade eventualmente selezionate
                this.lineextSel.forEach( (line) => {
                    //isolo index(line)
                    const indiceLine = line.split('-')[3];
                    this.righeSel = this.righeSel.filter( (riga) => {
                        //isolo lampade
                        if (riga.substring(0,7).toLowerCase() == 'extlamp') {
                            //suddivido la stringa rispetto a '-'
                            const arr = riga.split("-");
                            const indiceDisp = arr[3]; //Line
                            if (indiceDisp === indiceLine) {
                                //se il dispositivo appartiene alla centrale, lo filtro
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    });
                });
            }
        },
        //Elimina dalla lista dei dispositivi selezionati con checkbox, nel caso venga selezionata la loro LINE, le lampade presenti 
        toggleLineCheckbox(checked)  {
            console.log("Toggle Line");
            console.log("Line sel: ", this.lineSel);
            console.log("righe sel: ", this.righeSel);
            if (this.lampadeSel.length > 0)
            {
                //poiché l'evento 'change' viene emesso prima che venga aggiornata la property v-model 'righeSel', qui non troviamo l'AK selezionato,
                //per cui occorre aggiungerlo
                if (!this.righeSel.includes(checked)) {
                    this.righeSel.push(checked);
                }
                //Caso generale: per ogni LINE selezionato, tolgo le lampade eventualmente selezionate
                this.lineSel.forEach( (line) => {
                    //isolo index(line)
                    const indiceLine = line.split('-')[3];
                    this.righeSel = this.righeSel.filter( (riga) => {
                        //isolo lampade
                        if (riga.substring(0,4).toLowerCase() == 'lamp') {
                            //suddivido la stringa rispetto a '-'
                            const arr = riga.split("-");
                            const indiceDisp = arr[3]; //Line
                            if (indiceDisp === indiceLine) {
                                //se il dispositivo appartiene alla centrale, lo filtro
                                return false;
                            } else {
                                return true;
                            }
                        } else {
                            return true;
                        }
                    });
                });
            }
        },

        showMultipleAddToMonitoringZone(lamps)
        {
            let self = this 
            var lampsArray = [];
            var indexCent = 0;
            
            //prepara la lista di lampade o centrali selezionate da passare al modal di AddToMonitoringZone
            if (self.unitsDetails != null) {
                lamps.forEach(function (l) {
                    self.unitsDetails.forEach(function (u)
                    {
                        u.lamps_illum.forEach(function (ill) {

                            if (l.split('-')[0] == "cent" && indexCent.toString()==l.split('-')[1] && ill.nodo_orfano==false)
                            {
                                lampsArray.push(ill);
                            }                               
                            else if (ill.id == l.split('-')[0].replace("lampIll", "") && ill.nodo_orfano==false)
                            {
                                lampsArray.push(ill);
                            }
                        });

                        indexCent++;
                    });
                });
                this.lampsToAdd = lampsArray;
                console.log("Lamps to add to monitoring zone: ", this.lampsToAdd);
                this.modalMultipleAddToZone = true;
            }  
        },
        showAddToMonitoringZone(lampMonitor)
        {
            this.lampToAdd = lampMonitor;
            this.modalAddToZone = true;
        },
        showRemoveCu(cuRemove)
        {
            this.cuToRemove = cuRemove;
            this.modalRemoveCuVisible = true;
            console.log("Current Cu to remove", this.cuToRemove);
        },
        showResetCu(cuReset)
        {
            this.cuToReset = cuReset;
            this.modalResetCuVisible = true;
            console.log("Current Cu to reset", this.cuToReset, "visible: ", this.modalResetCuVisible);
        },
        showGatewayCommand(gatewayId)
        {
            this.gatewayToCommand = gatewayId;
            this.modalGatewayCommandVisible = true;
            console.log("Current Gateway to send command", this.gateway, "visible: ", this.modalGatewayCommandVisible);
        },
        showGatewayLampsInsert(gateway)
        {
            this.gatewayInsert = gateway;
            this.modalGatewayLampsInsertVisible = true;
            this.zonesInPlant = this.$store.state.plantZones;
            console.log("Current Gateway to insert lamps", gateway, "visible: ", this.modalGatewayLampsInsertVisible);

        },
        resetRemoveCuModal()
        {
            this.cuToRemove = null;
        },
        showAdvanced(cu)
        {
            this.cuAdvanced = cu;
            this.modalAdvancedCuVisible = true;
            console.log("Open modal advanced on Cu", this.cuAdvanced);
        },
        showInputsRelay(cu)
        {
            this.cuInputs = cu;
            this.modalInputsCuVisible = true;
            console.log("Open modal inputs & relay on Cu Logica", this.cuAdvanced);
        },
        resetAdvancedCuModal()
        {
            this.cuAdvanced = null;
        },
        resetInputsCuModal()
        {
            this.cuInputs = null;
        },
        showGroups(cu)
        {
            this.cuGroups = cu;
            this.modalGroupsCuVisible = true;
            console.log("Open modal groups on Cu", this.cuGroups);
        },
        showSicuroGroups(cu) {
            //this.currentCent = cu;
            this.cuSicuroId = cu.cu_id;
            this.cuSicuroType = cu.cu_type;
            this.modalGroupsSicuroCuVisible = true;
            console.log("Open modal sicuro groups on Cu", this.currentCent);
        },
        resetGroupsCuModal()
        {
            this.cuGroups = null;
        },

        resetAkDetail()
        {
            this.akInfo = null;
        },
        //apre il modal di dettaglio della Centrale
        hideCentDetails()
        {
            this.modalCentDetailShow = false;
        },
        //chiude il modal di dettaglio della linea
        hideLampDetails()
        {
            this.modalLampDetailShow = false;
        },
        //chiude il modal di configurazione lampade
        hideLampConfig()
        {
            this.modalLampConfigShow = false;
        },
        //chiude il modal di configurazione della Linea
        hideLineConfig()
        {
            this.modalLineConfigShow = false;
        },
        //apre un modale CentralDetails.vue
        showCentDetails(centDetails)
        {
            console.log("mostro dettaglio centrale ", centDetails)

            this.currentCent = centDetails;
            this.modalCentDetailShow = true;

            // this.currentCent = centDetails;
            // let self = this
            // Vue.nextTick(function () {
            //     self.$bvModal.show('dett-cent-modal');
            // })
        },
        //apre il modal LineDetails.vue
        showLineDetails(lineDetails)
        {
            this.currentLine = lineDetails;
            this.currentCent = this.tableData.find(cent => cent.cu_id === lineDetails.cu_id.split('#')[1]);
            this.modalLineDetailShow = true;
        },

        //visualizza il modal 'config-cent-modal' per configurare la Centrale
        showConfigCent(centConfig)
        {
            var n;

            if (centConfig.qr_amps_id == null) centConfig.qr_lamps_id = [];
            this.currentCent = centConfig;
            this.substituteLampsSelection = [];
            this.reopenConfig = false;
            if (this.configInProgress != 0) clearTimeout(this.configInProgress);   //ALEX
            this.configRetry = 3;
            this.configInProgress = 0;
            this.configError = false;
            this.configCompleted = false;
            this.createNetworkInProgress = false;
            this.selected_modalita_logica = 'logica_append';
            this.logica_config_sn = ''; //stringa dei nuovi codici da inserire
            this.logica_array_sn = [];
            this.logica_cu_list = ''; //lista dei codici presenti nella centrale
            this.delete_sn = false;
            if (this.currentCent.cu_type == "logicafm") {
                this.selected_modalita_logica = 'logica_preset';
                this.selected_plant_code = this.currentCent.plant_code;
            }                
            //compilo la lista 'logica_cu_list' delle lampade presenti in centrale
            if (this.currentCent.lamps_id != null) {
                for (n = 0; n < this.currentCent.lamps_id.length; n++)
                {
                    this.logica_cu_list = this.logica_cu_list + this.currentCent.lamps_id[n] + "\n";
                }
            }
            if (this.currentCent.lamps_illum_id != null) {
                for (n = 0; n < this.currentCent.lamps_illum_id.length; n++)
                {
                    this.logica_cu_list = this.logica_cu_list + this.currentCent.lamps_illum_id[n] + "\n";
                }
            }
            if (this.currentCent.lamps_altro_id != null) {
                for (n = 0; n < this.currentCent.lamps_altro_id.length; n++)
                {
                    this.logica_cu_list = this.logica_cu_list + this.currentCent.lamps_altro_id[n] + "\n";
                }
            }

            let self = this
            Vue.nextTick(function ()
            {
                self.$bvModal.show('config-cent-modal');
            })
        },
        reOpenConfigCent(cent)
        {
            console.log("restart check config status...");
            let self = this
            this.configRetry = 3;
            self.reopenConfig = true;
            self.headerClose = false;
            self.configError = false;
            self.configCompleted = false;
            if (self.configInProgress != 0) clearTimeout(self.configInProgress);   //ALEX
            self.configInProgress = setTimeout(self.checkConfigStatus, 3500);
            this.currentCent = cent;
            Vue.nextTick(function ()
            {
                self.$bvModal.show('config-cent-modal');
            })

        },
        stopSearching(cent)
        {
            console.log("Stop searching", cent);
            var cu_command = "stopSearching";
            this.$store.dispatch('sendCablecomCommand', { cu_command, cu_type: cent.cu_type, cu_id: cent.cu_id, addr: 'FFFF' })
        },
        showDeleteSerialId(cent)
        {
            var total_id_list = [];
            if (cent.lamps_id != null)
                total_id_list = total_id_list.concat(cent.lamps_id);
            if (cent.lamps_illum_id != null)
                total_id_list = total_id_list.concat(cent.lamps_illum_id);
            if (cent.lamps_altro_id != null)
                total_id_list = total_id_list.concat(cent.lamps_altro_id);
            return total_id_list
        },
        //termina l'inserimento dei Serial ID, verifica la loro correttezza formale ed invia il cmd di aggiornamento della tabella 'ControlUnits'
        endEditCSV()
        {
            let centType = this.currentCent.cu_type;
            let self = this;
            self.hasValidationError = false;
            if (this.validateSerialList(this.logica_config_sn, centType))
            {
                //metto i codici in lista qr e termino editing

                console.log("codici:", JSON.stringify(this.logica_array_sn));
                Vue.set(this.currentCent, "qr_lamps_id", this.logica_array_sn);
                //this.currentCent.qr_lamps_id = this.logica_array_sn;

                /*this.$nextTick(() => {
                    self.$forceUpdate();
                    console.log("qrLamps2:" + JSON.stringify(this.centQrLamps),this.currentCent.qr_lamps_id);
                });*/

                this.editingCSV = false;
                //this.currentCent.qr_lamps_id.push(lampId);
                self.$store.dispatch("dbUpdateQrLamps", {
                    cu_id: self.currentCent.cu_id,
                    cu_type: self.currentCent.cu_type,
                    plantId: self.$store.state.currentPlant.id,
                    lamps: self.currentCent.qr_lamps_id
                });


            } else
            {               
                setTimeout(function ()
                {    
                    self.hasValidationError = true;
                }, 100);
                return false;
            }
        },
        //resetta tutto quello che è stato scritto
        cancella() {
            this.editingCSV = false;
            this.logica_array_sn = [];
        },
        //gestisce l'invio delle informazioni di configurazione del modal "config-cent-modal"
        sendConfigCent(evt, centType, centId)
        {
            let self = this
            this.configRetry = 3;
            evt.preventDefault()
            //selezionata modalità logica di inserimento dei serial number di lampada
            console.log("sendconfigCent: ", evt, centType, centId);

            if (centType != "cablecom" && this.selected_modalita_logica == "logica_preset")
            {
                console.log("sendconfigCent Logica! Preset", this.centQrLamps);
                self.hasValidationError = false;
                this.logica_config_sn = this.centQrLamps.join("\r\n");

                if (this.validateSerialList(this.logica_config_sn, centType))
                {
                    this.sendPresetLogicaSerialId(this.logica_array_sn, centType, centId);
                } else
                {
                    setTimeout(function ()
                    {
                        self.hasValidationError = true;
                    }, 100);
                    return false;
                }
            } else if (centType == "logicafm" && this.selected_modalita_logica == "scan_qr")
            {
                self.hasValidationError = false;
                console.log("sendconfigCent LogicaFM!");
                //if(this.validateSerialList(this.logica_config_sn,centType))
                //{
                this.sendPresetLogicaSerialId(this.centQrLamps, centType, centId);
                /*} else {
                    setTimeout(function() {
                        self.hasValidationError = true;
                    },100);
                    return false;
                }*/
            } else if (centType != "cablecom" && this.selected_modalita_logica == "logica_substitute")
            {
                self.hasValidationError = false;
                console.log("check sostituzione!");
                if (this.validateSubstituteList(this.logica_config_sn))
                {
                    this.sendSubstituteLogicaSerialId(this.logica_array_sn, centType, centId);
                } else
                {
                    setTimeout(function ()
                    {
                        self.hasValidationError = true;
                    }, 100);
                    return false;
                }
            }
            else if (centType != "cablecom" && this.selected_modalita_logica == "logica_delete")
            {
                self.hasValidationError = false;
                if (!this.deleteAllLamps && this.substituteLampsSelection.length == 0)
                {

                    var alert = {
                        timeLeft: 5,
                        state: "danger",
                        msg: this.$t("config_cu_modal.logica_sn_empty_delete"),
                        countDownChanged: function (cd)
                        {
                            console.log("countdownchanged:" + cd)
                        }
                    }
                    this.validation_alerts.push(alert);
                    console.log("nessuna lampada sel per delete");

                    setTimeout(function ()
                    {
                        self.hasValidationError = true;
                    }, 100);
                    return false;

                }

                this.delete_sn = true;

            }
            else if (centType != "cablecom" && centType != "logica" && this.selected_modalita_logica == "network_create")
            {
                console.log("Invia comando di creazione rete per logica fm con plant code: ", this.selected_plant_code);
                var cu_command = {};
                cu_command.command = "createNetwork";
                var resp = self.$store.dispatch('sendLogicaCommand', { cu_command, cu_type: centType, cu_id: centId, plant_code: this.selected_plant_code, initialRetry: 0 });
                console.log("ricevuta risposta da promise!!!", resp);
                if (resp.error != null && resp.error != "")
                {
                    console.log("comando fallito!");
                    // error_preset=true;
                }
                else
                {
                    let self = this
                    Vue.nextTick(function ()
                    {
                        self.headerClose = false;
                        self.configError = false;
                        self.configCompleted = false;
                        self.createNetworkInProgress = true;
                        self.configInProgress = setTimeout(self.checkConfigStatus, 3500);
                        self.lamp_found = 0;
                    })
                }
            }
            //selezionata la modalità di ricerca per logica o per cablecom
            else
            {
                if (centType == "cablecom")
                {
                    let num_lamp = this.selected_num_lamp;
                    let ore_autonomia = this.selected_ore_autonomia;
                    this.$store.dispatch('sendCablecomConfigCommand', { centType, centId, num_lamp, ore_autonomia });
                }
                else if (centType == "logica" || centType == "logicafm")
                {
                    let modalita_config_logica = this.selected_modalita_logica;
                    this.$store.dispatch('sendLogicaConfigCommand', { centType, centId, modalita_config_logica });
                }
                let self = this
                Vue.nextTick(function ()
                {
                    self.headerClose = false;
                    self.configError = false;
                    self.configCompleted = false;
                    if (self.configInProgress != 0) clearTimeout(self.configInProgress);   //ALEX
                    self.configInProgress = setTimeout(self.checkConfigStatus, 3500);
                    self.lamp_found = 0;
                })
            }
        },
        checkConfigStatus()
        {
            console.log("GET DATI IMPIANTO: check config status...", Date.now() / 1000);
            this.$store.dispatch('sendCablecomConfigStatusCommand', { cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id });
        },
        //mostra il modale con la configurazione della lampada SICURO
        showLampSicuroConfig(ak, lamp)
        {
            console.log("showLampsSicuroConfig, lampada ", lamp);
            this.currentLamp = lamp;
            //passiamo la centrale selezionata
            this.currentCent = this.$store.state.plantUnits.find(
                cent => cent.cu_id === ak.cu_id.split('#')[1] && cent.cu_type === ak.cu_id.split('#')[0]
            );
            //apro il modale
            this.modalLampConfigShow = true;
        },
        //mostra il modale con la configurazione della linea
        showLineConfig(line)
        {
            this.currentCent = line.cu_id; //pe sicuro#000432
            this.currentLine = line;
            this.modalLineConfigShow = true;
            console.log('visualizzo modal line config su sicuro ', this.modalLineConfigShow, this.currentLine);
        },
        //mostra il modale con i dettagli della Lampada (ak serve solo alle lampade Sicuro)
        showLampDetails(ak, lamp)
        {
            this.currentLamp = lamp;           
            //passiamo la centrale selezionata; nel caso di impianto Blr senza Gateway this.$store.state.plantUnits sarà Null
            //nel caso di lampade sicuro, questa sarà una Linea!!!
            console.log("showLampDetails, ", this.$store.state.plantUnits);
            this.currentCent = null;
            // if (this.$store.state.plantUnits != null) {
            //     this.currentCent = this.$store.state.plantUnits.find(
            //         cent => (cent.cu_id === ak.cu_id.split('#')[1] && cent.cu_type === ak.cu_id.split('#')[0])
            //     );
            // }
            
            if (Array.isArray(this.$store.state.plantUnits) && ak?.cu_id) {
                const [type, id] = ak.cu_id.split('#');
                this.currentCent = this.$store.state.plantUnits.find(
                    cent => cent.cu_id === id && cent.cu_type === type
                );
            }

            this.scanning = false;
            this.modalLampDetailShow = true;
        },

        showLampBlink(cent, lamp)
        {
            console.log("lampada da blinkare lampada ", lamp.id, "su centrale", cent.cu_id);
            this.currentLamp = lamp;
            this.currentCent = cent;
            this.blinking = false;
            let self = this
            Vue.nextTick(function ()
            {
                console.log("Show");
                self.$bvModal.show('blink-lamp-modal');
            })
        },
        closeCentDetails()
        {
            console.log("close cent details");
            this.currentCent = null;
        },
        closeLampDetails()
        {
            console.log("close lamp details");
            this.currentLamp = null;
        },
        closeLampBlink()
        {
            console.log("close lamp blink su single lamp");
            if (this.blinking) { this.sendGenericCommand('stop_blink_single'); }
            this.currentLamp = null;
        },
        closeLampGroups()
        {
            console.log("close lamp groups");
            this.currentLamp = null;
        },
        onlineClass(value)
        {
            var online = (value.cu_connected) ? "dot-connected" : "dot-disconnected"
            return online
        },
        shadowPendingClass(value)
        {
            var pending = (value >= 0) ? "shadow-pending-true" : "shadow-pending-false"
            return pending
        },
        setByUser(value)
        {
            var userSet = (value == "true") ? "set-user-true" : "set-user-false"
            return userSet
        },
        working(value)
        {
            if (value.cu_status)
            {
                //console.log("oggetto: " + value.cu_id + " working: " + value.working);
                let s = value.cu_status
                //console.log("centrale " +value.cu_type+"_"+value.cu_id + " working=" + value.working);
                if (s.rest_mode_running == 'ON') return false;
                if (value.working == true || s.search_lamp == 'ON' || s.polling_lamp == 'ON' || s.search_lamp == 'ON'
                    || s.com_test_running == 'ON' || s.upgrade_fw_running == 'ON' || s.enrollment_running == 'ON') return true;
                return false;
            }
        },
        testactive(value)
        {
            if (value.cu_status)
            {
                let s = value.cu_status;
                s.working = false;
                if (s.funct_test_running == 'ON' || s.autonomy_test_running == 'ON') return true;
                return false;
            }
        },
        searchlampsactive(value)
        {
            if (value.cu_status)
            {
                let s = value.cu_status;
                //s.working=false;
                if (s.search_lamp == 'ON') 
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
        },
        waiting_first_shadow(value)
        {
            if (!value.cu_status)
            {
                return true;
            }
            return false;
        },
        restmodeactive(value)
        {
            if (value.cu_status)
            {
                let s = value.cu_status
                s.working = false;
                if (s.rest_mode_running == 'ON' && value.cu_connected == true) return true;
                return false;
            }
        },
        emergencyactive(value)
        {
            if (value.cu_status)
            {
                let s = value.cu_status
                s.working = false;
                if (s.emergency_running == "ON") 
                {
                    console.log("emergency active", s.emergency_running);
                    return true;
                }
                return false;
            }
        },
        FilterSelected(value)
        {
            var icon;
            if (value)
                icon = "btnFilterPress"
            else
                icon = "btnFilter"

            return icon
        },
        FilterComErrorSelected(value)
        {
            var icon;
            if (value)
                icon = "btnComErrorPress"
            else
                icon = "btnFilter"

            return icon
        },
        FilterBatteryErrorSelected(value)
        {
            var icon;
            if (value)
                icon = "btnBatteryErrorPress"
            else
                icon = "btnFilter"

            return icon
        },
        FilterHardwareErrorSelected(value)
        {
            var icon;
            if (value)
                icon = "btnHardwareErrorPress"
            else
                icon = "btnFilter"

            return icon
        },
        FilterLedErrorSelected(value)
        {
            var icon;
            if (value)
                icon = "btnLedErrorPress"
            else
                icon = "btnFilter"

            return icon
        },
        FilterOtherErrorSelected(value)
        {
            var icon;
            if (value)
                icon = "btnOtherErrorPress"
            else
                icon = "btnFilter"

            return icon
        },
        FilterSelectedOrphan(value)
        {
            var icon;
            if (value)
                icon = "btnFilterOrphanPress"
            else
                icon = "btnFilterOrphan"

            return icon
        },
        FilterSelectedEmergencyOn(value)
        {
            var icon;
            if (value)
                icon = "btnFilterEmergencyPress"
            else
                icon = "btnFilterEmergency"

            return icon
        },

        OrphanSelected(value)
        {
            var icon;
            if (value)
                icon = "btnOrphanPress"
            else
                icon = "btnOrphanFilter"

            return icon
        },
        EmergencyOnSelected(value)
        {
            var icon;
            if (value)
                icon = "btnEmergencyPress"
            else
                icon = "btnEmergencyFilter"

            return icon
        },

        centErrorClass(value)
        {
            if (value.cu_error)
            {
                var err = value.cu_error;
                var cent_exclamation = "cent-no-error";

                if (value.cu_type != 'sicuro') { 
                    if (
                        err.error_batt_low_voltage == 'ON' ||
                        err.error_batt_not_connected == 'ON' ||
                        err.error_duplicated_id_lamp == 'ON' ||
                        // err.error_lg == 'ON' ||
                        err.error_wiring == 'ON' ||
                        err.error_overload == 'ON' ||
                        err.error_more_32_lamp_in_config == 'ON' ||
                        err.error_more_128_lamp_in_config == 'ON' ||
                        err.err_data_invalid == 'ON' ||
                        err.err_UART1 == 'ON' ||
                        err.err_UART2 == 'ON' ||
                        err.err_UART3 == 'ON' ||
                        err.err_UART3_modem_powerON == 'ON' ||
                        err.err_UART4 == 'ON' ||
                        err.err_UART5 == 'ON' ||
                        err.err_UART6 == 'ON' ||
                        err.err_UART7 == 'ON'
                        // err.error_general == 'ON'
                    )
                    { cent_exclamation = "cent-error"; }
                    else if (
                        err.error_missing_lamp_in_config == 'ON' ||
                        err.error_too_much_lamp_in_config == 'ON' ||
                        err.mancanza_rete == 'ON' ||
                        value.cu_status.emergency_running == 'ON'
                    )
                    { cent_exclamation = "cent-warning"; }
                } else {
                    if ((err.error_general == 'ON') && (err.error_battery_fuse == 'OFF') && (err.error_battery_symmetry == 'OFF') &&
                        (err.error_power_supply_broken == 'OFF'))
                        cent_exclamation = "cent-error";
                }
                return cent_exclamation;
            }
        },
        //restituisce l'icona adeguata: circolo rosso se ci sono errori, oppure v verde se tutto va bene, o il simbolo di non configurato
        dotClass(value)
        {
            var stato = null;
            if (value.cu_error)
            {
                // if ((value.cu_type == 'sicuro') && ((value.cu_error.error_general == 'ON') || (this.trovaNumLampInError(value))))
                if ((value.cu_type == 'sicuro') && ((value.cu_error.error_general == 'ON') || (value.num_lamp_error > 0)))
                {
                    return "fa-exclamation-circle check-err";
                }
                if (value.num_lamp_error > 0 || value.cu_error.error_overload == 'ON' || value.cu_error.errorwiring == 'ON' || value.num_nodi_orfani > 0)
                {
                    stato = "fa-exclamation-circle check-err";
                }
                else if (value.num_lamp_found == 0 || value.cu_error.error_missing_lamp_in_config == 'ON' || value.cu_error.error_too_much_lamp_in_config == 'ON')
                {
                    stato = "fa-check check-not-config";
                }
                else
                {
                    if (value.cu_type != 'sicuro') {
                        if (value.cu_status.emergency_running == 'ON')
                            stato = "fa-exclamation-circle emergency-on"
                        else
                            stato = "fa-check check-ok";
                    } else {
                        stato = "fa-check check-ok";
                    }
                }
                return stato
            }

            if (value.cu_type == "blegateway")
            {
                if (value.num_lamp_error > 0) 
                {
                    stato = "fa-exclamation-circle check-err";
                }
                else if (value.num_lamp_found == 0) 
                {
                    stato = "fa-check check-not-config";
                }
                else
                {
                    stato = "fa-check check-ok";
                }

                return stato
            }
        },
        //come dotClass ma specifico per gli AK e LINEE
        dotClassLine(value)
        {
            var stato = null;
            if ((value.num_lamp_error > 0) || (this.calcolaNumErrori(value) > 0))
                stato = "fa-exclamation-circle check-err";
            else
                stato = "fa-check check-ok";

            return stato
        },
        
        zoneErrorBleLamp(zone)
        {

            var error_on_zone = 0;

            for (var k = 0; k < zone.bleLamps.length; k++)
            {
                var value = zone.bleLamps[k].lamp;
                if (zone.bleLamps[k].model != 9)
                {
                    if (value.error_com == "ON" || value.error_batt_short == "ON" || value.error_batt_test == "ON" || value.error_batt_test_auto == "ON" || value.error_hardware == "ON" || value.error_led == "ON")
                    {
                        error_on_zone++;
                    }
                }
                else
                {
                    if (value.lampFail == "ON" || value.errorBallastCom == "ON" || value.error_com == "ON")
                    {
                        error_on_zone++;
                    }
                }
            }

            return error_on_zone;

        },

        zoneTypeBleLamp(zone)
        {

            var ble_emergency = 0;
            var ble_lighting = 0;


            for (var k = 0; k < zone.bleLamps.length; k++)
            {
                // var value=zone.bleLamps[k].lamp;
                if (zone.bleLamps[k].model != 9)
                {
                    ble_emergency++;
                }
                else
                {
                    ble_lighting++;
                }
            }

            var zoneBleType = [ble_emergency, ble_lighting];
            return zoneBleType;

        },

        GsmClass(value)
        {
            if (value >= 25) return "signal-5"
            if (value >= 20 && value < 25) return "signal-4"
            if (value >= 15 && value < 20) return "signal-3"
            if (value >= 10 && value < 15) return "signal-2"
            if (value >= 1 && value < 10) return "signal-1"
            return "signal-0"
        },
        RssiClass(value)
        {
            //console.log("rssi: ", value);
            if (value && value.toString().includes('*'))
            {
                var indRssi = value;
                value = parseInt(indRssi.replace('*', '-'));
            }
            if (value >= -64 && value <= -10) return "signal-5"
            if (value >= -75 && value <= -65) return "signal-4"
            if (value >= -80 && value <= -76) return "signal-3"
            if (value >= -89 && value <= -81) return "signal-2"
            if (value >= -98 && value <= -90) return "signal-1"
            return "signal-0"
        },
        UpgradeAvailable(cent)
        {
            var upgrade_str = "Upgrade available:<br>";
            if (cent.cu_sw_ver.upgradable == 'YES')
                upgrade_str = upgrade_str + "cu fw build: " + cent.cu_sw_ver.cu_sw_build_fw_upg + "<br>";
            if (cent.modwifi_sw_ver.upgradable == 'YES')
                upgrade_str = upgrade_str + "wifi fw build: " + cent.modwifi_sw_ver.modwifi_sw_build_fw_upg;
            return upgrade_str;
        },
        //elimina una zona ble vuota
        deleteBleZone(plantId, zoneId, plantName) {
            console.log("deleteBleZone, plantId: " +  plantId + " zoneId: " + zoneId);
            let self = this;
            this.$bvModal.msgBoxConfirm( this.$t('bluetooth.blezone_delete_title'), {
                title: this.$t('settings.confirm'),
                okVariant: 'danger',
                okTitle: this.$t('settings.delete'),
                cancelTitle: this.$t('settings.cancel'),
                centered: true
            }).then((value) => {
                if (value == true) {
                    self.$store.dispatch("dbRemoveZone", {
                        plantId: plantId,
                        zoneId: zoneId,
                        plantName: plantName
                    });
                }
            });
        }
    }
}
</script>


<style lang="scss">


fixed-bottom-card {
  position: fixed !important;
  bottom: 48px !important; /* distance from bottom */
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 1rem;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  border-top: 1px solid #ddd;
}

.fixed-card {
    position: fixed;
    bottom: 48px; /*adjust to the height of the last component*/
    left: 0;
    right: 0;
    display: flex;
    z-index: 1000;
    justify-content: center;
}

.row-deactivated {
  background-color: #f0f0f0; /* colore grigio chiaro */
  opacity: 0.6;              /* effetto "disattivato" */
}

.battery-low {
    color: red;
}

.QrLampsContainer {
    background-color: #ffffff;
    border: 1px solid #ddd;
    height: 300px;
    overflow-y: auto;

}

.QrLampRow {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    border-bottom: 1px solid #ddd;
}

.check-ok {
    color: yellowgreen
}

.check-err {
    color: red
}

.check-orphan {
    color: violet
}

.check-com-err {
    color: orange
}

.check-not-config {
    color: orange
}

.emergency-on {
    color: brown
}

.cent-error {
    color: red;
    visibility: none;
}

.cent-warning {
    color: orange;
    visibility: none;
}

.cent-no-error {
    visibility: hidden;
}

.shadow-pending-true {
    color: blue
}

.shadow-pending-false {
    color: black
}

.set-user-true {
    border: white;
}

.set-user-false {
    border: #04709C;
    border-style: solid;
    border-width: 1px;
    padding-right: 0px;
    padding-left: 5px;
    padding-top: 4px;
    padding-bottom: 5px;
}

#dataTableAk {
    table-layout: fixed;
    width: 95%;
    margin: 0 auto;
    outline: none;
    font-size: 13px;
}

#dataTableCharger {
    table-layout: fixed;
    width: 95%;
    margin: 0 auto;
    outline: none;
    font-size: 13px;
}

#dataTableLssa {
    table-layout: fixed;
    width: 93%;
    //margin: 0 auto;
    margin-top: 0px;
    //margin-left: 60px;
    margin-left: 5%;
    outline: none;
    font-size: 13px;
}

#dataTable2 {
    table-layout: fixed;
    width: 95%;
    margin: 0 auto;
    outline: none;
    font-size: 13px;

    td.dettColumnClass {

        width: 60px;
        max-width: 60px;
        min-width: 60xp;
    }

    td.chkColumnClass {
        width: 80px;
        max-width: 80px;
        min-width: 80px;
    }

    td.descColumnClass {
        width: 218px;
    }

    td.imgColumnClass {
        width: 132px;
        max-width: 132px;
        min-width: 132px;
    }

    .dot-connected {
        color: yellowgreen
    }

    .dot-disconnected {
        color: grey
    }

    .VuePagination {
        text-align: center;
        justify-content: center;
    }

    .vue-title {
        text-align: center;
        margin-bottom: 10px;
    }

    .VueTables__search-field {
        visibility: hidden;
        display: flex;
    }

    .VueTables__search {
        height: 0px;
        margin-left: 0.25rem;
    }

    .VueTables__search-field input {
        margin-left: 0.25rem;
    }

    .VueTables__limit-field {
        display: flex;
    }

    .VuePagination__count {
        display: none;
    }

    .VueTables__limit-field select {
        margin-left: 0.25rem !important;
    }


    .VueTables__table td:nth-child(1) {
        background-color: #F4F4F4;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .VueTables__table td:nth-child(2) {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }


    .VueTables__table td:last-child {
        border-bottom-right-radius: 10px;
        border-top-right-radius: 10px;
    }

    .VueTables__table th {
        border: solid 0px;
        text-align: center;
        outline: none;
    }

    .VueTables__table td {
        vertical-align: middle;
        text-align: center;
        outline: none;
    }

    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: auto;
        text-align: center;
    }

    tr.VueTables__no-results {
        display: none;
    }

    tr.VueTables__row {
        border-radius: 10px !important;
        font-size: 13px;
        margin-bottom: 2px;
        height: 90px;
    }

    table tr {
        background-color: #F4F4F4;
    }

    table tr.row-deactivated {
        background-color: #dcdcdc !important; /* grigio ancora più chiaro */
    }

    .VueTables__child-row:hover {
        background-color: #fff;
    }

    .VueTables__child-row thead tr {
        background-color: #fff;
    }

    .VueTables__child-row thead tr:hover {
        background-color: #fff;
    }

    .VueTables__child-row-toggler--closed::before {
        content: "\f105"; // simbolo > di fontawesome
        font-family: FontAwesome;
        font-size: 1.5em;
        font-weight: 700;
        color: black;
    }

    .VueTables__child-row-toggler--closed:hover::before {
        content: "\f105"; // simbolo > di fontawesome
        font-family: FontAwesome;
        font-size: 1.8em;
        font-weight: 700;
        color: #0090CD;
        cursor: pointer;
    }

    .VueTables__child-row-toggler--open::before {
        content: "\f107"; // simbolo basso di fontawesome
        font-family: FontAwesome;
        font-size: 1.5em;
        font-weight: 700;
        color: black;
    }

    .VueTables__child-row-toggler--open:hover::before {
        content: "\f107"; // simbolo basso di fontawesome
        font-family: FontAwesome;
        font-size: 1.8em;
        font-weight: 700;
        color: #0090CD;
        cursor: pointer;
    }

    .VueTables__table .sp_cent_cod {
        margin-left: 20px;
    }

    .VueTables__table tr.cent-disabled td {
        background-color: rgba(124, 112, 112, 0.301);
    }

    .VueTables__table tr.cent-disabled td:nth-child(1) {
        background-color: #f4f4f4;
    }

    img.disabled {
        opacity: 0.1;
    }

}


#dataTableChild {
    td:nth-child(2) {
        background-color: #F4F4F4;
    }

    td:nth-child(3) {
        border-top: solid 1pt #E3E6E7;
        border-left: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    td:nth-child(4) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(5) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(6) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(7) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(8) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(9) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(10) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(11) {
        border-top: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td:nth-child(12) {
        border-top: solid 1pt #E3E6E7;
        border-right: solid 1pt #E3E6E7;
        border-bottom: solid 1pt #E3E6E7;
    }

    td {
        border: solid 0px #E3E6E7;
        //margin-bottom: 2px;
        height: 90px;
    }


}
</style>